// @ts-strict-ignore
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-no-target-blank */
export const s_caf = {
  overview: {
    check_caf_analysis: {
      toast: [
        `CAF 진단 확인 완료되었습니다.`,
        `Check completed!`,
        's_caf.overview.check_caf_analysis.toast',
        `确认完毕`,
        `確認完畢`,
        `確認完了`,
        `Check completed!`,
      ],
      btn: [
        `CAF 진단 확인 완료`,
        `Done checking CAF analysis`,
        's_caf.overview.check_caf_analysis.btn',
        `Done checking CAF analysis`,
        `Done checking CAF analysis`,
        `Done checking CAF analysis`,
        `Done checking CAF analysis`,
      ],
    },
    highlight_title: [
      `추천 학습 영역`,
      `Recommended Focus Areas`,
      's_caf.overview.highlight_title',
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
    ],
    highlight_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      's_caf.overview.highlight_detail',
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
    ],
    caf_level: [
      `CAF Level`,
      `CAF Level`,
      's_caf.overview.caf_level',
      `CAF Level`,
      `CAF Level`,
      `CAF Level`,
      `CAF Level`,
    ],
    caf_level_score: [`# / 9`, `# / 9`, 's_caf.overview.caf_level_score', `# / 10`, `# / 11`, `# / 12`, `# / 13`],
    complexity: [
      `Complexity`,
      `Complexity`,
      's_caf.overview.complexity',
      `Complexity`,
      `Complexity`,
      `Complexity`,
      `Complexity`,
    ],
    accuracy: [`Accuracy`, `Accuracy`, 's_caf.overview.accuracy', `Accuracy`, `Accuracy`, `Accuracy`, `Accuracy`],
    fluency: [`Fluency`, `Fluency`, 's_caf.overview.fluency', `Fluency`, `Fluency`, `Fluency`, `Fluency`],
    level_score: [`Lv`, `Lv`, 's_caf.overview.level_score', `Lv`, `Lv`, `Lv`, `Lv`],
    caf_level_detail: [
      `27가지 중 하나!`,
      `Out of 27 types!`,
      's_caf.overview.caf_level_detail',
      `Out of 27 types!`,
      `Out of 27 types!`,
      `Out of 27 types!`,
      `Out of 27 types!`,
    ],
    tab_name: [
      `CAF 결과`,
      `CAF Analysis Results`,
      's_caf.overview.tab_name',
      `CAF Analysis Results`,
      `CAF Analysis Results`,
      `CAF Analysis Results`,
      `CAF Analysis Results`,
    ],
    faq_title: [
      `CAF 진단이란 무엇인가요?`,
      `What is CAF Analysis?`,
      's_caf.overview.faq_title',
      `What is CAF Analysis?`,
      `What is CAF Analysis?`,
      `What is CAF Analysis?`,
      `What is CAF Analysis?`,
    ],
    faq_subtitle: [
      `CAF 진단에 대해 자주 들어오는 질문의 답변을 확인할 수 있습니다.`,
      `You can see the answers to frequently-asked questions about CAF Analysis.`,
      's_caf.overview.faq_subtitle',
      `You can see the answers to frequently-asked questions about CAF Analysis.`,
      `You can see the answers to frequently-asked questions about CAF Analysis.`,
      `You can see the answers to frequently-asked questions about CAF Analysis.`,
      `You can see the answers to frequently-asked questions about CAF Analysis.`,
    ],
    caf_level333: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았어요. 계속해서 더 다양한 교재, 튜터와 수업을 진행해 보세요.`,
      `Your CAF level was high overall in this lesson. Let's continue taking lessons with different materials and tutors!`,
      's_caf.overview.caf_level333',
      `Your CAF level was high overall in this lesson. Let's continue taking lessons with different materials and tutors!`,
      `Your CAF level was high overall in this lesson. Let's continue taking lessons with different materials and tutors!`,
      `Your CAF level was high overall in this lesson. Let's continue taking lessons with different materials and tutors!`,
      `Your CAF level was high overall in this lesson. Let's continue taking lessons with different materials and tutors!`,
    ],
    caf_level332: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았어요. 대화의 흐름이 끊기지 않도록 나에게 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Your CAF level was high overall in this lesson. Try speaking at a pace that allows you to continue conversing without interruption.`,
      's_caf.overview.caf_level332',
      `Your CAF level was high overall in this lesson. Try speaking at a pace that allows you to continue conversing without interruption.`,
      `Your CAF level was high overall in this lesson. Try speaking at a pace that allows you to continue conversing without interruption.`,
      `Your CAF level was high overall in this lesson. Try speaking at a pace that allows you to continue conversing without interruption.`,
      `Your CAF level was high overall in this lesson. Try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level233: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았어요. 튜터가 알려준 문장과 표현을 연습하여 다음 수업에 적용해 보세요. 교재에 있는 핵심 표현들도 복습해 보세요.`,
      `Your CAF level was high overall in this lesson. Practice the sentences and expressions you learned and use them in your next lesson. Also, go over key expressions from the material.`,
      's_caf.overview.caf_level233',
      `Your CAF level was high overall in this lesson. Practice the sentences and expressions you learned and use them in your next lesson. Also, go over key expressions from the material.`,
      `Your CAF level was high overall in this lesson. Practice the sentences and expressions you learned and use them in your next lesson. Also, go over key expressions from the material.`,
      `Your CAF level was high overall in this lesson. Practice the sentences and expressions you learned and use them in your next lesson. Also, go over key expressions from the material.`,
      `Your CAF level was high overall in this lesson. Practice the sentences and expressions you learned and use them in your next lesson. Also, go over key expressions from the material.`,
    ],
    caf_level323: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았어요. 다음 수업에서는 문법 정확성을 신경 써서 수업을 진행해 보세요.`,
      `Your CAF level was high overall in this lesson. Try paying more attention to grammatical accuracy in your next lesson.`,
      's_caf.overview.caf_level323',
      `Your CAF level was high overall in this lesson. Try paying more attention to grammatical accuracy in your next lesson.`,
      `Your CAF level was high overall in this lesson. Try paying more attention to grammatical accuracy in your next lesson.`,
      `Your CAF level was high overall in this lesson. Try paying more attention to grammatical accuracy in your next lesson.`,
      `Your CAF level was high overall in this lesson. Try paying more attention to grammatical accuracy in your next lesson.`,
    ],
    caf_level331: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았지만, 상대적으로 Fluency(유창성) 레벨이 낮았어요. 나의 Fluency가 낮은 이유를 확인하고 다음 수업에서는 말하는 흐름이 끊기지 않도록 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Your CAF level was high overall in this lesson, but your score for Fluency was relatively lower. Check why your Fluency level was low, and try speaking at a pace that allows you to continue conversing without interruption.`,
      's_caf.overview.caf_level331',
      `Your CAF level was high overall in this lesson, but your score for Fluency was relatively lower. Check why your Fluency level was low, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Your CAF level was high overall in this lesson, but your score for Fluency was relatively lower. Check why your Fluency level was low, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Your CAF level was high overall in this lesson, but your score for Fluency was relatively lower. Check why your Fluency level was low, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Your CAF level was high overall in this lesson, but your score for Fluency was relatively lower. Check why your Fluency level was low, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level232: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았어요. 상대적으로 Accuracy(정확성) 레벨이 높은 편이에요. 다음 수업에서는 Complexity(복잡성)와 Fluency(유창성)를 신경 써서 수업을 진행해 보세요.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Accuracy. In your next lesson, try to pay more attention to Complexity and Fluency.`,
      's_caf.overview.caf_level232',
      `Your CAF level was high overall in this lesson, with a relatively higher score for Accuracy. In your next lesson, try to pay more attention to Complexity and Fluency.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Accuracy. In your next lesson, try to pay more attention to Complexity and Fluency.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Accuracy. In your next lesson, try to pay more attention to Complexity and Fluency.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Accuracy. In your next lesson, try to pay more attention to Complexity and Fluency.`,
    ],
    caf_level133: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았지만, 상대적으로 Complexity(복잡성) 레벨이 낮았어요. 나의 Complexity가 낮은 이유를 확인하고 튜터가 알려준 표현과 문장 구조를 연습하여 다음 수업에 적용해 보세요.`,
      `Your CAF level was high overall in this lesson, but your score for Complexity was relatively lower. Check why your Complexity level was low, and practice the sentences and expressions you learned and use them in your next lesson.`,
      's_caf.overview.caf_level133',
      `Your CAF level was high overall in this lesson, but your score for Complexity was relatively lower. Check why your Complexity level was low, and practice the sentences and expressions you learned and use them in your next lesson.`,
      `Your CAF level was high overall in this lesson, but your score for Complexity was relatively lower. Check why your Complexity level was low, and practice the sentences and expressions you learned and use them in your next lesson.`,
      `Your CAF level was high overall in this lesson, but your score for Complexity was relatively lower. Check why your Complexity level was low, and practice the sentences and expressions you learned and use them in your next lesson.`,
      `Your CAF level was high overall in this lesson, but your score for Complexity was relatively lower. Check why your Complexity level was low, and practice the sentences and expressions you learned and use them in your next lesson.`,
    ],
    caf_level322: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았어요. 상대적으로 Complexity(복잡성) 레벨이 높은 편이에요. 다음 수업에서는 Accuracy(정확성)와 Fluency(유창성)를 신경 써서 수업을 진행해 보세요.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Complexity. In your next lesson, try to pay more attention to Accuracy and Fluency.`,
      's_caf.overview.caf_level322',
      `Your CAF level was high overall in this lesson, with a relatively higher score for Complexity. In your next lesson, try to pay more attention to Accuracy and Fluency.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Complexity. In your next lesson, try to pay more attention to Accuracy and Fluency.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Complexity. In your next lesson, try to pay more attention to Accuracy and Fluency.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Complexity. In your next lesson, try to pay more attention to Accuracy and Fluency.`,
    ],
    caf_level223: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았어요. 상대적으로 Fluency(유창성) 레벨이 높은 편이에요. 다음 수업에서는 Complexity(복잡성)와 Accuracy(정확성)를 신경 써서 수업을 진행해 보세요.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Fluency. In your next lesson, try to pay more attention to Complexity and Accuracy.`,
      's_caf.overview.caf_level223',
      `Your CAF level was high overall in this lesson, with a relatively higher score for Fluency. In your next lesson, try to pay more attention to Complexity and Accuracy.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Fluency. In your next lesson, try to pay more attention to Complexity and Accuracy.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Fluency. In your next lesson, try to pay more attention to Complexity and Accuracy.`,
      `Your CAF level was high overall in this lesson, with a relatively higher score for Fluency. In your next lesson, try to pay more attention to Complexity and Accuracy.`,
    ],
    caf_level313: [
      `이번 수업에서는 전반적으로 높은 CAF 레벨을 받았지만, 상대적으로 Accuracy(정확성) 레벨이 낮았어요. 나의 Accuracy가 낮은 이유를 확인하고 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `Your CAF level was high overall in this lesson, but your score for Accuracy was relatively lower. Check why your Accuracy level was low, and try prepping for or reviewing lessons focusing on 1-2 areas.`,
      's_caf.overview.caf_level313',
      `Your CAF level was high overall in this lesson, but your score for Accuracy was relatively lower. Check why your Accuracy level was low, and try prepping for or reviewing lessons focusing on 1-2 areas.`,
      `Your CAF level was high overall in this lesson, but your score for Accuracy was relatively lower. Check why your Accuracy level was low, and try prepping for or reviewing lessons focusing on 1-2 areas.`,
      `Your CAF level was high overall in this lesson, but your score for Accuracy was relatively lower. Check why your Accuracy level was low, and try prepping for or reviewing lessons focusing on 1-2 areas.`,
      `Your CAF level was high overall in this lesson, but your score for Accuracy was relatively lower. Check why your Accuracy level was low, and try prepping for or reviewing lessons focusing on 1-2 areas.`,
    ],
    caf_level231: [
      `이번 수업에서는 Accuracy(정확성) 레벨이 높았어요. 다음 수업에서 상대적으로 낮은 레벨을 받은 Fluency(유창성)를 신경 써서 말하는 흐름이 끊기지 않도록 나에게 알맞은 페이스로 수업을 진행해 보세요.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      's_caf.overview.caf_level231',
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level132: [
      `이번 수업에서는 Accuracy(정확성) 레벨이 높았어요. 다음 수업에서는 상대적으로 낮은 레벨을 받은 Complexity(복잡성)에 집중하여 튜터가 알려준 표현과 문장 구조, 교재에서 소개하는 핵심 표현을 연습하여 적용해 보세요.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      's_caf.overview.caf_level132',
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
    ],
    caf_level321: [
      `이번 수업에서는 Complexity(복잡성) 레벨이 높았어요. 다음 수업에서 상대적으로 낮은 레벨을 받은 Fluency(유창성)를 신경 써서 말하는 흐름이 끊기지 않도록 나에게 알맞은 페이스로 수업을 진행해 보세요.`,
      `You scored high for Complexity in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      's_caf.overview.caf_level321',
      `You scored high for Complexity in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored high for Complexity in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored high for Complexity in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored high for Complexity in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level222: [
      `이번 수업에서는 CAF 레벨이 전반적으로 비슷했어요. Complexity(복잡성), Accuracy(정확성), Fluency(유창성) 중 하나의 영역에 집중하여 다음 수업을 들어보세요.`,
      `Your scores for all areas were similar overall in this lesson. Try focusing on either Complexity, Accuracy, or Fluency in your next lesson.`,
      's_caf.overview.caf_level222',
      `Your scores for all areas were similar overall in this lesson. Try focusing on either Complexity, Accuracy, or Fluency in your next lesson.`,
      `Your scores for all areas were similar overall in this lesson. Try focusing on either Complexity, Accuracy, or Fluency in your next lesson.`,
      `Your scores for all areas were similar overall in this lesson. Try focusing on either Complexity, Accuracy, or Fluency in your next lesson.`,
      `Your scores for all areas were similar overall in this lesson. Try focusing on either Complexity, Accuracy, or Fluency in your next lesson.`,
    ],
    caf_level123: [
      `이번 수업에서는 Fluency(유창성) 레벨이 높았어요. 상대적으로 낮은 레벨을 받은 Complexity(복잡성)에 집중하여 튜터가 알려준 표현과 문장 구조, 교재에서 소개하는 핵심 표현을 연습해 보세요.`,
      `You scored high for Fluency in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      's_caf.overview.caf_level123',
      `You scored high for Fluency in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored high for Fluency in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored high for Fluency in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored high for Fluency in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
    ],
    caf_level312: [
      `이번 수업에서는 Complexity(복잡성) 레벨이 높았어요. 상대적으로 낮을 레벨을 받은 Accuracy(정확성)의 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `You scored high for Complexity in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      's_caf.overview.caf_level312',
      `You scored high for Complexity in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored high for Complexity in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored high for Complexity in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored high for Complexity in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
    ],
    caf_level213: [
      `이번 수업에서는 Fluency(유창성) 레벨이 높았어요. 상대적으로 낮을 레벨을 받은 Accuracy(정확성)의 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `You scored high for Fluency in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      's_caf.overview.caf_level213',
      `You scored high for Fluency in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored high for Fluency in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored high for Fluency in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored high for Fluency in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
    ],
    caf_level131: [
      `이번 수업에서는 Accuracy(정확성) 레벨이 높았어요. 상대적으로 낮은 레벨을 받은 Complexity(복잡성)와 Fluency(유창성)에 집중해서 복습을 진행해보세요.`,
      `You scored high for Accuracy in this lesson. Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson.`,
      's_caf.overview.caf_level131',
      `You scored high for Accuracy in this lesson. Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Accuracy in this lesson. Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Accuracy in this lesson. Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Accuracy in this lesson. Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson.`,
    ],
    caf_level221: [
      `전반적으로 평균적인 CAF 레벨을 받았어요. 다음 수업에서 상대적으로 낮은 레벨을 받은 Fluency(유창성)를 신경 써서 말하는 흐름이 끊기지 않도록 나에게 알맞은 페이스로 수업을 진행해 보세요.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      's_caf.overview.caf_level221',
      `You scored an average CAF level overall. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level122: [
      `전반적으로 평균적인 CAF 레벨을 받았어요. 다음 수업에서는 상대적으로 낮은 레벨을 받은 Complexity(복잡성)에 집중하여 튜터가 알려준 표현과 문장 구조, 교재에서 소개하는 핵심 표현을 연습하여 적용해 보세요.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      's_caf.overview.caf_level122',
      `You scored an average CAF level overall. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      `You scored an average CAF level overall. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
    ],
    caf_level311: [
      `이번 수업에서는 Complexity(복잡성) 레벨이 높았어요. 상대적으로 점수가 낮게 나온 Accuracy(정확성)와 Fluency(유창성)에 집중해서 복습을 진행해 보세요.`,
      `You scored high for Complexity in this lesson. Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson.`,
      's_caf.overview.caf_level311',
      `You scored high for Complexity in this lesson. Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Complexity in this lesson. Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Complexity in this lesson. Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Complexity in this lesson. Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson.`,
    ],
    caf_level212: [
      `전반적으로 평균적인 CAF 레벨을 받았어요. 상대적으로 낮을 레벨을 받은 Accuracy(정확성)의 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `You scored an average CAF level overall. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      's_caf.overview.caf_level212',
      `You scored an average CAF level overall. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored an average CAF level overall. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored an average CAF level overall. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      `You scored an average CAF level overall. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
    ],
    caf_level113: [
      `이번 수업에서는 Fluency(유창성) 레벨이 높았어요. 상대적으로 점수가 낮게 나온 Complexity(복잡성)와 Accuracy(정확성)에 집중해서 복습을 진행해 보세요.`,
      `You scored high for Fluency in this lesson. Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson.`,
      's_caf.overview.caf_level113',
      `You scored high for Fluency in this lesson. Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Fluency in this lesson. Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Fluency in this lesson. Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson.`,
      `You scored high for Fluency in this lesson. Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson.`,
    ],
    caf_level121: [
      `Accuracy(정확성)에 비해 상대적으로 낮은 레벨을 받은 Complexity(복잡성)와 Fluency(유창성)에 집중해서 복습을 진행해보세요. 다음 수업에서는 문장 구조와 단어에 조금 더 신경을 쓰고 말의 흐름이 끊기지 않도록 나에게 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to sentence structures and vocabulary and try speaking at a pace that allows you to continue conversing without interruption.`,
      's_caf.overview.caf_level121',
      `Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to sentence structures and vocabulary and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to sentence structures and vocabulary and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to sentence structures and vocabulary and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to sentence structures and vocabulary and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level211: [
      `Complexity(복잡성)에 비해 상대적으로 낮은 레벨을 받은 Accuracy(정확성)와 Fluency(유창성)에 집중해서 복습을 진행해보세요. 다음 수업에서는 문법 정확도에 조금 더 신경을 쓰고 말의 흐름이 끊기지 않도록 나에게 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to grammar and try speaking at a pace that allows you to continue conversing without interruption.`,
      's_caf.overview.caf_level211',
      `Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to grammar and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to grammar and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to grammar and try speaking at a pace that allows you to continue conversing without interruption.`,
      `Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to grammar and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level112: [
      `Fluency(유창성)에 비해 상대적으로 낮은 레벨을 받은 Complexity(복잡성)와 Accuracy(정확성)에 집중해서 복습을 진행해보세요. 다음 수업에서는 튜터가 알려준 표현과 문장 구조를 연습하여 적용해 보세요.`,
      `Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson. Practice the expressions and sentence structures you learned and try using them in your next lesson.`,
      's_caf.overview.caf_level112',
      `Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson. Practice the expressions and sentence structures you learned and try using them in your next lesson.`,
      `Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson. Practice the expressions and sentence structures you learned and try using them in your next lesson.`,
      `Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson. Practice the expressions and sentence structures you learned and try using them in your next lesson.`,
      `Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson. Practice the expressions and sentence structures you learned and try using them in your next lesson.`,
    ],
    caf_level111: [
      `문법이나 단어 선택에 너무 얽매이지 말고, 정확도가 조금 떨어져도 영어로 생각하고 말하는 연습을 해보세요. 영어로 대화하는 데 큰 어려움이 없다고 판단될 때까지 Fluency(유창성) 레벨을 높이는 것을 목표로 수업을 해보세요.`,
      `Don't get too hung up on grammar or vocabulary. Instead, try to think and speak in English, even if you end up being less accurate. Make improving your Fluency your goal until you feel comfortable communicating in English.`,
      's_caf.overview.caf_level111',
      `Don't get too hung up on grammar or vocabulary. Instead, try to think and speak in English, even if you end up being less accurate. Make improving your Fluency your goal until you feel comfortable communicating in English.`,
      `Don't get too hung up on grammar or vocabulary. Instead, try to think and speak in English, even if you end up being less accurate. Make improving your Fluency your goal until you feel comfortable communicating in English.`,
      `Don't get too hung up on grammar or vocabulary. Instead, try to think and speak in English, even if you end up being less accurate. Make improving your Fluency your goal until you feel comfortable communicating in English.`,
      `Don't get too hung up on grammar or vocabulary. Instead, try to think and speak in English, even if you end up being less accurate. Make improving your Fluency your goal until you feel comfortable communicating in English.`,
    ],
    tophighlights_title: [
      `내가 집중하고 싶은 학습 영역`,
      `My Focus Areas`,
      's_caf.overview.tophighlights_title',
      `My Focus Areas`,
      `My Focus Areas`,
      `My Focus Areas`,
      `My Focus Areas`,
    ],
    tophighlights_info: [
      <>
        학습 영역을 고정하고 다른 수업에서
        <br />
        어떻게 달라지는지 확인해보세요.
      </>,
      <>
        Pin a focus area and see how the CAF analysis
        <br />
        changes in other lessons.
      </>,
      's_caf.overview.tophighlights_info',
      <>
        Pin a focus area and see how the CAF analysis
        <br />
        changes in other lessons.
      </>,
      <>
        Pin a focus area and see how the CAF analysis
        <br />
        changes in other lessons.
      </>,
      <>
        Pin a focus area and see how the CAF analysis
        <br />
        changes in other lessons.
      </>,
      <>
        Pin a focus area and see how the CAF analysis
        <br />
        changes in other lessons.
      </>,
    ],
    tophighlights_edit: [`편집하기`, `Edit`, 's_caf.overview.tophighlights_edit', `Edit`, `Edit`, `Edit`, `Edit`],
    highlight_seeall: [
      `전체 학습 영역보기`,
      `View all focus areas`,
      's_caf.overview.highlight_seeall',
      `View all focus areas`,
      `View all focus areas`,
      `View all focus areas`,
      `View all focus areas`,
    ],
    guide_page: {
      title: [
        `CAF 진단 가이드`,
        `Introduction to CAF Analysis`,
        's_caf.overview.guide_page.title',
        `Introduction to CAF Analysis`,
        `Introduction to CAF Analysis`,
        `Introduction to CAF Analysis`,
        `Introduction to CAF Analysis`,
      ],
    },
    book_lesson: {
      btn: [
        `수업 예약하기`,
        `Book a lesson`,
        's_caf.overview.book_lesson.btn',
        `Book a lesson`,
        `Book a lesson`,
        `Book a lesson`,
        `Book a lesson`,
      ],
    },
    book_lesson_title: {
      msg1: [
        `다음 수업에서는 Fluency에 집중해 볼까요?`,
        `How about focusing on Fluency next lesson?`,
        's_caf.overview.book_lesson_title.msg1',
        `How about focusing on Fluency next lesson?`,
        `How about focusing on Fluency next lesson?`,
        `How about focusing on Fluency next lesson?`,
        `How about focusing on Fluency next lesson?`,
      ],
      msg2: [
        `다음 수업에서는 Complexity에 집중해 볼까요?`,
        `How about focusing on Complexity next lesson?`,
        's_caf.overview.book_lesson_title.msg2',
        `How about focusing on Complexity next lesson?`,
        `How about focusing on Complexity next lesson?`,
        `How about focusing on Complexity next lesson?`,
        `How about focusing on Complexity next lesson?`,
      ],
      msg3: [
        `다음 수업에서는 Accuracy에 집중해볼까요?`,
        `How about focusing on Accuracy next lesson?`,
        's_caf.overview.book_lesson_title.msg3',
        `How about focusing on Accuracy next lesson?`,
        `How about focusing on Accuracy next lesson?`,
        `How about focusing on Accuracy next lesson?`,
        `How about focusing on Accuracy next lesson?`,
      ],
    },
    book_lesson_body: {
      msg1: [
        `평균 월 6번 이상 수업을 듣는 사람들은 그렇지 않은 사람들보다 Fluency 향상될 가능성이 약 5배 더 높아요.`,
        `Ringlers who take 6 or more lessons per month are five times more likely to improve their Fluency than those who don't.`,
        's_caf.overview.book_lesson_body.msg1',
        `Ringlers who take 6 or more lessons per month are five times more likely to improve their Fluency than those who don't.`,
        `Ringlers who take 6 or more lessons per month are five times more likely to improve their Fluency than those who don't.`,
        `Ringlers who take 6 or more lessons per month are five times more likely to improve their Fluency than those who don't.`,
        `Ringlers who take 6 or more lessons per month are five times more likely to improve their Fluency than those who don't.`,
      ],
      msg2: [
        `수업 전에 교재의 답변을 미리 준비하는 사람은 준비하지 않는 사람보다 Complexity 향상될 가능성이 약 2배 정도 더 높아요.`,
        `Ringlers who prep for lessons are two times more likely to improve their Complexity than those who don't.`,
        's_caf.overview.book_lesson_body.msg2',
        `Ringlers who prep for lessons are two times more likely to improve their Complexity than those who don't.`,
        `Ringlers who prep for lessons are two times more likely to improve their Complexity than those who don't.`,
        `Ringlers who prep for lessons are two times more likely to improve their Complexity than those who don't.`,
        `Ringlers who prep for lessons are two times more likely to improve their Complexity than those who don't.`,
      ],
      msg3: [
        `모든 것을 한번에 고치려고 하다보면 오히려 잘했던 영역까지 실수를 할 수 있어요. 내가 개선하고 싶은 문법 유형 1-2개에 집중해보세요.`,
        `You may find yourself making mistakes in areas you've been good at if you try to fix everything all at once. Try working on 1-2 grammar rules you want to focus on at a time.`,
        's_caf.overview.book_lesson_body.msg3',
        `You may find yourself making mistakes in areas you've been good at if you try to fix everything all at once. Try working on 1-2 grammar rules you want to focus on at a time.`,
        `You may find yourself making mistakes in areas you've been good at if you try to fix everything all at once. Try working on 1-2 grammar rules you want to focus on at a time.`,
        `You may find yourself making mistakes in areas you've been good at if you try to fix everything all at once. Try working on 1-2 grammar rules you want to focus on at a time.`,
        `You may find yourself making mistakes in areas you've been good at if you try to fix everything all at once. Try working on 1-2 grammar rules you want to focus on at a time.`,
      ],
    },
    checkout: {
      btn: [
        `학습 영역 둘러보기`,
        `Check out Focus Areas`,
        's_caf.overview.checkout.btn',
        `Check out Focus Areas`,
        `Check out Focus Areas`,
        `Check out Focus Areas`,
        `Check out Focus Areas`,
      ],
    },
    tophighlights_info1: [
      `학습 영역을 고정하고 다른 수업에서 어떻게 달라지는지 확인해보세요.`,
      `Pin a focus area and see how the CAF analysis changes in other lessons.`,
      's_caf.overview.tophighlights_info1',
      `Pin a focus area and see how the CAF analysis changes in other lessons.`,
      `Pin a focus area and see how the CAF analysis changes in other lessons.`,
      `Pin a focus area and see how the CAF analysis changes in other lessons.`,
      `Pin a focus area and see how the CAF analysis changes in other lessons.`,
    ],
    menu_overview: [
      `진단 개요`,
      `Overview`,
      's_caf.overview.menu_overview',
      `综合评价`,
      `綜合評價`,
      `Overview`,
      `Overview`,
    ],
    menu_complexity: [
      `Complexity`,
      `Complexity`,
      's_caf.overview.menu_complexity',
      `複杂度`,
      `複雜度`,
      `Complexity`,
      `Complexity`,
    ],
    menu_accuracy: [`Accuracy`, `Accuracy`, 's_caf.overview.menu_accuracy', `准确度`, `準確度`, `Accuracy`, `Accuracy`],
    menu_fluency: [`Fluency`, `Fluency`, 's_caf.overview.menu_fluency', `流畅度`, `流暢度`, `Fluency`, `Fluency`],
    menu_areas: [
      `학습 영역`,
      `Focus Areas`,
      's_caf.overview.menu_areas',
      `学习重点`,
      `學習重點`,
      `Focus Areas`,
      `Focus Areas`,
    ],
    pronunciation: [
      `Pronunciation`,
      `Pronunciation`,
      's_caf.overview.pronunciation',
      `发音`,
      `發音`,
      `Pronunciation`,
      `Pronunciation`,
    ],
  },
  highlight: {
    repetition1: [
      `특정 단어를 반복적으로 사용했어요.`,
      `Certain words were repeatedly used.`,
      's_caf.highlight.repetition1',
      `Certain words were repeatedly used.`,
      `Certain words were repeatedly used.`,
      `Certain words were repeatedly used.`,
      `Certain words were repeatedly used.`,
    ],
    repetition2: [
      `반복적으로 사용한 단어가 없었어요.`,
      `No words were used repeatedly.`,
      's_caf.highlight.repetition2',
      `No words were used repeatedly.`,
      `No words were used repeatedly.`,
      `No words were used repeatedly.`,
      `No words were used repeatedly.`,
    ],
    msg_grammar: [
      `이번 수업에서는 문법 실수가 없었어요.`,
      `You did not make any grammar mistakes during this lesson.`,
      's_caf.highlight.msg_grammar',
      `You did not make any grammar mistakes during this lesson.`,
      `You did not make any grammar mistakes during this lesson.`,
      `You did not make any grammar mistakes during this lesson.`,
      `You did not make any grammar mistakes during this lesson.`,
    ],
    msg_repetition: [
      `이번 수업에서는 같은 구간에서 3번이상 
반복적으로 사용한 단어가 없었어요.`,
      `No words were used more than 3 times
in the same section during this lesson.`,
      's_caf.highlight.msg_repetition',
      `No words were used more than 3 times
in the same section during this lesson.`,
      `No words were used more than 3 times
in the same section during this lesson.`,
      `No words were used more than 3 times
 in the same section during this lesson.`,
      `No words were used more than 3 times
in the same section during this lesson.`,
    ],
    select: [
      `구간 선정 기준`,
      `Highlighted sections`,
      's_caf.highlight.select',
      `Highlighted sections`,
      `Highlighted sections`,
      `Highlighted sections`,
      `Highlighted sections`,
    ],
    time: [`시간`, `Time`, 's_caf.highlight.time', `Time`, `Time`, `Time`, `Time`],
    viewmore: [`더보기`, `See more`, 's_caf.highlight.viewmore', `See more`, `See more`, `See more`, `See more`],
    report: [
      `오류 제보`,
      `Report error`,
      's_caf.highlight.report',
      `Report error`,
      `Report error`,
      `Report error`,
      `Report error`,
    ],
    modal_repetition: [
      `수업 시간에 학습자가 말한 구간 중, 하나의 구간에서 같은 단어를 3번 이상 반복한 구간이 표시됩니다.`,
      `Shows sections where you used the same word 3 or more times.`,
      's_caf.highlight.modal_repetition',
      `Shows sections where you used the same word 3 or more times.`,
      `Shows sections where you used the same word 3 or more times.`,
      `Shows sections where you used the same word 3 or more times.`,
      `Shows sections where you used the same word 3 or more times.`,
    ],
    modal_grammar_error: [
      `13가지 문법 실수 유형중에 이번 수업에서 가장 빈도가 높았던 3가지 유형을 보여줍니다.`,
      `Shows the top 3 most frequently made grammar mistakes (out of 13 types) you made during this lesson.`,
      's_caf.highlight.modal_grammar_error',
      `Shows the top 3 most frequently made grammar mistakes (out of 13 types) you made during this lesson.`,
      `Shows the top 3 most frequently made grammar mistakes (out of 13 types) you made during this lesson.`,
      `Shows the top 3 most frequently made grammar mistakes (out of 13 types) you made during this lesson.`,
      `Shows the top 3 most frequently made grammar mistakes (out of 13 types) you made during this lesson.`,
    ],
    modal_speech_rate: [
      `수업시간에 학습자가 말한 문장 중 말하기 속도가 부자연스럽게 느렸던 문장(77 wpm 이하)이 표시됩니다. 원어민의 자연스러운 말하기 속도는 120 - 180 wpm 사이 입니다.`,
      `Shows the sentences you spoke unnaturally slowly (under 77 wpm). A native speaker's natural speech rate is between 120 and 180 words per minute.`,
      's_caf.highlight.modal_speech_rate',
      `Shows the sentences you spoke unnaturally slowly (under 77 wpm). A native speaker's natural speech rate is between 120 and 180 words per minute.`,
      `Shows the sentences you spoke unnaturally slowly (under 77 wpm). A native speaker's natural speech rate is between 120 and 180 words per minute.`,
      `Shows the sentences you spoke unnaturally slowly (under 77 wpm). A native speaker's natural speech rate is between 120 and 180 words per minute.`,
      `Shows the sentences you spoke unnaturally slowly (under 77 wpm). A native speaker's natural speech rate is between 120 and 180 words per minute.`,
    ],
    modal_title: [
      `구간 선정 기준`,
      `Highlighted sections`,
      's_caf.highlight.modal_title',
      `Highlighted sections`,
      `Highlighted sections`,
      `Highlighted sections`,
      `Highlighted sections`,
    ],
    okay: [`확인`, `OK`, 's_caf.highlight.okay', `OK`, `OK`, `OK`, `OK`],
    repeat: (count) => [
      `${count}번 반복`,
      `Repeat ${count}`,
      's_caf.highlight.repeat',
      `Repeat ${count}`,
      `Repeat ${count}`,
      `Repeat ${count}`,
      `Repeat ${count}`,
    ],
    graph_sr: [
      `나의 말하기 속도 (wpm)`,
      `My speech rate (wpm)`,
      's_caf.highlight.graph_sr',
      `My speech rate (wpm)`,
      `My speech rate (wpm)`,
      `My speech rate (wpm)`,
      `My speech rate (wpm)`,
    ],
    sr_section: [
      `말하기 속도가 느린 구간`,
      `Slow speech section`,
      's_caf.highlight.sr_section',
      `Slow speech section`,
      `Slow speech section`,
      `Slow speech section`,
      `Slow speech section`,
    ],
    category1: [`불변화사`, `Particle`, 's_caf.highlight.category1', `Particle`, `Particle`, `Particle`, `Particle`],
    category2: [
      `전치사`,
      `Preposition`,
      's_caf.highlight.category2',
      `Preposition`,
      `Preposition`,
      `Preposition`,
      `Preposition`,
    ],
    category3: [
      `동사 형태`,
      `Verb Form`,
      's_caf.highlight.category3',
      `Verb Form`,
      `Verb Form`,
      `Verb Form`,
      `Verb Form`,
    ],
    category4: [
      `명사 수일치`,
      `Noun Number`,
      's_caf.highlight.category4',
      `Noun Number`,
      `Noun Number`,
      `Noun Number`,
      `Noun Number`,
    ],
    category5: [
      `단어 순서`,
      `Word Order`,
      's_caf.highlight.category5',
      `Word Order`,
      `Word Order`,
      `Word Order`,
      `Word Order`,
    ],
    category6: [
      `형태 혼동`,
      `Morphology`,
      's_caf.highlight.category6',
      `Morphology`,
      `Morphology`,
      `Morphology`,
      `Morphology`,
    ],
    ringletip: [
      `Ringle’s Tip`,
      `Ringle’s Tip`,
      's_caf.highlight.ringletip',
      `Ringle’s Tip`,
      `Ringle’s Tip`,
      `Ringle’s Tip`,
      `Ringle’s Tip`,
    ],
    msg_ros: [
      `이번 수업에서는 3개 이상의 독립절이 포함된
길게 이어진 문장이 없었어요.`,
      `There were no run-on sentences with 3 or more
independent clauses in this lesson.`,
      's_caf.highlight.msg_ros',
      `There were no run-on sentences with 3 or more
independent clauses in this lesson.`,
      `There were no run-on sentences with 3 or more
independent clauses in this lesson.`,
      `There were no run-on sentences with 3 or more
 independent clauses in this lesson.`,
      `There were no run-on sentences with 3 or more
independent clauses in this lesson.`,
    ],
    count: [`개`, `on avg.`, 's_caf.highlight.count', `on avg.`, `on avg.`, `on avg.`, `on avg.`],
    msg_speech_rate: [
      `이번 수업에서는 말하기 속도가 
전반적으로 자연스러웠어요.`,
      `Your speech rate was
natural throughout this lesson.`,
      's_caf.highlight.msg_speech_rate',
      `Your speech rate was
natural throughout this lesson.`,
      `Your speech rate was
natural throughout this lesson.`,
      `Your speech rate was
 natural throughout this lesson.`,
      `Your speech rate was
natural throughout this lesson.`,
    ],
    modal_runon: [
      `하나의 문장에 3개 이상의 독립절이 포함된 경우를 Run-on 문장으로 진단합니다.`,
      `A sentence is considered "run-on" if it includes more than 3 independent clauses.`,
      's_caf.highlight.modal_runon',
      `A sentence is considered "run-on" if it includes more than 3 independent clauses.`,
      `A sentence is considered "run-on" if it includes more than 3 independent clauses.`,
      `A sentence is considered "run-on" if it includes more than 3 independent clauses.`,
      `A sentence is considered "run-on" if it includes more than 3 independent clauses.`,
    ],
    category7: [
      `주어동사 수일치`,
      `Subject-Verb Agreement`,
      's_caf.highlight.category7',
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
    ],
    category8: [`형용사`, `Adjective`, 's_caf.highlight.category8', `Adjective`, `Adjective`, `Adjective`, `Adjective`],
    category9: [
      `최상급/비교급`,
      `Superlative/Comparative`,
      's_caf.highlight.category9',
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      `Superlative/Comparative`,
    ],
    category10: [`부사`, `Adverb`, 's_caf.highlight.category10', `Adverb`, `Adverb`, `Adverb`, `Adverb`],
    category11: [
      `가산/불가산 명사`,
      `Noun Inflection`,
      's_caf.highlight.category11',
      `Noun Inflection`,
      `Noun Inflection`,
      `Noun Inflection`,
      `Noun Inflection`,
    ],
    category12: [
      `동사 시제`,
      `Verb Tense`,
      's_caf.highlight.category12',
      `Verb Tense`,
      `Verb Tense`,
      `Verb Tense`,
      `Verb Tense`,
    ],
    category13: [
      `단어 반복`,
      `Word Repetition`,
      's_caf.highlight.category13',
      `Word Repetition`,
      `Word Repetition`,
      `Word Repetition`,
      `Word Repetition`,
    ],
    category14: [
      `Run-on 문장`,
      `Run-on Sentence`,
      's_caf.highlight.category14',
      `Run-on Sentence`,
      `Run-on Sentence`,
      `Run-on Sentence`,
      `Run-on Sentence`,
    ],
    category15: [
      `말하기 속도`,
      `Speech Rate`,
      's_caf.highlight.category15',
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
    ],
    category16: [
      `필러워드`,
      `Filler Words`,
      's_caf.highlight.category16',
      `Filler Words`,
      `Filler Words`,
      `Filler Words`,
      `Filler Words`,
    ],
    correct: {
      grammar0: [
        `한정사| 관련 문법 실수가 없었어요.`,
        `Determiner| No mistakes detected.`,
        's_caf.highlight.correct.grammar0',
        `Determiner| No mistakes detected.`,
        `Determiner| No mistakes detected.`,
        `Determiner| No mistakes detected.`,
        `Determiner| No mistakes detected.`,
      ],
      grammar1: [
        `불변화사| 관련 문법 실수가 없었어요.`,
        `Particle| No mistakes detected.`,
        's_caf.highlight.correct.grammar1',
        `Particle| No mistakes detected.`,
        `Particle| No mistakes detected.`,
        `Particle| No mistakes detected.`,
        `Particle| No mistakes detected.`,
      ],
      grammar2: [
        `전치사| 관련 문법 실수가 없었어요`,
        `Preposition| No mistakes detected.`,
        's_caf.highlight.correct.grammar2',
        `Preposition| No mistakes detected.`,
        `Preposition| No mistakes detected.`,
        `Preposition| No mistakes detected.`,
        `Preposition| No mistakes detected.`,
      ],
      grammar3: [
        `동사 형태| 관련 문법 실수가 없었어요.`,
        `Verb Form| No mistakes detected.`,
        's_caf.highlight.correct.grammar3',
        `Verb Form| No mistakes detected.`,
        `Verb Form| No mistakes detected.`,
        `Verb Form| No mistakes detected.`,
        `Verb Form| No mistakes detected.`,
      ],
      grammar4: [
        `명사 수일치| 관련 문법 실수가 없었어요.`,
        `Noun Number| No mistakes detected.`,
        's_caf.highlight.correct.grammar4',
        `Noun Number| No mistakes detected.`,
        `Noun Number| No mistakes detected.`,
        `Noun Number| No mistakes detected.`,
        `Noun Number| No mistakes detected.`,
      ],
      grammar5: [
        `단어 순서| 관련 문법 실수가 없었어요.`,
        `Word Order| No mistakes detected.`,
        's_caf.highlight.correct.grammar5',
        `Word Order| No mistakes detected.`,
        `Word Order| No mistakes detected.`,
        `Word Order| No mistakes detected.`,
        `Word Order| No mistakes detected.`,
      ],
      grammar6: [
        `형태 혼동| 관련 문법 실수가 없었어요.`,
        `Morphology| No mistakes detected.`,
        's_caf.highlight.correct.grammar6',
        `Morphology| No mistakes detected.`,
        `Morphology| No mistakes detected.`,
        `Morphology| No mistakes detected.`,
        `Morphology| No mistakes detected.`,
      ],
      grammar7: [
        `주어동사 수일치| 관련 문법 실수가 없었어요`,
        `Subject-Verb Agreement| No mistakes detected.`,
        's_caf.highlight.correct.grammar7',
        `Subject-Verb Agreement| No mistakes detected.`,
        `Subject-Verb Agreement| No mistakes detected.`,
        `Subject-Verb Agreement| No mistakes detected.`,
        `Subject-Verb Agreement| No mistakes detected.`,
      ],
      grammar8: [
        `형용사| 관련 문법 실수가 없었어요.`,
        `Adjective| No mistakes detected.`,
        's_caf.highlight.correct.grammar8',
        `Adjective| No mistakes detected.`,
        `Adjective| No mistakes detected.`,
        `Adjective| No mistakes detected.`,
        `Adjective| No mistakes detected.`,
      ],
      grammar9: [
        `최상급/비교급| 관련 문법 실수가 없었어요.`,
        `Superlative/Comparative| No mistakes detected.`,
        's_caf.highlight.correct.grammar9',
        `Superlative/Comparative| No mistakes detected.`,
        `Superlative/Comparative| No mistakes detected.`,
        `Superlative/Comparative| No mistakes detected.`,
        `Superlative/Comparative| No mistakes detected.`,
      ],
      grammar10: [
        `부사| 관련 문법 실수가 없었어요.`,
        `Adverb| No mistakes detected.`,
        's_caf.highlight.correct.grammar10',
        `Adverb| No mistakes detected.`,
        `Adverb| No mistakes detected.`,
        `Adverb| No mistakes detected.`,
        `Adverb| No mistakes detected.`,
      ],
      grammar11: [
        `가산/불가산 명사| 관련 문법 실수가 없었어요.`,
        `Noun Inflection| No mistakes detected.`,
        's_caf.highlight.correct.grammar11',
        `Noun Inflection| No mistakes detected.`,
        `Noun Inflection| No mistakes detected.`,
        `Noun Inflection| No mistakes detected.`,
        `Noun Inflection| No mistakes detected.`,
      ],
      grammar12: [
        `동사 시제| 관련 문법 실수가 없었어요.`,
        `Verb Tense| No mistakes detected.`,
        's_caf.highlight.correct.grammar12',
        `Verb Tense| No mistakes detected.`,
        `Verb Tense| No mistakes detected.`,
        `Verb Tense| No mistakes detected.`,
        `Verb Tense| No mistakes detected.`,
      ],
      grammar13: [
        `반복적으로 사용한 단어|가 없었어요.`,
        `Word Repetition| None detected.`,
        's_caf.highlight.correct.grammar13',
        `Word Repetition| None detected.`,
        `Word Repetition| None detected.`,
        `Word Repetition| None detected.`,
        `Word Repetition| None detected.`,
      ],
      grammar14: [
        `Run-on 문장|이 없었어요.`,
        `Run-on Sentence| None detected.`,
        's_caf.highlight.correct.grammar14',
        `Run-on Sentence| None detected.`,
        `Run-on Sentence| None detected.`,
        `Run-on Sentence| None detected.`,
        `Run-on Sentence| None detected.`,
      ],
      grammar15: [
        `말하기 속도|가 느렸던 구간이 없었어요.`,
        `Speech Rate| No slow speech sections detected.`,
        's_caf.highlight.correct.grammar15',
        `Speech Rate| No slow speech sections detected.`,
        `Speech Rate| No slow speech sections detected.`,
        `Speech Rate| No slow speech sections detected.`,
        `Speech Rate| No slow speech sections detected.`,
      ],
      grammar16: [
        `필러워드| 사용이 많았던 구간이 없었어요.`,
        `Filler Words| No problematic sections detected.`,
        's_caf.highlight.correct.grammar16',
        `Filler Words| No problematic sections detected.`,
        `Filler Words| No problematic sections detected.`,
        `Filler Words| No problematic sections detected.`,
        `Filler Words| No problematic sections detected.`,
      ],
      grammar17: [
        `더 복잡한 문장 구조|를 시도해 볼 수 있는 구간이 없었어요.`,
        `Complex Sentence| No applicable sections.`,
        's_caf.highlight.correct.grammar17',
        `Complex Sentence| No applicable sections.`,
        `Complex Sentence| No applicable sections.`,
        `Complex Sentence| No applicable sections.`,
        `Complex Sentence| No applicable sections.`,
      ],
    },
    error: {
      grammar0: (count) => [
        `한정사| 관련 문법 실수가 ${count}개 있어요.`,
        `Determiner| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar0',
        `Determiner| ${count} mistakes detected.`,
        `Determiner| ${count} mistakes detected.`,
        `Determiner| ${count} mistakes detected.`,
        `Determiner| ${count} mistakes detected.`,
      ],
      grammar1: (count) => [
        `불변화사| 관련 문법 실수가 ${count}개 있어요.`,
        `Particle| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar1',
        `Particle| ${count} mistakes detected.`,
        `Particle| ${count} mistakes detected.`,
        `Particle| ${count} mistakes detected.`,
        `Particle| ${count} mistakes detected.`,
      ],
      grammar2: (count) => [
        `전치사| 관련 문법 실수가 ${count}개 있어요.`,
        `Preposition| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar2',
        `Preposition| ${count} mistakes detected.`,
        `Preposition| ${count} mistakes detected.`,
        `Preposition| ${count} mistakes detected.`,
        `Preposition| ${count} mistakes detected.`,
      ],
      grammar3: (count) => [
        `동사 형태| 관련 문법 실수가 ${count}개 있어요.`,
        `Verb Form| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar3',
        `Verb Form| ${count} mistakes detected.`,
        `Verb Form| ${count} mistakes detected.`,
        `Verb Form| ${count} mistakes detected.`,
        `Verb Form| ${count} mistakes detected.`,
      ],
      grammar4: (count) => [
        `명사 수일치| 관련 문법 실수가 ${count}개 있어요.`,
        `Noun Number| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar4',
        `Noun Number| ${count} mistakes detected.`,
        `Noun Number| ${count} mistakes detected.`,
        `Noun Number| ${count} mistakes detected.`,
        `Noun Number| ${count} mistakes detected.`,
      ],
      grammar5: (count) => [
        `단어 순서| 관련 문법 실수가 ${count}개 있어요.`,
        `Word Order| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar5',
        `Word Order| ${count} mistakes detected.`,
        `Word Order| ${count} mistakes detected.`,
        `Word Order| ${count} mistakes detected.`,
        `Word Order| ${count} mistakes detected.`,
      ],
      grammar6: (count) => [
        `형태 혼동| 관련 문법 실수가 ${count}개 있어요.`,
        `Morphology| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar6',
        `Morphology| ${count} mistakes detected.`,
        `Morphology| ${count} mistakes detected.`,
        `Morphology| ${count} mistakes detected.`,
        `Morphology| ${count} mistakes detected.`,
      ],
      grammar7: (count) => [
        `주어동사 수일치| 관련 문법 실수가 ${count}개 있어요.`,
        `Subject-Verb Agreement| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar7',
        `Subject-Verb Agreement| ${count} mistakes detected.`,
        `Subject-Verb Agreement| ${count} mistakes detected.`,
        `Subject-Verb Agreement| ${count} mistakes detected.`,
        `Subject-Verb Agreement| ${count} mistakes detected.`,
      ],
      grammar8: (count) => [
        `형용사| 관련 문법 실수가 ${count}개 있어요.`,
        `Adjective| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar8',
        `Adjective| ${count} mistakes detected.`,
        `Adjective| ${count} mistakes detected.`,
        `Adjective| ${count} mistakes detected.`,
        `Adjective| ${count} mistakes detected.`,
      ],
      grammar9: (count) => [
        `최상급/비교급| 관련 문법 실수가 ${count}개 있어요.`,
        `Superlative/Comparative| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar9',
        `Superlative/Comparative| ${count} mistakes detected.`,
        `Superlative/Comparative| ${count} mistakes detected.`,
        `Superlative/Comparative| ${count} mistakes detected.`,
        `Superlative/Comparative| ${count} mistakes detected.`,
      ],
      grammar10: (count) => [
        `부사| 관련 문법 실수가 ${count}개 있어요.`,
        `Adverb| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar10',
        `Adverb| ${count} mistakes detected.`,
        `Adverb| ${count} mistakes detected.`,
        `Adverb| ${count} mistakes detected.`,
        `Adverb| ${count} mistakes detected.`,
      ],
      grammar11: (count) => [
        `가산/불가산 명사| 관련 문법 실수가 ${count}개 있어요.`,
        `Noun Inflection| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar11',
        `Noun Inflection| ${count} mistakes detected.`,
        `Noun Inflection| ${count} mistakes detected.`,
        `Noun Inflection| ${count} mistakes detected.`,
        `Noun Inflection| ${count} mistakes detected.`,
      ],
      grammar12: (count) => [
        `동사 시제| 관련 문법 실수가 ${count}개 있어요.`,
        `Verb Tense| ${count} mistakes detected.`,
        's_caf.highlight.error.grammar12',
        `Verb Tense| ${count} mistakes detected.`,
        `Verb Tense| ${count} mistakes detected.`,
        `Verb Tense| ${count} mistakes detected.`,
        `Verb Tense| ${count} mistakes detected.`,
      ],
      grammar13: (count) => [
        `반복적으로 사용한 단어|가 ${count}개 있어요.`,
        `Word Repetition| ${count} detected.`,
        's_caf.highlight.error.grammar13',
        `Word Repetition| ${count} detected.`,
        `Word Repetition| ${count} detected.`,
        `Word Repetition| ${count} detected.`,
        `Word Repetition| ${count} detected.`,
      ],
      grammar14: (count) => [
        `Run-on 문장|이 ${count}개 있어요.`,
        `Run-on Sentence| ${count} detected.`,
        's_caf.highlight.error.grammar14',
        `Run-on Sentence| ${count} detected.`,
        `Run-on Sentence| ${count} detected.`,
        `Run-on Sentence| ${count} detected.`,
        `Run-on Sentence| ${count} detected.`,
      ],
      grammar15: (count) => [
        `말하기 속도|가 느렸던 구간이 ${count}개 있어요.`,
        `Speech Rate| ${count} slow speech sections detected.`,
        's_caf.highlight.error.grammar15',
        `Speech Rate| ${count} slow speech sections detected.`,
        `Speech Rate| ${count} slow speech sections detected.`,
        `Speech Rate| ${count} slow speech sections detected.`,
        `Speech Rate| ${count} slow speech sections detected.`,
      ],
      grammar16: (count) => [
        `필러워드| 사용이 많았던 구간이 ${count}개 있어요.`,
        `Filler Words| ${count} problematic sections detected.`,
        's_caf.highlight.error.grammar16',
        `Filler Words| ${count} problematic sections detected.`,
        `Filler Words| ${count} problematic sections detected.`,
        `Filler Words| ${count} problematic sections detected.`,
        `Filler Words| ${count} problematic sections detected.`,
      ],
      grammar17: (count) => [
        `더 복잡한 문장 구조|를 시도해 볼 수 있는 구간이 ${count}개 있어요.`,
        `Complex Sentence| ${count} applicable sections.`,
        's_caf.highlight.error.grammar17',
        `Complex Sentence| ${count} applicable sections.`,
        `Complex Sentence| ${count} applicable sections.`,
        `Complex Sentence| ${count} applicable sections.`,
        `Complex Sentence| ${count} applicable sections.`,
      ],
    },
    msg_filler: [
      `이번 수업에서는 
필러워드 사용 빈도가 적절했어요.`,
      `You used filler words
appropriately during this lesson.`,
      's_caf.highlight.msg_filler',
      `You used filler words
appropriately during this lesson.`,
      `You used filler words
appropriately during this lesson.`,
      `You used filler words
 appropriately during this lesson.`,
      `You used filler words
appropriately during this lesson.`,
    ],
    filler_length: [
      `평균 filler words 길이`,
      `Avg. filler word length`,
      's_caf.highlight.filler_length',
      `Avg. filler word length`,
      `Avg. filler word length`,
      `Avg. filler word length`,
      `Avg. filler word length`,
    ],
    ai_paraphrase: [
      `AI 교정 보기`,
      `AI Proofreading`,
      's_caf.highlight.ai_paraphrase',
      `AI Proofreading`,
      `AI Proofreading`,
      `AI Proofreading`,
      `AI Proofreading`,
    ],
    ai_phrase: [
      `AI 교정`,
      `AI Proofreading`,
      's_caf.highlight.ai_phrase',
      `AI Proofreading`,
      `AI Proofreading`,
      `AI Proofreading`,
      `AI Proofreading`,
    ],
    ai_loading: [
      <>
        열심히 교정을 생성하고 있어요.
        <br />
        잠시만 기다려주세요.
      </>,
      <>
        Proofreading is in process.
        <br />
        Please wait a moment.
      </>,
      's_caf.highlight.ai_loading',
      <>
        Proofreading is in process.
        <br />
        Please wait a moment.
      </>,
      <>
        Proofreading is in process.
        <br />
        Please wait a moment.
      </>,
      <>
        Proofreading is in process.
        <br />
        Please wait a moment.
      </>,
      <>
        Proofreading is in process.
        <br />
        Please wait a moment.
      </>,
    ],
    ai_error: [
      `오류가 발생했습니다.`,
      `An error has occurred.`,
      's_caf.highlight.ai_error',
      `An error has occurred.`,
      `An error has occurred.`,
      `An error has occurred.`,
      `An error has occurred.`,
    ],
    ai_tryagain: [
      `다시 시도하기`,
      `Try again`,
      's_caf.highlight.ai_tryagain',
      `Try again`,
      `Try again`,
      `Try again`,
      `Try again`,
    ],
    modal_filler_word: [
      `Um, uh와 같이 특정한 의미를 전달하지 않는 필러워드 사용으로 인해 발화의 진행에 부정적인 영향을 미친다고 판단되는 구간을 선정합니다.`,
      `Sections where the use of filler words (such as "um" and "uh" that have no specific meaning) negatively affected your speech are detected.`,
      's_caf.highlight.modal_filler_word',
      `Sections where the use of filler words (such as "um" and "uh" that have no specific meaning) negatively affected your speech are detected.`,
      `Sections where the use of filler words (such as "um" and "uh" that have no specific meaning) negatively affected your speech are detected.`,
      `Sections where the use of filler words (such as "um" and "uh" that have no specific meaning) negatively affected your speech are detected.`,
      `Sections where the use of filler words (such as "um" and "uh" that have no specific meaning) negatively affected your speech are detected.`,
    ],
    grammar_category: [
      `문법 실수`,
      `Grammar mistakes`,
      's_caf.highlight.grammar_category',
      `Grammar mistakes`,
      `Grammar mistakes`,
      `Grammar mistakes`,
      `Grammar mistakes`,
    ],
    category0: [
      `한정사`,
      `Determiner`,
      's_caf.highlight.category0',
      `Determiner`,
      `Determiner`,
      `Determiner`,
      `Determiner`,
    ],
    min: [`분`, `min`, 's_caf.highlight.min', `min`, `min`, `min`, `min`],
    sec: [`초`, `sec`, 's_caf.highlight.sec', `sec`, `sec`, `sec`, `sec`],
    fraction_counts: (detail_count, total_count) => [
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}개
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}
      </>,
      's_caf.highlight.fraction_counts',
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}
      </>,
    ],
    category17: [
      `문장 구조`,
      `Sentence structure`,
      's_caf.highlight.category17',
      `Sentence structure`,
      `Sentence structure`,
      `Sentence structure`,
      `Sentence structure`,
    ],
    msg_simpletocomplex: [
      <>
        이번 수업에서는 더 복잡한 문장 구조를 <br />
        시도해 볼 수 있는 구간을 찾지 못했어요.{' '}
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      's_caf.highlight.msg_simpletocomplex',
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
    ],
    modal_sentence_structure: [
      `수업시간에 학습자가 말한 구간 중 하나의 구간 내에서 연속해서 단문을 사용하거나 중문을 사용한 구간 중 더 복잡한 문장 구조를 사용할 수 있는 구간이 표시됩니다.`,
      `Shows where you used simple sentences consecutively in a section or the sections where compound sentences could be changed to complex ones.`,
      's_caf.highlight.modal_sentence_structure',
      `Shows where you used simple sentences consecutively in a section or the sections where compound sentences could be changed to complex ones.`,
      `Shows where you used simple sentences consecutively in a section or the sections where compound sentences could be changed to complex ones.`,
      `Shows where you used simple sentences consecutively in a section or the sections where compound sentences could be changed to complex ones.`,
      `Shows where you used simple sentences consecutively in a section or the sections where compound sentences could be changed to complex ones.`,
    ],
    report_sentence: [
      `선택된 문장`,
      `Selected Sentence`,
      's_caf.highlight.report_sentence',
      `Selected Sentence`,
      `Selected Sentence`,
      `Selected Sentence`,
      `Selected Sentence`,
    ],
    report_content: [
      `리포팅 내용을 입력해주세요.`,
      `Please input the details.`,
      's_caf.highlight.report_content',
      `Please input the details.`,
      `Please input the details.`,
      `Please input the details.`,
      `Please input the details.`,
    ],
    msg_sentence_structure: [
      <>
        이번 수업에서는 더 복잡한 문장 구조를 <br />
        시도해 볼 수 있는 구간을 찾지 못했어요.{' '}
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      's_caf.highlight.msg_sentence_structure',
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
    ],
  },
  complexity: {
    default: [
      `Complexity`,
      `Complexity`,
      's_caf.complexity.default',
      `Complexity`,
      `Complexity`,
      `Complexity`,
      `Complexity`,
    ],
    level_score: [`Level`, `Level`, 's_caf.complexity.level_score', `Level`, `Level`, `Level`, `Level`],
    percent: (percent) => [
      `상위 ${percent}%`,
      `Upper ${percent}% / Top`,
      's_caf.complexity.percent',
      `Upper ${percent}% / Top`,
      `Upper ${percent}% / Top`,
      `Upper ${percent}% / Top`,
      `Upper ${percent}% / Top`,
    ],
    level_detail: [
      `9가지 중 하나!`,
      `Out of 9 types!`,
      's_caf.complexity.level_detail',
      `Out of 9 types!`,
      `Out of 9 types!`,
      `Out of 9 types!`,
      `Out of 9 types!`,
    ],
    tab1: [
      `어휘 난이도`,
      `Vocabulary level`,
      's_caf.complexity.tab1',
      `Vocabulary level`,
      `Vocabulary level`,
      `Vocabulary level`,
      `Vocabulary level`,
    ],
    tab2: [
      `문장 구조`,
      `Sentence structure`,
      's_caf.complexity.tab2',
      `Sentence structure`,
      `Sentence structure`,
      `Sentence structure`,
      `Sentence structure`,
    ],
    tab3: [
      `어휘 다양성`,
      `Lexical diversity`,
      's_caf.complexity.tab3',
      `Lexical diversity`,
      `Lexical diversity`,
      `Lexical diversity`,
      `Lexical diversity`,
    ],
    graph_name1: [
      `어휘 사용률`,
      `Word usage rate`,
      's_caf.complexity.graph_name1',
      `Word usage rate`,
      `Word usage rate`,
      `Word usage rate`,
      `Word usage rate`,
    ],
    graph_name2: [
      `문장 사용률`,
      `Sentence usage rate`,
      's_caf.complexity.graph_name2',
      `Sentence usage rate`,
      `Sentence usage rate`,
      `Sentence usage rate`,
      `Sentence usage rate`,
    ],
    highlights: [
      `Complexity 관련 학습 영역`,
      `Areas related to Complexity`,
      's_caf.complexity.highlights',
      `Areas related to Complexity`,
      `Areas related to Complexity`,
      `Areas related to Complexity`,
      `Areas related to Complexity`,
    ],
    highlights_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      's_caf.complexity.highlights_detail',
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
    ],
    vocab_info: [
      `최대 15개의 단어가 표시됩니다.`,
      `Shows the top 15 most frequently used words.`,
      's_caf.complexity.vocab_info',
      `Shows the top 15 most frequently used words.`,
      `Shows the top 15 most frequently used words.`,
      `Shows the top 15 most frequently used words.`,
      `Shows the top 15 most frequently used words.`,
    ],
    vocab_info1: (count) => [
      `총 ${count} 단어가 표시됩니다.`,
      `Shows a total of ${count} words.`,
      's_caf.complexity.vocab_info1',
      `Shows a total of ${count} words.`,
      `Shows a total of ${count} words.`,
      `Shows a total of ${count} words.`,
      `Shows a total of ${count} words.`,
    ],
    viewmore_btn: [
      `더보기`,
      `See more`,
      's_caf.complexity.viewmore_btn',
      `See more`,
      `See more`,
      `See more`,
      `See more`,
    ],
    subsection_info: (count) => [
      <span>
        총 <span className="text-primary">{count}</span>개의 단어
      </span>,
      <span>
        A total of <span className="text-primary">{count}</span> words{' '}
      </span>,
      's_caf.complexity.subsection_info',
      <span>
        A total of <span className="text-primary">{count}</span> words{' '}
      </span>,
      <span>
        A total of <span className="text-primary">{count}</span> words{' '}
      </span>,
      <span>
        A total of <span className="text-primary">{count}</span> words{' '}
      </span>,
      <span>
        A total of <span className="text-primary">{count}</span> words{' '}
      </span>,
    ],
    sentence_info: [
      `최대 5개의 문장이 표시됩니다.`,
      `Shows up to 5 sentences.`,
      's_caf.complexity.sentence_info',
      `Shows up to 5 sentences.`,
      `Shows up to 5 sentences.`,
      `Shows up to 5 sentences.`,
      `Shows up to 5 sentences.`,
    ],
    subsection_info2: (count) => [
      `총 ${count}개의 문장`,
      `A total of ${count} sentences`,
      's_caf.complexity.subsection_info2',
      `A total of ${count} sentences`,
      `A total of ${count} sentences`,
      `A total of ${count} sentences`,
      `A total of ${count} sentences`,
    ],
    sentence_info1: (count) => [
      `총 ${count}개의 문장이 표시됩니다.`,
      `Shows a total of ${count} sentences.`,
      's_caf.complexity.sentence_info1',
      `Shows a total of ${count} sentences.`,
      `Shows a total of ${count} sentences.`,
      `Shows a total of ${count} sentences.`,
      `Shows a total of ${count} sentences.`,
    ],
    mtld: [
      `Measure of Textual Lexical Diversity (MTLD)`,
      `Measure of Textual Lexical Diversity (MTLD)`,
      's_caf.complexity.mtld',
      `Measure of Textual Lexical Diversity (MTLD)`,
      `Measure of Textual Lexical Diversity (MTLD)`,
      `Measure of Textual Lexical Diversity (MTLD)`,
      `Measure of Textual Lexical Diversity (MTLD)`,
    ],
    my_mtld: [
      `이번 수업`,
      `This lesson`,
      's_caf.complexity.my_mtld',
      `This lesson`,
      `This lesson`,
      `This lesson`,
      `This lesson`,
    ],
    percent_mtld: [
      `상위 25% 평균`,
      `Top 25%`,
      's_caf.complexity.percent_mtld',
      `Top 25%`,
      `Top 25%`,
      `Top 25%`,
      `Top 25%`,
    ],
    tutor_mtld: [
      `원어민 평균`,
      `Native Speakers`,
      's_caf.complexity.tutor_mtld',
      `Native Speakers`,
      `Native Speakers`,
      `Native Speakers`,
      `Native Speakers`,
    ],
    mtld_modal_title: [
      `어휘 다양성`,
      `Lexical diversity`,
      's_caf.complexity.mtld_modal_title',
      `Lexical diversity`,
      `Lexical diversity`,
      `Lexical diversity`,
      `Lexical diversity`,
    ],
    mtld_modal_body: [
      `어휘 다양성을 보여주는 Measure of Textual Lexical Diversity (MTLD) 을 측정한 지표입니다. 
MTLD란, TTR 값(Type-token ratio: 전체 단어 개수에 대한 중복을 제외한 단어 개수의 비율)을 특정 기준이상으로 유지하며 말 할 수 있는 단어 개수의 평균입니다.`,
      `Indicator measuring the Measure of Textual Lexical Diversity (MTLD), which shows the diversity of your vocabulary. MTLD is measured as the avg. number of words you speak while maintaining TTR above a certain level. (Type-token ratio (TTR): the total number of unique words divided by the total number of words)`,
      's_caf.complexity.mtld_modal_body',
      `Indicator measuring the Measure of Textual Lexical Diversity (MTLD), which shows the diversity of your vocabulary. MTLD is measured as the avg. number of words you speak while maintaining TTR above a certain level. (Type-token ratio (TTR): the total number of unique words divided by the total number of words)`,
      `Indicator measuring the Measure of Textual Lexical Diversity (MTLD), which shows the diversity of your vocabulary. MTLD is measured as the avg. number of words you speak while maintaining TTR above a certain level. (Type-token ratio (TTR): the total number of unique words divided by the total number of words)`,
      `Indicator measuring the Measure of Textual Lexical Diversity (MTLD), which shows the diversity of your vocabulary. MTLD is measured as the avg. number of words you speak while maintaining TTR above a certain level. (Type-token ratio (TTR): the total number of unique words divided by the total number of words)`,
      `Indicator measuring the Measure of Textual Lexical Diversity (MTLD), which shows the diversity of your vocabulary. MTLD is measured as the avg. number of words you speak while maintaining TTR above a certain level. (Type-token ratio (TTR): the total number of unique words divided by the total number of words)`,
    ],
    mtld_modal_btn: [`확인`, `OK`, 's_caf.complexity.mtld_modal_btn', `OK`, `OK`, `OK`, `OK`],
    vocab_detail: [
      `*어휘 유형은 CEFR 척도를 기반으로 분류되었습니다.`,
      `*Vocabulary types are classified based on the CEFR's English Vocabulary Profile.`,
      's_caf.complexity.vocab_detail',
      `*Vocabulary types are classified based on the CEFR's English Vocabulary Profile.`,
      `*Vocabulary types are classified based on the CEFR's English Vocabulary Profile.`,
      `*Vocabulary types are classified based on the CEFR's English Vocabulary Profile.`,
      `*Vocabulary types are classified based on the CEFR's English Vocabulary Profile.`,
    ],
    pos: {
      adjective: [
        `형용사`,
        `Adjective`,
        's_caf.complexity.pos.adjective',
        `Adjective`,
        `Adjective`,
        `Adjective`,
        `Adjective`,
      ],
      adverb: [`부사`, `Adverb`, 's_caf.complexity.pos.adverb', `Adverb`, `Adverb`, `Adverb`, `Adverb`],
      conjunction: [
        `접속사`,
        `Conjunction`,
        's_caf.complexity.pos.conjunction',
        `Conjunction`,
        `Conjunction`,
        `Conjunction`,
        `Conjunction`,
      ],
      determiner: [
        `한정사`,
        `Determiner`,
        's_caf.complexity.pos.determiner',
        `Determiner`,
        `Determiner`,
        `Determiner`,
        `Determiner`,
      ],
      noun: [`명사`, `Noun`, 's_caf.complexity.pos.noun', `Noun`, `Noun`, `Noun`, `Noun`],
      numeral: [`수사`, `Numeral`, 's_caf.complexity.pos.numeral', `Numeral`, `Numeral`, `Numeral`, `Numeral`],
      particle: [
        `불변화사`,
        `Particle`,
        's_caf.complexity.pos.particle',
        `Particle`,
        `Particle`,
        `Particle`,
        `Particle`,
      ],
      pronoun: [`대명사`, `Pronoun`, 's_caf.complexity.pos.pronoun', `Pronoun`, `Pronoun`, `Pronoun`, `Pronoun`],
      verb: [`동사`, `Verb`, 's_caf.complexity.pos.verb', `Verb`, `Verb`, `Verb`, `Verb`],
      auxiliary: [
        `조동사`,
        `Auxiliary Verb`,
        's_caf.complexity.pos.auxiliary',
        `Auxiliary Verb`,
        `Auxiliary Verb`,
        `Auxiliary Verb`,
        `Auxiliary Verb`,
      ],
    },
    caf_level9: [
      `9 레벨을 받은 대부분 사람은 모든 주제에 대해 유연하고 정확한 어휘를 사용하며 관용적인 표현을 자연스럽게 사용합니다.`,
      `Lv. 9 denotes that you use flexible and precise vocabulary for all topics and apply idiomatic expressions suitably.`,
      's_caf.complexity.caf_level9',
      `Lv. 9 denotes that you use flexible and precise vocabulary for all topics and apply idiomatic expressions suitably.`,
      `Lv. 9 denotes that you use flexible and precise vocabulary for all topics and apply idiomatic expressions suitably.`,
      `Lv. 9 denotes that you use flexible and precise vocabulary for all topics and apply idiomatic expressions suitably.`,
      `Lv. 9 denotes that you use flexible and precise vocabulary for all topics and apply idiomatic expressions suitably.`,
    ],
    caf_level8: [
      `8 레벨을 받은 대부분 사람은 다양한 단어를 쉽고 유연하게 사용하여 정확한 의미를 전달합니다. 고급 어휘를 능숙하게 사용하지만, 가끔 부정확할 수 있습니다.`,
      `Lv. 8 denotes that you use a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
      's_caf.complexity.caf_level8',
      `Lv. 8 denotes that you use a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
      `Lv. 8 denotes that you use a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
      `Lv. 8 denotes that you use a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
      `Lv. 8 denotes that you use a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
    ],
    caf_level7: [
      `7 레벨을 받은 대부분 사람은 다양한 주제를 논의하기 위해 유연하게 어휘를 사용합니다. 몇몇 고급 어휘를 사용할 수 있고 반복되는 단어를 대체할 수 있습니다.`,
      `Lv. 7 denotes that you employ vocabulary flexibly when discussing different topics, including some advanced vocabulary, and know how to substitute repetitive words.`,
      's_caf.complexity.caf_level7',
      `Lv. 7 denotes that you employ vocabulary flexibly when discussing different topics, including some advanced vocabulary, and know how to substitute repetitive words.`,
      `Lv. 7 denotes that you employ vocabulary flexibly when discussing different topics, including some advanced vocabulary, and know how to substitute repetitive words.`,
      `Lv. 7 denotes that you employ vocabulary flexibly when discussing different topics, including some advanced vocabulary, and know how to substitute repetitive words.`,
      `Lv. 7 denotes that you employ vocabulary flexibly when discussing different topics, including some advanced vocabulary, and know how to substitute repetitive words.`,
    ],
    caf_level6: [
      `6 레벨을 받은 대부분 사람은 대부분의 주제에 대해 명확하고 충분한 어휘력으로 의사소통할 수 있습니다. 하지만 때로는 부적절한 선택이 있을 수 있습니다.`,
      `Lv. 6 denotes that you can communicate precisely on most topics using sufficient vocabulary, but your word choice can be inappropriate at times.`,
      's_caf.complexity.caf_level6',
      `Lv. 6 denotes that you can communicate precisely on most topics using sufficient vocabulary, but your word choice can be inappropriate at times.`,
      `Lv. 6 denotes that you can communicate precisely on most topics using sufficient vocabulary, but your word choice can be inappropriate at times.`,
      `Lv. 6 denotes that you can communicate precisely on most topics using sufficient vocabulary, but your word choice can be inappropriate at times.`,
      `Lv. 6 denotes that you can communicate precisely on most topics using sufficient vocabulary, but your word choice can be inappropriate at times.`,
    ],
    caf_level5: [
      `5 레벨을 받은 대부분 사람은 익숙하지 않은 주제에 관해서도 이야기할 수 있지만, 제한된 어휘를 사용합니다.`,
      `Lv. 5 denotes that you can converse freely even on unfamiliar topics but with a limited vocabulary.`,
      's_caf.complexity.caf_level5',
      `Lv. 5 denotes that you can converse freely even on unfamiliar topics but with a limited vocabulary.`,
      `Lv. 5 denotes that you can converse freely even on unfamiliar topics but with a limited vocabulary.`,
      `Lv. 5 denotes that you can converse freely even on unfamiliar topics but with a limited vocabulary.`,
      `Lv. 5 denotes that you can converse freely even on unfamiliar topics but with a limited vocabulary.`,
    ],
    caf_level4: [
      `4 레벨을 받은 대부분 사람은 익숙한 주제에 대해 잘 논의할 수 있지만, 익숙하지 않은 주제일 경우 기본적인 의미만 전달하며, 단어 선택에 실수가 있을 수 있습니다.`,
      `Lv. 4 denotes that you can discuss familiar topics well but are able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
      's_caf.complexity.caf_level4',
      `Lv. 4 denotes that you can discuss familiar topics well but are able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
      `Lv. 4 denotes that you can discuss familiar topics well but are able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
      `Lv. 4 denotes that you can discuss familiar topics well but are able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
      `Lv. 4 denotes that you can discuss familiar topics well but are able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
    ],
    caf_level3: [
      `3 레벨을 받은 대부분 사람은 개인적인 정보를 전달하기 위해 간단한 단어를 사용하며, 덜 친숙한 주제에 대해서는 적절한 어휘 선택에 어려움이 있을 수 있습니다.`,
      `Lv. 3 denotes that you use simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
      's_caf.complexity.caf_level3',
      `Lv. 3 denotes that you use simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
      `Lv. 3 denotes that you use simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
      `Lv. 3 denotes that you use simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
      `Lv. 3 denotes that you use simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
    ],
    caf_level2: [
      `2 레벨을 받은 대부분 사람은 제한된 단어만 사용하며, 기억한 단어에 의존합니다.`,
      `Lv. 2 denotes that you use only a limited number of words, relying on words you memorized.`,
      's_caf.complexity.caf_level2',
      `Lv. 2 denotes that you use only a limited number of words, relying on words you memorized.`,
      `Lv. 2 denotes that you use only a limited number of words, relying on words you memorized.`,
      `Lv. 2 denotes that you use only a limited number of words, relying on words you memorized.`,
      `Lv. 2 denotes that you use only a limited number of words, relying on words you memorized.`,
    ],
    caf_level1: [
      `1 레벨을 받은 대부분 사람은 제한된 몇 가지 단어만 사용합니다.`,
      `Lv. 1 denotes that you only use a limited number of words.`,
      's_caf.complexity.caf_level1',
      `Lv. 1 denotes that you only use a limited number of words.`,
      `Lv. 1 denotes that you only use a limited number of words.`,
      `Lv. 1 denotes that you only use a limited number of words.`,
      `Lv. 1 denotes that you only use a limited number of words.`,
    ],
    metric: [
      `이번 수업의 Complexity`,
      `This Lesson's Complexity`,
      's_caf.complexity.metric',
      `This Lesson's Complexity`,
      `This Lesson's Complexity`,
      `This Lesson's Complexity`,
      `This Lesson's Complexity`,
    ],
    vocab_advanced: [
      `고급 (Advanced)`,
      `Advanced (A)`,
      's_caf.complexity.vocab_advanced',
      `Advanced (A)`,
      `Advanced (A)`,
      `Advanced (A)`,
      `Advanced (A)`,
    ],
    vocab_high: [
      `중고급 (High Intermediate)`,
      `High Intermediate (HI)`,
      's_caf.complexity.vocab_high',
      `High Intermediate (HI)`,
      `High Intermediate (HI)`,
      `High Intermediate (HI)`,
      `High Intermediate (HI)`,
    ],
    vocab_inter: [
      `중급 (Intermediate)`,
      `Intermediate (I)`,
      's_caf.complexity.vocab_inter',
      `Intermediate (I)`,
      `Intermediate (I)`,
      `Intermediate (I)`,
      `Intermediate (I)`,
    ],
    vocab_low: [
      `중하급 (Low Intermediate)`,
      `Low Intermediate (LI)`,
      's_caf.complexity.vocab_low',
      `Low Intermediate (LI)`,
      `Low Intermediate (LI)`,
      `Low Intermediate (LI)`,
      `Low Intermediate (LI)`,
    ],
    vocab_beginner: [
      `초급 (Beginner)`,
      `Beginner (B)`,
      's_caf.complexity.vocab_beginner',
      `Beginner (B)`,
      `Beginner (B)`,
      `Beginner (B)`,
      `Beginner (B)`,
    ],
    graph_advanced: [`고급`, `A`, 's_caf.complexity.graph_advanced', `A`, `A`, `A`, `A`],
    graph_high: [`중고급`, `HI`, 's_caf.complexity.graph_high', `HI`, `HI`, `HI`, `HI`],
    graph_inter: [`중급`, `I`, 's_caf.complexity.graph_inter', `I`, `I`, `I`, `I`],
    graph_low: [`중하급`, `LI`, 's_caf.complexity.graph_low', `LI`, `LI`, `LI`, `LI`],
    graph_beginner: [`초급`, `B`, 's_caf.complexity.graph_beginner', `B`, `B`, `B`, `B`],
    sentence_cc: [
      `혼합문 (Compound-complex)`,
      `Compound-complex (CC)`,
      's_caf.complexity.sentence_cc',
      `Compound-complex (CC)`,
      `Compound-complex (CC)`,
      `Compound-complex (CC)`,
      `Compound-complex (CC)`,
    ],
    sentence_complex: [
      `복문 (Complex)`,
      `Complex (CX)`,
      's_caf.complexity.sentence_complex',
      `Complex (CX)`,
      `Complex (CX)`,
      `Complex (CX)`,
      `Complex (CX)`,
    ],
    sentence_compound: [
      `중문 (Compound)`,
      `Compound (CD)`,
      's_caf.complexity.sentence_compound',
      `Compound (CD)`,
      `Compound (CD)`,
      `Compound (CD)`,
      `Compound (CD)`,
    ],
    sentence_simple: [
      `단문 (Simple)`,
      `Simple (S)`,
      's_caf.complexity.sentence_simple',
      `Simple (S)`,
      `Simple (S)`,
      `Simple (S)`,
      `Simple (S)`,
    ],
    sentence_other: [
      `비문 (Not a Sentence)`,
      `Not a Sentence (NaS)`,
      's_caf.complexity.sentence_other',
      `Not a Sentence (NaS)`,
      `Not a Sentence (NaS)`,
      `Not a Sentence (NaS)`,
      `Not a Sentence (NaS)`,
    ],
    graph_cc: [`혼합문`, `CC`, 's_caf.complexity.graph_cc', `CC`, `CC`, `CC`, `CC`],
    graph_complex: [`복문`, `CX`, 's_caf.complexity.graph_complex', `CX`, `CX`, `CX`, `CX`],
    graph_compound: [`중문`, `CD`, 's_caf.complexity.graph_compound', `CD`, `CD`, `CD`, `CD`],
    graph_simple: [`단문`, `S`, 's_caf.complexity.graph_simple', `S`, `S`, `S`, `S`],
    graph_other: [`비문`, `NaS`, 's_caf.complexity.graph_other', `NaS`, `NaS`, `NaS`, `NaS`],
    top25: [`상위 25%`, `Top 25%`, 's_caf.complexity.top25', `Top 25%`, `Top 25%`, `Top 25%`, `Top 25%`],
    native: [
      `원어민`,
      `Native speaker`,
      's_caf.complexity.native',
      `Native speaker`,
      `Native speaker`,
      `Native speaker`,
      `Native speaker`,
    ],
  },
  accuracy: {
    default: [`Accuracy`, `Accuracy`, 's_caf.accuracy.default', `Accuracy`, `Accuracy`, `Accuracy`, `Accuracy`],
    level_score: [`Level`, `Level`, 's_caf.accuracy.level_score', `Level`, `Level`, `Level`, `Level`],
    percent: (percent) => [
      `상위 ${percent}%`,
      `Top ${percent}%`,
      's_caf.accuracy.percent',
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
    ],
    level_detail: [
      `9가지 중 하나!`,
      `Out of 9 types!`,
      's_caf.accuracy.level_detail',
      `Out of 9 types!`,
      `Out of 9 types!`,
      `Out of 9 types!`,
      `Out of 9 types!`,
    ],
    my_epc: [`나의 EPC`, `My EPC`, 's_caf.accuracy.my_epc', `My EPC`, `My EPC`, `My EPC`, `My EPC`],
    top_25_epc: [`상위 25% EPC`, `Top 25%`, 's_caf.accuracy.top_25_epc', `Top 25%`, `Top 25%`, `Top 25%`, `Top 25%`],
    tutor_epc: [
      `원어민 EPC`,
      `Native speaker`,
      's_caf.accuracy.tutor_epc',
      `Native speaker`,
      `Native speaker`,
      `Native speaker`,
      `Native speaker`,
    ],
    modal_title: [`EPC`, `EPC`, 's_caf.accuracy.modal_title', `EPC`, `EPC`, `EPC`, `EPC`],
    modal_body: [
      `EPC (Error Per Clause): 문장의 문법적 오류 빈도
한 절에 오류가 하나일때 EPC는 1.0입니다.`,
      `Error Per Clause (EPC): Frequency of grammar mistakes in a sentence
EPC is 1.0 when one mistake was made per clause.`,
      's_caf.accuracy.modal_body',
      `Error Per Clause (EPC): Frequency of grammar mistakes in a sentence
EPC is 1.0 when one mistake was made per clause.`,
      `Error Per Clause (EPC): Frequency of grammar mistakes in a sentence
EPC is 1.0 when one mistake was made per clause.`,
      `Error Per Clause (EPC): Frequency of grammar mistakes in a sentence
EPC is 1.0 when one mistake was made per clause.`,
      `Error Per Clause (EPC): Frequency of grammar mistakes in a sentence
EPC is 1.0 when one mistake was made per clause.`,
    ],
    modal_btn: [`확인`, `OK`, 's_caf.accuracy.modal_btn', `OK`, `OK`, `OK`, `OK`],
    grammarerror_type: [
      `진단한 문법 유형`,
      `Grammar Analysis`,
      's_caf.accuracy.grammarerror_type',
      `Grammar Analysis`,
      `Grammar Analysis`,
      `Grammar Analysis`,
      `Grammar Analysis`,
    ],
    error_type1: [
      `한정사`,
      `Determiner`,
      's_caf.accuracy.error_type1',
      `Determiner`,
      `Determiner`,
      `Determiner`,
      `Determiner`,
    ],
    error_type2: [`불변화사`, `Particle`, 's_caf.accuracy.error_type2', `Particle`, `Particle`, `Particle`, `Particle`],
    error_type3: [
      `전치사`,
      `Preposition`,
      's_caf.accuracy.error_type3',
      `Preposition`,
      `Preposition`,
      `Preposition`,
      `Preposition`,
    ],
    error_type4: [
      `동사 형태`,
      `Verb Form`,
      's_caf.accuracy.error_type4',
      `Verb Form`,
      `Verb Form`,
      `Verb Form`,
      `Verb Form`,
    ],
    error_type5: [
      `명사 수일치`,
      `Noun Number`,
      's_caf.accuracy.error_type5',
      `Noun Number`,
      `Noun Number`,
      `Noun Number`,
      `Noun Number`,
    ],
    error_type6: [
      `단어 순서`,
      `Word Order`,
      's_caf.accuracy.error_type6',
      `Word Order`,
      `Word Order`,
      `Word Order`,
      `Word Order`,
    ],
    error_type7: [
      `형태 혼동`,
      `Morphology`,
      's_caf.accuracy.error_type7',
      `Morphology`,
      `Morphology`,
      `Morphology`,
      `Morphology`,
    ],
    error_type8: [
      `주어동사 수일치`,
      `Subject-Verb Agreement`,
      's_caf.accuracy.error_type8',
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
    ],
    error_type_en1: [
      `Determiner`,
      `Determiner`,
      's_caf.accuracy.error_type_en1',
      `Determiner`,
      `Determiner`,
      `Determiner`,
      `Determiner`,
    ],
    error_type_en2: [
      `Particle`,
      `Particle`,
      's_caf.accuracy.error_type_en2',
      `Particle`,
      `Particle`,
      `Particle`,
      `Particle`,
    ],
    error_type_en3: [
      `Preposition`,
      `Preposition`,
      's_caf.accuracy.error_type_en3',
      `Preposition`,
      `Preposition`,
      `Preposition`,
      `Preposition`,
    ],
    error_type_en4: [
      `Verb Form`,
      `Verb Form`,
      's_caf.accuracy.error_type_en4',
      `Verb Form`,
      `Verb Form`,
      `Verb Form`,
      `Verb Form`,
    ],
    error_type_en5: [
      `Noun Number`,
      `Noun Number`,
      's_caf.accuracy.error_type_en5',
      `Noun Number`,
      `Noun Number`,
      `Noun Number`,
      `Noun Number`,
    ],
    error_type_en6: [
      `Word Order`,
      `Word Order`,
      's_caf.accuracy.error_type_en6',
      `Word Order`,
      `Word Order`,
      `Word Order`,
      `Word Order`,
    ],
    error_type_en7: [
      `Morphology`,
      `Morphology`,
      's_caf.accuracy.error_type_en7',
      `Morphology`,
      `Morphology`,
      `Morphology`,
      `Morphology`,
    ],
    error_type_en8: [
      `Subject-verb Agreement`,
      `Subject-Verb Agreement`,
      's_caf.accuracy.error_type_en8',
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
    ],
    highlights: [
      `Accuracy 관련 학습 영역`,
      `Areas related to Accuracy`,
      's_caf.accuracy.highlights',
      `Areas related to Accuracy`,
      `Areas related to Accuracy`,
      `Areas related to Accuracy`,
      `Areas related to Accuracy`,
    ],
    highlights_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      's_caf.accuracy.highlights_detail',
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
    ],
    subsection_info: (count, category) => [
      <span>
        총 <span className="text-primary">{count}</span>개의 {category} 관련 문법 실수 구간
      </span>,
      <span>
        Section where you made a total of <span className="text-primary">{count}</span> {category} related grammar
        mistakes
      </span>,
      's_caf.accuracy.subsection_info',
      <span>
        Section where you made a total of <span className="text-primary">{count}</span> {category} related grammar
        mistakes
      </span>,
      <span>
        Section where you made a total of <span className="text-primary">{count}</span> {category} related grammar
        mistakes
      </span>,
      <span>
        Section where you made a total of <span className="text-primary">{count}</span> {category} related grammar
        mistakes
      </span>,
      <span>
        Section where you made a total of <span className="text-primary">{count}</span> {category} related grammar
        mistakes
      </span>,
    ],
    viewmore_btn: [`더보기`, `See more`, 's_caf.accuracy.viewmore_btn', `See more`, `See more`, `See more`, `See more`],
    error_toast: [
      `링글팀에게 오류가 제보되었어요.`,
      `The error report has been sent to the Ringle team.`,
      's_caf.accuracy.error_toast',
      `The error report has been sent to the Ringle team.`,
      `The error report has been sent to the Ringle team.`,
      `The error report has been sent to the Ringle team.`,
      `The error report has been sent to the Ringle team.`,
    ],
    caf_level9: [
      `9 레벨을 받은 대부분 사람은 모든 문법을 정확하고 적절하게 사용할 줄 알며, 원어민이 하는 정도의 문법 실수만 합니다.`,
      `Lv. 9 denotes that you use correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
      's_caf.accuracy.caf_level9',
      `Lv. 9 denotes that you use correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
      `Lv. 9 denotes that you use correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
      `Lv. 9 denotes that you use correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
      `Lv. 9 denotes that you use correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
    ],
    caf_level8: [
      `8 레벨을 받은 대부분 사람은 다양한 형태의 문법 구조를 유연하게 사용하며, 대부분의 문장에 문법적 오류가 없습니다. 다만, 가끔 기본적인 문법 실수를 합니다.`,
      `Lv. 8 denotes that you can flexibly employ diverse grammar structures and construct flawless sentences, although you make occasional mistakes in basic grammar.`,
      's_caf.accuracy.caf_level8',
      `Lv. 8 denotes that you can flexibly employ diverse grammar structures and construct flawless sentences, although you make occasional mistakes in basic grammar.`,
      `Lv. 8 denotes that you can flexibly employ diverse grammar structures and construct flawless sentences, although you make occasional mistakes in basic grammar.`,
      `Lv. 8 denotes that you can flexibly employ diverse grammar structures and construct flawless sentences, although you make occasional mistakes in basic grammar.`,
      `Lv. 8 denotes that you can flexibly employ diverse grammar structures and construct flawless sentences, although you make occasional mistakes in basic grammar.`,
    ],
    caf_level7: [
      `7 레벨을 받은 대부분 사람은 복잡한 문법 구조를 어느 정도 유연하게 사용할 줄 알며, 자주 문법적 실수가 없는 문장을 사용합니다. 다만, 비슷한 문법 실수를 반복합니다.`,
      `Lv. 7 denotes that you can employ complex grammar structures with some flexibility and often construct flawless sentences, but you tend to make similar grammar mistakes.`,
      's_caf.accuracy.caf_level7',
      `Lv. 7 denotes that you can employ complex grammar structures with some flexibility and often construct flawless sentences, but you tend to make similar grammar mistakes.`,
      `Lv. 7 denotes that you can employ complex grammar structures with some flexibility and often construct flawless sentences, but you tend to make similar grammar mistakes.`,
      `Lv. 7 denotes that you can employ complex grammar structures with some flexibility and often construct flawless sentences, but you tend to make similar grammar mistakes.`,
      `Lv. 7 denotes that you can employ complex grammar structures with some flexibility and often construct flawless sentences, but you tend to make similar grammar mistakes.`,
    ],
    caf_level6: [
      `6 레벨을 받은 대부분 사람은 단순한 문법 구조뿐 아니라 복잡한 문법 구조를 혼합하여 사용할 줄 알지만, 고급 문법을 사용할 때 실수가 잦아집니다.`,
      `Lv. 6 denotes that you know how to use both simple and complex grammar structures but make mistakes often when using more advanced grammar.`,
      's_caf.accuracy.caf_level6',
      `Lv. 6 denotes that you know how to use both simple and complex grammar structures but make mistakes often when using more advanced grammar.`,
      `Lv. 6 denotes that you know how to use both simple and complex grammar structures but make mistakes often when using more advanced grammar.`,
      `Lv. 6 denotes that you know how to use both simple and complex grammar structures but make mistakes often when using more advanced grammar.`,
      `Lv. 6 denotes that you know how to use both simple and complex grammar structures but make mistakes often when using more advanced grammar.`,
    ],
    caf_level5: [
      `5 레벨을 받은 대부분 사람은 기본 문장들은 정확도에 큰 무리 없이 사용하고, 익숙한 복잡한 문법 구조를 사용할 줄 압니다. 다만, 복잡한 문법 구조를 사용할 때, 문법 실수로 인해 상대방이 이해하는 데 어려움을 겪을 수 있습니다.`,
      `Lv. 5 denotes that you can construct basic sentences quite accurately and use complex grammar structures you are familiar with, but complex sentences you make can be difficult to understand.`,
      's_caf.accuracy.caf_level5',
      `Lv. 5 denotes that you can construct basic sentences quite accurately and use complex grammar structures you are familiar with, but complex sentences you make can be difficult to understand.`,
      `Lv. 5 denotes that you can construct basic sentences quite accurately and use complex grammar structures you are familiar with, but complex sentences you make can be difficult to understand.`,
      `Lv. 5 denotes that you can construct basic sentences quite accurately and use complex grammar structures you are familiar with, but complex sentences you make can be difficult to understand.`,
      `Lv. 5 denotes that you can construct basic sentences quite accurately and use complex grammar structures you are familiar with, but complex sentences you make can be difficult to understand.`,
    ],
    caf_level4: [
      `4 레벨을 받은 대부분 사람은 기본적인 문장들을 만들어 낼 수 있지만, 복잡한 문장들은 잘 사용하지 않습니다. 문법 실수가 꽤 잦은 편이며, 가끔 상대방이 이해하는 데 어려움을 겪을 수 있습니다.`,
      `Lv. 4 denotes that you can speak basic sentences but rarely construct complex ones. Also, you make grammar mistakes fairly often and can sometimes be difficult to understand.`,
      's_caf.accuracy.caf_level4',
      `Lv. 4 denotes that you can speak basic sentences but rarely construct complex ones. Also, you make grammar mistakes fairly often and can sometimes be difficult to understand.`,
      `Lv. 4 denotes that you can speak basic sentences but rarely construct complex ones. Also, you make grammar mistakes fairly often and can sometimes be difficult to understand.`,
      `Lv. 4 denotes that you can speak basic sentences but rarely construct complex ones. Also, you make grammar mistakes fairly often and can sometimes be difficult to understand.`,
      `Lv. 4 denotes that you can speak basic sentences but rarely construct complex ones. Also, you make grammar mistakes fairly often and can sometimes be difficult to understand.`,
    ],
    caf_level3: [
      `3 레벨을 받은 대부분 사람은 외우고 있는 문법에 의존하거나, 기본적인 문장을 자유롭게 사용하는 데 어려움을 겪을 때가 있습니다. 익숙한 표현을 사용할 때를 제외하고는 문법적 실수를 자주 합니다.`,
      `Lv. 3 denotes that you rely on grammar you memorized and sometimes find it difficult to construct basic sentences. You also make frequent grammar mistakes, except when using familiar expressions.`,
      's_caf.accuracy.caf_level3',
      `Lv. 3 denotes that you rely on grammar you memorized and sometimes find it difficult to construct basic sentences. You also make frequent grammar mistakes, except when using familiar expressions.`,
      `Lv. 3 denotes that you rely on grammar you memorized and sometimes find it difficult to construct basic sentences. You also make frequent grammar mistakes, except when using familiar expressions.`,
      `Lv. 3 denotes that you rely on grammar you memorized and sometimes find it difficult to construct basic sentences. You also make frequent grammar mistakes, except when using familiar expressions.`,
      `Lv. 3 denotes that you rely on grammar you memorized and sometimes find it difficult to construct basic sentences. You also make frequent grammar mistakes, except when using familiar expressions.`,
    ],
    caf_level2: [
      `2 레벨을 받은 대부분 사람은 기본적인 문장 구조를 만들어내는 데 어려움을 겪는 편입니다.`,
      `Lv. 2 denotes that you have difficulty constructing basic sentences.`,
      's_caf.accuracy.caf_level2',
      `Lv. 2 denotes that you have difficulty constructing basic sentences.`,
      `Lv. 2 denotes that you have difficulty constructing basic sentences.`,
      `Lv. 2 denotes that you have difficulty constructing basic sentences.`,
      `Lv. 2 denotes that you have difficulty constructing basic sentences.`,
    ],
    caf_level1: [`-`, `-`, 's_caf.accuracy.caf_level1', `-`, `-`, `-`, `-`],
    more_info: (count) => [
      `외 ${count}가지 오류`,
      `and ${count} other errors`,
      's_caf.accuracy.more_info',
      `and ${count} other errors`,
      `and ${count} other errors`,
      `and ${count} other errors`,
      `and ${count} other errors`,
    ],
    error_type9: [
      `형용사`,
      `Adjective`,
      's_caf.accuracy.error_type9',
      `Adjective`,
      `Adjective`,
      `Adjective`,
      `Adjective`,
    ],
    error_type10: [
      `최상급/비교급`,
      `Superlative/Comparative`,
      's_caf.accuracy.error_type10',
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      `Superlative/Comparative`,
    ],
    error_type11: [`부사`, `Adverb`, 's_caf.accuracy.error_type11', `Adverb`, `Adverb`, `Adverb`, `Adverb`],
    error_type12: [
      `가산/불가산 명사`,
      `Noun Inflection`,
      's_caf.accuracy.error_type12',
      `Noun Inflection`,
      `Noun Inflection`,
      `Noun Inflection`,
      `Noun Inflection`,
    ],
    error_type13: [
      `동사 시제`,
      `Verb Tense`,
      's_caf.accuracy.error_type13',
      `Verb Tense`,
      `Verb Tense`,
      `Verb Tense`,
      `Verb Tense`,
    ],
    error_type14: [
      `단어 반복`,
      `Word Repetition`,
      's_caf.accuracy.error_type14',
      `Word Repetition`,
      `Word Repetition`,
      `Word Repetition`,
      `Word Repetition`,
    ],
    error_type15: [
      `Run-on 문장`,
      `Run-on Sentence`,
      's_caf.accuracy.error_type15',
      `Run-on Sentence`,
      `Run-on Sentence`,
      `Run-on Sentence`,
      `Run-on Sentence`,
    ],
    error_type16: [
      `짧게 말한 구간`,
      `Short Sentence`,
      's_caf.accuracy.error_type16',
      `Short Sentence`,
      `Short Sentence`,
      `Short Sentence`,
      `Short Sentence`,
    ],
    error_type17: [
      `말하기 속도`,
      `Speech Rate`,
      's_caf.accuracy.error_type17',
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
    ],
    error_type18: [`Pause`, `Pause`, 's_caf.accuracy.error_type18', `Pause`, `Pause`, `Pause`, `Pause`],
    error_type_en9: [
      `Adjective`,
      `Adjective`,
      's_caf.accuracy.error_type_en9',
      `Adjective`,
      `Adjective`,
      `Adjective`,
      `Adjective`,
    ],
    error_type_en10: [
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      's_caf.accuracy.error_type_en10',
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      `Superlative/Comparative`,
    ],
    error_type_en11: [`Adverb`, `Adverb`, 's_caf.accuracy.error_type_en11', `Adverb`, `Adverb`, `Adverb`, `Adverb`],
    error_type_en12: [
      `Noun inflection`,
      `Noun inflection`,
      's_caf.accuracy.error_type_en12',
      `Noun inflection`,
      `Noun inflection`,
      `Noun inflection`,
      `Noun inflection`,
    ],
    error_type_en13: [
      `Verb Tense`,
      `Verb Tense`,
      's_caf.accuracy.error_type_en13',
      `Verb Tense`,
      `Verb Tense`,
      `Verb Tense`,
      `Verb Tense`,
    ],
    underline_text: [
      `다른 유형의 문법실수`,
      `Other types of grammar mistakes`,
      's_caf.accuracy.underline_text',
      `Other types of grammar mistakes`,
      `Other types of grammar mistakes`,
      `Other types of grammar mistakes`,
      `Other types of grammar mistakes`,
    ],
    other_errors: (count) => [
      `외 ${count}가지 오류`,
      `and ${count} other types of errors`,
      's_caf.accuracy.other_errors',
      `and ${count} other types of errors`,
      `and ${count} other types of errors`,
      `and ${count} other types of errors`,
      `and ${count} other types of errors`,
    ],
    collapse: [`접기`, `Close`, 's_caf.accuracy.collapse', `Close`, `Close`, `Close`, `Close`],
  },
  fluency: {
    default: [`Fluency`, `Fluency`, 's_caf.fluency.default', `Fluency`, `Fluency`, `Fluency`, `Fluency`],
    level_score: [`Level`, `Level`, 's_caf.fluency.level_score', `Level`, `Level`, `Level`, `Level`],
    percent: (percent) => [
      `상위 ${percent}%`,
      `Top ${percent}%`,
      's_caf.fluency.percent',
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
    ],
    level_detail: [
      `9가지 중 하나!`,
      `Out of 9 types!`,
      's_caf.fluency.level_detail',
      `Out of 9 types!`,
      `Out of 9 types!`,
      `Out of 9 types!`,
      `Out of 9 types!`,
    ],
    tab1: [
      `평균 말하기 속도`,
      `Avg. speech rate`,
      's_caf.fluency.tab1',
      `Avg. speech rate`,
      `Avg. speech rate`,
      `Avg. speech rate`,
      `Avg. speech rate`,
    ],
    tab2: [
      `평균 이어 말한 단어수`,
      `Mean length of run`,
      's_caf.fluency.tab2',
      `Mean length of run`,
      `Mean length of run`,
      `Mean length of run`,
      `Mean length of run`,
    ],
    tab3: [
      `필러워드 비율`,
      `Filler word ratio`,
      's_caf.fluency.tab3',
      `Filler word ratio`,
      `Filler word ratio`,
      `Filler word ratio`,
      `Filler word ratio`,
    ],
    graph_name1: [
      `나의 말하기 속도 (wpm)`,
      `My speech rate (wpm)`,
      's_caf.fluency.graph_name1',
      `My speech rate (wpm)`,
      `My speech rate (wpm)`,
      `My speech rate (wpm)`,
      `My speech rate (wpm)`,
    ],
    graph_name2: [
      `나의 이어 말한 단어 수`,
      `My mean length of run`,
      's_caf.fluency.graph_name2',
      `My mean length of run`,
      `My mean length of run`,
      `My mean length of run`,
      `My mean length of run`,
    ],
    graph_name3: [
      `나의 필러워드 비율`,
      `My filler word ratio`,
      's_caf.fluency.graph_name3',
      `My filler word ratio`,
      `My filler word ratio`,
      `My filler word ratio`,
      `My filler word ratio`,
    ],
    highlights: [
      `Fluency 관련 학습 영역`,
      `Areas related to Fluency`,
      's_caf.fluency.highlights',
      `Areas related to Fluency`,
      `Areas related to Fluency`,
      `Areas related to Fluency`,
      `Areas related to Fluency`,
    ],
    highlights_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      's_caf.fluency.highlights_detail',
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
    ],
    caf_level9: [
      `9 레벨을 받은 대부분 사람은 망설임 없이 말하고자 하는 바를 문법적 실수 없이 정확하게 전달할 수 있습니다.`,
      `Lv. 9 denotes that you can convey what you want to say flawlessly and without hesitation.`,
      's_caf.fluency.caf_level9',
      `Lv. 9 denotes that you can convey what you want to say flawlessly and without hesitation.`,
      `Lv. 9 denotes that you can convey what you want to say flawlessly and without hesitation.`,
      `Lv. 9 denotes that you can convey what you want to say flawlessly and without hesitation.`,
      `Lv. 9 denotes that you can convey what you want to say flawlessly and without hesitation.`,
    ],
    caf_level8: [
      `8 레벨을 받은 대부분 사람은 단어 반복이나 자기 교정(self-correction) 없이 유창하게 말할 수 있습니다. 말하는 도중에 일시적인 pause가 있을 수 있지만, 대부분은 다음에 말할 내용을 생각하느라 발생합니다.`,
      `Lv. 8 denotes that you can speak fluently without word repetition or self-correction. You may make short pauses while speaking, mostly because you are thinking about what to say next.`,
      's_caf.fluency.caf_level8',
      `Lv. 8 denotes that you can speak fluently without word repetition or self-correction. You may make short pauses while speaking, mostly because you are thinking about what to say next.`,
      `Lv. 8 denotes that you can speak fluently without word repetition or self-correction. You may make short pauses while speaking, mostly because you are thinking about what to say next.`,
      `Lv. 8 denotes that you can speak fluently without word repetition or self-correction. You may make short pauses while speaking, mostly because you are thinking about what to say next.`,
      `Lv. 8 denotes that you can speak fluently without word repetition or self-correction. You may make short pauses while speaking, mostly because you are thinking about what to say next.`,
    ],
    caf_level7: [
      `7 레벨을 받은 대부분 사람은 무리 없이 길이가 있는 논리적인 대화를 원활하게 이어갈 수 있습니다. 질문에 대한 대답을 영어로 생각하느라 멈추는 것보다, 단어나 문법이 생각이 안 나서 멈추는 경우가 더 많습니다.`,
      `Lv. 7 denotes that you can easily carry on a lengthy conversation in a logical manner. You tend to make pauses because of word choice or grammar more often than to think about what to say.`,
      's_caf.fluency.caf_level7',
      `Lv. 7 denotes that you can easily carry on a lengthy conversation in a logical manner. You tend to make pauses because of word choice or grammar more often than to think about what to say.`,
      `Lv. 7 denotes that you can easily carry on a lengthy conversation in a logical manner. You tend to make pauses because of word choice or grammar more often than to think about what to say.`,
      `Lv. 7 denotes that you can easily carry on a lengthy conversation in a logical manner. You tend to make pauses because of word choice or grammar more often than to think about what to say.`,
      `Lv. 7 denotes that you can easily carry on a lengthy conversation in a logical manner. You tend to make pauses because of word choice or grammar more often than to think about what to say.`,
    ],
    caf_level6: [
      `6 레벨을 받은 대부분 사람은 유창하게 말하려고 노력하지만, 종종 망설임이나, 단어 반복, 자기 교정(self-correction) 때문에 전달력이 떨어질 수 있습니다.`,
      `Lv. 6 denotes that you try to speak fluently, but your speech is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
      's_caf.fluency.caf_level6',
      `Lv. 6 denotes that you try to speak fluently, but your speech is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
      `Lv. 6 denotes that you try to speak fluently, but your speech is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
      `Lv. 6 denotes that you try to speak fluently, but your speech is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
      `Lv. 6 denotes that you try to speak fluently, but your speech is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
    ],
    caf_level5: [
      `5 레벨을 받은 대부분 사람은 간단한 대화에서는 유창하지만, 더욱 복잡한 소통 환경에서는 유창함이 무너지는 경우가 있습니다.`,
      `Lv. 5 denotes that you are fluent in simple conversations but not so much when engaging in more complex communication.`,
      's_caf.fluency.caf_level5',
      `Lv. 5 denotes that you are fluent in simple conversations but not so much when engaging in more complex communication.`,
      `Lv. 5 denotes that you are fluent in simple conversations but not so much when engaging in more complex communication.`,
      `Lv. 5 denotes that you are fluent in simple conversations but not so much when engaging in more complex communication.`,
      `Lv. 5 denotes that you are fluent in simple conversations but not so much when engaging in more complex communication.`,
    ],
    caf_level4: [
      `4 레벨을 받은 대부분 사람은 천천히 말하거나, 멈춤 없이 대화를 이어가는 것을 힘들어하는 경우가 있습니다.`,
      `Lv. 4 denotes that you speak slowly or find it difficult to carry on a conversation without pauses.`,
      's_caf.fluency.caf_level4',
      `Lv. 4 denotes that you speak slowly or find it difficult to carry on a conversation without pauses.`,
      `Lv. 4 denotes that you speak slowly or find it difficult to carry on a conversation without pauses.`,
      `Lv. 4 denotes that you speak slowly or find it difficult to carry on a conversation without pauses.`,
      `Lv. 4 denotes that you speak slowly or find it difficult to carry on a conversation without pauses.`,
    ],
    caf_level3: [
      `3 레벨을 받은 대부분 사람은 말하는 중에 긴 pause가 있으며, 간단한 문장들로 대화를 이어가는 경향이 있습니다.`,
      `Lv. 3 denotes that you make long pauses while speaking and tend to carry on  conversations with simple sentences.`,
      's_caf.fluency.caf_level3',
      `Lv. 3 denotes that you make long pauses while speaking and tend to carry on  conversations with simple sentences.`,
      `Lv. 3 denotes that you make long pauses while speaking and tend to carry on  conversations with simple sentences.`,
      `Lv. 3 denotes that you make long pauses while speaking and tend to carry on conversations with simple sentences.`,
      `Lv. 3 denotes that you make long pauses while speaking and tend to carry on  conversations with simple sentences.`,
    ],
    caf_level2: [
      `2 레벨을 받은 대부분 사람은 대부분 단어를 말하기 전에 길게 멈추는 경향이 있습니다.`,
      `Lv. 2 denotes that you tend to make long pauses before saying most words.`,
      's_caf.fluency.caf_level2',
      `Lv. 2 denotes that you tend to make long pauses before saying most words.`,
      `Lv. 2 denotes that you tend to make long pauses before saying most words.`,
      `Lv. 2 denotes that you tend to make long pauses before saying most words.`,
      `Lv. 2 denotes that you tend to make long pauses before saying most words.`,
    ],
    caf_level1: [`-`, `-`, 's_caf.fluency.caf_level1', `-`, `-`, `-`, `-`],
    tab4: [`Pause 비율`, `Pause Rate`, 's_caf.fluency.tab4', `Pause Rate`, `Pause Rate`, `Pause Rate`, `Pause Rate`],
    tab5: [
      `반복단어 비율`,
      `Word Repeat Rate`,
      's_caf.fluency.tab5',
      `Word Repeat Rate`,
      `Word Repeat Rate`,
      `Word Repeat Rate`,
      `Word Repeat Rate`,
    ],
    graph_name4: [
      `나의 Pause 비율`,
      `My Pause Rate`,
      's_caf.fluency.graph_name4',
      `My Pause Rate`,
      `My Pause Rate`,
      `My Pause Rate`,
      `My Pause Rate`,
    ],
    graph_name5: [
      `나의 단어 반복 비율`,
      `My Word Repeat Rate`,
      's_caf.fluency.graph_name5',
      `My Word Repeat Rate`,
      `My Word Repeat Rate`,
      `My Word Repeat Rate`,
      `My Word Repeat Rate`,
    ],
    metric: [
      `이번 수업의 Fluency`,
      `This Lesson's Fluency`,
      's_caf.fluency.metric',
      `This Lesson's Fluency`,
      `This Lesson's Fluency`,
      `This Lesson's Fluency`,
      `This Lesson's Fluency`,
    ],
    graph_sentence: [
      `내가 말한 문장`,
      `My Sentences`,
      's_caf.fluency.graph_sentence',
      `My Sentences`,
      `My Sentences`,
      `My Sentences`,
      `My Sentences`,
    ],
    graph_legend1: [
      `자연스러운 말하기 속도`,
      `Natural speech rate`,
      's_caf.fluency.graph_legend1',
      `Natural speech rate`,
      `Natural speech rate`,
      `Natural speech rate`,
      `Natural speech rate`,
    ],
    graph_legend2: [
      `문장별 말하기속도 평균`,
      `Avg. speech rate`,
      's_caf.fluency.graph_legend2',
      `Avg. speech rate`,
      `Avg. speech rate`,
      `Avg. speech rate`,
      `Avg. speech rate`,
    ],
    graph_legend3: [`77 wpm`, `77 wpm`, 's_caf.fluency.graph_legend3', `77 wpm`, `77 wpm`, `77 wpm`, `77 wpm`],
    graph_legend4: [
      `느린 구간`,
      `Slow speech section`,
      's_caf.fluency.graph_legend4',
      `Slow speech section`,
      `Slow speech section`,
      `Slow speech section`,
      `Slow speech section`,
    ],
    myav: [
      `이번 수업 평균`,
      `This Lesson`,
      's_caf.fluency.myav',
      `This Lesson`,
      `This Lesson`,
      `This Lesson`,
      `This Lesson`,
    ],
    top: [`상위 25% 평균`, `Top 25%`, 's_caf.fluency.top', `Top 25%`, `Top 25%`, `Top 25%`, `Top 25%`],
    tutor: [
      `원어민 평균`,
      `Native Speaker`,
      's_caf.fluency.tutor',
      `Native Speaker`,
      `Native Speaker`,
      `Native Speaker`,
      `Native Speaker`,
    ],
    s_modal_title: [
      `학습자가 말한 문장`,
      `My Sentences`,
      's_caf.fluency.s_modal_title',
      `My Sentences`,
      `My Sentences`,
      `My Sentences`,
      `My Sentences`,
    ],
    s_modal_subtitle: [
      `대화 형식의 링글 수업 중 튜터가 말한 구간을 제외한 학습자가 말한 문장입니다.`,
      `Sentences you spoke when conversing with the tutor during the lesson.`,
      's_caf.fluency.s_modal_subtitle',
      `Sentences you spoke when conversing with the tutor during the lesson.`,
      `Sentences you spoke when conversing with the tutor during the lesson.`,
      `Sentences you spoke when conversing with the tutor during the lesson.`,
      `Sentences you spoke when conversing with the tutor during the lesson.`,
    ],
    modal_okay: [`확인`, `OK`, 's_caf.fluency.modal_okay', `OK`, `OK`, `OK`, `OK`],
    modal_title1: [
      `말하기 속도`,
      `Speech rate (wpm)`,
      's_caf.fluency.modal_title1',
      `Speech rate (wpm)`,
      `Speech rate (wpm)`,
      `Speech rate (wpm)`,
      `Speech rate (wpm)`,
    ],
    modal_subtitle1: [
      `말하기 속도는 분당 말한 단어 수(word per minute, wpm)입니다. 원어민의 자연스러운 말하기 속도는 120 - 180 wpm 사이입니다.`,
      `Speech rate refers to the number of words you speak per minute (word per minute, wpm). A native speaker's natural speech rate is between 120 - 180 wpm.`,
      's_caf.fluency.modal_subtitle1',
      `Speech rate refers to the number of words you speak per minute (word per minute, wpm). A native speaker's natural speech rate is between 120 - 180 wpm.`,
      `Speech rate refers to the number of words you speak per minute (word per minute, wpm). A native speaker's natural speech rate is between 120 - 180 wpm.`,
      `Speech rate refers to the number of words you speak per minute (word per minute, wpm). A native speaker's natural speech rate is between 120 - 180 wpm.`,
      `Speech rate refers to the number of words you speak per minute (word per minute, wpm). A native speaker's natural speech rate is between 120 - 180 wpm.`,
    ],
    modal_title3: [
      `필러워드 비율`,
      `Filler word ratio`,
      's_caf.fluency.modal_title3',
      `Filler word ratio`,
      `Filler word ratio`,
      `Filler word ratio`,
      `Filler word ratio`,
    ],
    modal_subtitle3: [
      `필러워드는 um, uh와 같이 특정한 의미를 전달하지 않는 filler word를 사용하는 것을 의미합니다. 필러워드 비율은 필러워드를 사용한 빈도와 시간을 합산하여 계산합니다.`,
      `Filler words refer to words like "um" and "uh" that do not have any specific meaning. Filler word percentage is calculated based on the frequency and duration of filler word usage.`,
      's_caf.fluency.modal_subtitle3',
      `Filler words refer to words like "um" and "uh" that do not have any specific meaning. Filler word percentage is calculated based on the frequency and duration of filler word usage.`,
      `Filler words refer to words like "um" and "uh" that do not have any specific meaning. Filler word percentage is calculated based on the frequency and duration of filler word usage.`,
      `Filler words refer to words like "um" and "uh" that do not have any specific meaning. Filler word percentage is calculated based on the frequency and duration of filler word usage.`,
      `Filler words refer to words like "um" and "uh" that do not have any specific meaning. Filler word percentage is calculated based on the frequency and duration of filler word usage.`,
    ],
    modal_title4: [
      `Pause 비율`,
      `Pause rate`,
      's_caf.fluency.modal_title4',
      `Pause rate`,
      `Pause rate`,
      `Pause rate`,
      `Pause rate`,
    ],
    modal_subtitle4: [
      `Pause는 단어와 단어 사이에 발생하는 무음으로 된 공백을 의미합니다. Pause 비율은 공백이 있었던 빈도와 시간을 합산하여 계산합니다.`,
      `A pause refers to the unfilled gaps between words. Pause rate is calculated based on the frequency and duration of pauses between words.`,
      's_caf.fluency.modal_subtitle4',
      `A pause refers to the unfilled gaps between words. Pause rate is calculated based on the frequency and duration of pauses between words.`,
      `A pause refers to the unfilled gaps between words. Pause rate is calculated based on the frequency and duration of pauses between words.`,
      `A pause refers to the unfilled gaps between words. Pause rate is calculated based on the frequency and duration of pauses between words.`,
      `A pause refers to the unfilled gaps between words. Pause rate is calculated based on the frequency and duration of pauses between words.`,
    ],
    modal_title5: [
      `단어 반복 비율`,
      `Word repeat rate`,
      's_caf.fluency.modal_title5',
      `Word repeat rate`,
      `Word repeat rate`,
      `Word repeat rate`,
      `Word repeat rate`,
    ],
    modal_subtitle5: [
      `단어 반복은 같은 단어 혹은 구를 여러 번 반복하여 사용하는 것을 의미합니다. 단어 반복 비율은 반복한 단어 개수와 말한 총 단어 개수의 비율을 계산합니다.`,
      `Word repeat rate denotes the repeated use of the same words or phrases and is calculated by finding the ratio between the number of repeated words and the total number of words spoken.`,
      's_caf.fluency.modal_subtitle5',
      `Word repeat rate denotes the repeated use of the same words or phrases and is calculated by finding the ratio between the number of repeated words and the total number of words spoken.`,
      `Word repeat rate denotes the repeated use of the same words or phrases and is calculated by finding the ratio between the number of repeated words and the total number of words spoken.`,
      `Word repeat rate denotes the repeated use of the same words or phrases and is calculated by finding the ratio between the number of repeated words and the total number of words spoken.`,
      `Word repeat rate denotes the repeated use of the same words or phrases and is calculated by finding the ratio between the number of repeated words and the total number of words spoken.`,
    ],
    tooltip1: (count) => [
      <span>
        이어 말한 단어 <span className="font-medium">{count}개</span>
      </span>,
      <span>
        <span className="font-medium">{count} words</span>&nbsp;spoken without pause
      </span>,
      's_caf.fluency.tooltip1',
      <span>
        <span className="font-medium">{count} words</span>&nbsp;spoken without pause
      </span>,
      <span>
        <span className="font-medium">{count} words</span>&nbsp;spoken without pause
      </span>,
      <span>
        <span className="font-medium">{count} words</span>&nbsp;spoken without pause
      </span>,
      <span>
        <span className="font-medium">{count} words</span>&nbsp;spoken without pause
      </span>,
    ],
  },
  faq: {
    ques_1: [
      `CAF 진단이란 
무엇인가요?`,
      `What is 
"CAF Analysis"?`,
      's_caf.faq.ques_1',
      `What is 
"CAF Analysis"?`,
      `What is 
"CAF Analysis"?`,
      `What is 
 "CAF Analysis"?`,
      `What is 
"CAF Analysis"?`,
    ],
    ques_2: [
      `CAF 레벨은 어떻게 
구성되나요?`,
      `What are the
CAF levels?`,
      's_caf.faq.ques_2',
      `What are the
CAF levels?`,
      `What are the
CAF levels?`,
      `What are the
 CAF levels?`,
      `What are the
CAF levels?`,
    ],
    ques_3: [
      `CAF 진단은 어떻게
이루어지나요?`,
      `How is CAF Analysis
performed?`,
      's_caf.faq.ques_3',
      `How is CAF Analysis
performed?`,
      `How is CAF Analysis
performed?`,
      `How is CAF Analysis
 performed?`,
      `How is CAF Analysis
performed?`,
    ],
    ques_4: [
      `학습 영역은 
무엇인가요?`,
      `What are Focus Areas?`,
      's_caf.faq.ques_4',
      `What are Focus Areas?`,
      `What are Focus Areas?`,
      `What are Focus Areas?`,
      `What are Focus Areas?`,
    ],
    tab_1: [
      `CAF 진단`,
      `CAF Analysis`,
      's_caf.faq.tab_1',
      `CAF Analysis`,
      `CAF Analysis`,
      `CAF Analysis`,
      `CAF Analysis`,
    ],
    tab_2: [`CAF 레벨`, `CAF Level`, 's_caf.faq.tab_2', `CAF Level`, `CAF Level`, `CAF Level`, `CAF Level`],
    tab_3: [
      `진단 방법`,
      `Analysis Method`,
      's_caf.faq.tab_3',
      `Analysis Method`,
      `Analysis Method`,
      `Analysis Method`,
      `Analysis Method`,
    ],
    tab_4: [`학습 영역`, `Focus Areas`, 's_caf.faq.tab_4', `Focus Areas`, `Focus Areas`, `Focus Areas`, `Focus Areas`],
  },
  graph_common: {
    user_section: {
      title: [
        `내가 말한 구간`,
        `My Turns`,
        's_caf.graph_common.user_section.title',
        `My Turns`,
        `My Turns`,
        `My Turns`,
        `My Turns`,
      ],
      modal_title: [
        `내가 말한 구간`,
        `My Turns`,
        's_caf.graph_common.user_section.modal_title',
        `My Turns`,
        `My Turns`,
        `My Turns`,
        `My Turns`,
      ],
      modal_subtitle: [
        `대화 형식의 링글 수업 중 튜터가 말한 구간을 제외한 학습자가 말한 구간(Turn)입니다.`,
        `Sections where you took your turn speaking when coversing with the tutor during the lesson.`,
        's_caf.graph_common.user_section.modal_subtitle',
        `Sections where you took your turn speaking when coversing with the tutor during the lesson.`,
        `Sections where you took your turn speaking when coversing with the tutor during the lesson.`,
        `Sections where you took your turn speaking when coversing with the tutor during the lesson.`,
        `Sections where you took your turn speaking when coversing with the tutor during the lesson.`,
      ],
    },
  },
  highlight_list: {
    sort_title: [`정렬 기준`, `Sort by`, 's_caf.highlight_list.sort_title', `Sort by`, `Sort by`, `Sort by`, `Sort by`],
    sort_optn1: [
      `링글 추천순`,
      `Ringle recommended`,
      's_caf.highlight_list.sort_optn1',
      `Ringle recommended`,
      `Ringle recommended`,
      `Ringle recommended`,
      `Ringle recommended`,
    ],
    sort_optn2: [
      `구간 많은 순`,
      `Number of sections`,
      's_caf.highlight_list.sort_optn2',
      `Number of sections`,
      `Number of sections`,
      `Number of sections`,
      `Number of sections`,
    ],
    sort_optn3: [
      `카테고리 순`,
      `Category`,
      's_caf.highlight_list.sort_optn3',
      `Category`,
      `Category`,
      `Category`,
      `Category`,
    ],
    weakness1: [
      `Weakness`,
      `Weakness`,
      's_caf.highlight_list.weakness1',
      `Weakness`,
      `Weakness`,
      `Weakness`,
      `Weakness`,
    ],
    weakness2: (level) => [
      `레벨 ${level} 평균보다 못한 영역`,
      `Areas below Lv. ${level} average`,
      's_caf.highlight_list.weakness2',
      `Areas below Lv. ${level} average`,
      `Areas below Lv. ${level} average`,
      `Areas below Lv. ${level} average`,
      `Areas below Lv. ${level} average`,
    ],
    strength1: [
      `Strength`,
      `Strength`,
      's_caf.highlight_list.strength1',
      `Strength`,
      `Strength`,
      `Strength`,
      `Strength`,
    ],
    strength2: (level) => [
      `레벨 ${level} 평균보다 잘한 영역`,
      `Areas above Lv. ${level} average`,
      's_caf.highlight_list.strength2',
      `Areas above Lv. ${level} average`,
      `Areas above Lv. ${level} average`,
      `Areas above Lv. ${level} average`,
      `Areas above Lv. ${level} average`,
    ],
    complexity1: [
      `Complexity`,
      `Complexity`,
      's_caf.highlight_list.complexity1',
      `Complexity`,
      `Complexity`,
      `Complexity`,
      `Complexity`,
    ],
    complexity2: [
      `복잡성`,
      `Complexity`,
      's_caf.highlight_list.complexity2',
      `Complexity`,
      `Complexity`,
      `Complexity`,
      `Complexity`,
    ],
    accuracy1: [
      `Accuracy`,
      `Accuracy`,
      's_caf.highlight_list.accuracy1',
      `Accuracy`,
      `Accuracy`,
      `Accuracy`,
      `Accuracy`,
    ],
    accuracy2: [`정확성`, `Accuracy`, 's_caf.highlight_list.accuracy2', `Accuracy`, `Accuracy`, `Accuracy`, `Accuracy`],
    fluency1: [`Fluency`, `Fluency`, 's_caf.highlight_list.fluency1', `Fluency`, `Fluency`, `Fluency`, `Fluency`],
    fluency2: [`유창성`, `Fluency`, 's_caf.highlight_list.fluency2', `Fluency`, `Fluency`, `Fluency`, `Fluency`],
    title: [
      `학습 영역`,
      `Focus Areas`,
      's_caf.highlight_list.title',
      `Focus Areas`,
      `Focus Areas`,
      `Focus Areas`,
      `Focus Areas`,
    ],
    edit: [`편집하기`, `Edit`, 's_caf.highlight_list.edit', `Edit`, `Edit`, `Edit`, `Edit`],
    count: [
      <>
        총 <span className="text-purple-500">18</span> 가지 학습 영역
      </>,
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
      's_caf.highlight_list.count',
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
    ],
    edit_done: [`편집 완료`, `Done`, 's_caf.highlight_list.edit_done', `编辑完成`, `編輯完成`, `Done`, `Done`],
  },
  highlight_list_edit: {
    title: [
      `내가 집중하고 싶은 학습 영역`,
      `My Focus Areas`,
      's_caf.highlight_list_edit.title',
      `My Focus Areas`,
      `My Focus Areas`,
      `My Focus Areas`,
      `My Focus Areas`,
    ],
    done: [`완료`, `Done`, 's_caf.highlight_list_edit.done', `Done`, `Done`, `Done`, `Done`],
    count: (count) => [
      <>
        고정한 학습 영역 <span className="text-purple-500">{count}</span>개
      </>,
      <>
        <span className="text-purple-500">{count}</span> pinned focus areas
      </>,
      's_caf.highlight_list_edit.count',
      <>
        <span className="text-purple-500">{count}</span> pinned focus areas
      </>,
      <>
        <span className="text-purple-500">{count}</span> pinned focus areas
      </>,
      <>
        <span className="text-purple-500">{count}</span> pinned focus areas
      </>,
      <>
        <span className="text-purple-500">{count}</span> pinned focus areas
      </>,
    ],
    info: [
      <>
        <span className="text-purple-500">최대 3개</span>의 학습 영역을 고정할 수 있습니다.
      </>,
      <>
        You can pin <span className="text-purple-500">&nbsp;up to 3&nbsp;</span> focus areas.
      </>,
      's_caf.highlight_list_edit.info',
      <>
        You can pin <span className="text-purple-500">&nbsp;up to 3&nbsp;</span> focus areas.
      </>,
      <>
        You can pin <span className="text-purple-500">&nbsp;up to 3&nbsp;</span> focus areas.
      </>,
      <>
        You can pin <span className="text-purple-500">&nbsp;up to 3&nbsp;</span> focus areas.
      </>,
      <>
        You can pin <span className="text-purple-500">&nbsp;up to 3&nbsp;</span> focus areas.
      </>,
    ],
    toast1: [
      `내가 집중하고 싶은 학습 영역에 추가되었습니다.`,
      `Added to My Focus Areas.`,
      's_caf.highlight_list_edit.toast1',
      `Added to My Focus Areas.`,
      `Added to My Focus Areas.`,
      `Added to My Focus Areas.`,
      `Added to My Focus Areas.`,
    ],
    toast2: [
      `내가 집중하고 싶은 학습 영역에서 제외되었습니다.`,
      `Deleted from My Focus Areas.`,
      's_caf.highlight_list_edit.toast2',
      `Deleted from My Focus Areas.`,
      `Deleted from My Focus Areas.`,
      `Deleted from My Focus Areas.`,
      `Deleted from My Focus Areas.`,
    ],
    toast3: [
      `최대 3개의 학습 영역을 고정 할 수 있습니다.`,
      `You can pin up to 3 focus areas.`,
      's_caf.highlight_list_edit.toast3',
      `You can pin up to 3 focus areas.`,
      `You can pin up to 3 focus areas.`,
      `You can pin up to 3 focus areas.`,
      `You can pin up to 3 focus areas.`,
    ],
    toast4: [
      `최대 3개의 학습 영역을 고정 할 수 있습니다.`,
      `You can pin up to 3 focus areas.`,
      's_caf.highlight_list_edit.toast4',
      `You can pin up to 3 focus areas.`,
      `You can pin up to 3 focus areas.`,
      `You can pin up to 3 focus areas.`,
      `You can pin up to 3 focus areas.`,
    ],
    toast4_btn: [`편집하기`, `Edit`, 's_caf.highlight_list_edit.toast4_btn', `Edit`, `Edit`, `Edit`, `Edit`],
  },
  level_info: [
    `레벨 분포와 설명`,
    `Level distribution & description`,
    's_caf.level_info',
    `Level distribution & description`,
    `Level distribution & description`,
    `Level distribution & description`,
    `Level distribution & description`,
  ],
  speechrate_def: {
    modal_title: [
      `토`,
      `Speech Rate`,
      's_caf.speechrate_def.modal_title',
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
    ],
    modal_body: [
      `분당 말한 단어 수(word per minute, wpm)입니다.`,
      `Shows the number of words you spoke per minute (wpm).`,
      's_caf.speechrate_def.modal_body',
      `Shows the number of words you spoke per minute (wpm).`,
      `Shows the number of words you spoke per minute (wpm).`,
      `Shows the number of words you spoke per minute (wpm).`,
      `Shows the number of words you spoke per minute (wpm).`,
    ],
  },
  mlr_def: {
    modal_title: [
      `나의 이어 말한 단어 수`,
      `Mean Length of Run (MLR)`,
      's_caf.mlr_def.modal_title',
      `Mean Length of Run (MLR)`,
      `Mean Length of Run (MLR)`,
      `Mean Length of Run (MLR)`,
      `Mean Length of Run (MLR)`,
    ],
    modal_body: [
      `0.25초 이상의 공백 없이 이어말한 단어수(Mean Length of Run, MLR)입니다.`,
      `Shows to the average number of words you spoke without pauses exceeding 0.25 seconds.`,
      's_caf.mlr_def.modal_body',
      `Shows to the average number of words you spoke without pauses exceeding 0.25 seconds.`,
      `Shows to the average number of words you spoke without pauses exceeding 0.25 seconds.`,
      `Shows to the average number of words you spoke without pauses exceeding 0.25 seconds.`,
      `Shows to the average number of words you spoke without pauses exceeding 0.25 seconds.`,
    ],
  },
  pause_def: {
    modal_title: [
      `Pause 비율`,
      `Pause Rate`,
      's_caf.pause_def.modal_title',
      `Pause Rate`,
      `Pause Rate`,
      `Pause Rate`,
      `Pause Rate`,
    ],
    modal_body: [
      `학습자가 말한 시간과 말하는 중 Pause가있었던 시간의 비율입니다.`,
      `Shows the ratio between the time you spent speaking and the time you spent pausing.`,
      's_caf.pause_def.modal_body',
      `Shows the ratio between the time you spent speaking and the time you spent pausing.`,
      `Shows the ratio between the time you spent speaking and the time you spent pausing.`,
      `Shows the ratio between the time you spent speaking and the time you spent pausing.`,
      `Shows the ratio between the time you spent speaking and the time you spent pausing.`,
    ],
  },
  vocablv_def: {
    modal_title: [
      `어휘 난이도`,
      `Vocabulary Level`,
      's_caf.vocablv_def.modal_title',
      `Vocabulary Level`,
      `Vocabulary Level`,
      `Vocabulary Level`,
      `Vocabulary Level`,
    ],
    modal_body: [
      `학습자가 사용한 어휘의 난이도 유형별 분포입니다.`,
      `Shows the distribution of the types of vocabulary you used.`,
      's_caf.vocablv_def.modal_body',
      `Shows the distribution of the types of vocabulary you used.`,
      `Shows the distribution of the types of vocabulary you used.`,
      `Shows the distribution of the types of vocabulary you used.`,
      `Shows the distribution of the types of vocabulary you used.`,
    ],
  },
  sentence_def: {
    modal_title: [
      `문장 구조`,
      `Sentence Structure`,
      's_caf.sentence_def.modal_title',
      `Sentence Structure`,
      `Sentence Structure`,
      `Sentence Structure`,
      `Sentence Structure`,
    ],
    modal_body: [
      `학습자가 사용한 문장 유형별 분포입니다.`,
      `Shows the distribution of the types of sentences you used.`,
      's_caf.sentence_def.modal_body',
      `Shows the distribution of the types of sentences you used.`,
      `Shows the distribution of the types of sentences you used.`,
      `Shows the distribution of the types of sentences you used.`,
      `Shows the distribution of the types of sentences you used.`,
    ],
  },
  statistic: {
    tab_menu: [
      `CAF 통계`,
      `CAF Statistics`,
      's_caf.statistic.tab_menu',
      `CAF Statistics`,
      `CAF Statistics`,
      `CAF Statistics`,
      `CAF Statistics`,
    ],
    period: (year, month) => [
      `${year}년 ${month}월`,
      `${month}/${year}`,
      's_caf.statistic.period',
      `${month}/${year}`,
      `${month}/${year}`,
      `${month}/${year}`,
      `${month}/${year}`,
    ],
    level_avg: [
      `CAF 레벨 평균`,
      `Average CAF Level`,
      's_caf.statistic.level_avg',
      `Average CAF Level`,
      `Average CAF Level`,
      `Average CAF Level`,
      `Average CAF Level`,
    ],
    lessons: [`분석한 수업`, `Lessons`, 's_caf.statistic.lessons', `Lessons`, `Lessons`, `Lessons`, `Lessons`],
    highlight_title: [
      `추천 학습 영역`,
      `Recommended Focus Areas`,
      's_caf.statistic.highlight_title',
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
    ],
    highlight_detail: (name, count) => [
      `${name}님의 지난 ${count}개의 수업 분석을 기반으로 다음 링글 수업에서 집중하여 개선하면 좋을 영역을 추천드립니다.`,
      `Recommended focus areas for your next lesson based on the CAF analyses of your last ${count} lessons.`,
      's_caf.statistic.highlight_detail',
      `Recommended focus areas for your next lesson based on the CAF analyses of your last ${count} lessons.`,
      `Recommended focus areas for your next lesson based on the CAF analyses of your last ${count} lessons.`,
      `Recommended focus areas for your next lesson based on the CAF analyses of your last ${count} lessons.`,
      `Recommended focus areas for your next lesson based on the CAF analyses of your last ${count} lessons.`,
    ],
    trend: {
      caf: [`CAF 레벨`, `CAF Level`, 's_caf.statistic.trend.caf', `CAF Level`, `CAF Level`, `CAF Level`, `CAF Level`],
      complexity: [
        `Complexity 레벨`,
        `Complexity Level`,
        's_caf.statistic.trend.complexity',
        `Complexity Level`,
        `Complexity Level`,
        `Complexity Level`,
        `Complexity Level`,
      ],
      accuracy: [
        `Accuracy 레벨`,
        `Accuracy Level`,
        's_caf.statistic.trend.accuracy',
        `Accuracy Level`,
        `Accuracy Level`,
        `Accuracy Level`,
        `Accuracy Level`,
      ],
      fluency: [
        `Fluency 레벨`,
        `Fluency Level`,
        's_caf.statistic.trend.fluency',
        `Fluency Level`,
        `Fluency Level`,
        `Fluency Level`,
        `Fluency Level`,
      ],
      date: [
        `수업날짜`,
        `Lesson date`,
        's_caf.statistic.trend.date',
        `Lesson date`,
        `Lesson date`,
        `Lesson date`,
        `Lesson date`,
      ],
      cafallchip: [
        `CAF 전체`,
        `CAF All`,
        's_caf.statistic.trend.cafallchip',
        `CAF All`,
        `CAF All`,
        `CAF All`,
        `CAF All`,
      ],
      cafall: [
        `CAF 전체 레벨`,
        `CAF Levels`,
        's_caf.statistic.trend.cafall',
        `CAF Levels`,
        `CAF Levels`,
        `CAF Levels`,
        `CAF Levels`,
      ],
      min: [
        `최저 레벨`,
        `Lowest level`,
        's_caf.statistic.trend.min',
        `Lowest level`,
        `Lowest level`,
        `Lowest level`,
        `Lowest level`,
      ],
      max: [
        `최대 레벨`,
        `Highest level`,
        's_caf.statistic.trend.max',
        `Highest level`,
        `Highest level`,
        `Highest level`,
        `Highest level`,
      ],
    },
    nodata: [
      `선택한 기간에 한 개 이상의 수업 진단이
있어야 CAF 통계를 확인할 수 있습니다.`,
      `You need at least one CAF analysis during
the chosen period to view CAF statistics.`,
      's_caf.statistic.nodata',
      `You need at least one CAF analysis during
the chosen period to view CAF statistics.`,
      `You need at least one CAF analysis during
the chosen period to view CAF statistics.`,
      `You need at least one CAF analysis during
 the chosen period to view CAF statistics.`,
      `You need at least one CAF analysis during
the chosen period to view CAF statistics.`,
    ],
    less_list: {
      title: [
        `수업 리스트`,
        `Lesson list`,
        's_caf.statistic.less_list.title',
        `Lesson list`,
        `Lesson list`,
        `Lesson list`,
        `Lesson list`,
      ],
      edit: [`편집`, `Edit`, 's_caf.statistic.less_list.edit', `Edit`, `Edit`, `Edit`, `Edit`],
      done: [`완료`, `Done`, 's_caf.statistic.less_list.done', `Done`, `Done`, `Done`, `Done`],
      count: (count) => [
        <>
          총 <span className="text-primary">{count}</span>개의 수업
        </>,
        <>
          A total of <span className="text-primary">{count}</span> lessons
        </>,
        's_caf.statistic.less_list.count',
        <>
          A total of <span className="text-primary">{count}</span> lessons
        </>,
        <>
          A total of <span className="text-primary">{count}</span> lessons
        </>,
        <>
          A total of <span className="text-primary">{count}</span> lessons
        </>,
        <>
          A total of <span className="text-primary">{count}</span> lessons
        </>,
      ],
    },
    highlight: {
      graph_date: [
        `수업 날짜`,
        `Lesson date`,
        's_caf.statistic.highlight.graph_date',
        `Lesson date`,
        `Lesson date`,
        `Lesson date`,
        `Lesson date`,
      ],
      count: (count) => [
        `총 ${count}개 수업의 학습 영역`,
        `Focus areas for ${count} lessons`,
        's_caf.statistic.highlight.count',
        `Focus areas for ${count} lessons`,
        `Focus areas for ${count} lessons`,
        `Focus areas for ${count} lessons`,
        `Focus areas for ${count} lessons`,
      ],
      select: [
        `조회한 수업의 학습 영역`,
        `Focus areas for the chosen lesson`,
        's_caf.statistic.highlight.select',
        `Focus areas for the chosen lesson`,
        `Focus areas for the chosen lesson`,
        `Focus areas for the chosen lesson`,
        `Focus areas for the chosen lesson`,
      ],
      grammarerror0: (count) => [
        `한정사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Determiner| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror0',
        `Determiner| ${count} mistakes detected on average.`,
        `Determiner| ${count} mistakes detected on average.`,
        `Determiner| ${count} mistakes detected on average.`,
        `Determiner| ${count} mistakes detected on average.`,
      ],
      grammarerror1: (count) => [
        `불변화사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Particle| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror1',
        `Particle| ${count} mistakes detected on average.`,
        `Particle| ${count} mistakes detected on average.`,
        `Particle| ${count} mistakes detected on average.`,
        `Particle| ${count} mistakes detected on average.`,
      ],
      grammarerror2: (count) => [
        `전치사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Preposition| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror2',
        `Preposition| ${count} mistakes detected on average.`,
        `Preposition| ${count} mistakes detected on average.`,
        `Preposition| ${count} mistakes detected on average.`,
        `Preposition| ${count} mistakes detected on average.`,
      ],
      grammarerror3: (count) => [
        `동사 형태| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Verb Form| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror3',
        `Verb Form| ${count} mistakes detected on average.`,
        `Verb Form| ${count} mistakes detected on average.`,
        `Verb Form| ${count} mistakes detected on average.`,
        `Verb Form| ${count} mistakes detected on average.`,
      ],
      grammarerror4: (count) => [
        `명사 수일치| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Noun Number| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror4',
        `Noun Number| ${count} mistakes detected on average.`,
        `Noun Number| ${count} mistakes detected on average.`,
        `Noun Number| ${count} mistakes detected on average.`,
        `Noun Number| ${count} mistakes detected on average.`,
      ],
      grammarerror5: (count) => [
        `단어 순서| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Word Order| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror5',
        `Word Order| ${count} mistakes detected on average.`,
        `Word Order| ${count} mistakes detected on average.`,
        `Word Order| ${count} mistakes detected on average.`,
        `Word Order| ${count} mistakes detected on average.`,
      ],
      grammarerror6: (count) => [
        `형태 혼동| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Morphology| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror6',
        `Morphology| ${count} mistakes detected on average.`,
        `Morphology| ${count} mistakes detected on average.`,
        `Morphology| ${count} mistakes detected on average.`,
        `Morphology| ${count} mistakes detected on average.`,
      ],
      grammarerror7: (count) => [
        `주어동사 수일치| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Subject-Verb Agreement| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror7',
        `Subject-Verb Agreement| ${count} mistakes detected on average.`,
        `Subject-Verb Agreement| ${count} mistakes detected on average.`,
        `Subject-Verb Agreement| ${count} mistakes detected on average.`,
        `Subject-Verb Agreement| ${count} mistakes detected on average.`,
      ],
      grammarerror8: (count) => [
        `형용사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Adjective| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror8',
        `Adjective| ${count} mistakes detected on average.`,
        `Adjective| ${count} mistakes detected on average.`,
        `Adjective| ${count} mistakes detected on average.`,
        `Adjective| ${count} mistakes detected on average.`,
      ],
      grammarerror9: (count) => [
        `최상급/비교급| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Superlative/Comparative| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror9',
        `Superlative/Comparative| ${count} mistakes detected on average.`,
        `Superlative/Comparative| ${count} mistakes detected on average.`,
        `Superlative/Comparative| ${count} mistakes detected on average.`,
        `Superlative/Comparative| ${count} mistakes detected on average.`,
      ],
      grammarerror10: (count) => [
        `부사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Adverb| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror10',
        `Adverb| ${count} mistakes detected on average.`,
        `Adverb| ${count} mistakes detected on average.`,
        `Adverb| ${count} mistakes detected on average.`,
        `Adverb| ${count} mistakes detected on average.`,
      ],
      grammarerror11: (count) => [
        `가산/불가산 명사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Noun Inflection| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror11',
        `Noun Inflection| ${count} mistakes detected on average.`,
        `Noun Inflection| ${count} mistakes detected on average.`,
        `Noun Inflection| ${count} mistakes detected on average.`,
        `Noun Inflection| ${count} mistakes detected on average.`,
      ],
      grammarerror12: (count) => [
        `동사 시제| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Verb Tense| ${count} mistakes detected on average.`,
        's_caf.statistic.highlight.grammarerror12',
        `Verb Tense| ${count} mistakes detected on average.`,
        `Verb Tense| ${count} mistakes detected on average.`,
        `Verb Tense| ${count} mistakes detected on average.`,
        `Verb Tense| ${count} mistakes detected on average.`,
      ],
      grammarerror13: (count) => [
        `반복적으로 사용한 단어|가 평균 ${count}개 있어요.`,
        `Word Repetition| ${count} problematic sections detected on average.`,
        's_caf.statistic.highlight.grammarerror13',
        `Word Repetition| ${count} problematic sections detected on average.`,
        `Word Repetition| ${count} problematic sections detected on average.`,
        `Word Repetition| ${count} problematic sections detected on average.`,
        `Word Repetition| ${count} problematic sections detected on average.`,
      ],
      grammarerror14: (count) => [
        `Run-on 문장|이 평균 ${count}개 있어요.`,
        `Run-on Sentence| ${count} detected on average.`,
        's_caf.statistic.highlight.grammarerror14',
        `Run-on Sentence| ${count} detected on average.`,
        `Run-on Sentence| ${count} detected on average.`,
        `Run-on Sentence| ${count} detected on average.`,
        `Run-on Sentence| ${count} detected on average.`,
      ],
      grammarerror15: (count) => [
        `말하기 속도|가 느렸던 구간이 평균 ${count}개 있어요.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        's_caf.statistic.highlight.grammarerror15',
        `Speech Rate| ${count} slow speech sections detected on average.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
      ],
      grammarerror16: (count) => [
        `필러워드| 사용이 많았던 구간이 평균 ${count}개 있어요.`,
        `Filler Words| ${count} problematic sections detected on average.`,
        's_caf.statistic.highlight.grammarerror16',
        `Filler Words| ${count} problematic sections detected on average.`,
        `Filler Words| ${count} problematic sections detected on average.`,
        `Filler Words| ${count} problematic sections detected on average.`,
        `Filler Words| ${count} problematic sections detected on average.`,
      ],
      speech_rate1: (count) => [
        `말하기 속도|가 느렸던 구간이 평균 ${count}개 있었어요.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        's_caf.statistic.highlight.speech_rate1',
        `Speech Rate| ${count} slow speech sections detected on average.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
      ],
      graph_title0: [
        `실수 개수`,
        `No. of mistakes`,
        's_caf.statistic.highlight.graph_title0',
        `No. of mistakes`,
        `No. of mistakes`,
        `No. of mistakes`,
        `No. of mistakes`,
      ],
      graph_title13: [
        `반복 단어 수`,
        `No. of repeated words`,
        's_caf.statistic.highlight.graph_title13',
        `No. of repeated words`,
        `No. of repeated words`,
        `No. of repeated words`,
        `No. of repeated words`,
      ],
      graph_title14: [
        `Run-on 문장 수`,
        `No. of run-on sentences`,
        's_caf.statistic.highlight.graph_title14',
        `No. of run-on sentences`,
        `No. of run-on sentences`,
        `No. of run-on sentences`,
        `No. of run-on sentences`,
      ],
      graph_title15: [
        `말하기 속도가 느린 구간 수`,
        `No. of slow speech sections`,
        's_caf.statistic.highlight.graph_title15',
        `No. of slow speech sections`,
        `No. of slow speech sections`,
        `No. of slow speech sections`,
        `No. of slow speech sections`,
      ],
      grammarerror17: (count) => [
        `더 복잡한 문장 구조|를 시도해 볼 수 있는 구간이 평균 ${count}개 있어요.`,
        `Complex Sentence| ${count} applicable sections on average.`,
        's_caf.statistic.highlight.grammarerror17',
        `Complex Sentence| ${count} applicable sections on average.`,
        `Complex Sentence| ${count} applicable sections on average.`,
        `Complex Sentence| ${count} applicable sections on average.`,
        `Complex Sentence| ${count} applicable sections on average.`,
      ],
      graph_title17: [
        `더 복잡한 문장 구조를 시도해 볼 수 있는 구간 수`,
        `Number of sections where complex sentences could be used`,
        's_caf.statistic.highlight.graph_title17',
        `Number of sections where complex sentences could be used`,
        `Number of sections where complex sentences could be used`,
        `Number of sections where complex sentences could be used`,
        `Number of sections where complex sentences could be used`,
      ],
    },
    lesson_list: {
      on: [
        `해당 수업의 진단은 CAF 통계에 포함됩니다.`,
        `This lesson's CAF analysis is included in the CAF statistics.`,
        's_caf.statistic.lesson_list.on',
        `This lesson's CAF analysis is included in the CAF statistics.`,
        `This lesson's CAF analysis is included in the CAF statistics.`,
        `This lesson's CAF analysis is included in the CAF statistics.`,
        `This lesson's CAF analysis is included in the CAF statistics.`,
      ],
      off: [
        `해당 수업의 진단은 CAF 통계에서 제외되었습니다.`,
        `This lesson's CAF analysis is excluded from the CAF statistics.`,
        's_caf.statistic.lesson_list.off',
        `This lesson's CAF analysis is excluded from the CAF statistics.`,
        `This lesson's CAF analysis is excluded from the CAF statistics.`,
        `This lesson's CAF analysis is excluded from the CAF statistics.`,
        `This lesson's CAF analysis is excluded from the CAF statistics.`,
      ],
      unavailable: [
        `조회하신 기간의 모든 수업을 제외할 수 없습니다.`,
        `It is not possible to exclude all lessons within the selected period.`,
        's_caf.statistic.lesson_list.unavailable',
        `It is not possible to exclude all lessons within the selected period.`,
        `It is not possible to exclude all lessons within the selected period.`,
        `It is not possible to exclude all lessons within the selected period.`,
        `It is not possible to exclude all lessons within the selected period.`,
      ],
    },
    date_optn1: [`최근 1개월`, `1 month`, 's_caf.statistic.date_optn1', `2 month`, `3 month`, `4 month`, `5 month`],
    date_optn2: [
      `최근 3개월`,
      `3 months`,
      's_caf.statistic.date_optn2',
      `4 months`,
      `5 months`,
      `6 months`,
      `7 months`,
    ],
    date_optn3: [
      `최근 6개월`,
      `6 months`,
      's_caf.statistic.date_optn3',
      `7 months`,
      `8 months`,
      `9 months`,
      `10 months`,
    ],
    date_optn4: [
      `최근 12개월`,
      `12 months`,
      's_caf.statistic.date_optn4',
      `13 months`,
      `14 months`,
      `15 months`,
      `16 months`,
    ],
    date_optn5: [
      `직접 설정`,
      `Set manually`,
      's_caf.statistic.date_optn5',
      `Set manually`,
      `Set manually`,
      `Set manually`,
      `Set manually`,
    ],
    date_chip1: [`최근 1개월`, `1 month`, 's_caf.statistic.date_chip1', `2 month`, `3 month`, `4 month`, `5 month`],
    date_chip2: [`3개월`, `3 months`, 's_caf.statistic.date_chip2', `4 months`, `5 months`, `6 months`, `7 months`],
    date_chip3: [`6개월`, `6 months`, 's_caf.statistic.date_chip3', `7 months`, `8 months`, `9 months`, `10 months`],
    date_chip4: [
      `12개월`,
      `12 months`,
      's_caf.statistic.date_chip4',
      `13 months`,
      `14 months`,
      `15 months`,
      `16 months`,
    ],
    date_title: [
      `기간 설정`,
      `Set period`,
      's_caf.statistic.date_title',
      `Set period`,
      `Set period`,
      `Set period`,
      `Set period`,
    ],
    date_btn: [`조회하기`, `Search`, 's_caf.statistic.date_btn', `Search`, `Search`, `Search`, `Search`],
    date_modal: [
      `CAF 진단이 없습니다. 한 개 이상의 수업 진단이 있어야 CAF 통계의 기간 설정이 가능합니다.`,
      `You have no CAF Analysis results. You must have at least one CAF analysis to set the period for viewing CAF statistics.`,
      's_caf.statistic.date_modal',
      `You have no CAF Analysis results. You must have at least one CAF analysis to set the period for viewing CAF statistics.`,
      `You have no CAF Analysis results. You must have at least one CAF analysis to set the period for viewing CAF statistics.`,
      `You have no CAF Analysis results. You must have at least one CAF analysis to set the period for viewing CAF statistics.`,
      `You have no CAF Analysis results. You must have at least one CAF analysis to set the period for viewing CAF statistics.`,
    ],
    okay: [`확인`, `OK`, 's_caf.statistic.okay', `OK`, `OK`, `OK`, `OK`],
    bottomsheet_cancel: [
      `취소`,
      `Cancel`,
      's_caf.statistic.bottomsheet_cancel',
      `Cancel`,
      `Cancel`,
      `Cancel`,
      `Cancel`,
    ],
    bottomsheet_apply: [`완료`, `Done`, 's_caf.statistic.bottomsheet_apply', `Done`, `Done`, `Done`, `Done`],
    nodata1: [
      `선택한 기간에 진단된 수업이 없습니다.`,
      `You have no CAF Analysis results.`,
      's_caf.statistic.nodata1',
      `You have no CAF Analysis results.`,
      `You have no CAF Analysis results.`,
      `You have no CAF Analysis results.`,
      `You have no CAF Analysis results.`,
    ],
    nodata2: [
      `기간을 다시 선택해 주세요.`,
      `Please re-select the period.`,
      's_caf.statistic.nodata2',
      `Please re-select the period.`,
      `Please re-select the period.`,
      `Please re-select the period.`,
      `Please re-select the period.`,
    ],
    view_list: [
      `수업 리스트 보기`,
      `View lesson list`,
      's_caf.statistic.view_list',
      `看所有课程`,
      `看所有課程`,
      `View lesson list`,
      `View lesson list`,
    ],
    date_title1: [
      `직접 설정`,
      `Set period`,
      's_caf.statistic.date_title1',
      `设定日期区间`,
      `設定日期區間`,
      `Set period`,
      `Set period`,
    ],
    view_detail: [
      `자세히 보기`,
      `View details`,
      's_caf.statistic.view_detail',
      `看更多`,
      `看更多`,
      `View details`,
      `View details`,
    ],
    menu_statistics: [
      `통계 개요`,
      `Statistics`,
      's_caf.statistic.menu_statistics',
      `统计`,
      `統計`,
      `Statistics`,
      `Statistics`,
    ],
  },
  speech_rate_def: {
    modal_title: [
      `말하기 속도`,
      `Speech Rate`,
      's_caf.speech_rate_def.modal_title',
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
      `Speech Rate`,
    ],
    modal_body: [
      `분당 말한 단어 수(word per minute, wpm)입니다.`,
      `Refers to the number of words you spoke per minute (wpm).`,
      's_caf.speech_rate_def.modal_body',
      `Refers to the number of words you spoke per minute (wpm).`,
      `Refers to the number of words you spoke per minute (wpm).`,
      `Refers to the number of words you spoke per minute (wpm).`,
      `Refers to the number of words you spoke per minute (wpm).`,
    ],
  },
  tip: {
    highlight13: {
      title1: [
        `단어 반복이란?`,
        `What is word repetition?`,
        's_caf.tip.highlight13.title1',
        `What is word repetition?`,
        `What is word repetition?`,
        `What is word repetition?`,
        `What is word repetition?`,
      ],
      title2: [
        `단어를 반복하는 원인과 단점?`,
        `What are its causes and disadvantages?`,
        's_caf.tip.highlight13.title2',
        `What are its causes and disadvantages?`,
        `What are its causes and disadvantages?`,
        `What are its causes and disadvantages?`,
        `What are its causes and disadvantages?`,
      ],
      title3: [
        `반복을 피하기 위한 방법은?`,
        `How can we avoid it?`,
        's_caf.tip.highlight13.title3',
        `How can we avoid it?`,
        `How can we avoid it?`,
        `How can we avoid it?`,
        `How can we avoid it?`,
      ],
      body1: [
        `2~3문장 이내에 동일한 단어를 3번이상 반복하는 경우 반복사용 단어로 제공합니다.`,
        `It is counted as "word repetition" if the same word is repeated 3 or more times within 2-3 sentences.`,
        's_caf.tip.highlight13.body1',
        `It is counted as "word repetition" if the same word is repeated 3 or more times within 2-3 sentences.`,
        `It is counted as "word repetition" if the same word is repeated 3 or more times within 2-3 sentences.`,
        `It is counted as "word repetition" if the same word is repeated 3 or more times within 2-3 sentences.`,
        `It is counted as "word repetition" if the same word is repeated 3 or more times within 2-3 sentences.`,
      ],
      body2: [
        `숙지하고있는 단어의 부족, 반복사용을 인지하지 못함 혹은 습관적으로 반복사용하는 경우 등이 있습니다.
동일 단어를 반복적으로 사용하면 스피치가 단조롭고 지루하게 느껴질 수 있습니다. 또한 메시지의 명확성을 떨어트릴 수 있고, 과하게 반복적으로 사용하면 의사소통 능력이 부족하다고 판단될 수도 있습니다.`,
        `Word repetition occurs when you know a limited number of vocabulary, are unaware that you repeat the same words, or habitually use the same words.
Using the same words repeatedly can make your speech monotonous and boring. It can also make your meaning unclear and, if excessive, may make you seem lacking in communication skills.`,
        's_caf.tip.highlight13.body2',
        `Word repetition occurs when you know a limited number of vocabulary, are unaware that you repeat the same words, or habitually use the same words.
Using the same words repeatedly can make your speech monotonous and boring. It can also make your meaning unclear and, if excessive, may make you seem lacking in communication skills.`,
        `Word repetition occurs when you know a limited number of vocabulary, are unaware that you repeat the same words, or habitually use the same words.
Using the same words repeatedly can make your speech monotonous and boring. It can also make your meaning unclear and, if excessive, may make you seem lacking in communication skills.`,
        `Word repetition occurs when you know a limited number of vocabulary, are unaware that you repeat the same words, or habitually use the same words.
 Using the same words repeatedly can make your speech monotonous and boring. It can also make your meaning unclear and, if excessive, may make you seem lacking in communication skills.`,
        `Word repetition occurs when you know a limited number of vocabulary, are unaware that you repeat the same words, or habitually use the same words.
Using the same words repeatedly can make your speech monotonous and boring. It can also make your meaning unclear and, if excessive, may make you seem lacking in communication skills.`,
      ],
      body3: [
        <>
          1. 동의어에 대한 숙지: 문맥상 동일한 의미를 가지는 단어들을 찾아보고 학습해보세요.
          <br />
          <br />
          2. 문장 구조의 변경: 동일한 내용을 다른 문장 구조로 표현할 수 있게 학습해보세요.
          <br />
          <br />
          3. 다양한 단어에 대한 숙지: 새로운 단어 및 표현들을 꾸준히 학습해보세요.
        </>,
        <>
          1. Learn synonyms: Look up and learn words that have the same meaning in the given context.
          <br />
          <br />
          2. Use different sentence structures: Practice saying the same thing using different sentence structures.
          <br />
          <br />
          3. Increase your vocabulary: Keep learning new words and expressions.
        </>,
        's_caf.tip.highlight13.body3',
        <>
          1. Learn synonyms: Look up and learn words that have the same meaning in the given context.
          <br />
          <br />
          2. Use different sentence structures: Practice saying the same thing using different sentence structures.
          <br />
          <br />
          3. Increase your vocabulary: Keep learning new words and expressions.
        </>,
        <>
          1. Learn synonyms: Look up and learn words that have the same meaning in the given context.
          <br />
          <br />
          2. Use different sentence structures: Practice saying the same thing using different sentence structures.
          <br />
          <br />
          3. Increase your vocabulary: Keep learning new words and expressions.
        </>,
        <>
          1. Learn synonyms: Look up and learn words that have the same meaning in the given context.
          <br />
          <br />
          2. Use different sentence structures: Practice saying the same thing using different sentence structures.
          <br />
          <br />
          3. Increase your vocabulary: Keep learning new words and expressions.
        </>,
        <>
          1. Learn synonyms: Look up and learn words that have the same meaning in the given context.
          <br />
          <br />
          2. Use different sentence structures: Practice saying the same thing using different sentence structures.
          <br />
          <br />
          3. Increase your vocabulary: Keep learning new words and expressions.
        </>,
      ],
    },
    highlight14: {
      title1: [
        `Run-on 문장이란?`,
        `What is a run-on sentence?`,
        's_caf.tip.highlight14.title1',
        `What is a run-on sentence?`,
        `What is a run-on sentence?`,
        `What is a run-on sentence?`,
        `What is a run-on sentence?`,
      ],
      title2: [
        `Run-on 문장의 원인과 단점은?`,
        `What are its causes and disadvantages?`,
        's_caf.tip.highlight14.title2',
        `What are its causes and disadvantages?`,
        `What are its causes and disadvantages?`,
        `What are its causes and disadvantages?`,
        `What are its causes and disadvantages?`,
      ],
      title3: [
        `Run-on 문장을 피하기 위한 방법은?`,
        `How can we avoid it?`,
        's_caf.tip.highlight14.title3',
        `How can we avoid it?`,
        `How can we avoid it?`,
        `How can we avoid it?`,
        `How can we avoid it?`,
      ],
      body1: [
        `2~3개의 문장을 적절한 마침표나 접속사 없이 이어말하는 것을 Run-on Sentence라고 합니다.`,
        `A sentence is considered "run-on" when 2-3 sentences continue one after another without periods or conjunctions dividing them.`,
        's_caf.tip.highlight14.body1',
        `A sentence is considered "run-on" when 2-3 sentences continue one after another without periods or conjunctions dividing them.`,
        `A sentence is considered "run-on" when 2-3 sentences continue one after another without periods or conjunctions dividing them.`,
        `A sentence is considered "run-on" when 2-3 sentences continue one after another without periods or conjunctions dividing them.`,
        `A sentence is considered "run-on" when 2-3 sentences continue one after another without periods or conjunctions dividing them.`,
      ],
      body2: [
        `멈추지 않고 계속 말하는 것이 유창할것이라고 생각하거나, 이어 말하는 습관에 의해 발생합니다.
내용이 이어지지 않는 말을 지속하면 맥락파악이 어려워지고 듣는사람 입장에서 이해하지 못하는 단점이 존재합니다.`,
        `People speak in run-on sentences either because they think speaking continuously make them sound fluent or out of habit.
When sentences run-on without a logical connection, it becomes difficult to understand the context or what you mean to say.`,
        's_caf.tip.highlight14.body2',
        `People speak in run-on sentences either because they think speaking continuously make them sound fluent or out of habit.
When sentences run-on without a logical connection, it becomes difficult to understand the context or what you mean to say.`,
        `People speak in run-on sentences either because they think speaking continuously make them sound fluent or out of habit.
When sentences run-on without a logical connection, it becomes difficult to understand the context or what you mean to say.`,
        `People speak in run-on sentences either because they think speaking continuously make them sound fluent or out of habit.
 When sentences run-on without a logical connection, it becomes difficult to understand the context or what you mean to say.`,
        `People speak in run-on sentences either because they think speaking continuously make them sound fluent or out of habit.
When sentences run-on without a logical connection, it becomes difficult to understand the context or what you mean to say.`,
      ],
      body3: [
        <>
          1. 적절한 의미 단위로 문장을 끊어 말하는 연습을 해보세요. and,so 등을 지속적으로 쓰는 것 대신 명확하게
          마침표로 문장을 마쳐보세요.
          <br />
          <br />
          2. 이어지는 내용이 있다면 Although, However, Therefore 등의 접속사를 사용해서 문장을 적절히 연결하는 연습을
          해보세요.
        </>,
        <>
          1. Practice breaking your sentences into appropriate meaning units. End your sentences with a full stop
          instead of connecting them with "and" or "so."
          <br />
          <br />
          2. If the next sentence is connects to the previous one, practice connecting them properly using conjunctions
          like "Although," "However," and "Therefore."
        </>,
        's_caf.tip.highlight14.body3',
        <>
          1. Practice breaking your sentences into appropriate meaning units. End your sentences with a full stop
          instead of connecting them with "and" or "so."
          <br />
          <br />
          2. If the next sentence is connects to the previous one, practice connecting them properly using conjunctions
          like "Although," "However," and "Therefore."
        </>,
        <>
          1. Practice breaking your sentences into appropriate meaning units. End your sentences with a full stop
          instead of connecting them with "and" or "so."
          <br />
          <br />
          2. If the next sentence is connects to the previous one, practice connecting them properly using conjunctions
          like "Although," "However," and "Therefore."
        </>,
        <>
          1. Practice breaking your sentences into appropriate meaning units. End your sentences with a full stop
          instead of connecting them with "and" or "so."
          <br />
          <br />
          2. If the next sentence is connects to the previous one, practice connecting them properly using conjunctions
          like "Although," "However," and "Therefore."
        </>,
        <>
          1. Practice breaking your sentences into appropriate meaning units. End your sentences with a full stop
          instead of connecting them with "and" or "so."
          <br />
          <br />
          2. If the next sentence is connects to the previous one, practice connecting them properly using conjunctions
          like "Although," "However," and "Therefore."
        </>,
      ],
    },
    highlight16: {
      title1: [
        `필러워드란?`,
        `What are filler words?`,
        's_caf.tip.highlight16.title1',
        `What are filler words?`,
        `What are filler words?`,
        `What are filler words?`,
        `What are filler words?`,
      ],
      title2: [
        `필러워드 사용이 많아졌을때의 원인과 단점은?`,
        `Why do we use them and why are they a problem?`,
        's_caf.tip.highlight16.title2',
        `Why do we use them and why are they a problem?`,
        `Why do we use them and why are they a problem?`,
        `Why do we use them and why are they a problem?`,
        `Why do we use them and why are they a problem?`,
      ],
      title3: [
        `필러워드를 적절히 사용하기 위한 방법은?`,
        `How can we avoid them?`,
        's_caf.tip.highlight16.title3',
        `How can we avoid them?`,
        `How can we avoid them?`,
        `How can we avoid them?`,
        `How can we avoid them?`,
      ],
      body1: [
        `필러워드는 Ah, Umm, uh, huh 처럼 대화 중에 생기는 어색함이나 공백을 채우기 위해 사용되는 단어입니다. 이를 과도하게 사용한 경우를 ‘필러워드 사용이 많았던 구간’으로 진단하고 있습니다.`,
        `Filler words are words used to fill awkwardness or gaps in conversation, such as "ah," "umm," "uh," and "huh." The CAF engine detects sections where you use filler words excessively.`,
        's_caf.tip.highlight16.body1',
        `Filler words are words used to fill awkwardness or gaps in conversation, such as "ah," "umm," "uh," and "huh." The CAF engine detects sections where you use filler words excessively.`,
        `Filler words are words used to fill awkwardness or gaps in conversation, such as "ah," "umm," "uh," and "huh." The CAF engine detects sections where you use filler words excessively.`,
        `Filler words are words used to fill awkwardness or gaps in conversation, such as "ah," "umm," "uh," and "huh." The CAF engine detects sections where you use filler words excessively.`,
        `Filler words are words used to fill awkwardness or gaps in conversation, such as "ah," "umm," "uh," and "huh." The CAF engine detects sections where you use filler words excessively.`,
      ],
      body2: [
        `말을 이어가고 있다는 것을 나타내거나 생각을 정리하는 등의 긍정적인 목적으로 쓰이기도 하지만, 과도하게 사용되는 경우 전문성이 떨어져 보이거나 하고자 하는 말의 목적을 이해하는 데 방해가 되기도 합니다.`,
        `Filler words can be used to indicate that you are in the midst of speaking or organizing your thoughts. However, when used excessively, it can make you look unprofessional or make it difficult to understand what you are trying to say.`,
        's_caf.tip.highlight16.body2',
        `Filler words can be used to indicate that you are in the midst of speaking or organizing your thoughts. However, when used excessively, it can make you look unprofessional or make it difficult to understand what you are trying to say.`,
        `Filler words can be used to indicate that you are in the midst of speaking or organizing your thoughts. However, when used excessively, it can make you look unprofessional or make it difficult to understand what you are trying to say.`,
        `Filler words can be used to indicate that you are in the midst of speaking or organizing your thoughts. However, when used excessively, it can make you look unprofessional or make it difficult to understand what you are trying to say.`,
        `Filler words can be used to indicate that you are in the midst of speaking or organizing your thoughts. However, when used excessively, it can make you look unprofessional or make it difficult to understand what you are trying to say.`,
      ],
      body3: [
        <>
          1. 말을 할 때 다음 단어가 생각이 나지 않는다면, 잠시 말하는 것을 멈추고 생각할 시간을 가져보세요. 필러워드를
          사용하기보단 튜터에게 생각할 시간을 조금 달라고 한 뒤 말하는 것을 추천합니다. <br />
          <br />
          2. 말하기 속도가 너무 빨라 생각할 시간이 필요하거나 속도 조절을 하기 위해 필러워드를 사용하는 경우라면,
          필러워드를 사용하는 것보다 대화에 여유를 가지고 말하기 속도를 늦춰보는 것을 추천합니다.
        </>,
        <>
          1. If you can't think of the word you want to say, take a pause to think rather than using filler words. You
          can ask the tutor to give you some time to think before speaking. <br />
          <br />
          2. If you need time to think because you talk too fast, or if you are using filler words to control your
          speech rate, you should try speaking more slowly rather than using filler words.
        </>,
        's_caf.tip.highlight16.body3',
        <>
          1. If you can't think of the word you want to say, take a pause to think rather than using filler words. You
          can ask the tutor to give you some time to think before speaking. <br />
          <br />
          2. If you need time to think because you talk too fast, or if you are using filler words to control your
          speech rate, you should try speaking more slowly rather than using filler words.
        </>,
        <>
          1. If you can't think of the word you want to say, take a pause to think rather than using filler words. You
          can ask the tutor to give you some time to think before speaking. <br />
          <br />
          2. If you need time to think because you talk too fast, or if you are using filler words to control your
          speech rate, you should try speaking more slowly rather than using filler words.
        </>,
        <>
          1. If you can't think of the word you want to say, take a pause to think rather than using filler words. You
          can ask the tutor to give you some time to think before speaking. <br />
          <br />
          2. If you need time to think because you talk too fast, or if you are using filler words to control your
          speech rate, you should try speaking more slowly rather than using filler words.
        </>,
        <>
          1. If you can't think of the word you want to say, take a pause to think rather than using filler words. You
          can ask the tutor to give you some time to think before speaking. <br />
          <br />
          2. If you need time to think because you talk too fast, or if you are using filler words to control your
          speech rate, you should try speaking more slowly rather than using filler words.
        </>,
      ],
    },
    highlight15: {
      title1: [
        `말하기 속도란?`,
        `What is speech rate?`,
        's_caf.tip.highlight15.title1',
        `What is speech rate?`,
        `What is speech rate?`,
        `What is speech rate?`,
        `What is speech rate?`,
      ],
      title2: [
        `말하기 속도가 느려졌을때의 단점은?`,
        `Why is slow speech rate a problem?`,
        's_caf.tip.highlight15.title2',
        `Why is slow speech rate a problem?`,
        `Why is slow speech rate a problem?`,
        `Why is slow speech rate a problem?`,
        `Why is slow speech rate a problem?`,
      ],
      title3: [
        `말하기 속도를 늘리는 방법은?`,
        `How can it be increased?`,
        's_caf.tip.highlight15.title3',
        `How can it be increased?`,
        `How can it be increased?`,
        `How can it be increased?`,
        `How can it be increased?`,
      ],
      body1: [
        `말하기 속도는 분당 말한 단어의 개수를 wpm(word per minute)의 단위로 표현합니다.
대화 상황에서 적절한 말하기 속도는 120~150 wpm이라고 해요. 대화를 할때 의미 전달에 부정적인 영향을 끼친다고 판단되는 90 wpm 이하의 매우 느린 문장의 경우를 ‘말하기 속도가 느린 구간’으로 진단하고 있습니다.`,
        `Speech rate shows how fast you speak in terms of words per minute (wpm).
The appropriate speaking speed in a conversation is said to be between 120 and 150 wpm. The CAF engine detects "slow speech sections" where you speak at a pace of 90 wpm or less, which is judge too slow to convey what you mean to say clearly.`,
        's_caf.tip.highlight15.body1',
        `Speech rate shows how fast you speak in terms of words per minute (wpm).
The appropriate speaking speed in a conversation is said to be between 120 and 150 wpm. The CAF engine detects "slow speech sections" where you speak at a pace of 90 wpm or less, which is judge too slow to convey what you mean to say clearly.`,
        `Speech rate shows how fast you speak in terms of words per minute (wpm).
The appropriate speaking speed in a conversation is said to be between 120 and 150 wpm. The CAF engine detects "slow speech sections" where you speak at a pace of 90 wpm or less, which is judge too slow to convey what you mean to say clearly.`,
        `Speech rate shows how fast you speak in terms of words per minute (wpm).
 The appropriate speaking speed in a conversation is said to be between 120 and 150 wpm. The CAF engine detects "slow speech sections" where you speak at a pace of 90 wpm or less, which is judge too slow to convey what you mean to say clearly.`,
        `Speech rate shows how fast you speak in terms of words per minute (wpm).
The appropriate speaking speed in a conversation is said to be between 120 and 150 wpm. The CAF engine detects "slow speech sections" where you speak at a pace of 90 wpm or less, which is judge too slow to convey what you mean to say clearly.`,
      ],
      body2: [
        `공백이 많아 말하기 속도가 느려진다면, 듣는 사람이 대화에 집중을 못 하게 되는 경우가 있습니다. 또한 대화의 감정이나 톤이 효과적으로 전달되지 못해, 의도한 대로 대화를 이끌어가기 어려울 수 있습니다.`,
        `Speaking with a lot of silent pauses can distract your listener from the conversation. Also, the listener can have difficulties catching the emotion or tone of the conversation if you talk too slow, making it difficult to lead the conversation as intended.`,
        's_caf.tip.highlight15.body2',
        `Speaking with a lot of silent pauses can distract your listener from the conversation. Also, the listener can have difficulties catching the emotion or tone of the conversation if you talk too slow, making it difficult to lead the conversation as intended.`,
        `Speaking with a lot of silent pauses can distract your listener from the conversation. Also, the listener can have difficulties catching the emotion or tone of the conversation if you talk too slow, making it difficult to lead the conversation as intended.`,
        `Speaking with a lot of silent pauses can distract your listener from the conversation. Also, the listener can have difficulties catching the emotion or tone of the conversation if you talk too slow, making it difficult to lead the conversation as intended.`,
        `Speaking with a lot of silent pauses can distract your listener from the conversation. Also, the listener can have difficulties catching the emotion or tone of the conversation if you talk too slow, making it difficult to lead the conversation as intended.`,
      ],
      body3: [
        <>
          1. 영어를 주기적으로 사용하는 게 가장 큰 도움이 됩니다. 링글 수업을 주기적으로 수강하거나, 이전 수업의
          문장들을 다시 한번 말하면서 영어로 말하는 것을 익숙하게 만들어 보세요.
          <br />
          <br />
          2. 단어가 생각이 나지 않아 말하기 속도가 느려지는 경우가 많습니다. 대화를 시작하기 전에 어떤 내용으로 답변할지
          미리 생각해 보고 적절한 키워드들을 생각해 보는 것도 도움이 될 수 있습니다.
        </>,
        <>
          1. Using English regularly is most helpful. Try to get used to talking English by taking Ringle lessons
          regularly, or by practicing sentences from previous classes.
          <br />
          <br />
          2. If you talk too slowlly because you can't think of the word, it can be helpful to think about what you're
          going to say in advance and come up with appropriate keywords before starting a conversation.
        </>,
        's_caf.tip.highlight15.body3',
        <>
          1. Using English regularly is most helpful. Try to get used to talking English by taking Ringle lessons
          regularly, or by practicing sentences from previous classes.
          <br />
          <br />
          2. If you talk too slowlly because you can't think of the word, it can be helpful to think about what you're
          going to say in advance and come up with appropriate keywords before starting a conversation.
        </>,
        <>
          1. Using English regularly is most helpful. Try to get used to talking English by taking Ringle lessons
          regularly, or by practicing sentences from previous classes.
          <br />
          <br />
          2. If you talk too slowlly because you can't think of the word, it can be helpful to think about what you're
          going to say in advance and come up with appropriate keywords before starting a conversation.
        </>,
        <>
          1. Using English regularly is most helpful. Try to get used to talking English by taking Ringle lessons
          regularly, or by practicing sentences from previous classes.
          <br />
          <br />
          2. If you talk too slowlly because you can't think of the word, it can be helpful to think about what you're
          going to say in advance and come up with appropriate keywords before starting a conversation.
        </>,
        <>
          1. Using English regularly is most helpful. Try to get used to talking English by taking Ringle lessons
          regularly, or by practicing sentences from previous classes.
          <br />
          <br />
          2. If you talk too slowlly because you can't think of the word, it can be helpful to think about what you're
          going to say in advance and come up with appropriate keywords before starting a conversation.
        </>,
      ],
    },
    highlight0: {
      title1: [
        `한정사란?`,
        `What is "incorrect determiner"?`,
        's_caf.tip.highlight0.title1',
        `What is "incorrect determiner"?`,
        `What is "incorrect determiner"?`,
        `What is "incorrect determiner"?`,
        `What is "incorrect determiner"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight0.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight0.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `a/an/the등의 관사, his/her등의 속격, this/that/these의 지시어, some/any/many/few등의 가산성이 포함되며 명사를 수식하는 문법 유형입니다.`,
        `A determiner is a word that modifies a noun and includes articles such as "a/an/the," genitives such as "his/her," demonstratives such as "this/that/these," and countables such as "some/any/many/few.`,
        's_caf.tip.highlight0.body1',
        `A determiner is a word that modifies a noun and includes articles such as "a/an/the," genitives such as "his/her," demonstratives such as "this/that/these," and countables such as "some/any/many/few.`,
        `A determiner is a word that modifies a noun and includes articles such as "a/an/the," genitives such as "his/her," demonstratives such as "this/that/these," and countables such as "some/any/many/few.`,
        `A determiner is a word that modifies a noun and includes articles such as "a/an/the," genitives such as "his/her," demonstratives such as "this/that/these," and countables such as "some/any/many/few.`,
        `A determiner is a word that modifies a noun and includes articles such as "a/an/the," genitives such as "his/her," demonstratives such as "this/that/these," and countables such as "some/any/many/few.`,
      ],
      body2: [
        <>
          한정사가 정확히 어떤 의미와 목적을 가지는지 인지하지 못해 실수하는 경우가 가장 많고, 잘못 사용하는 경우
          말하고자 하는 의미가 정확히 전달되지 않을 수 있습니다.
          <br />
          <br />
          예를 들어, “I would like to work for a company that motivates me.”라는 문장에서 일반적인 회사를 언급하면 a
          company이고, 특정한 회사를 지칭하는 경우 the company라고 지칭해야합니다.
        </>,
        <>
          Most mistakes are made because the speaker does not understand the exact meaning and purpose of determiners.
          Incorrect determiners can hinder the clarity of what you mean to say.
          <br />
          <br />
          Let's take “I would like to work for a/the company that motivates me.” as an example. Here, saying "a company"
          refers to any company in general, and saying "the company" means a specific company.
        </>,
        's_caf.tip.highlight0.body2',
        <>
          Most mistakes are made because the speaker does not understand the exact meaning and purpose of determiners.
          Incorrect determiners can hinder the clarity of what you mean to say.
          <br />
          <br />
          Let's take “I would like to work for a/the company that motivates me.” as an example. Here, saying "a company"
          refers to any company in general, and saying "the company" means a specific company.
        </>,
        <>
          Most mistakes are made because the speaker does not understand the exact meaning and purpose of determiners.
          Incorrect determiners can hinder the clarity of what you mean to say.
          <br />
          <br />
          Let's take “I would like to work for a/the company that motivates me.” as an example. Here, saying "a company"
          refers to any company in general, and saying "the company" means a specific company.
        </>,
        <>
          Most mistakes are made because the speaker does not understand the exact meaning and purpose of determiners.
          Incorrect determiners can hinder the clarity of what you mean to say.
          <br />
          <br />
          Let's take “I would like to work for a/the company that motivates me.” as an example. Here, saying "a company"
          refers to any company in general, and saying "the company" means a specific company.
        </>,
        <>
          Most mistakes are made because the speaker does not understand the exact meaning and purpose of determiners.
          Incorrect determiners can hinder the clarity of what you mean to say.
          <br />
          <br />
          Let's take “I would like to work for a/the company that motivates me.” as an example. Here, saying "a company"
          refers to any company in general, and saying "the company" means a specific company.
        </>,
      ],
      body3: [
        <>
          1. 한정사가 사용된 문장들을 학습해보세요. 아래 수업때 말한 한정사 실수가 있었던 문장, 튜터가 수정해준 문장
          혹은 교재에서 한정사가 사용된 문장들을 학습해보세요.
          <br />
          <br />
          2. 튜터 혹은 원어민은 맥락에 따라 어떤 한정사를 사용하는지 관찰해보세요.
        </>,
        <>
          1. Practice sentences that uses determiners. Review the sentences in which you used the wrong determiner,
          those your tutor corrected for you, or sentences using determiners in the material.
          <br />
          <br />
          2. Pay attention to the determiners tutors or native speakers use depending on the context.
        </>,
        's_caf.tip.highlight0.body3',
        <>
          1. Practice sentences that uses determiners. Review the sentences in which you used the wrong determiner,
          those your tutor corrected for you, or sentences using determiners in the material.
          <br />
          <br />
          2. Pay attention to the determiners tutors or native speakers use depending on the context.
        </>,
        <>
          1. Practice sentences that uses determiners. Review the sentences in which you used the wrong determiner,
          those your tutor corrected for you, or sentences using determiners in the material.
          <br />
          <br />
          2. Pay attention to the determiners tutors or native speakers use depending on the context.
        </>,
        <>
          1. Practice sentences that uses determiners. Review the sentences in which you used the wrong determiner,
          those your tutor corrected for you, or sentences using determiners in the material.
          <br />
          <br />
          2. Pay attention to the determiners tutors or native speakers use depending on the context.
        </>,
        <>
          1. Practice sentences that uses determiners. Review the sentences in which you used the wrong determiner,
          those your tutor corrected for you, or sentences using determiners in the material.
          <br />
          <br />
          2. Pay attention to the determiners tutors or native speakers use depending on the context.
        </>,
      ],
    },
    highlight1: {
      title1: [
        `불변화사란?`,
        `What is "incorrect particle"?`,
        's_caf.tip.highlight1.title1',
        `What is "incorrect particle"?`,
        `What is "incorrect particle"?`,
        `What is "incorrect particle"?`,
        `What is "incorrect particle"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight1.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight1.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `look, turn, take와 같은 동사와 만나서 look up, turn in,  take off 등의 구동사를 이루는 문법 유형입니다.`,
        `A particle is a words such as "up," "in," and "off" that are used with verbs to form phrasal verbs, such as "look up," "turn in," and "take off.`,
        's_caf.tip.highlight1.body1',
        `A particle is a words such as "up," "in," and "off" that are used with verbs to form phrasal verbs, such as "look up," "turn in," and "take off.`,
        `A particle is a words such as "up," "in," and "off" that are used with verbs to form phrasal verbs, such as "look up," "turn in," and "take off.`,
        `A particle is a words such as "up," "in," and "off" that are used with verbs to form phrasal verbs, such as "look up," "turn in," and "take off.`,
        `A particle is a words such as "up," "in," and "off" that are used with verbs to form phrasal verbs, such as "look up," "turn in," and "take off.`,
      ],
      body2: [
        `불변화사는 문맥에 따라 다른 의미를 가지고 사용성도 다양하기 때문에 실수할 가능성이 높습니다.
예를 들어 동사 Turn과 불변화사 In이 결합해 “Turn In”이라는 단어를 만드는 경우 기존 단어들과 매우 다른 “제출하다”라는 의미를 가지기에 적절한 불변화사를 사용하지 않으면 다른 의미로 해석될 수 있습니다.`,
        `Mistakes in using particles are common because they have different meanings and usages depending on the context.
For example, "turn in" (combining the verb "turn" and the particle "in") means “to submit,” which diverges from the meanings of the individual verb and particle. Thus, using the wrong particle can result in a completely different meaning.`,
        's_caf.tip.highlight1.body2',
        `Mistakes in using particles are common because they have different meanings and usages depending on the context.
For example, "turn in" (combining the verb "turn" and the particle "in") means “to submit,” which diverges from the meanings of the individual verb and particle. Thus, using the wrong particle can result in a completely different meaning.`,
        `Mistakes in using particles are common because they have different meanings and usages depending on the context.
For example, "turn in" (combining the verb "turn" and the particle "in") means “to submit,” which diverges from the meanings of the individual verb and particle. Thus, using the wrong particle can result in a completely different meaning.`,
        `Mistakes in using particles are common because they have different meanings and usages depending on the context.
 For example, "turn in" (combining the verb "turn" and the particle "in") means “to submit,” which diverges from the meanings of the individual verb and particle. Thus, using the wrong particle can result in a completely different meaning.`,
        `Mistakes in using particles are common because they have different meanings and usages depending on the context.
For example, "turn in" (combining the verb "turn" and the particle "in") means “to submit,” which diverges from the meanings of the individual verb and particle. Thus, using the wrong particle can result in a completely different meaning.`,
      ],
      body3: [
        <>
          1. CAF 엔진에서 포착한 불변화사 실수들을 확인하고, 적절한 불변화사를 사용할 수 있도록 복습해보세요.
          <br />
          <br />
          2. 또한 표현들을 많이 학습하고 그에 대한 의미를 숙지하는걸 권장드립니다. 해당 표현이 사용된 문장들을 반복해서
          읽다보면 보다 자연스럽게 불변화사를 적절히 사용할 수 있습니다.
        </>,
        <>
          1. Check the mistakes in using particles detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. We also recommended you to learn different expressions and learn their meanings. Reading the sentences with
          those expressions many times will help you learn how to use particles appropriately.
        </>,
        's_caf.tip.highlight1.body3',
        <>
          1. Check the mistakes in using particles detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. We also recommended you to learn different expressions and learn their meanings. Reading the sentences with
          those expressions many times will help you learn how to use particles appropriately.
        </>,
        <>
          1. Check the mistakes in using particles detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. We also recommended you to learn different expressions and learn their meanings. Reading the sentences with
          those expressions many times will help you learn how to use particles appropriately.
        </>,
        <>
          1. Check the mistakes in using particles detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. We also recommended you to learn different expressions and learn their meanings. Reading the sentences with
          those expressions many times will help you learn how to use particles appropriately.
        </>,
        <>
          1. Check the mistakes in using particles detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. We also recommended you to learn different expressions and learn their meanings. Reading the sentences with
          those expressions many times will help you learn how to use particles appropriately.
        </>,
      ],
    },
    highlight2: {
      title1: [
        `전치사란?`,
        `What is "incorrect preposition"?`,
        's_caf.tip.highlight2.title1',
        `What is "incorrect preposition"?`,
        `What is "incorrect preposition"?`,
        `What is "incorrect preposition"?`,
        `What is "incorrect preposition"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight2.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight2.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `명사 앞에 위치해서 시간, 장소, 방향 등을 나타내는 문법 유형입니다. at/in/on/to/about 등이 대표적인 전치사입니다.`,
        `A preposition is a word that is placed before a noun to indicate time, place, direction, etc. Examples of prepositions are "at/in/on/to/about.`,
        's_caf.tip.highlight2.body1',
        `A preposition is a word that is placed before a noun to indicate time, place, direction, etc. Examples of prepositions are "at/in/on/to/about.`,
        `A preposition is a word that is placed before a noun to indicate time, place, direction, etc. Examples of prepositions are "at/in/on/to/about.`,
        `A preposition is a word that is placed before a noun to indicate time, place, direction, etc. Examples of prepositions are "at/in/on/to/about.`,
        `A preposition is a word that is placed before a noun to indicate time, place, direction, etc. Examples of prepositions are "at/in/on/to/about.`,
      ],
      body2: [
        <>
          전치사의 사용법이 영어와 한국어는 많이 다르기 때문에 실수하는 경우가 많고, 익숙하지 않은 구문을 사용하는 경우
          적절한 전치사를 사용하는데 어려움을 겪습니다.
          <br />
          <br />
          전치사를 실수하는 경우에 의도하지 않은 의미로 문장이 받아들여질 수 있습니다. 예를 들어, “Can I put this knife
          on your leg”를 “Can I put this knife in your leg”로 말한다면 칼을 다리 위에 놓는다에서 칼을 찌른다의 의미가 될
          수 있습니다.
        </>,
        <>
          For Koreans, mistakes commonly arise from the different ways prepositions are used in English. Also, people
          often find it hard using appropriate prepositions when using unfamiliar phrases.
          <br />
          <br />
          Using the wrong preposition may make the sentence take on an unintended meaning. For example, saying “Can I
          put this knife in your leg" instead of “Can I put this knife on your leg” changes the meaning from placing a
          knife on the leg to stabbing the leg.
        </>,
        's_caf.tip.highlight2.body2',
        <>
          For Koreans, mistakes commonly arise from the different ways prepositions are used in English. Also, people
          often find it hard using appropriate prepositions when using unfamiliar phrases.
          <br />
          <br />
          Using the wrong preposition may make the sentence take on an unintended meaning. For example, saying “Can I
          put this knife in your leg" instead of “Can I put this knife on your leg” changes the meaning from placing a
          knife on the leg to stabbing the leg.
        </>,
        <>
          For Koreans, mistakes commonly arise from the different ways prepositions are used in English. Also, people
          often find it hard using appropriate prepositions when using unfamiliar phrases.
          <br />
          <br />
          Using the wrong preposition may make the sentence take on an unintended meaning. For example, saying “Can I
          put this knife in your leg" instead of “Can I put this knife on your leg” changes the meaning from placing a
          knife on the leg to stabbing the leg.
        </>,
        <>
          For Koreans, mistakes commonly arise from the different ways prepositions are used in English. Also, people
          often find it hard using appropriate prepositions when using unfamiliar phrases.
          <br />
          <br />
          Using the wrong preposition may make the sentence take on an unintended meaning. For example, saying “Can I
          put this knife in your leg" instead of “Can I put this knife on your leg” changes the meaning from placing a
          knife on the leg to stabbing the leg.
        </>,
        <>
          For Koreans, mistakes commonly arise from the different ways prepositions are used in English. Also, people
          often find it hard using appropriate prepositions when using unfamiliar phrases.
          <br />
          <br />
          Using the wrong preposition may make the sentence take on an unintended meaning. For example, saying “Can I
          put this knife in your leg" instead of “Can I put this knife on your leg” changes the meaning from placing a
          knife on the leg to stabbing the leg.
        </>,
      ],
      body3: [
        <>
          1. CAF 엔진에서 포착한 전치사 실수들을 확인하고, 적절한 전치사를 사용할 수 있도록 복습해보세요.
          <br />
          <br />
          2. 전치사마다의 의미와 사용법을 익히시고, 원어민들이 사용하는 다양한 예제들을 접해보세요.
        </>,
        <>
          1. Check the mistakes in using prepositions detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Learn the meaning and usage of each preposition and go over how they are used by native speakers.
        </>,
        's_caf.tip.highlight2.body3',
        <>
          1. Check the mistakes in using prepositions detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Learn the meaning and usage of each preposition and go over how they are used by native speakers.
        </>,
        <>
          1. Check the mistakes in using prepositions detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Learn the meaning and usage of each preposition and go over how they are used by native speakers.
        </>,
        <>
          1. Check the mistakes in using prepositions detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Learn the meaning and usage of each preposition and go over how they are used by native speakers.
        </>,
        <>
          1. Check the mistakes in using prepositions detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Learn the meaning and usage of each preposition and go over how they are used by native speakers.
        </>,
      ],
    },
    highlight3: {
      title1: [
        `동사 형태란?`,
        `What is "incorrect verb form"?`,
        's_caf.tip.highlight3.title1',
        `What is "incorrect verb form"?`,
        `What is "incorrect verb form"?`,
        `What is "incorrect verb form"?`,
        `What is "incorrect verb form"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight3.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight3.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `단수 복수(+ s), 과거형(+ ed), 현재분사(+ ing) 등 동사의 형태를 결정짓는 문법 유형입니다.`,
        `Verb form determines the form of a verb, such as singular plural (+ s), past tense (+ ed), and present participle (+ ing).`,
        's_caf.tip.highlight3.body1',
        `Verb form determines the form of a verb, such as singular plural (+ s), past tense (+ ed), and present participle (+ ing).`,
        `Verb form determines the form of a verb, such as singular plural (+ s), past tense (+ ed), and present participle (+ ing).`,
        `Verb form determines the form of a verb, such as singular plural (+ s), past tense (+ ed), and present participle (+ ing).`,
        `Verb form determines the form of a verb, such as singular plural (+ s), past tense (+ ed), and present participle (+ ing).`,
      ],
      body2: [
        <>
          표현하고자하는 적절한 의미를 가지는 동사형태를 찾지 못하거나, 동사의 불규칙변화에 대해 인지하지 못하는 경우
          실수하는 경우가 많습니다.
          <br />
          <br />
          동사 형태에 따라서도 의미가 달라질 수 있기에 정확한 의미 전달을 위해 동사 형태를 학습해야합니다. 예를 들어 “I
          eat breakfast this morning” 대신 “I ate breakfast this morning”을 사용해야합니다.
        </>,
        <>
          Mistakes are often made when the speaker does not know the correct verb form for what he/she wants to say or
          is unaware that the verb is an irregular verb.
          <br />
          <br />
          Since the meaning can change depending on the verb form, you need to learn the correct verb form for conveying
          what you mean. For example, you should use “I ate breakfast this morning” instead of “I eat breakfast this
          morning.”
        </>,
        's_caf.tip.highlight3.body2',
        <>
          Mistakes are often made when the speaker does not know the correct verb form for what he/she wants to say or
          is unaware that the verb is an irregular verb.
          <br />
          <br />
          Since the meaning can change depending on the verb form, you need to learn the correct verb form for conveying
          what you mean. For example, you should use “I ate breakfast this morning” instead of “I eat breakfast this
          morning.”
        </>,
        <>
          Mistakes are often made when the speaker does not know the correct verb form for what he/she wants to say or
          is unaware that the verb is an irregular verb.
          <br />
          <br />
          Since the meaning can change depending on the verb form, you need to learn the correct verb form for conveying
          what you mean. For example, you should use “I ate breakfast this morning” instead of “I eat breakfast this
          morning.”
        </>,
        <>
          Mistakes are often made when the speaker does not know the correct verb form for what he/she wants to say or
          is unaware that the verb is an irregular verb.
          <br />
          <br />
          Since the meaning can change depending on the verb form, you need to learn the correct verb form for conveying
          what you mean. For example, you should use “I ate breakfast this morning” instead of “I eat breakfast this
          morning.”
        </>,
        <>
          Mistakes are often made when the speaker does not know the correct verb form for what he/she wants to say or
          is unaware that the verb is an irregular verb.
          <br />
          <br />
          Since the meaning can change depending on the verb form, you need to learn the correct verb form for conveying
          what you mean. For example, you should use “I ate breakfast this morning” instead of “I eat breakfast this
          morning.”
        </>,
      ],
      body3: [
        <>
          1. CAF 엔진에서 포착한 동사 형태 실수들을 확인하고, 적절한 동사 형태를 사용할 수 있도록 복습해보세요.
          <br />
          <br />
          2. 동사 형태에 대한 공부를 하며 외국인들이 어떻게 사용하는지 다양한 예제를 접해보세요.
        </>,
        <>
          1. Check the mistakes in using verb form detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Study different verb forms and go over examples of how native speakers use them.
        </>,
        's_caf.tip.highlight3.body3',
        <>
          1. Check the mistakes in using verb form detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Study different verb forms and go over examples of how native speakers use them.
        </>,
        <>
          1. Check the mistakes in using verb form detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Study different verb forms and go over examples of how native speakers use them.
        </>,
        <>
          1. Check the mistakes in using verb form detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Study different verb forms and go over examples of how native speakers use them.
        </>,
        <>
          1. Check the mistakes in using verb form detected by the CAF engine and review how to use them correctly.
          <br />
          <br />
          2. Study different verb forms and go over examples of how native speakers use them.
        </>,
      ],
    },
    highlight4: {
      title1: [
        `명사 수일치란?`,
        `What is "incorrect noun number"?`,
        's_caf.tip.highlight4.title1',
        `What is "incorrect noun number"?`,
        `What is "incorrect noun number"?`,
        `What is "incorrect noun number"?`,
        `What is "incorrect noun number"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight4.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight4.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `명사가 관련된 단어(대명사, 형용사, 동사 등)와 같은 수(단수/복수)를 가지도록 일치시키는 문법 유형입니다. 예를 들어 one of 복수명사에서 단수명사를 사용하거나 or/and로 병렬로 이어진 단어에서 하나는 복수형, 하나는 명사형으로 사용되는 경우 포착됩니다.`,
        `Noun number refers to the singular/plural agreement of words related to the noun (pronouns, adjectives, verbs, etc.) with noun in the sentence. The CAF engine detects when a singular noun is used after "one of" or when nouns following "or/and" do not match each other.`,
        's_caf.tip.highlight4.body1',
        `Noun number refers to the singular/plural agreement of words related to the noun (pronouns, adjectives, verbs, etc.) with noun in the sentence. The CAF engine detects when a singular noun is used after "one of" or when nouns following "or/and" do not match each other.`,
        `Noun number refers to the singular/plural agreement of words related to the noun (pronouns, adjectives, verbs, etc.) with noun in the sentence. The CAF engine detects when a singular noun is used after "one of" or when nouns following "or/and" do not match each other.`,
        `Noun number refers to the singular/plural agreement of words related to the noun (pronouns, adjectives, verbs, etc.) with noun in the sentence. The CAF engine detects when a singular noun is used after "one of" or when nouns following "or/and" do not match each other.`,
        `Noun number refers to the singular/plural agreement of words related to the noun (pronouns, adjectives, verbs, etc.) with noun in the sentence. The CAF engine detects when a singular noun is used after "one of" or when nouns following "or/and" do not match each other.`,
      ],
      body2: [
        <>
          올바른 명사 수일치를 유지하지 않으면 문장이 불분명하거나 의미가 왜곡될 수 있습니다.
          <br />
          <br />
          예를 들어 “I will watch one of the awards program”대신 “I will watch one of the awards programs”로
          사용해야하며, “listen to their opinions or their story” 대신 “listen to their opinions or their stories”로
          수정해야합니다.
        </>,
        <>
          When noun number is not in agreement, the sentence can become unclear or distorted.
          <br />
          <br />
          For example, you should say “I will watch one of the awards programs” instead of “I will watch one of the
          awards program” and “listen to their opinions or their stories” instead of “listen to their opinions or their
          story.”
        </>,
        's_caf.tip.highlight4.body2',
        <>
          When noun number is not in agreement, the sentence can become unclear or distorted.
          <br />
          <br />
          For example, you should say “I will watch one of the awards programs” instead of “I will watch one of the
          awards program” and “listen to their opinions or their stories” instead of “listen to their opinions or their
          story.”
        </>,
        <>
          When noun number is not in agreement, the sentence can become unclear or distorted.
          <br />
          <br />
          For example, you should say “I will watch one of the awards programs” instead of “I will watch one of the
          awards program” and “listen to their opinions or their stories” instead of “listen to their opinions or their
          story.”
        </>,
        <>
          When noun number is not in agreement, the sentence can become unclear or distorted.
          <br />
          <br />
          For example, you should say “I will watch one of the awards programs” instead of “I will watch one of the
          awards program” and “listen to their opinions or their stories” instead of “listen to their opinions or their
          story.”
        </>,
        <>
          When noun number is not in agreement, the sentence can become unclear or distorted.
          <br />
          <br />
          For example, you should say “I will watch one of the awards programs” instead of “I will watch one of the
          awards program” and “listen to their opinions or their stories” instead of “listen to their opinions or their
          story.”
        </>,
      ],
      body3: [
        <>
          1. CAF 엔진이 잡아준 문장들을 확인하면서 어떤 상황에서 명사 수일치 실수를 하는지 확인해보세요.
          <br />
          <br />
          2. 명사와 그 주변 단어들 간의 관계를 보면서 수일치의 유무에 따른 의미 차이를 비교해보세요.
        </>,
        <>
          1. Review the sentences detected by the CAF engine and check the contexts in which you make mistakes related
          to noun numbers.
          <br />
          <br />
          2. Look at the relationship between a noun and its surrounding words and compare how their meanings change
          depending on noun number agreement.
        </>,
        's_caf.tip.highlight4.body3',
        <>
          1. Review the sentences detected by the CAF engine and check the contexts in which you make mistakes related
          to noun numbers.
          <br />
          <br />
          2. Look at the relationship between a noun and its surrounding words and compare how their meanings change
          depending on noun number agreement.
        </>,
        <>
          1. Review the sentences detected by the CAF engine and check the contexts in which you make mistakes related
          to noun numbers.
          <br />
          <br />
          2. Look at the relationship between a noun and its surrounding words and compare how their meanings change
          depending on noun number agreement.
        </>,
        <>
          1. Review the sentences detected by the CAF engine and check the contexts in which you make mistakes related
          to noun numbers.
          <br />
          <br />
          2. Look at the relationship between a noun and its surrounding words and compare how their meanings change
          depending on noun number agreement.
        </>,
        <>
          1. Review the sentences detected by the CAF engine and check the contexts in which you make mistakes related
          to noun numbers.
          <br />
          <br />
          2. Look at the relationship between a noun and its surrounding words and compare how their meanings change
          depending on noun number agreement.
        </>,
      ],
    },
    highlight7: {
      title1: [
        `주어동사 수일치란?`,
        `What is "incorrect subject-verb agreement"?`,
        's_caf.tip.highlight7.title1',
        `What is "incorrect subject-verb agreement"?`,
        `What is "incorrect subject-verb agreement"?`,
        `What is "incorrect subject-verb agreement"?`,
        `What is "incorrect subject-verb agreement"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight7.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight7.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `복수형의 주어가 사용되었는데 단수형의 동사로 부적절히 사용되거나 그 반대의 상황에서 포착되는 문법 유형입니다. 예를 들어, “The cat chases the mouse.” 대신 “The cat chase the mouse.”를 사용하는 경우 포착됩니다.`,
        `Subject-verb agreement is wrong when the subject is plural but the verb is singular or vice versa. For example, the CAF engine detects when “The cat chase the mouse” is used instead of “The cat chases the mouse.”`,
        's_caf.tip.highlight7.body1',
        `Subject-verb agreement is wrong when the subject is plural but the verb is singular or vice versa. For example, the CAF engine detects when “The cat chase the mouse” is used instead of “The cat chases the mouse.”`,
        `Subject-verb agreement is wrong when the subject is plural but the verb is singular or vice versa. For example, the CAF engine detects when “The cat chase the mouse” is used instead of “The cat chases the mouse.”`,
        `Subject-verb agreement is wrong when the subject is plural but the verb is singular or vice versa. For example, the CAF engine detects when “The cat chase the mouse” is used instead of “The cat chases the mouse.”`,
        `Subject-verb agreement is wrong when the subject is plural but the verb is singular or vice versa. For example, the CAF engine detects when “The cat chase the mouse” is used instead of “The cat chases the mouse.”`,
      ],
      body2: [
        <>
          there + is를 습관적으로 사용하고 뒤에 복수형인 many를 붙여서 어색하게 만드는 경우가 많습니다. 혹은 사용한
          주어가 복수형인지 알지 못한채 습관적으로 단수형 동사를 사용하는 경우도 많습니다.
          <br />
          <br />
          원어민은 단수형 맥락에서 당연히 뒤의 내용도 단수일것으로 기대하지만, 복수형 내용이 나오는 경우 기대한것과 달라
          의미를 파악하기 어려울 수 있어 나의 발화의 전달력이 떨어질 수 있습니다.
        </>,
        <>
          Often, the speaker habitually uses "there + is" then adds "many," which is plural, right afterwards. There are
          also many cases where singular verbs are habitually used without considering whether the subject is singular
          or plural.
          <br />
          <br />
          Native speakers expect the verb to be singular after a singular subject, so it confuses them if a plural verb
          follows a singular subject. Thus, the intended meaning may not be conveyed properly.
        </>,
        's_caf.tip.highlight7.body2',
        <>
          Often, the speaker habitually uses "there + is" then adds "many," which is plural, right afterwards. There are
          also many cases where singular verbs are habitually used without considering whether the subject is singular
          or plural.
          <br />
          <br />
          Native speakers expect the verb to be singular after a singular subject, so it confuses them if a plural verb
          follows a singular subject. Thus, the intended meaning may not be conveyed properly.
        </>,
        <>
          Often, the speaker habitually uses "there + is" then adds "many," which is plural, right afterwards. There are
          also many cases where singular verbs are habitually used without considering whether the subject is singular
          or plural.
          <br />
          <br />
          Native speakers expect the verb to be singular after a singular subject, so it confuses them if a plural verb
          follows a singular subject. Thus, the intended meaning may not be conveyed properly.
        </>,
        <>
          Often, the speaker habitually uses "there + is" then adds "many," which is plural, right afterwards. There are
          also many cases where singular verbs are habitually used without considering whether the subject is singular
          or plural.
          <br />
          <br />
          Native speakers expect the verb to be singular after a singular subject, so it confuses them if a plural verb
          follows a singular subject. Thus, the intended meaning may not be conveyed properly.
        </>,
        <>
          Often, the speaker habitually uses "there + is" then adds "many," which is plural, right afterwards. There are
          also many cases where singular verbs are habitually used without considering whether the subject is singular
          or plural.
          <br />
          <br />
          Native speakers expect the verb to be singular after a singular subject, so it confuses them if a plural verb
          follows a singular subject. Thus, the intended meaning may not be conveyed properly.
        </>,
      ],
      body3: [
        <>
          1. 앞뒤에 복수형/단수형 명사를 사용할건지 생각하고 적절한 동사를 사용하는 연습을 해보세요.
          <br />
          <br />
          2. CAF 엔진에서 포착한 수업에서 내가 말한 문장들을 다시 읽어보며 반복 학습을 진행해보세요.
        </>,
        <>
          1. Think about whether you will be using singular or plural nouns, and practice using matching verbs.
          <br />
          <br />
          2. Check the sentences detected by the CAF engine and review them multiple times.
        </>,
        's_caf.tip.highlight7.body3',
        <>
          1. Think about whether you will be using singular or plural nouns, and practice using matching verbs.
          <br />
          <br />
          2. Check the sentences detected by the CAF engine and review them multiple times.
        </>,
        <>
          1. Think about whether you will be using singular or plural nouns, and practice using matching verbs.
          <br />
          <br />
          2. Check the sentences detected by the CAF engine and review them multiple times.
        </>,
        <>
          1. Think about whether you will be using singular or plural nouns, and practice using matching verbs.
          <br />
          <br />
          2. Check the sentences detected by the CAF engine and review them multiple times.
        </>,
        <>
          1. Think about whether you will be using singular or plural nouns, and practice using matching verbs.
          <br />
          <br />
          2. Check the sentences detected by the CAF engine and review them multiple times.
        </>,
      ],
    },
    highlight5: {
      title1: [
        `단어순서란?`,
        `What is "incorrect word order"?`,
        's_caf.tip.highlight5.title1',
        `What is "incorrect word order"?`,
        `What is "incorrect word order"?`,
        `What is "incorrect word order"?`,
        `What is "incorrect word order"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight5.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight5.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `영어에서는 단어의 순서에 따라 다른 의미를 가지며, 맥락에 따라 단어순서를 적절히 배치하는 문법 유형입니다.`,
        `In English, the order of words can change the meaning of the sentence. Word order refers to the proper arrangement of words according to the context.`,
        's_caf.tip.highlight5.body1',
        `In English, the order of words can change the meaning of the sentence. Word order refers to the proper arrangement of words according to the context.`,
        `In English, the order of words can change the meaning of the sentence. Word order refers to the proper arrangement of words according to the context.`,
        `In English, the order of words can change the meaning of the sentence. Word order refers to the proper arrangement of words according to the context.`,
        `In English, the order of words can change the meaning of the sentence. Word order refers to the proper arrangement of words according to the context.`,
      ],
      body2: [
        <>
          한국어와 영어의 어순이 달라 많이 실수하며, 문장의 의미와 해석이 달라질 수 있습니다.
          <br />
          <br />
          예를 들어 “나는 밥을 먹는다.”를 영어에서는 “I eat a meal.”로 말하는것처럼 동사와 목적어의 순서가 다르게
          표현됩니다.
        </>,
        <>
          Mistakes are common among Koreans because the word order is different between Korean and English and end up
          changing the meaning of the sentence.
          <br />
          <br />
          For example, when saying "I eat a meal" where the verb comes before the object in English, the verb comes
          after the object in Korean.
        </>,
        's_caf.tip.highlight5.body2',
        <>
          Mistakes are common among Koreans because the word order is different between Korean and English and end up
          changing the meaning of the sentence.
          <br />
          <br />
          For example, when saying "I eat a meal" where the verb comes before the object in English, the verb comes
          after the object in Korean.
        </>,
        <>
          Mistakes are common among Koreans because the word order is different between Korean and English and end up
          changing the meaning of the sentence.
          <br />
          <br />
          For example, when saying "I eat a meal" where the verb comes before the object in English, the verb comes
          after the object in Korean.
        </>,
        <>
          Mistakes are common among Koreans because the word order is different between Korean and English and end up
          changing the meaning of the sentence.
          <br />
          <br />
          For example, when saying "I eat a meal" where the verb comes before the object in English, the verb comes
          after the object in Korean.
        </>,
        <>
          Mistakes are common among Koreans because the word order is different between Korean and English and end up
          changing the meaning of the sentence.
          <br />
          <br />
          For example, when saying "I eat a meal" where the verb comes before the object in English, the verb comes
          after the object in Korean.
        </>,
      ],
      body3: [
        `다양한 문장 형식에 친숙해지시는걸 추천드립니다. 가장 흔한 형태는 주어-동사-목적어이지만, 부사, 형용사, 전치사 등이 포함된 다양한 문장 형태를 찾아 읽어보세요.`,
        `Familiarize yourself with diverse types of sentences. While subject-verb-object is the most common, it helps to go over ones that include adverbs, adjectives, prepositions, and more.`,
        's_caf.tip.highlight5.body3',
        `Familiarize yourself with diverse types of sentences. While subject-verb-object is the most common, it helps to go over ones that include adverbs, adjectives, prepositions, and more.`,
        `Familiarize yourself with diverse types of sentences. While subject-verb-object is the most common, it helps to go over ones that include adverbs, adjectives, prepositions, and more.`,
        `Familiarize yourself with diverse types of sentences. While subject-verb-object is the most common, it helps to go over ones that include adverbs, adjectives, prepositions, and more.`,
        `Familiarize yourself with diverse types of sentences. While subject-verb-object is the most common, it helps to go over ones that include adverbs, adjectives, prepositions, and more.`,
      ],
    },
    highlight6: {
      title1: [
        `형태 혼동이란?`,
        `What is "incorrect morphology"?`,
        's_caf.tip.highlight6.title1',
        `What is "incorrect morphology"?`,
        `What is "incorrect morphology"?`,
        `What is "incorrect morphology"?`,
        `What is "incorrect morphology"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight6.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight6.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `단어의 생성 원리와 구조를 적절히 사용했는지 판단하는 문법 유형입니다. 예를들어 child의 복수형은 childs 대신 children, advantage의 부정형은 disadvantage 등이 적절히 사용되었는가를 판단합니다.`,
        `Morphology refers to the formation of words based on their principles and structures. For instance, the CAF engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
        's_caf.tip.highlight6.body1',
        `Morphology refers to the formation of words based on their principles and structures. For instance, the CAF engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
        `Morphology refers to the formation of words based on their principles and structures. For instance, the CAF engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
        `Morphology refers to the formation of words based on their principles and structures. For instance, the CAF engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
        `Morphology refers to the formation of words based on their principles and structures. For instance, the CAF engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
      ],
      body2: [
        <>
          적절한 접미사/접두사를 알지 못하는 경우 해당 유형을 실수할 가능성이 높습니다.
          <br />
          <br />
          또한 적절한 형태로 사용하지 않는경우 원어민들이 말하고자 하는 단어를 이해하지 못할 가능성이 높습니다.
        </>,
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
        's_caf.tip.highlight6.body2',
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
      ],
      body3: [
        <>
          1. 주로 실수 하는 것들을 모아서 실수 했던 문장들을 나의 문장으로 가져오는 것이 필요합니다. 특히 단어
          하나하나를 암기하는 형태가 아니라, 다양한 나의 문장 형태로 저장하는 것을 추천드립니다.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. 또한, 동사의 과거형은 어떻게 변하는지, 형용사/부사로 바뀌는 경우 단어의 형태가 어떻게 변하는지 등을
          학습해보세요.
        </>,
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
        's_caf.tip.highlight6.body3',
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
      ],
    },
    highlight8: {
      title1: [
        `형용사 문법 유형이란?`,
        `What is an "incorrect adjective"?`,
        's_caf.tip.highlight8.title1',
        `What is an "incorrect adjective"?`,
        `What is an "incorrect adjective"?`,
        `What is an "incorrect adjective"?`,
        `What is an "incorrect adjective"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight8.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight8.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `형용사가 어색하게 사용되거나 불필요한 경우 포착하는 문법 유형입니다. 예를 들어 “little city” 대신 “small city”, “The weather is nice for skiing” 대신 “The weather is good for skiing”를 사용해하는 문장을 포착합니다.`,
        `Incorrect adjective use is when adjectives are used awkwardly or unnecessarily. Examples are: saying “little city” instead of “small city,” “The weather is nice for skiing” instead of “The weather is good for skiing.”`,
        's_caf.tip.highlight8.body1',
        `Incorrect adjective use is when adjectives are used awkwardly or unnecessarily. Examples are: saying “little city” instead of “small city,” “The weather is nice for skiing” instead of “The weather is good for skiing.”`,
        `Incorrect adjective use is when adjectives are used awkwardly or unnecessarily. Examples are: saying “little city” instead of “small city,” “The weather is nice for skiing” instead of “The weather is good for skiing.”`,
        `Incorrect adjective use is when adjectives are used awkwardly or unnecessarily. Examples are: saying “little city” instead of “small city,” “The weather is nice for skiing” instead of “The weather is good for skiing.”`,
        `Incorrect adjective use is when adjectives are used awkwardly or unnecessarily. Examples are: saying “little city” instead of “small city,” “The weather is nice for skiing” instead of “The weather is good for skiing.”`,
      ],
      body2: [
        `형용사의 정확한 의미를 파악하지 못하거나 문장의 구조를 잘못잡아 어색한 위치에 형용사를 사용하는 경우 주로 발생합니다.
다른 명사를 수식하게 되거나 다른 의미로 해석되어 소통에 어려움이 있을 수 있습니다.`,
        `This usually occurs when the speaker does not know the exact meaning of the adjective or puts the adjective in an awkward place in the sentence structure.
The adjective may end up modifying the wrong noun or understood incorrectly, causing difficulties in communication.`,
        's_caf.tip.highlight8.body2',
        `This usually occurs when the speaker does not know the exact meaning of the adjective or puts the adjective in an awkward place in the sentence structure.
The adjective may end up modifying the wrong noun or understood incorrectly, causing difficulties in communication.`,
        `This usually occurs when the speaker does not know the exact meaning of the adjective or puts the adjective in an awkward place in the sentence structure.
The adjective may end up modifying the wrong noun or understood incorrectly, causing difficulties in communication.`,
        `This usually occurs when the speaker does not know the exact meaning of the adjective or puts the adjective in an awkward place in the sentence structure.
 The adjective may end up modifying the wrong noun or understood incorrectly, causing difficulties in communication.`,
        `This usually occurs when the speaker does not know the exact meaning of the adjective or puts the adjective in an awkward place in the sentence structure.
The adjective may end up modifying the wrong noun or understood incorrectly, causing difficulties in communication.`,
      ],
      body3: [
        <>
          1. 비슷한 의미를 가진 형용사들을 찾아보고 수업때 말했던 문장을 되돌아보면서 어떤 차이들이 존재하는지
          복습해보세요.
          <br />
          <br />
          2. 다양한 문맥속에서 형용사를 사용하고 튜터에게 피드백을 받아보세요. 사람, 장소, 사물 등 수식하는 대상에 따라
          미묘한 차이가 있을 수 있습니다.
        </>,
        <>
          1. Look up adjectives that have similar meanings and check their differences as you review the sentences you
          spoke duuring lessons.
          <br />
          <br />
          2. Use adjectives in different contexts and get feedback from your tutor. There may be subtle differences
          depending on what the adjective modifies, such as a person, place, or thing.
        </>,
        's_caf.tip.highlight8.body3',
        <>
          1. Look up adjectives that have similar meanings and check their differences as you review the sentences you
          spoke duuring lessons.
          <br />
          <br />
          2. Use adjectives in different contexts and get feedback from your tutor. There may be subtle differences
          depending on what the adjective modifies, such as a person, place, or thing.
        </>,
        <>
          1. Look up adjectives that have similar meanings and check their differences as you review the sentences you
          spoke duuring lessons.
          <br />
          <br />
          2. Use adjectives in different contexts and get feedback from your tutor. There may be subtle differences
          depending on what the adjective modifies, such as a person, place, or thing.
        </>,
        <>
          1. Look up adjectives that have similar meanings and check their differences as you review the sentences you
          spoke duuring lessons.
          <br />
          <br />
          2. Use adjectives in different contexts and get feedback from your tutor. There may be subtle differences
          depending on what the adjective modifies, such as a person, place, or thing.
        </>,
        <>
          1. Look up adjectives that have similar meanings and check their differences as you review the sentences you
          spoke duuring lessons.
          <br />
          <br />
          2. Use adjectives in different contexts and get feedback from your tutor. There may be subtle differences
          depending on what the adjective modifies, such as a person, place, or thing.
        </>,
      ],
    },
    highlight9: {
      title1: [
        `비교급/최상급 문법 유형이란?`,
        `What is an "incorrect comparative/superlative"?`,
        's_caf.tip.highlight9.title1',
        `What is an "incorrect comparative/superlative"?`,
        `What is an "incorrect comparative/superlative"?`,
        `What is an "incorrect comparative/superlative"?`,
        `What is an "incorrect comparative/superlative"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight9.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight9.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `easier이 아닌 more easy, much fastest 등 비교급/최상급 형용사를 잘못 사용하는 경우 포착하는 문법 유형입니다.`,
        `Incorrect comparative/superlative refers to the misuse of comparative/superlative adjectives, such as saying "more easy" instead of "easier" or "much fastest.`,
        's_caf.tip.highlight9.body1',
        `Incorrect comparative/superlative refers to the misuse of comparative/superlative adjectives, such as saying "more easy" instead of "easier" or "much fastest.`,
        `Incorrect comparative/superlative refers to the misuse of comparative/superlative adjectives, such as saying "more easy" instead of "easier" or "much fastest.`,
        `Incorrect comparative/superlative refers to the misuse of comparative/superlative adjectives, such as saying "more easy" instead of "easier" or "much fastest.`,
        `Incorrect comparative/superlative refers to the misuse of comparative/superlative adjectives, such as saying "more easy" instead of "easier" or "much fastest.`,
      ],
      body2: [
        <>
          more + er으로 중복 비교급 혹은 most + est 최상급을 중복으로 쓰는 경우가 많으며, 비교급으로 사용되는 단어를
          모르는 경우가 많습니다.
          <br />
          <br />
          어색한 영어 문법으로 정확한 의미를 전달하거나 듣는 사람에게 Native처럼 느껴지지 않을 가능성이 있습니다.
        </>,
        <>
          A common mistake is redundant usage such as "more + er" or "most + est." Also, the speaker may not know the
          comparative adjective.
          <br />
          <br />
          This kind of mistake can confuse the intended meaning and make the speaker sound awkward and non-native.
        </>,
        's_caf.tip.highlight9.body2',
        <>
          A common mistake is redundant usage such as "more + er" or "most + est." Also, the speaker may not know the
          comparative adjective.
          <br />
          <br />
          This kind of mistake can confuse the intended meaning and make the speaker sound awkward and non-native.
        </>,
        <>
          A common mistake is redundant usage such as "more + er" or "most + est." Also, the speaker may not know the
          comparative adjective.
          <br />
          <br />
          This kind of mistake can confuse the intended meaning and make the speaker sound awkward and non-native.
        </>,
        <>
          A common mistake is redundant usage such as "more + er" or "most + est." Also, the speaker may not know the
          comparative adjective.
          <br />
          <br />
          This kind of mistake can confuse the intended meaning and make the speaker sound awkward and non-native.
        </>,
        <>
          A common mistake is redundant usage such as "more + er" or "most + est." Also, the speaker may not know the
          comparative adjective.
          <br />
          <br />
          This kind of mistake can confuse the intended meaning and make the speaker sound awkward and non-native.
        </>,
      ],
      body3: [
        <>
          1. 자주 틀리는 비교급/최상급 형용사를 찾고, 정확한 사용법을 숙지하세요. 특히 말하는 상황에 의식적으로
          기억하는것을 추천드립니다.
          <br />
          <br />
          2. 몇가지 기억이 안나는 비교급/최상급이 있다면 예문을 만들거나 아래 실수한 문장들을 여러번 반복해서 말해
          기억속에 각인시켜보세요.
        </>,
        <>
          1. Look up the comparatives{'/'}superlatives you often use incorrectly and learn how to use them correctly.
          Try to remember these when speaking.
          <br />
          <br />
          2. If there are comparatives/superlatives that are hard to remember, make sample sentences or go over your
          mistakes many times to imprint them in your memory.
        </>,
        's_caf.tip.highlight9.body3',
        <>
          1. Look up the comparatives{'/'}superlatives you often use incorrectly and learn how to use them correctly.
          Try to remember these when speaking.
          <br />
          <br />
          2. If there are comparatives/superlatives that are hard to remember, make sample sentences or go over your
          mistakes many times to imprint them in your memory.
        </>,
        <>
          1. Look up the comparatives{'/'}superlatives you often use incorrectly and learn how to use them correctly.
          Try to remember these when speaking.
          <br />
          <br />
          2. If there are comparatives/superlatives that are hard to remember, make sample sentences or go over your
          mistakes many times to imprint them in your memory.
        </>,
        <>
          1. Look up the comparatives{'/'}superlatives you often use incorrectly and learn how to use them correctly.
          Try to remember these when speaking.
          <br />
          <br />
          2. If there are comparatives/superlatives that are hard to remember, make sample sentences or go over your
          mistakes many times to imprint them in your memory.
        </>,
        <>
          1. Look up the comparatives{'/'}superlatives you often use incorrectly and learn how to use them correctly.
          Try to remember these when speaking.
          <br />
          <br />
          2. If there are comparatives/superlatives that are hard to remember, make sample sentences or go over your
          mistakes many times to imprint them in your memory.
        </>,
      ],
    },
    highlight10: {
      title1: [
        `부사 문법 실수란?`,
        `What is "incorrect adverb"?`,
        's_caf.tip.highlight10.title1',
        `What is "incorrect adverb"?`,
        `What is "incorrect adverb"?`,
        `What is "incorrect adverb"?`,
        `What is "incorrect adverb"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight10.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight10.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        <>
          “He plays the piano ~~good~~ well.” 과 같은 어색한 부사의 사용, “He speak ~~slow~~ slowly” 부사 대신 형용사를
          사용하는 경우, 잘못된 위치에 부사를 사용하는 경우 등이 포함됩니다.
          <br />
          <br />⇒ “He plays the piano ~~good~~ well.”, “He speak ~~slow~~ slowly” 처럼 어색하거나 잘못된 부사의 용법과
          관련된 문법 유형입니다.
        </>,
        <>
          Incorrect adverb use includes using awkward adverbs (ex. “He plays the piano ~~good~~ well”), using adjectives
          instead of adverbs (ex. “He speak ~~slow~~ slowly”) and putting adverbs in the wrong place.
          <br />
          <br />⇒ This type of mistake is related to using adverbs awkwardly or incorrectly, like “He plays the piano
          ~~good~~ well” or “He speak ~~slow~~ slowly.”
        </>,
        's_caf.tip.highlight10.body1',
        <>
          Incorrect adverb use includes using awkward adverbs (ex. “He plays the piano ~~good~~ well”), using adjectives
          instead of adverbs (ex. “He speak ~~slow~~ slowly”) and putting adverbs in the wrong place.
          <br />
          <br />⇒ This type of mistake is related to using adverbs awkwardly or incorrectly, like “He plays the piano
          ~~good~~ well” or “He speak ~~slow~~ slowly.”
        </>,
        <>
          Incorrect adverb use includes using awkward adverbs (ex. “He plays the piano ~~good~~ well”), using adjectives
          instead of adverbs (ex. “He speak ~~slow~~ slowly”) and putting adverbs in the wrong place.
          <br />
          <br />⇒ This type of mistake is related to using adverbs awkwardly or incorrectly, like “He plays the piano
          ~~good~~ well” or “He speak ~~slow~~ slowly.”
        </>,
        <>
          Incorrect adverb use includes using awkward adverbs (ex. “He plays the piano ~~good~~ well”), using adjectives
          instead of adverbs (ex. “He speak ~~slow~~ slowly”) and putting adverbs in the wrong place.
          <br />
          <br />⇒ This type of mistake is related to using adverbs awkwardly or incorrectly, like “He plays the piano
          ~~good~~ well” or “He speak ~~slow~~ slowly.”
        </>,
        <>
          Incorrect adverb use includes using awkward adverbs (ex. “He plays the piano ~~good~~ well”), using adjectives
          instead of adverbs (ex. “He speak ~~slow~~ slowly”) and putting adverbs in the wrong place.
          <br />
          <br />⇒ This type of mistake is related to using adverbs awkwardly or incorrectly, like “He plays the piano
          ~~good~~ well” or “He speak ~~slow~~ slowly.”
        </>,
      ],
      body2: [
        <>
          형용사로 착각하여 부사를 써서 잘못된 의미가 전달되거나 잘못된 위치에 부사를 사용하여 문장이 어색해지는 경우가
          있습니다.
          <br />
          <br />
          예를 들어, “He works hard”는 열심히 일한다, “He works hardly”는 거의 일하지 않는다의 의미로 다른 의미의 문장이
          됩니다. 또한 “I eat breakfast never.” 대신 “I never eat breakfast”라고 표현해야 정확한 의미 전달이 가능합니다.
        </>,
        <>
          Using an adverb instead of an adjective can deliver the wrong meaning, and using adverbs in the wrong place
          can make the sentence seem awkward.
          <br />
          <br />
          For example, “He works hard” and “He works hardly” convey entirely different meanings. Also, instead of “I eat
          breakfast never," it should be “I never eat breakfast” to convey the precise meaning.
        </>,
        's_caf.tip.highlight10.body2',
        <>
          Using an adverb instead of an adjective can deliver the wrong meaning, and using adverbs in the wrong place
          can make the sentence seem awkward.
          <br />
          <br />
          For example, “He works hard” and “He works hardly” convey entirely different meanings. Also, instead of “I eat
          breakfast never," it should be “I never eat breakfast” to convey the precise meaning.
        </>,
        <>
          Using an adverb instead of an adjective can deliver the wrong meaning, and using adverbs in the wrong place
          can make the sentence seem awkward.
          <br />
          <br />
          For example, “He works hard” and “He works hardly” convey entirely different meanings. Also, instead of “I eat
          breakfast never," it should be “I never eat breakfast” to convey the precise meaning.
        </>,
        <>
          Using an adverb instead of an adjective can deliver the wrong meaning, and using adverbs in the wrong place
          can make the sentence seem awkward.
          <br />
          <br />
          For example, “He works hard” and “He works hardly” convey entirely different meanings. Also, instead of “I eat
          breakfast never," it should be “I never eat breakfast” to convey the precise meaning.
        </>,
        <>
          Using an adverb instead of an adjective can deliver the wrong meaning, and using adverbs in the wrong place
          can make the sentence seem awkward.
          <br />
          <br />
          For example, “He works hard” and “He works hardly” convey entirely different meanings. Also, instead of “I eat
          breakfast never," it should be “I never eat breakfast” to convey the precise meaning.
        </>,
      ],
      body3: [
        <>
          1. CAF 엔진이 포착한 부사 실수 중 어떤 형태로 가장 많이 틀리는지 파악하고, 관련 사용법을 찾아보세요.
          <br />
          <br />
          2. 자주 실수한 형태를 활용하고, 다양한 예문을 만들어 여러번 읽어 말하는 연습을 하는것을 추천드립니다.
        </>,
        <>
          1. Review the wrong adverb usages detected by the CAF engine to check the types of mistakes you make the most
          and learn how to use them correctly.
          <br />
          <br />
          2. Practice adverbs you misuse often by reading sample sentences out loud many times.
        </>,
        's_caf.tip.highlight10.body3',
        <>
          1. Review the wrong adverb usages detected by the CAF engine to check the types of mistakes you make the most
          and learn how to use them correctly.
          <br />
          <br />
          2. Practice adverbs you misuse often by reading sample sentences out loud many times.
        </>,
        <>
          1. Review the wrong adverb usages detected by the CAF engine to check the types of mistakes you make the most
          and learn how to use them correctly.
          <br />
          <br />
          2. Practice adverbs you misuse often by reading sample sentences out loud many times.
        </>,
        <>
          1. Review the wrong adverb usages detected by the CAF engine to check the types of mistakes you make the most
          and learn how to use them correctly.
          <br />
          <br />
          2. Practice adverbs you misuse often by reading sample sentences out loud many times.
        </>,
        <>
          1. Review the wrong adverb usages detected by the CAF engine to check the types of mistakes you make the most
          and learn how to use them correctly.
          <br />
          <br />
          2. Practice adverbs you misuse often by reading sample sentences out loud many times.
        </>,
      ],
    },
    highlight11: {
      title1: [
        `가산/불가산 명사 문법 실수란?`,
        `What is "incorrect noun inflection"?`,
        's_caf.tip.highlight11.title1',
        `What is "incorrect noun inflection"?`,
        `What is "incorrect noun inflection"?`,
        `What is "incorrect noun inflection"?`,
        `What is "incorrect noun inflection"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight11.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight11.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `영어 단어에는 셀수있는 명사가 있고, 셀수없는 명사가 있는데, 셀 수 없는 명사에 s를 붙여서 셀 수 있는 명사로 말하는 경우 가산/불가산 명사 문법 실수로 포착하고 있습니다.`,
        `In English, there are countable nouns and uncountable nouns. Cases where an "s" is attached at the end of an uncountable noun and used as a countable noun are detected by the CAF engine as a noun inflection mistake.`,
        's_caf.tip.highlight11.body1',
        `In English, there are countable nouns and uncountable nouns. Cases where an "s" is attached at the end of an uncountable noun and used as a countable noun are detected by the CAF engine as a noun inflection mistake.`,
        `In English, there are countable nouns and uncountable nouns. Cases where an "s" is attached at the end of an uncountable noun and used as a countable noun are detected by the CAF engine as a noun inflection mistake.`,
        `In English, there are countable nouns and uncountable nouns. Cases where an "s" is attached at the end of an uncountable noun and used as a countable noun are detected by the CAF engine as a noun inflection mistake.`,
        `In English, there are countable nouns and uncountable nouns. Cases where an "s" is attached at the end of an uncountable noun and used as a countable noun are detected by the CAF engine as a noun inflection mistake.`,
      ],
      body2: [
        `s가 붙을것 같지만 안붙는 불가산 명사를 가장 많이 실수합니다. 예를 들어 feedback이라는 단어는 복수형이 될 수 있을것 같지만, 그렇게 쓰이지 않습니다. “Ringle appreciates both positive and negative feedback from users.” 긍정적이고 부정적인 피드백을 모두 환영한다에서도 “s”를 붙이지 않습니다.`,
        `The most common mistake is adding an "s" at the end of an uncountable noun. For example, the word "feedback" seems like it may be changed to plural form by adding an "s," but this is incorrect. For instance, in “Ringle appreciates both positive and negative feedback from users,” there is no "s" after feedback.`,
        's_caf.tip.highlight11.body2',
        `The most common mistake is adding an "s" at the end of an uncountable noun. For example, the word "feedback" seems like it may be changed to plural form by adding an "s," but this is incorrect. For instance, in “Ringle appreciates both positive and negative feedback from users,” there is no "s" after feedback.`,
        `The most common mistake is adding an "s" at the end of an uncountable noun. For example, the word "feedback" seems like it may be changed to plural form by adding an "s," but this is incorrect. For instance, in “Ringle appreciates both positive and negative feedback from users,” there is no "s" after feedback.`,
        `The most common mistake is adding an "s" at the end of an uncountable noun. For example, the word "feedback" seems like it may be changed to plural form by adding an "s," but this is incorrect. For instance, in “Ringle appreciates both positive and negative feedback from users,” there is no "s" after feedback.`,
        `The most common mistake is adding an "s" at the end of an uncountable noun. For example, the word "feedback" seems like it may be changed to plural form by adding an "s," but this is incorrect. For instance, in “Ringle appreciates both positive and negative feedback from users,” there is no "s" after feedback.`,
      ],
      body3: [
        <>
          1. 틀리는 특정한 단어들이 있다면, 해당 단어들의 사용법만 추가적으로 익히시면 금방 가산/불가산 명사 문법 유형의
          정확도가 올라갈 것으로 기대됩니다. <br />
          <br />
          2. 이외에 추가적인 실수를 방지하기 위해 미리 불가산 명사에 대해 숙지하는것도 추천드립니다.
        </>,
        <>
          1. If you use certain words incorrectly, you'll be able to increase your accuracy for this type of mistakes
          quickly by learning how to use those words. <br />
          <br />
          2. To prevent additional mistakes, familiarize yourself with other uncountable nouns beforehand.
        </>,
        's_caf.tip.highlight11.body3',
        <>
          1. If you use certain words incorrectly, you'll be able to increase your accuracy for this type of mistakes
          quickly by learning how to use those words. <br />
          <br />
          2. To prevent additional mistakes, familiarize yourself with other uncountable nouns beforehand.
        </>,
        <>
          1. If you use certain words incorrectly, you'll be able to increase your accuracy for this type of mistakes
          quickly by learning how to use those words. <br />
          <br />
          2. To prevent additional mistakes, familiarize yourself with other uncountable nouns beforehand.
        </>,
        <>
          1. If you use certain words incorrectly, you'll be able to increase your accuracy for this type of mistakes
          quickly by learning how to use those words. <br />
          <br />
          2. To prevent additional mistakes, familiarize yourself with other uncountable nouns beforehand.
        </>,
        <>
          1. If you use certain words incorrectly, you'll be able to increase your accuracy for this type of mistakes
          quickly by learning how to use those words. <br />
          <br />
          2. To prevent additional mistakes, familiarize yourself with other uncountable nouns beforehand.
        </>,
      ],
    },
    highlight12: {
      title1: [
        `동사 시제 변화 문법 실수란?`,
        `What is "incorrect verb tense"?`,
        's_caf.tip.highlight12.title1',
        `What is "incorrect verb tense"?`,
        `What is "incorrect verb tense"?`,
        `What is "incorrect verb tense"?`,
        `What is "incorrect verb tense"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        's_caf.tip.highlight12.title2',
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        's_caf.tip.highlight12.title3',
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `수동태를 사용할때, would/could의 조동사 및 동사의 과거형이 잘못 사용된 경우, 혹은 의미상 시제가 잘못된 경우를 동사 시제 문법 실수로 포착하고 있습니다. 예를 들어 “When I am eating food, I saw him”는 의미상 어색하여 “When I was eating food, I saw him.”이 되어야 합니다.`,
        `The incorrect use of "would/could" as an auxillary verb or the past tense of "will/can" and the wrong use of verb tenses semantically or in passive voice are detected by the CAF engine as mistakes. For example, “When I am eating food, I saw him” is semantically awkward and should be “When I was eating food, I saw him.”`,
        's_caf.tip.highlight12.body1',
        `The incorrect use of "would/could" as an auxillary verb or the past tense of "will/can" and the wrong use of verb tenses semantically or in passive voice are detected by the CAF engine as mistakes. For example, “When I am eating food, I saw him” is semantically awkward and should be “When I was eating food, I saw him.”`,
        `The incorrect use of "would/could" as an auxillary verb or the past tense of "will/can" and the wrong use of verb tenses semantically or in passive voice are detected by the CAF engine as mistakes. For example, “When I am eating food, I saw him” is semantically awkward and should be “When I was eating food, I saw him.”`,
        `The incorrect use of "would/could" as an auxillary verb or the past tense of "will/can" and the wrong use of verb tenses semantically or in passive voice are detected by the CAF engine as mistakes. For example, “When I am eating food, I saw him” is semantically awkward and should be “When I was eating food, I saw him.”`,
        `The incorrect use of "would/could" as an auxillary verb or the past tense of "will/can" and the wrong use of verb tenses semantically or in passive voice are detected by the CAF engine as mistakes. For example, “When I am eating food, I saw him” is semantically awkward and should be “When I was eating food, I saw him.”`,
      ],
      body2: [
        <>
          시제가 바뀌면 듣는 원어민 입장에서 맥락이 뒤죽박죽이 되어 본래 뜻을 이해하기 굉장히 힘들어서 특히 주의가
          필요합니다.
          <br />
          <br />
          예를 들어 “너 감기 걸려본적 있어?”라고 물어보는것을 “Did you get a cold?”라고 말한다면 “과거 특정 시점에
          감기가 걸렸었니”의 의미로 전달됩니다.
        </>,
        <>
          Verb tense requires special attention because using the wrong tense can confuse the context and make it very
          difficult to grasp the intended meaning.
          <br />
          <br />
          For example, if you ask “Did you get a cold?” instead of “Have you ever caught a cold?,” you end up asking
          “Have you catch a cold at some point in the past?”
        </>,
        's_caf.tip.highlight12.body2',
        <>
          Verb tense requires special attention because using the wrong tense can confuse the context and make it very
          difficult to grasp the intended meaning.
          <br />
          <br />
          For example, if you ask “Did you get a cold?” instead of “Have you ever caught a cold?,” you end up asking
          “Have you catch a cold at some point in the past?”
        </>,
        <>
          Verb tense requires special attention because using the wrong tense can confuse the context and make it very
          difficult to grasp the intended meaning.
          <br />
          <br />
          For example, if you ask “Did you get a cold?” instead of “Have you ever caught a cold?,” you end up asking
          “Have you catch a cold at some point in the past?”
        </>,
        <>
          Verb tense requires special attention because using the wrong tense can confuse the context and make it very
          difficult to grasp the intended meaning.
          <br />
          <br />
          For example, if you ask “Did you get a cold?” instead of “Have you ever caught a cold?,” you end up asking
          “Have you catch a cold at some point in the past?”
        </>,
        <>
          Verb tense requires special attention because using the wrong tense can confuse the context and make it very
          difficult to grasp the intended meaning.
          <br />
          <br />
          For example, if you ask “Did you get a cold?” instead of “Have you ever caught a cold?,” you end up asking
          “Have you catch a cold at some point in the past?”
        </>,
      ],
      body3: [
        `동사 시제 실수는 범위기 넓기에 세부 유형에서 어떤것들을 자주 틀리는지 확인하고, 하나하나가 명확하게 어떻게 쓰여야하는지 체크하는것을 추천드립니다.`,
        `There are various types of verb tense mistakes, so you should check which types you misuse often and learn the correct verb tense for each case.`,
        's_caf.tip.highlight12.body3',
        `There are various types of verb tense mistakes, so you should check which types you misuse often and learn the correct verb tense for each case.`,
        `There are various types of verb tense mistakes, so you should check which types you misuse often and learn the correct verb tense for each case.`,
        `There are various types of verb tense mistakes, so you should check which types you misuse often and learn the correct verb tense for each case.`,
        `There are various types of verb tense mistakes, so you should check which types you misuse often and learn the correct verb tense for each case.`,
      ],
    },
    highlight17: {
      title1: [
        `단문이란?`,
        `What is a simple sentence?`,
        's_caf.tip.highlight17.title1',
        `What is a simple sentence?`,
        `What is a simple sentence?`,
        `What is a simple sentence?`,
        `What is a simple sentence?`,
      ],
      title2: [
        `중문이란?`,
        `What is a compound sentence?`,
        's_caf.tip.highlight17.title2',
        `What is a compound sentence?`,
        `What is a compound sentence?`,
        `What is a compound sentence?`,
        `What is a compound sentence?`,
      ],
      title3: [
        `복잡한 문장 구조(복문)란?`,
        `What is a complex sentence?`,
        's_caf.tip.highlight17.title3',
        `What is a complex sentence?`,
        `What is a complex sentence?`,
        `What is a complex sentence?`,
        `What is a complex sentence?`,
      ],
      title4: [
        `복잡한 문장 구조를 사용해야 하는 이유는?`,
        `Why should we use complex sentences?`,
        's_caf.tip.highlight17.title4',
        `Why should we use complex sentences?`,
        `Why should we use complex sentences?`,
        `Why should we use complex sentences?`,
        `Why should we use complex sentences?`,
      ],
      title5: [
        `복잡한 문장 구조를 사용하는 방법은?`,
        `How can we learn how to use complex sentences?`,
        's_caf.tip.highlight17.title5',
        `How can we learn how to use complex sentences?`,
        `How can we learn how to use complex sentences?`,
        `How can we learn how to use complex sentences?`,
        `How can we learn how to use complex sentences?`,
      ],
      body1: [
        `단문은 주어와 동사가 하나씩만 사용된 문장을 의미합니다.`,
        `A simple sentence has one subject and one verb.`,
        's_caf.tip.highlight17.body1',
        `A simple sentence has one subject and one verb.`,
        `A simple sentence has one subject and one verb.`,
        `A simple sentence has one subject and one verb.`,
        `A simple sentence has one subject and one verb.`,
      ],
      body2: [
        `중문은 두 개의 단문이 접속사로 연결된 문장을 의미합니다.`,
        `A compound sentence connects two clauses using a conjunction.`,
        's_caf.tip.highlight17.body2',
        `A compound sentence connects two clauses using a conjunction.`,
        `A compound sentence connects two clauses using a conjunction.`,
        `A compound sentence connects two clauses using a conjunction.`,
        `A compound sentence connects two clauses using a conjunction.`,
      ],
      body3: [
        `종속접속사로 연결된 종속절을 포함하는 문장을 복문이라고 합니다.`,
        `A complex sentence includes a dependent clause that is connected by a subordinating conjunction.`,
        's_caf.tip.highlight17.body3',
        `A complex sentence includes a dependent clause that is connected by a subordinating conjunction.`,
        `A complex sentence includes a dependent clause that is connected by a subordinating conjunction.`,
        `A complex sentence includes a dependent clause that is connected by a subordinating conjunction.`,
        `A complex sentence includes a dependent clause that is connected by a subordinating conjunction.`,
      ],
      body4: [
        `모든 발화에서 복문을 사용하는 것이 좋은 말하기 습관인 것은 아닙니다. 단, 복문으로 표현할 수 있는 상황에서 단문이나 중문을 자주 사용할 경우 한 문장 내의 복잡하고 다양한 생각을 전달하기 어려울 수 있습니다. 또한 단문이나 중문은 문장 간의 관계를 나타내는 데 제한이 있어 표현이 단조롭고 끊기는 듯한 느낌을 줄 수 있습니다. 따라서 상황과 표현에 따라 적절하게 복문을 사용할 수 있도록 학습해야 합니다.`,
        `It's not necessarily a good habit to use complex sentences every time. However, sticking to simple or compound sentences can make your speech sound monotonous and disjointed as they can limit the expression of complex ideas or the relationships between sentences. So, it is important to learn how to use complex sentences appropriately.`,
        's_caf.tip.highlight17.body4',
        `It's not necessarily a good habit to use complex sentences every time. However, sticking to simple or compound sentences can make your speech sound monotonous and disjointed as they can limit the expression of complex ideas or the relationships between sentences. So, it is important to learn how to use complex sentences appropriately.`,
        `It's not necessarily a good habit to use complex sentences every time. However, sticking to simple or compound sentences can make your speech sound monotonous and disjointed as they can limit the expression of complex ideas or the relationships between sentences. So, it is important to learn how to use complex sentences appropriately.`,
        `It's not necessarily a good habit to use complex sentences every time. However, sticking to simple or compound sentences can make your speech sound monotonous and disjointed as they can limit the expression of complex ideas or the relationships between sentences. So, it is important to learn how to use complex sentences appropriately.`,
        `It's not necessarily a good habit to use complex sentences every time. However, sticking to simple or compound sentences can make your speech sound monotonous and disjointed as they can limit the expression of complex ideas or the relationships between sentences. So, it is important to learn how to use complex sentences appropriately.`,
      ],
      body5: [
        `1. 단문을 복문으로 전환하는 방법에는 부사절, 관계절, 명사절 사용이 있습니다. 각각이 언제, 어떻게 사용되는 지 공부하는 것이 가장 큰 도움이 됩니다.
    - 부사절 : I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - 관계절 : I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - 명사절 : I know what the answer is.
2. AI가 교정한 문장들을 보면서 반복해서 말하는 연습을 해보며 익숙해지도록 만들어보세요.`,
        `1. You can use an adverb/relative/noun clause to change a simple sentence into a complex one. It helps to learn when and how each of these clauses are used. 
    - Adverb clause: I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - Relative clause: I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - Noun clause: I know what the answer is.
2. Try to familiarize yourself with complex sentences by reading the AI-proofread sentences out loud many times.`,
        's_caf.tip.highlight17.body5',
        `1. You can use an adverb/relative/noun clause to change a simple sentence into a complex one. It helps to learn when and how each of these clauses are used. 
    - Adverb clause: I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - Relative clause: I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - Noun clause: I know what the answer is.
2. Try to familiarize yourself with complex sentences by reading the AI-proofread sentences out loud many times.`,
        `1. You can use an adverb/relative/noun clause to change a simple sentence into a complex one. It helps to learn when and how each of these clauses are used. 
    - Adverb clause: I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - Relative clause: I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - Noun clause: I know what the answer is.
2. Try to familiarize yourself with complex sentences by reading the AI-proofread sentences out loud many times.`,
        `1. You can use an adverb/relative/noun clause to change a simple sentence into a complex one. It helps to learn when and how each of these clauses are used. 
  - Adverb clause: I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
  - Relative clause: I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
  - Noun clause: I know what the answer is.
 2. Try to familiarize yourself with complex sentences by reading the AI-proofread sentences out loud many times.`,
        `1. You can use an adverb/relative/noun clause to change a simple sentence into a complex one. It helps to learn when and how each of these clauses are used. 
    - Adverb clause: I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - Relative clause: I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - Noun clause: I know what the answer is.
2. Try to familiarize yourself with complex sentences by reading the AI-proofread sentences out loud many times.`,
      ],
    },
  },
  level_detail: {
    stat_info: [
      `*5000여명의 링글 학습자의 진단 데이터를 토대로 제공되는 레벨 분포입니다.`,
      `*Level distribution is provided based on the data of 5,000+ Ringle users.`,
      's_caf.level_detail.stat_info',
      `*Level distribution is provided based on the data of 5,000+ Ringle users.`,
      `*Level distribution is provided based on the data of 5,000+ Ringle users.`,
      `*Level distribution is provided based on the data of 5,000+ Ringle users.`,
      `*Level distribution is provided based on the data of 5,000+ Ringle users.`,
    ],
    c: {
      title: [
        `Complexity 레벨`,
        `Complexity Level`,
        's_caf.level_detail.c.title',
        `Complexity Level`,
        `Complexity Level`,
        `Complexity Level`,
        `Complexity Level`,
      ],
      level9: [
        `모든 주제에서 유연하고 정확한 어휘를 사용하고 관용적인 언어를 자연스럽고 정확하게 사용합니다.`,
        `Uses flexible and precise vocabulary for all topics and applies idiomatic expressions suitably and clearly.`,
        's_caf.level_detail.c.level9',
        `Uses flexible and precise vocabulary for all topics and applies idiomatic expressions suitably and clearly.`,
        `Uses flexible and precise vocabulary for all topics and applies idiomatic expressions suitably and clearly.`,
        `Uses flexible and precise vocabulary for all topics and applies idiomatic expressions suitably and clearly.`,
        `Uses flexible and precise vocabulary for all topics and applies idiomatic expressions suitably and clearly.`,
      ],
      level8: [
        `다양한 단어를 쉽고 유연하게 사용하여 정확한 의미를 전달합니다. 고급 어휘를 능숙하게 사용하지만, 가끔 부정확합니다. 필요에 따라 구문을 효과적으로 사용합니다.`,
        `Uses a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
        's_caf.level_detail.c.level8',
        `Uses a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
        `Uses a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
        `Uses a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
        `Uses a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
      ],
      level7: [
        `다양한 주제를 논의하기 위해 어휘를 유연하게 구사합니다. 몇몇 고급 어휘를 사용할 줄 알고, 대부분은 반복 단어를 대체할 줄 압니다.`,
        `Employs vocabulary flexibly when discussing different topics, including some advanced vocabulary, and knows how to substitute repetitive words.`,
        's_caf.level_detail.c.level7',
        `Employs vocabulary flexibly when discussing different topics, including some advanced vocabulary, and knows how to substitute repetitive words.`,
        `Employs vocabulary flexibly when discussing different topics, including some advanced vocabulary, and knows how to substitute repetitive words.`,
        `Employs vocabulary flexibly when discussing different topics, including some advanced vocabulary, and knows how to substitute repetitive words.`,
        `Employs vocabulary flexibly when discussing different topics, including some advanced vocabulary, and knows how to substitute repetitive words.`,
      ],
      level6: [
        `대부분의 경우에 주제에 대해 길고 분명하게 의미를 전달할 수 있을 만큼 충분한 어휘력이 있습니다. 하지만, 종종 부적절한 경우가 있습니다.`,
        `Has sufficient vocabulary to communicate precisely and lengthily on the topic, but may show inappropriate word choice at times.`,
        's_caf.level_detail.c.level6',
        `Has sufficient vocabulary to communicate precisely and lengthily on the topic, but may show inappropriate word choice at times.`,
        `Has sufficient vocabulary to communicate precisely and lengthily on the topic, but may show inappropriate word choice at times.`,
        `Has sufficient vocabulary to communicate precisely and lengthily on the topic, but may show inappropriate word choice at times.`,
        `Has sufficient vocabulary to communicate precisely and lengthily on the topic, but may show inappropriate word choice at times.`,
      ],
      level5: [
        `익숙하지 않은 주제에 관해서도 이야기할 수 있지만, 제한된 범위의 단어들을 사용합니다.`,
        `Can converse freely even on unfamiliar topics but with a limited vocabulary.`,
        's_caf.level_detail.c.level5',
        `Can converse freely even on unfamiliar topics but with a limited vocabulary.`,
        `Can converse freely even on unfamiliar topics but with a limited vocabulary.`,
        `Can converse freely even on unfamiliar topics but with a limited vocabulary.`,
        `Can converse freely even on unfamiliar topics but with a limited vocabulary.`,
      ],
      level4: [
        `익숙한 주제에 대해서 잘 논의할 수 있지만, 익숙하지 않은 주제일 경우 기본적인 의미만 전달하며, 단어 선택에 있어 실수가 종종 있습니다.`,
        `Can discuss familiar topics well but is able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
        's_caf.level_detail.c.level4',
        `Can discuss familiar topics well but is able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
        `Can discuss familiar topics well but is able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
        `Can discuss familiar topics well but is able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
        `Can discuss familiar topics well but is able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
      ],
      level3: [
        `개인적인 정보를 전달하기 위해 단순한 단어들만 사용하고, 덜 친숙한 주제의 경우 적절한 단어를 사용하는 데에 어려움을 겪습니다.`,
        `Uses simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
        's_caf.level_detail.c.level3',
        `Uses simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
        `Uses simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
        `Uses simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
        `Uses simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
      ],
      level2: [
        `매번 사용하는 단어나 암기한 단어를 위주로 사용합니다.`,
        `Uses the same set of words or those that have been memorized.`,
        's_caf.level_detail.c.level2',
        `Uses the same set of words or those that have been memorized.`,
        `Uses the same set of words or those that have been memorized.`,
        `Uses the same set of words or those that have been memorized.`,
        `Uses the same set of words or those that have been memorized.`,
      ],
      level1: [
        `제한된 몇가지 단어만 사용합니다.`,
        `Only uses only a limited number of words.`,
        's_caf.level_detail.c.level1',
        `Only uses only a limited number of words.`,
        `Only uses only a limited number of words.`,
        `Only uses only a limited number of words.`,
        `Only uses only a limited number of words.`,
      ],
    },
    a: {
      title: [
        `Accuracy 레벨`,
        `Accuracy Level`,
        's_caf.level_detail.a.title',
        `Accuracy Level`,
        `Accuracy Level`,
        `Accuracy Level`,
        `Accuracy Level`,
      ],
      level9: [
        `모든 문법을 정확하고 적절하게 사용할 줄 알며, 원어민이 하는 정도의 문법 실수만 합니다.`,
        `Uses correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
        's_caf.level_detail.a.level9',
        `Uses correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
        `Uses correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
        `Uses correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
        `Uses correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
      ],
      level8: [
        `다양한 형태의 문법 구조를 유연하게 사용하며, 대부분의 문장에 문법적 오류가 없습니다. 다만, 가끔 기본적인 문법 실수를 합니다.`,
        `Can flexibly employ diverse grammar structures and construct flawless sentences, although basic grammar mistakes are made every now and then.`,
        's_caf.level_detail.a.level8',
        `Can flexibly employ diverse grammar structures and construct flawless sentences, although basic grammar mistakes are made every now and then.`,
        `Can flexibly employ diverse grammar structures and construct flawless sentences, although basic grammar mistakes are made every now and then.`,
        `Can flexibly employ diverse grammar structures and construct flawless sentences, although basic grammar mistakes are made every now and then.`,
        `Can flexibly employ diverse grammar structures and construct flawless sentences, although basic grammar mistakes are made every now and then.`,
      ],
      level7: [
        `복잡한 문법 구조를 어느정도 유연하게 사용할 줄 알며, 자주 문법적 실수가 없는 문장을 사용합니다. 다만, 비슷한 문법 실수를 반복합니다.`,
        `Can employ complex grammar structures with some flexibility and often constructs flawless sentences, but tends to make similar grammar mistakes.`,
        's_caf.level_detail.a.level7',
        `Can employ complex grammar structures with some flexibility and often constructs flawless sentences, but tends to make similar grammar mistakes.`,
        `Can employ complex grammar structures with some flexibility and often constructs flawless sentences, but tends to make similar grammar mistakes.`,
        `Can employ complex grammar structures with some flexibility and often constructs flawless sentences, but tends to make similar grammar mistakes.`,
        `Can employ complex grammar structures with some flexibility and often constructs flawless sentences, but tends to make similar grammar mistakes.`,
      ],
      level6: [
        `단순한 문법 구조뿐 아니라 복잡한 문법 구조를 혼합하여 사용할 줄 알지만, 고급 문법을 사용할 때 실수가 잦아집니다.`,
        `Knows how to use both simple and complex grammar structures, but makes mistakes often when using more advanced grammar.`,
        's_caf.level_detail.a.level6',
        `Knows how to use both simple and complex grammar structures, but makes mistakes often when using more advanced grammar.`,
        `Knows how to use both simple and complex grammar structures, but makes mistakes often when using more advanced grammar.`,
        `Knows how to use both simple and complex grammar structures, but makes mistakes often when using more advanced grammar.`,
        `Knows how to use both simple and complex grammar structures, but makes mistakes often when using more advanced grammar.`,
      ],
      level5: [
        `기본 문장들은 정확도에 큰 무리 없이 사용하고, 익숙한 복잡한 문법 구조를 사용할 줄 압니다. 다만, 복잡한 문법 구조를 사용할때, 문법 실수로 인해 상대방이 이해하는데 어려움을 겪을 수 있습니다.`,
        `Can construct basic sentences quite accurately and uses complex grammar structures that are familiar. However, complex sentences can be difficult to understand due to grammar mistakes.`,
        's_caf.level_detail.a.level5',
        `Can construct basic sentences quite accurately and uses complex grammar structures that are familiar. However, complex sentences can be difficult to understand due to grammar mistakes.`,
        `Can construct basic sentences quite accurately and uses complex grammar structures that are familiar. However, complex sentences can be difficult to understand due to grammar mistakes.`,
        `Can construct basic sentences quite accurately and uses complex grammar structures that are familiar. However, complex sentences can be difficult to understand due to grammar mistakes.`,
        `Can construct basic sentences quite accurately and uses complex grammar structures that are familiar. However, complex sentences can be difficult to understand due to grammar mistakes.`,
      ],
      level4: [
        `기본적인 문장들을 만들어낼 수 있지만, 복잡한 문장들은 잘 사용하지 않습니다. 문법 실수가 꽤 잦은 편이며, 가끔 상대방이 이해하는 데 어려움을 겪을 수 있습니다.`,
        `Can speak basic sentences but rarely constructs complex ones. Also, grammar mistakes are fairly common and can sometimes be difficult to understand.`,
        's_caf.level_detail.a.level4',
        `Can speak basic sentences but rarely constructs complex ones. Also, grammar mistakes are fairly common and can sometimes be difficult to understand.`,
        `Can speak basic sentences but rarely constructs complex ones. Also, grammar mistakes are fairly common and can sometimes be difficult to understand.`,
        `Can speak basic sentences but rarely constructs complex ones. Also, grammar mistakes are fairly common and can sometimes be difficult to understand.`,
        `Can speak basic sentences but rarely constructs complex ones. Also, grammar mistakes are fairly common and can sometimes be difficult to understand.`,
      ],
      level3: [
        `외우고 있는 문법에 의존하거나, 기본적인 문장을 자유롭게 사용하는 데 어려움을 겪을 때가 있습니다. 익숙한 표현을 사용할 때를 제외하고는 문법적 실수를 자주 합니다.`,
        `Relies on grammar that has been memorized and sometimes has difficulties constructing basic sentences. Also makes frequent grammar mistakes, except when using familiar expressions.`,
        's_caf.level_detail.a.level3',
        `Relies on grammar that has been memorized and sometimes has difficulties constructing basic sentences. Also makes frequent grammar mistakes, except when using familiar expressions.`,
        `Relies on grammar that has been memorized and sometimes has difficulties constructing basic sentences. Also makes frequent grammar mistakes, except when using familiar expressions.`,
        `Relies on grammar that has been memorized and sometimes has difficulties constructing basic sentences. Also makes frequent grammar mistakes, except when using familiar expressions.`,
        `Relies on grammar that has been memorized and sometimes has difficulties constructing basic sentences. Also makes frequent grammar mistakes, except when using familiar expressions.`,
      ],
      level2: [
        `기본적인 문장 구조를 만들어내는데 어려움을 겪는 편입니다.`,
        `Has difficulties constructing basic sentences.`,
        's_caf.level_detail.a.level2',
        `Has difficulties constructing basic sentences.`,
        `Has difficulties constructing basic sentences.`,
        `Has difficulties constructing basic sentences.`,
        `Has difficulties constructing basic sentences.`,
      ],
      level1: [
        `기초적인 문장 형식을 전혀 사용할 수 없습니다.`,
        `Cannot construct basic sentences at all.`,
        's_caf.level_detail.a.level1',
        `Cannot construct basic sentences at all.`,
        `Cannot construct basic sentences at all.`,
        `Cannot construct basic sentences at all.`,
        `Cannot construct basic sentences at all.`,
      ],
    },
    f: {
      title: [
        `Fluency 레벨`,
        `Fluency Level`,
        's_caf.level_detail.f.title',
        `Fluency Level`,
        `Fluency Level`,
        `Fluency Level`,
        `Fluency Level`,
      ],
      level9: [
        `망설임 없이 말하고자 하는 바를 문법적 실수 없이 정확하게 전달할 수 있습니다.`,
        `Can convey intended meaning precisely, flawlessly, and without hesitation.`,
        's_caf.level_detail.f.level9',
        `Can convey intended meaning precisely, flawlessly, and without hesitation.`,
        `Can convey intended meaning precisely, flawlessly, and without hesitation.`,
        `Can convey intended meaning precisely, flawlessly, and without hesitation.`,
        `Can convey intended meaning precisely, flawlessly, and without hesitation.`,
      ],
      level8: [
        `반복이나 self-correction 없이 유창하게 말할 수 있습니다. 멈춤이나 망설임이 있는 경우는 대부분 다음 말할 내용을 생각하느라 그렇습니다.`,
        `Can speak fluently without word repetition or self-correction. May make short pauses while speaking, mostly to think about what to say next.`,
        's_caf.level_detail.f.level8',
        `Can speak fluently without word repetition or self-correction. May make short pauses while speaking, mostly to think about what to say next.`,
        `Can speak fluently without word repetition or self-correction. May make short pauses while speaking, mostly to think about what to say next.`,
        `Can speak fluently without word repetition or self-correction. May make short pauses while speaking, mostly to think about what to say next.`,
        `Can speak fluently without word repetition or self-correction. May make short pauses while speaking, mostly to think about what to say next.`,
      ],
      level7: [
        `무리 없이 길이감이 있는 논리적인 대화를 진행할 수 있습니다. 질문에 대한 대답을 영어로 생각하느라 멈추는 것보다, 단어나 문법이 생각이 안 나서 멈추는 경우가 더 많습니다.`,
        `Can easily carry on a lengthy conversation in a logical manner. Tends to make pauses because of word choice or grammar more often than to think about what to say.`,
        's_caf.level_detail.f.level7',
        `Can easily carry on a lengthy conversation in a logical manner. Tends to make pauses because of word choice or grammar more often than to think about what to say.`,
        `Can easily carry on a lengthy conversation in a logical manner. Tends to make pauses because of word choice or grammar more often than to think about what to say.`,
        `Can easily carry on a lengthy conversation in a logical manner. Tends to make pauses because of word choice or grammar more often than to think about what to say.`,
        `Can easily carry on a lengthy conversation in a logical manner. Tends to make pauses because of word choice or grammar more often than to think about what to say.`,
      ],
      level6: [
        `유창하게 말하려고 노력하나 종종 망설임이나, 반복, 자기 교정을 통해 전달력이 떨어질 수 있습니다.`,
        `Tries to speak fluently, but is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
        's_caf.level_detail.f.level6',
        `Tries to speak fluently, but is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
        `Tries to speak fluently, but is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
        `Tries to speak fluently, but is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
        `Tries to speak fluently, but is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
      ],
      level5: [
        `간단한 대화에서는 유창하나, 복잡한 소통 환경에서는 유창함이 떨어지는 경우가 있습니다.`,
        `Is fluent in simple conversations but not so much when engaging in more complex communication.`,
        's_caf.level_detail.f.level5',
        `Is fluent in simple conversations but not so much when engaging in more complex communication.`,
        `Is fluent in simple conversations but not so much when engaging in more complex communication.`,
        `Is fluent in simple conversations but not so much when engaging in more complex communication.`,
        `Is fluent in simple conversations but not so much when engaging in more complex communication.`,
      ],
      level4: [
        `자주 같은 말을 반복하고 천천히 말하거나, 멈춤 없이 대화를 이어가기 힘들어하는 경우가 있습니다.`,
        `Speaks slowly or finds it difficult to carry on a conversation without pauses.`,
        's_caf.level_detail.f.level4',
        `Speaks slowly or finds it difficult to carry on a conversation without pauses.`,
        `Speaks slowly or finds it difficult to carry on a conversation without pauses.`,
        `Speaks slowly or finds it difficult to carry on a conversation without pauses.`,
        `Speaks slowly or finds it difficult to carry on a conversation without pauses.`,
      ],
      level3: [
        `말하는 중에 긴 pause가 있으며, 간단한 문장들로 대화를 이어가는 경향이 있습니다.`,
        `Makes long pauses while speaking and tends to carry on  conversations with simple sentences.`,
        's_caf.level_detail.f.level3',
        `Makes long pauses while speaking and tends to carry on  conversations with simple sentences.`,
        `Makes long pauses while speaking and tends to carry on  conversations with simple sentences.`,
        `Makes long pauses while speaking and tends to carry on conversations with simple sentences.`,
        `Makes long pauses while speaking and tends to carry on  conversations with simple sentences.`,
      ],
      level2: [
        `대부분 단어를 말하기 전에 길게 멈추는 경향이 있습니다.`,
        `Tends to make long pauses before saying most words.`,
        's_caf.level_detail.f.level2',
        `Tends to make long pauses before saying most words.`,
        `Tends to make long pauses before saying most words.`,
        `Tends to make long pauses before saying most words.`,
        `Tends to make long pauses before saying most words.`,
      ],
      level1: [
        `대화가 진행되지 않고 의사소통이 불가능 합니다.`,
        `Is impossible to hold a conversation or communicate with in English.`,
        's_caf.level_detail.f.level1',
        `Is impossible to hold a conversation or communicate with in English.`,
        `Is impossible to hold a conversation or communicate with in English.`,
        `Is impossible to hold a conversation or communicate with in English.`,
        `Is impossible to hold a conversation or communicate with in English.`,
      ],
    },
    caflevel: {
      title: [
        `CAF 레벨`,
        `CAF Level`,
        's_caf.level_detail.caflevel.title',
        `CAF Level`,
        `CAF Level`,
        `CAF Level`,
        `CAF Level`,
      ],
    },
    description: [
      `레벨 분포와 설명보기`,
      `Level description`,
      's_caf.level_detail.description',
      `Level description`,
      `Level description`,
      `Level description`,
      `Level description`,
    ],
  },
  type_c: {
    word: [`어휘`, `vocabulary`, 's_caf.type_c.word', `单字`, `單字`, `vocabulary`, `vocabulary`],
    sentence: [
      `문장`,
      `use of sentences`,
      's_caf.type_c.sentence',
      `使用句型`,
      `使用句型`,
      `use of sentences`,
      `use of sentences`,
    ],
    main: {
      up: (group) => [
        <>지난 수업보다 {group} 영역에서 성장했어요.</>,
        <>Your {group} got better than last time.</>,
        's_caf.type_c.main.up',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>Your {group} got better than last time.</>,
        <>Your {group} got better than last time.</>,
      ],
      down: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        's_caf.type_c.main.down',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>Your {group} was not as good as last time.</>,
        <>Your {group} was not as good as last time.</>,
      ],
      same: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        's_caf.type_c.main.same',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>Your {group} was not as good as last time.</>,
        <>Your {group} was not as good as last time.</>,
      ],
    },
    sub: {
      up: (group) => [
        <>다음 수업에서는 {group} 영역을 신경써서 수업해보세요.</>,
        <>Try paying more attention to your {group} next time.</>,
        's_caf.type_c.sub.up',
        <>下次试着多注意{group}</>,
        <>下次試著多注意{group}</>,
        <>Try paying more attention to your {group} next time.</>,
        <>Try paying more attention to your {group} next time.</>,
      ],
      down: (group) => [
        <>하지만 {group} 영역은 지난 수업보다 개선되었어요.</>,
        <>But your {group} was better than last time.</>,
        's_caf.type_c.sub.down',
        <>但是你的{group}比上次表现好</>,
        <>但是你的{group}比上次表現好</>,
        <>But your {group} was better than last time.</>,
        <>But your {group} was better than last time.</>,
      ],
      same: (group) => [
        <>{group} 영역은 지난 수업보다 개선되었어요.</>,
        <>Your {group} improved from last time.</>,
        's_caf.type_c.sub.same',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>Your {group} improved from last time.</>,
        <>Your {group} improved from last time.</>,
      ],
    },
  },
  type_f: {
    speed: [`말하기 속도`, `speech rate`, 's_caf.type_f.speed', `说话速度`, `說話速度`, `speech rate`, `speech rate`],
    pause: [`멈춤`, `use of pauses`, 's_caf.type_f.pause', `停顿`, `停頓`, `use of pauses`, `use of pauses`],
    main: {
      down: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        's_caf.type_f.main.down',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>Your {group} was not as good as last time.</>,
        <>Your {group} was not as good as last time.</>,
      ],
      same: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        's_caf.type_f.main.same',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>Your {group} was not as good as last time.</>,
        <>Your {group} was not as good as last time.</>,
      ],
      up: (group) => [
        <>지난 수업보다 {group} 영역에서 성장했어요.</>,
        <>Your {group} got better than last time.</>,
        's_caf.type_f.main.up',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>Your {group} got better than last time.</>,
        <>Your {group} got better than last time.</>,
      ],
    },
    sub: {
      up: (group) => [
        <>다음 수업에서는 {group} 영역을 신경써서 수업해보세요.</>,
        <>Try paying more attention to your {group} next time.</>,
        's_caf.type_f.sub.up',
        <>下次试着多注意{group}</>,
        <>下次試著多注意{group}</>,
        <>Try paying more attention to your {group} next time.</>,
        <>Try paying more attention to your {group} next time.</>,
      ],
      down: (group) => [
        <>하지만 {group} 영역은 지난 수업보다 개선되었어요.</>,
        <>But your {group} was better than last time.</>,
        's_caf.type_f.sub.down',
        <>但是你的{group}比上次表现好</>,
        <>但是你的{group}比上次表現好</>,
        <>But your {group} was better than last time.</>,
        <>But your {group} was better than last time.</>,
      ],
      same: (group) => [
        <>{group} 영역은 지난 수업보다 개선되었어요.</>,
        <>Your {group} improved from last time.</>,
        's_caf.type_f.sub.same',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>Your {group} improved from last time.</>,
        <>Your {group} improved from last time.</>,
      ],
    },
  },
  type_a: {
    det: [
      `한정사`,
      `use of determiners`,
      's_caf.type_a.det',
      `冠词使用(determiners）`,
      `冠詞使用(determiners）`,
      `use of determiners`,
      `use of determiners`,
    ],
    part: [
      `불변화사`,
      `use of particles`,
      's_caf.type_a.part',
      `助词使用(particles）`,
      `助詞使用(particles）`,
      `use of particles`,
      `use of particles`,
    ],
    prep: [
      `전치사`,
      `use of prepositions`,
      's_caf.type_a.prep',
      `介词使用(prepositions)`,
      `介系詞使用(prepositions)`,
      `use of prepositions`,
      `use of prepositions`,
    ],
    verb_form: [
      `동사 형태`,
      `use of verb form`,
      's_caf.type_a.verb_form',
      `动词形式(verb form)`,
      `動詞形式(verb form)`,
      `use of verb form`,
      `use of verb form`,
    ],
    noun_num: [
      `명사 수일치`,
      `use of noun number`,
      's_caf.type_a.noun_num',
      `名词单複数`,
      `名詞單複數`,
      `use of noun number`,
      `use of noun number`,
    ],
    word: [
      `단어 순서`,
      `use of word order`,
      's_caf.type_a.word',
      `词语顺序`,
      `詞語順序`,
      `use of word order`,
      `use of word order`,
    ],
    morph: [
      `형태 혼동`,
      `use of morphology`,
      's_caf.type_a.morph',
      `词语型态使用`,
      `詞語型態使用`,
      `use of morphology`,
      `use of morphology`,
    ],
    sva: [
      `주어동사 수일치`,
      `use of subject-verb agreement`,
      's_caf.type_a.sva',
      `主词动词一致性`,
      `主詞動詞一致性`,
      `use of subject-verb agreement`,
      `use of subject-verb agreement`,
    ],
    adj: [
      `형용사`,
      `use of adjectives`,
      's_caf.type_a.adj',
      `形容词使用(adjectives)`,
      `形容詞使用(adjectives)`,
      `use of adjectives`,
      `use of adjectives`,
    ],
    adj_form: [
      `최상급/비교급`,
      `use of superlative/comparative`,
      's_caf.type_a.adj_form',
      `最高级/比较级使用(superlative/comparative)`,
      `最高級/比較級使用(superlative/comparative)`,
      `use of superlative/comparative`,
      `use of superlative/comparative`,
    ],
    adv: [
      `부사`,
      `use of adverbs`,
      's_caf.type_a.adv',
      `副词使用(adverbs)`,
      `副詞使用(adverbs)`,
      `use of adverbs`,
      `use of adverbs`,
    ],
    noun_infl: [
      `가산/불가산 명사`,
      `use of noun Inflection`,
      's_caf.type_a.noun_infl',
      `可数/不可数名词`,
      `可數/不可數名詞`,
      `use of noun Inflection`,
      `use of noun Inflection`,
    ],
    verb_tense: [
      `동사 시제`,
      `use of verb tense`,
      's_caf.type_a.verb_tense',
      `动词时态`,
      `動詞時態`,
      `use of verb tense`,
      `use of verb tense`,
    ],
    main: {
      up: (group) => [
        <>지난 수업보다 {group} 문법 실수가 적었어요.</>,
        <>Your made less mistakes in your {group} than last time.</>,
        's_caf.type_a.main.up',
        <>你在{group}犯的错误比上次少</>,
        <>你在{group}犯的錯誤比上次少</>,
        <>Your made less mistakes in your {group} than last time.</>,
        <>Your made less mistakes in your {group} than last time.</>,
      ],
      down: (group) => [
        <>지난 수업보다 {group} 문법 실수가 많았어요.</>,
        <>Your made more mistakes in your {group} than last time.</>,
        's_caf.type_a.main.down',
        <>你在{group}犯的错误比上次多</>,
        <>你在{group}犯的錯誤比上次多</>,
        <>Your made more mistakes in your {group} than last time.</>,
        <>Your made more mistakes in your {group} than last time.</>,
      ],
      same: (group) => [
        <>지난 수업보다 {group} 문법 실수가 많았어요.</>,
        <>Your made more mistakes in your {group} than last time.</>,
        's_caf.type_a.main.same',
        <>你在{group}犯的错误比上次多</>,
        <>你在{group}犯的錯誤比上次多</>,
        <>Your made more mistakes in your {group} than last time.</>,
        <>Your made more mistakes in your {group} than last time.</>,
      ],
    },
    sub: {
      up: (group) => [
        <>다음 수업에서는 {group} 까지 신경써서 수업해보세요.</>,
        <>Try paying more attention to your {group} during lessons.</>,
        's_caf.type_a.sub.up',
        <>试着在课堂中多注意{group}</>,
        <>試著在課堂中多注意{group}</>,
        <>Try paying more attention to your {group} during lessons.</>,
        <>Try paying more attention to your {group} during lessons.</>,
      ],
      down: (group) => [
        <>하지만 {group} 실수는 줄었어요.</>,
        <>But you made less mistakes in your {group}.</>,
        's_caf.type_a.sub.down',
        <>但是你减少在{group}犯错</>,
        <>但是你減少在{group}犯錯</>,
        <>But you made less mistakes in your {group}.</>,
        <>But you made less mistakes in your {group}.</>,
      ],
      same: (group) => [
        <>{group}은 지난 수업보다 실수가 적었어요.</>,
        <>You made less mistakes in your {group} than last time.</>,
        's_caf.type_a.sub.same',
        <>你在{group}犯的错误比上次少</>,
        <>你在{group}犯的錯誤比上次少</>,
        <>You made less mistakes in your {group} than last time.</>,
        <>You made less mistakes in your {group} than last time.</>,
      ],
    },
  },
  diff_title: {
    up: (type, score) => [
      `${type}가 ${score} 올랐어요!`,
      `You scored ${score} higher in ${type}!`,
      's_caf.diff_title.up',
      `${type}的 ${score}分数提升了!`,
      `${type}的 ${score}分數提升了!`,
      `You scored ${score} higher in ${type}!`,
      `You scored ${score} higher in ${type}!`,
    ],
    down: (type, score) => [
      `${type}가 ${score} 떨어졌어요.`,
      `You scored ${score} lower in ${type}.`,
      's_caf.diff_title.down',
      `${type}的 ${score}分数降低了`,
      `${type}的 ${score}分數降低了`,
      `You scored ${score} lower in ${type}.`,
      `You scored ${score} lower in ${type}.`,
    ],
    same: (type) => [
      `${type} 레벨 변동이 없었어요.`,
      `Your ${type} level stayed the same.`,
      's_caf.diff_title.same',
      `${type}的分数维持一致`,
      `${type}的分数维持一致`,
      `Your ${type} level stayed the same.`,
      `Your ${type} level stayed the same.`,
    ],
    up_little: (type, score) => [
      `${type}가 ${score} 올랐어요.`,
      `You scored ${score} higher in ${type}.`,
      's_caf.diff_title.up_little',
      `${type}的 ${score}分数提升了!`,
      `${type}的 ${score}分數提升了!`,
      `You scored ${score} higher in ${type}.`,
      `You scored ${score} higher in ${type}.`,
    ],
  },
  trend: {
    history: [`레벨 변화`, `History`, 's_caf.trend.history', `等级变化`, `等級變化`, `History`, `History`],
    score_detail: [
      `상세 레벨`,
      `Score Detail`,
      's_caf.trend.score_detail',
      `等级详细说明`,
      `等級詳細說明`,
      `Score Detail`,
      `Score Detail`,
    ],
  },
  past_lesson: [`지난 수업`, `Past Lesson`, 's_caf.past_lesson', `上一堂课`, `上一堂課`, `Past Lesson`, `Past Lesson`],
  this_lesson: [`이번 수업`, `This lesson`, 's_caf.this_lesson', `本次课程`, `本次課程`, `This lesson`, `This lesson`],
}
export const s_lesson_review = {
  lesson_recoding_msg: {
    modal_body: [
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF 진단은 링글에서 새롭게 제작한 AI 엔진으로 기존 수업 분석보다 개선된 기능입니다.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          기존 수업 녹음의 텍스트보다 정확하게 인식이 가능해졌고, 기존 수업 분석보다 다각도에서 분석이 진행됩니다.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>베타 서비스가 종료된 후 하반기에 기존 기능들과 병합될
          예정입니다.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>CAF 진단에 대해 구체적인 가이드가 궁금하시다면?
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, CAF analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about CAF analylsis?
        </p>
      </div>,
      's_lesson_review.lesson_recoding_msg.modal_body',
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, CAF analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about CAF analylsis?
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, CAF analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about CAF analylsis?
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, CAF analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about CAF analylsis?
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, CAF analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about CAF analylsis?
        </p>
      </div>,
    ],
    modal_btn: [
      `확인`,
      `Got it`,
      's_lesson_review.lesson_recoding_msg.modal_btn',
      `Got it`,
      `Got it`,
      `Got it`,
      `Got it`,
    ],
    modal_body2: [
      `CAF 진단 가이드`,
      `See "Introduction to CAF Analysis`,
      's_lesson_review.lesson_recoding_msg.modal_body2',
      `See "Introduction to CAF Analysis`,
      `See "Introduction to CAF Analysis`,
      `See "Introduction to CAF Analysis`,
      `See "Introduction to CAF Analysis`,
    ],
  },
}
export const s_system = {
  lesson_style_caf: [
    `CAF 진단이란?`,
    `What is CAF?`,
    's_system.lesson_style_caf',
    `What is CAF?`,
    `What is CAF?`,
    `What is CAF?`,
    `What is CAF?`,
  ],
}
export const n_caf = {
  pronuciation: {
    level9: [
      `9 레벨을 받은 대부분 사람은 말할 때, 모든 소리와 억양을 자연스럽게 사용하며 개인적인 발음 특징이 있어도 다른 사람이 이해하기에 어려움이 없습니다.`,
      `Most people who are level 9 use all sounds and intonations naturally, and they are easy to understand regardless of their personal accents.`,
      'n_caf.pronuciation.level9',
      `大多数 9 级的人都能自然地使用所有的发音和语调，无论他们的个人口音如何，都很容易被理解。`,
      `大多數 9 級的人都能自然地使用所有的發音和語調，無論他們的個人口音如何，都很容易被理解。`,
      `レベル9の多くの人は、全ての音やイントネーションを自然に駆使し、個々のアクセントに関わらず容易に理解してます。`,
      ``,
    ],
    level8: [
      `8 레벨을 받은 대부분 사람은 가끔 강세와 억양이 잘못되긴 하지만, 대체로 안정된 리듬으로 다양한 소리와 억양을 사용하여 말할 수 있습니다.`,
      `Most people at level 8 are able to incorporate sounds and intonations in a fairly stable rhythm, although they make occasional mistakes in stress and intonation.`,
      'n_caf.pronuciation.level8',
      `8 级的大多数人都能以相当稳定的节奏将发音和语调结合起来，尽管他们偶尔会在重音和语调方面犯错。`,
      `8 級的大多數人都能以相當穩定的節奏將發音和語調結合起來，盡管他們偶爾會在重音和語調方面犯錯。`,
      `レベル8の多くの人は、時折音の強弱やイントネーションにおいてミスをすることがありますが、多くの人が比較的安定したリズムで音やイントネーションを組み入れることができます。`,
      ``,
    ],
    level7: [
      `7 레벨을 받은 대부분 사람은 밴드 6의 모든 긍정적인 특징과 밴드 8의 일부 (하지만 모든 것은 아님) 긍정적인 특징을 나타냅니다.`,
      `Most people at level 7 exhibit all of the positive features of Band 6 and some (but not all) positive characteristics of Band 8.`,
      'n_caf.pronuciation.level7',
      `大多数处于 7 级的人拥有 6 级的所有优点和 8 级的一些优点。`,
      `大多數處於 7 級的人擁有 6 級的所有優點和 8 級的一些優點。`,
      `レベル7の多くの人は、バンド6のすべてのポジティブな特性を備えており、バンド8のポジティブな特性も一部（全てではない）示しています。`,
      ``,
    ],
    level6: [
      `6 레벨을 받은 대부분 사람은 적절한 청킹(chunking)을 기반으로 여러 음운론적 요소를 사용하지만 가끔 실수합니다. 그러나 이로 인해 소통에 큰 어려움이 없습니다.`,
      `Most people at level 6 utilize multiple phonological elements with appropriate chunking, but make occasional mistakes. However, this does not cause any major difficulties in communication.`,
      'n_caf.pronuciation.level6',
      `处于 6 级的大多数人都能利用多种语音要素和适当的语言分块，但偶尔会犯错误。不过，这不会给交流造成任何障碍。`,
      `處於 6 級的大多數人都能利用多種語音要素和適當的語言分塊，但偶爾會犯錯誤。不過，這不會讓溝通產生障礙。`,
      `レベル6の多くの人は、適切な区切りをつけることで複数の音韻要素を利用していますが、時折ミスをします。しかし、それがコミュニケーションに大きな支障をきたすことはありません。`,
      ``,
    ],
    level5: [
      `5 레벨을 받은 대부분 사람은 밴드 4의 모든 긍정적인 특징과 밴드 6의 일부 (하지만 모든 것은 아님) 긍정적인 특징을 나타냅니다.`,
      `Most people at level 5 exhibit all of the positive features of Band 4 and some (but not all) positive features of Band 6.`,
      'n_caf.pronuciation.level5',
      `5 级的大多数人表现出 4 级的所有优点和 6 级的某些优点。`,
      `5 級的大多數人表現出 4 級的所有優點和 6 級的某些優點。`,
      `レベル5の多くの人は、バンド4のすべてのポジティブな特性を備えており、バンド6のポジティブな特性も一部（全てではない）示しています。`,
      ``,
    ],
    level4: [
      `4 레벨을 받은 대부분 사람은 청킹(chunking), 억양, 그리고 강세와 같은 음운론적 요소의 사용이 제한된 범주 안에서 이뤄지고, 실수가 많아서 말하기 전달력이 좋지 않습니다.`,
      `Most people at level 4 use phonological elements (such as chunking, intonation, and stress), very limitedly and make many mistakes, resulting in poor speech delivery.`,
      'n_caf.pronuciation.level4',
      `大多数处于第 4 级的人对语音要素（如分块、语调和重音）的使用非常有限，而且会犯很多错误，导致语言表达不流畅。`,
      `大多數處於第 4 級的人對語音要素（如分塊、語調和重音）的使用非常有限，而且會犯很多錯誤，導致語言表達不流暢。`,
      `レベル4の多くの人は、音韻要素（区切り方、イントネーション、音の強弱など）を非常に限定的に使用し、多くのミスが見られ、結果としてスピーチの表現が不十分です。`,
      ``,
    ],
    level3: [
      `3 레벨을 받은 대부분 사람은 대부분의 발음, 그리고 음운론적 요소들의 사용이 적절하지 못하여 말하기의 전달력이 매우 부족합니다.`,
      `Most people at level 3 do not pronounce words or use phonological elements adequately, making it very hard to understand what they are saying.`,
      'n_caf.pronuciation.level3',
      `大多数处于第 3 级的人发音不准确，也没有充分使用语音要素，因此很难理解他们在说什么。`,
      `大多數處於第 3 級的人發音不準確，也沒有充分使用語音要素，因此很難理解他們在說什麼。`,
      `レベル3の多くの人は、単語の発音や音韻の使い方が不十分であるため、相手の発言内容を理解することが非常に難しくなります。`,
      ``,
    ],
    level2: [`-`, `-`, 'n_caf.pronuciation.level2', `-`, `-`, `-`, ``],
    level1: [`-`, `-`, 'n_caf.pronuciation.level1', `-`, `-`, `-`, ``],
  },
  type_p: {
    main: {
      down: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        'n_caf.type_p.main.down',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>あなたの{group}は前回ほど優れていませんでした。</>,
        ``,
      ],
      same: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        'n_caf.type_p.main.same',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>あなたの{group}は前回ほど優れていませんでした。</>,
        ``,
      ],
      up: (group) => [
        <>지난 수업보다 {group} 영역에서 성장했어요.</>,
        <>Your {group} got better than last time.</>,
        'n_caf.type_p.main.up',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>あなたの{group}は前回よりも良くなりました。 </>,
        ``,
      ],
    },
    sub: {
      up: (group) => [
        <>다음 수업에서는 {group} 영역을 신경써서 수업해보세요.</>,
        <>Try paying more attention to your {group} next time.</>,
        'n_caf.type_p.sub.up',
        <>下次试着多注意{group}</>,
        <>下次試著多注意{group}</>,
        <>次回は、あなたの{group}にもっと注意を払ってみてください。</>,
        ``,
      ],
      down: (group) => [
        <>하지만 {group} 영역은 지난 수업보다 개선되었어요.</>,
        <>But your {group} was better than last time.</>,
        'n_caf.type_p.sub.down',
        <>但是你的{group}比上次表现好</>,
        <>但是你的{group}比上次表現好</>,
        <>一方で、あなたの{group}は前回よりも向上していました。</>,
        ``,
      ],
      same: (group) => [
        <>{group} 영역은 지난 수업보다 개선되었어요.</>,
        <>Your {group} improved from last time.</>,
        'n_caf.type_p.sub.same',
        <>你的{group}比上次表现好</>,
        <>你的{group}比上次表現好</>,
        <>あなたの{group}は前回から向上しています。</>,
        ``,
      ],
    },
    articulation: [
      `발음 명확성`,
      `articulation`,
      'n_caf.type_p.articulation',
      `发音清晰度`,
      `發音清晰度`,
      `articulation（音の明瞭さ）`,
      `speech rate`,
    ],
    prosody: [`운율`, `prosody`, 'n_caf.type_p.prosody', `韵律`, `韻律`, `prosody（韻律）`, `use of pauses`],
  },
  diff_title_p: {
    up: (type, score) => [
      `${type}이 ${score} 올랐어요!`,
      `You scored ${score} higher in ${type}!`,
      'n_caf.diff_title_p.up',
      `${type}的 ${score}分数提升了!`,
      `${type}的 ${score}分數提升了!`,
      `あなたは${type}でより高いスコア${score}を獲得しました！`,
      ``,
    ],
    down: (type, score) => [
      `${type}이 ${score} 떨어졌어요.`,
      `You scored ${score} lower in ${type}.`,
      'n_caf.diff_title_p.down',
      `${type}的 ${score}分数降低了`,
      `${type}的 ${score}分數降低了`,
      `あなたは${type}で${score}低いスコアを出しました。`,
      ``,
    ],
    up_little: (type, score) => [
      `${type}이 ${score} 올랐어요.`,
      `You scored ${score} higher in ${type}.`,
      'n_caf.diff_title_p.up_little',
      `${type}的 ${score}分数提升了`,
      `${type}的 ${score}分數提升了`,
      `あなたは${type}でより高いスコア${score}を獲得しました。`,
      ``,
    ],
  },
  pronunciation: {
    default: [
      `Pronunciation`,
      `Pronunciation`,
      'n_caf.pronunciation.default',
      `发音`,
      `發音`,
      `Pronunciation`,
      `Pronunciation`,
    ],
    metric: [
      `이번 수업의 Pronunciation`,
      `This Lesson's Pronunciation`,
      'n_caf.pronunciation.metric',
      `这堂课的发音`,
      `這堂課的發音`,
      `This Lesson's Pronunciation`,
      `This Lesson's Pronunciation`,
    ],
    metric1: [
      `평균 발음 명확성 점수`,
      `Avg. Articulation Score`,
      'n_caf.pronunciation.metric1',
      `平均发音分数`,
      `平均發音分數`,
      `平均Articulation Score`,
      ``,
    ],
    metric2: [
      `평균 운율 점수`,
      `Avg. Prosody Score`,
      'n_caf.pronunciation.metric2',
      `平均韵律分数`,
      `平均韻律分數`,
      `平均Prosody Score`,
      ``,
    ],
    graph_title1: [
      `나의 발음 명확성 점수`,
      `My Articulation Score`,
      'n_caf.pronunciation.graph_title1',
      `我的发音分数`,
      `我的發音分數`,
      `あなたのArticulation Score`,
      ``,
    ],
    graph_legend1: [
      `문장별 발음 명확성 점수`,
      `Articulation score by sentence`,
      'n_caf.pronunciation.graph_legend1',
      `每个句子的发音分数`,
      `每個句子的發音分數`,
      `文章毎のArticulation score`,
      ``,
    ],
    section_title: [
      `자주 나타난 발음 오류`,
      `Recurring mistakes`,
      'n_caf.pronunciation.section_title',
      `反复出现的错误`,
      `反覆出現的錯誤`,
      `よくある間違い`,
      ``,
    ],
    section_detail: [
      `이번 수업에서 가장 여러 번 있었던 오류 최대 10가지가 표시됩니다.`,
      `Shows up to 10 most common mistakes you made in this lesson`,
      'n_caf.pronunciation.section_detail',
      `本次课程最常出现的10次错误`,
      `本次課程最常出現的10次錯誤`,
      `このレッスンで最も多く発生した訂正箇所が最大10個表示されます。`,
      ``,
    ],
    section_btn: [
      `발음 오류 난이도와 설명`,
      `Pronunciation difficulty levels`,
      'n_caf.pronunciation.section_btn',
      `发音难易度说明`,
      `發音難易度說明`,
      `Pronunciation難易度レベル`,
      ``,
    ],
    label_1: [`난이도 하`, `Basic`, 'n_caf.pronunciation.label_1', `初级`, `初級`, `初級`, ``],
    label_2: [`난이도 중`, `Intermediate`, 'n_caf.pronunciation.label_2', `中级`, `中級`, `中級`, ``],
    label_3: [`난이도 상`, `Advanced`, 'n_caf.pronunciation.label_3', `高级`, `高級`, `上級`, ``],
    metric1_popup: {
      title: [
        `발음 명확성 점수`,
        `Articulation Score`,
        'n_caf.pronunciation.metric1_popup.title',
        `发音分数`,
        `發音分數`,
        `Articulation Score`,
        ``,
      ],
      body: [
        `발음 명확성 점수는 말하고자 하는 바를 잘못된 발음 없이 정확하게 발화하는 정도입니다.`,
        `Articulation score indicates the degree to which you are able to clearly say what you want to say without mispronuncing any words.`,
        'n_caf.pronunciation.metric1_popup.body',
        `发音分数代表能在无发音错误的情况下清楚表达自己意思的程度`,
        `發音分數代表能在無發音錯誤的情況下清楚表達自己意思的程度`,
        `Articulation scoreは、言いたいことを明確に述べ、発音を間違えずに話すことができる度合いを示しています。`,
        ``,
      ],
    },
    metric2_popup: {
      title: [
        `운율 점수`,
        `Prosody Score`,
        'n_caf.pronunciation.metric2_popup.title',
        `韵律分数(语调、重音、停顿)`,
        `韻律分數(語調、重音、停頓)`,
        `Prosody Score`,
        ``,
      ],
      body: [
        `운율 점수는 강약과 높낮이를 잘 살려서 발화하는지 평가하는 점수입니다.`,
        `Prosody score evaluates how well you integrate stress and pitch in your speech.`,
        'n_caf.pronunciation.metric2_popup.body',
        `韵律分数评断说话时语调、重音、停顿的使用能力`,
        `韻律分數評斷說話時語調、重音、停頓的使用能力`,
        `Prosody Scoreは、スピーチにおける音の強弱と速さの統合度を評価します。`,
        ``,
      ],
    },
    metric1_popup1: {
      title: [
        `발음 오류 난이도와 설명`,
        `Pronunciation difficulty levels`,
        'n_caf.pronunciation.metric1_popup1.title',
        `发音错误及难易度说明`,
        `發音錯誤及難易度說明`,
        `Pronunciation難易度レベル`,
        ``,
      ],
      body: [
        `총 52가지의 발음 오류 중에 이번 수업에서 가장 여러 번 있었던 오류 최대 10가지가 발음 난이도와 함께 표시됩니다.`,
        `Among the 52 types of pronunciation mistakes available for analysis, this section displays up to 10 pronunciation mistakes you made most often in this lesson along with the pronunciation difficulty level.`,
        'n_caf.pronunciation.metric1_popup1.body',
        `在可供分析的 52 种发音错误中，本分析最多可显示 10 个您在本次课堂中最常犯的发音错误以及发音难度级别`,
        `在可供分析的 52 種發音錯誤中，本分析最多可顯示 10 個您在本次課堂中最常犯的發音錯誤以及發音難度級別`,
        `分析可能な52種類のPronunciationにおける訂正箇所の中から、このレッスンで最も多く間違えた箇所を最大10個まで、発音の難易度とともに表示します。`,
        ``,
      ],
      body2: [
        `오류임을 확실하게 구분할 수 있거나, 고치기 쉬운 발음 오류입니다. (e.g. /b/ vs. /v/)`,
        `A mispronunciation that can be clearly identified as one or is easy to correct. (e.g. /b/ vs. /v/)`,
        'n_caf.pronunciation.metric1_popup1.body2',
        `可以被清楚识别为错误或容易纠正的发音错误。（例如 /b/ 与 /v/）`,
        `可以被清楚識別為錯誤或容易糾正的發音錯誤。（例如 /b/ 與 /v/）`,
        `明確に識別できる発音ミス、または訂正が容易な発音。(例：/b/ vs. /v/)`,
        ``,
      ],
      body3: [
        `들었을 때 오류임을 알 수 있지만 고치기 어려운 발음 오류입니다. (e.g. /a/ vs. /o/)`,
        `A mispronunciation that can be recognized as one when heard but is difficult to correct. (e.g. /a/ vs. /o/)`,
        'n_caf.pronunciation.metric1_popup1.body3',
        `在听到时可以识别为错误但难以纠正的发音错误。（例如 /a/ 与 /o/）`,
        `在聽到時可以識別為錯誤但難以糾正的發音錯誤。（例如 /a/ 與 /o/）`,
        `聞いたときは発音ミスであることがわかるが、訂正が困難な発音ミス。(例：/a/ vs. /o/)`,
        ``,
      ],
      body4: [
        `발음에 대한 사전지식 없이 오류임을 판별하기 어렵고, 고치기 어려운 발음 오류입니다. (e.g. /i/ vs. /i-/)`,
        `A mispronunciation that is difficult to correct or discern without knowing what word is being said. (e.g. /i/ vs. /i-/)`,
        'n_caf.pronunciation.metric1_popup1.body4',
        `在不知道所说单词的情况下难以纠正或辨别的发音错误。（例如 /i/ 与 /i-/）`,
        `在不知道所說單詞的情況下難以糾正或辨別的發音錯誤。（例如 /i/ 與 /i-/）`,
        `特定の単語が何かを知らないと修正または識別が難しい発音ミス。（例：/i/ vs. /i-/）`,
        ``,
      ],
    },
    metric1_empty_msg: [
      `발음 오류가 없었어요.`,
      `You did not make any pronunciation mistakes.`,
      'n_caf.pronunciation.metric1_empty_msg',
      `您没有任何发音错误`,
      `您沒有任何發音錯誤`,
      `Pronunciationにおける訂正箇所はありませんでした。`,
      ``,
    ],
    graph_title2: [
      `나의 운율 점수`,
      `My Prosody Score`,
      'n_caf.pronunciation.graph_title2',
      `我的韵律分数`,
      `我的韻律分數`,
      `あなたのProsody Score`,
      ``,
    ],
    graph_legend2: [
      `문장별 운율 점수`,
      `Prosody score by sentence`,
      'n_caf.pronunciation.graph_legend2',
      `每个句子的韵律分数`,
      `每個句子的韻律分數`,
      `文章毎のProsody score`,
      ``,
    ],
    error: (right, wrong) => [
      `${right}를 ${wrong}으로 발음한 경우`,
      `${right} pronounced as ${wrong}`,
      'n_caf.pronunciation.error',
      `将 ${right}发音成 ${wrong}`,
      `將 ${right}發音成 ${wrong}`,
      `${right} を${wrong}と発音した場合`,
      `${right} pronounced as ${wrong}`,
    ],
    area_sentence: [`문장`, `sentences`, 'n_caf.pronunciation.area_sentence', `句子`, `句子`, `sentences`, `sentences`],
  },
  label: {
    beta: [`Beta`, `Beta`, 'n_caf.label.beta', `Beta`, `Beta`, `Beta`, `Beta`],
  },
  lesson_style_caf: [
    `링글 AI 분석이란?`,
    `What is AI analysis?`,
    'n_caf.lesson_style_caf',
    `什麽是AI分析报告?`,
    `什麼是AI分析報告?`,
    `AI analysisとは？`,
    ``,
  ],
  overview: {
    check_caf_analysis: {
      btn: [
        `AI 분석 확인 완료`,
        `Check as done`,
        'n_caf.overview.check_caf_analysis.btn',
        `已确认AI分析报告`,
        `已確認AI分析報告`,
        `確認済`,
        ``,
      ],
      toast: [
        `AI 분석 확인 완료`,
        `Check completed!`,
        'n_caf.overview.check_caf_analysis.toast',
        `确认完毕`,
        `確認完畢`,
        `確認完了`,
        `Check completed!`,
      ],
    },
    highlight_title: [
      `추천 학습 영역`,
      `Recommended Focus Areas`,
      'n_caf.overview.highlight_title',
      `推荐重点学习领域`,
      `推薦重點學習領域`,
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
    ],
    highlight_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the CAF analysis.`,
      'n_caf.overview.highlight_detail',
      `根据 CAF 分析建议的选择重点学习领域。`,
      `根據 CAF 分析建議的選擇重點學習領域。`,
      `CAF analysisに基づいた、今後の学習で重点的に取り組むべき分野です。`,
      `Recommended focus areas for learning based on the CAF analysis.`,
    ],
    caf_level: [
      `AI 분석 Level`,
      `AI Analysis Level`,
      'n_caf.overview.caf_level',
      `AI分级等级`,
      `AI分級等級`,
      `AI Analysis Level`,
      `AI Analysis Level`,
    ],
    caf_level_score: [`# / 9`, `# / 9`, 'n_caf.overview.caf_level_score', `# / 11`, `# / 11`, `# / 9`, `# / 13`],
    complexity: [
      `Complexity`,
      `Complexity`,
      'n_caf.overview.complexity',
      `複杂度`,
      `複雜度`,
      `Complexity`,
      `Complexity`,
    ],
    accuracy: [`Accuracy`, `Accuracy`, 'n_caf.overview.accuracy', `准确度`, `準確度`, `Accuracy`, `Accuracy`],
    fluency: [`Fluency`, `Fluency`, 'n_caf.overview.fluency', `流畅度`, `流暢度`, `Fluency`, `Fluency`],
    pronunciation: [
      `Pronunciation`,
      `Pronunciation`,
      'n_caf.overview.pronunciation',
      `发音`,
      `發音`,
      `Pronunciation`,
      `Pronunciation`,
    ],
    level_score: [`Lv`, `Lv`, 'n_caf.overview.level_score', `Lv`, `Lv`, `Lv`, `Lv`],
    caf_level_detail: [
      `27가지 중 하나!`,
      `Out of 27 types!`,
      'n_caf.overview.caf_level_detail',
      `27种中的一种!`,
      `27種中的一種!`,
      `27種類の中から1つ！`,
      `Out of 27 types!`,
    ],
    tab_name: [
      `AI 분석 결과`,
      `AI Analysis Results`,
      'n_caf.overview.tab_name',
      `AI分析结果`,
      `AI分析結果`,
      `AI Analysisによる結果`,
      `AI Analysis Results`,
    ],
    faq_title: [
      `링글 AI 분석이란 무엇인가요?`,
      `What is Ringle AI Analysis?`,
      'n_caf.overview.faq_title',
      `什麽是Ringle AI分析？`,
      `什麼是Ringle AI分析？`,
      `Ringle AI analysisとは何ですか?`,
      `What is Ringle AI Analysis?`,
    ],
    faq_subtitle: [
      `AI 분석에 대해 자주 들어오는 질문의 답변을 확인할 수 있습니다.`,
      `You can see the answers to frequently-asked questions about AI Analysis.`,
      'n_caf.overview.faq_subtitle',
      `确认AI分析常见问题`,
      `確認AI分析常見問題`,
      `AI Analysisに関するよくある質問の回答をご覧いただけます。`,
      `You can see the answers to frequently-asked questions about AI Analysis.`,
    ],
    caf_level333: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았어요. 계속해서 더 다양한 교재, 튜터와 수업을 진행해 보세요.`,
      `Your level was high overall in this lesson. Let's continue taking lessons with different materials and tutors!`,
      'n_caf.overview.caf_level333',
      `这节课你的整体水平很高。让我们用不同的教材和老师继续上课吧！`,
      `這節課你的整體水準很高。讓我們用不同的教材和老師繼續上課吧！`,
      `今回のレッスンは全体的にレベルが高かったですね。異なる教材や講師を使って、レッスンを続けましょう！`,
      `Your level was high overall in this lesson. Let's continue taking lessons with different materials and tutors!`,
    ],
    caf_level332: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았어요. 대화의 흐름이 끊기지 않도록 나에게 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Your level was high overall in this lesson. Try speaking at a pace that allows you to continue conversing without interruption.`,
      'n_caf.overview.caf_level332',
      `您在本课中的总体水平较高。请试着以能够让您在不被打断的情况下继续交谈的速度说话。`,
      `您在本堂課中的總體水準較高。請試著以能夠讓您在不被打斷的情況下繼續交談的速度說話。`,
      `今回のレッスンは全体的にレベルが高かったですね。会話が途切れないペースで話すことを心がけてみましょう。`,
      `Your level was high overall in this lesson. Try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level233: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았어요. 튜터가 알려준 문장과 표현을 연습하여 다음 수업에 적용해 보세요. 교재에 있는 핵심 표현들도 복습해 보세요.`,
      `Your level was high overall in this lesson. Practice the sentences and expressions you learned and use them in your next lesson. Also, go over key expressions from the material.`,
      'n_caf.overview.caf_level233',
      `您在本课中的总体水平较高。练习您学到的句子和表达方式，并在下节课中使用。同时，复习教材中的关键表达。`,
      `您在本堂課中的總體水準較高。練習您學到的句子和表達方式，並在下一堂課中使用。同時，複習教材中的核心單字。`,
      `今回のレッスンは全体的にレベルが高かったですね。学んだ文章や表現を練習し、次のレッスンで使ってみましょう。また、教材で習った重要な表現も確認しましょう。`,
      `Your level was high overall in this lesson. Practice the sentences and expressions you learned and use them in your next lesson. Also, go over key expressions from the material.`,
    ],
    caf_level323: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았어요. 다음 수업에서는 문법 정확성을 신경 써서 수업을 진행해 보세요.`,
      `Your level was high overall in this lesson. Try paying more attention to grammatical accuracy in your next lesson.`,
      'n_caf.overview.caf_level323',
      `本节课您的总体水平较高。下节课请注意语法的准确度。`,
      `您本堂課您的總體水準較高。下節課請注意文法的準確度。`,
      `今回のレッスンでは全体的にレベルが高かったですね。次回のレッスンでは、文法の正確さにもっと注意を払ってみてください。`,
      `Your level was high overall in this lesson. Try paying more attention to grammatical accuracy in your next lesson.`,
    ],
    caf_level331: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았지만, 상대적으로 Fluency(유창성) 레벨이 낮았어요. 나의 Fluency가 낮은 이유를 확인하고 다음 수업에서는 말하는 흐름이 끊기지 않도록 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Your level was high overall in this lesson, but your score for Fluency was relatively lower. Check why your Fluency level was low, and try speaking at a pace that allows you to continue conversing without interruption.`,
      'n_caf.overview.caf_level331',
      `您在本课中的整体水平较高，但流畅度得分相对较低。请确认为何您的流畅程度较低，并尝试以能够让您继续交谈而不被打断的速度说话。`,
      `您在本堂課中的整體水準較高，但流暢度得分相對較低。請確認為何您的流暢度較低，並嘗試以能夠讓您繼續交談而不被打斷的速度說話。`,
      `今回のレッスンであなたのレベルは全体的に高かったのですが、Fluency のスコアが相対的に低かったようです。なぜFluencyのスコアが低かったのかを確認し、会話が途切れないペースで話すことを心がけてみましょう。`,
      `Your level was high overall in this lesson, but your score for Fluency was relatively lower. Check why your Fluency level was low, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level232: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았어요. 상대적으로 Accuracy(정확성) 레벨이 높은 편이에요. 다음 수업에서는 Complexity(복잡성)와 Fluency(유창성)를 신경 써서 수업을 진행해 보세요.`,
      `Your level was high overall in this lesson, with a relatively higher score for Accuracy. In your next lesson, try to pay more attention to Complexity and Fluency.`,
      'n_caf.overview.caf_level232',
      `您在本课中的总体水平较高，准确度得分相对较高。在下节课，请尝试更多地关注复杂度和流畅度。`,
      `您在本堂課中的總體水準較高，準確度得分相對較高。下一堂課，請嘗試更多地注意複雜度和流暢度。`,
      `今回のレッスンでは全体的にレベルが高く、特にAccuracyのスコアが高かったですね。次回のレッスンでは、ComplexityとFluencyにもっと注意を払うようにしましょう。`,
      `Your level was high overall in this lesson, with a relatively higher score for Accuracy. In your next lesson, try to pay more attention to Complexity and Fluency.`,
    ],
    caf_level133: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았지만, 상대적으로 Complexity(복잡성) 레벨이 낮았어요. 나의 Complexity가 낮은 이유를 확인하고 튜터가 알려준 표현과 문장 구조를 연습하여 다음 수업에 적용해 보세요.`,
      `Your level was high overall in this lesson, but your score for Complexity was relatively lower. Check why your Complexity level was low, and practice the sentences and expressions you learned and use them in your next lesson.`,
      'n_caf.overview.caf_level133',
      `在本课中，您的总体水平较高，但复杂度得分相对较低。请检查您的复杂度得分较低的原因，并练习您学到的句子和表达方式，并在下节课使用它们。`,
      `您在本堂課中，您的總體水準較高，但覆雜度得分相對較低。請檢查您的複雜度得分較低的原因，並練習您學到的句子和表達方式，並在下一課中使用它們。`,
      `今回のレッスンであなたのレベルは全体的に高かったのですが、Complexityのスコアが相対的に低かったようです。なぜComplexityのスコアが低かったのかを確認し、学んだ文章や表現を練習して次のレッスンで使ってみましょう。`,
      `Your level was high overall in this lesson, but your score for Complexity was relatively lower. Check why your Complexity level was low, and practice the sentences and expressions you learned and use them in your next lesson.`,
    ],
    caf_level322: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았어요. 상대적으로 Complexity(복잡성) 레벨이 높은 편이에요. 다음 수업에서는 Accuracy(정확성)와 Fluency(유창성)를 신경 써서 수업을 진행해 보세요.`,
      `Your level was high overall in this lesson, with a relatively higher score for Complexity. In your next lesson, try to pay more attention to Accuracy and Fluency.`,
      'n_caf.overview.caf_level322',
      `在本课中，您的总体水平较高，但复杂度得分相对较高。在下节课，尽量多注意准确度和流畅度。`,
      `您在本堂課中，您的總體水準較高，但複雜度得分相對較高。下一堂課，盡量多注意準確度和流暢度。`,
      `今回のレッスンでは全体的にレベルが高く、特にComplexityのスコアが高かったですね。次回のレッスンでは、AccuracyとFluencyにもっと注意を払うようにしましょう。`,
      `Your level was high overall in this lesson, with a relatively higher score for Complexity. In your next lesson, try to pay more attention to Accuracy and Fluency.`,
    ],
    caf_level223: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았어요. 상대적으로 Fluency(유창성) 레벨이 높은 편이에요. 다음 수업에서는 Complexity(복잡성)와 Accuracy(정확성)를 신경 써서 수업을 진행해 보세요.`,
      `Your level was high overall in this lesson, with a relatively higher score for Fluency. In your next lesson, try to pay more attention to Complexity and Accuracy.`,
      'n_caf.overview.caf_level223',
      `您在本课中的总体水平较高，流畅度得分相对较高。在下节课，尝试更加关注复杂度和准确度。`,
      `您在本堂課中的總體水準較高，流暢度得分相對較高。下一堂課，嘗試更加注意複雜度和準確度。您`,
      `今回のレッスンでは全体的にレベルが高く、特にFluencyのスコアが高かったですね。次回のレッスンでは、ComplexityとAccuracyにもっと注意を払うようにしましょう。`,
      `Your level was high overall in this lesson, with a relatively higher score for Fluency. In your next lesson, try to pay more attention to Complexity and Accuracy.`,
    ],
    caf_level313: [
      `이번 수업에서는 전반적으로 높은 레벨을 받았지만, 상대적으로 Accuracy(정확성) 레벨이 낮았어요. 나의 Accuracy가 낮은 이유를 확인하고 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `Your level was high overall in this lesson, but your score for Accuracy was relatively lower. Check why your Accuracy level was low, and try prepping for or reviewing lessons focusing on 1-2 areas.`,
      'n_caf.overview.caf_level313',
      `您在本课中的整体水平较高，但准确度得分相对较低。检查一下您的准确度水平较低的原因，并尝试预习或复习课程，重点关注 1-2 个方面。`,
      `您在本堂課中的整體水準較高，但準確度得分相對較低。確認您的準確度分數較低的原因，並嘗試預習或複習課程，著重在改善1~2個錯誤。`,
      `今回のレッスンであなたのレベルは全体的に高かったのですが、Accuracyのスコアが相対的に低かったようです。なぜAccuracyのレベルが低かったのかを確認し、1～2つの分野に焦点を当てたレッスンの準備や復習をしてみてください。`,
      `Your level was high overall in this lesson, but your score for Accuracy was relatively lower. Check why your Accuracy level was low, and try prepping for or reviewing lessons focusing on 1-2 areas.`,
    ],
    caf_level231: [
      `이번 수업에서는 Accuracy(정확성) 레벨이 높았어요. 다음 수업에서 상대적으로 낮은 레벨을 받은 Fluency(유창성)를 신경 써서 말하는 흐름이 끊기지 않도록 나에게 알맞은 페이스로 수업을 진행해 보세요.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      'n_caf.overview.caf_level231',
      `您在本课中的准确度得分较高。在下节课，请更加关注您得分相对较低的 "流畅度"，并尝试以允许您在不被打断的情况下继续交谈的速度说话。`,
      `您在本堂課中的準確度得分較高。下一堂課，請更加注意您得分相對較低的 "流暢度"，並嘗試以允許您在不被打斷的情況下繼續交談的速度說話。`,
      `今回のレッスンではAccuracyのスコアが高かったですね。次回のレッスンでは、相対的にスコアが低かったFluencyにもっと注意を払い、話が途切れないペースで話すことを心がけてみましょう。`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level132: [
      `이번 수업에서는 Accuracy(정확성) 레벨이 높았어요. 다음 수업에서는 상대적으로 낮은 레벨을 받은 Complexity(복잡성)에 집중하여 튜터가 알려준 표현과 문장 구조, 교재에서 소개하는 핵심 표현을 연습하여 적용해 보세요.`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      'n_caf.overview.caf_level132',
      `您在本课中的准确度得分较高。在下节课，请更加关注您得分相对较低的 "复杂度"，并尝试使用本课中学到的表达方式和句子结构。`,
      `您在本堂課中的準確度得分較高。下一堂課，請更加注意您得分相對較低的 "複雜度"，並嘗試使用本課中學到的表達方式和句子結構。`,
      `今回のレッスンでは Accuracyのスコアが高かったですね。次回のレッスンでは、相対的にスコアが低かったComplexityにもっと注意を払い、今回レッスンで学んだ表現や文型を使ってみましょう。`,
      `You scored high for Accuracy in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
    ],
    caf_level321: [
      `이번 수업에서는 Complexity(복잡성) 레벨이 높았어요. 다음 수업에서 상대적으로 낮은 레벨을 받은 Fluency(유창성)를 신경 써서 말하는 흐름이 끊기지 않도록 나에게 알맞은 페이스로 수업을 진행해 보세요.`,
      `You scored high for Complexity in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      'n_caf.overview.caf_level321',
      `本课中，您在 "复杂度"方面得分较高。在下节课，请更加关注您得分相对较低的流畅度，并试着以能够让您在不被打断的情况下继续交谈的速度说话。`,
      `於本堂課中，您在 "複雜度"得分較高。在下一堂課，請更加注意您得分相對較低的流暢度，並試著以能夠讓您在不被打斷的情況下繼續交談的速度說話。`,
      `今回のレッスンでは、Complexity のスコアが高かったですね。次のレッスンでは、相対的にスコアが低かったFluencyにもっと注意を払い、会話が途切れないペースで話すことを心がけてみましょう。`,
      `You scored high for Complexity in this lesson. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level222: [
      `이번 수업에서는 레벨이 전반적으로 비슷했어요. Complexity(복잡성), Accuracy(정확성), Fluency(유창성) 중 하나의 영역에 집중하여 다음 수업을 들어보세요.`,
      `Your scores for all areas were similar overall in this lesson. Try focusing on either Complexity, Accuracy, or Fluency in your next lesson.`,
      'n_caf.overview.caf_level222',
      `在本堂课中，各方面水平总体上差不多。在下一堂课，请选择一个方面提高分数，不论是複杂度、准确度或流畅度。`,
      `在本堂課中，各方面得分總體上差不多。在下一堂課，請選擇一個方面提高分數，不論是複雜度、準確度或流暢度。`,
      `今回のレッスンでは、すべての分野のスコアがほぼ同じでした。次回のレッスンでは、Complexity、Accuracy、Fluencyのいずれかに焦点を当ててみてください。`,
      `Your scores for all areas were similar overall in this lesson. Try focusing on either Complexity, Accuracy, or Fluency in your next lesson.`,
    ],
    caf_level123: [
      `이번 수업에서는 Fluency(유창성) 레벨이 높았어요. 상대적으로 낮은 레벨을 받은 Complexity(복잡성)에 집중하여 튜터가 알려준 표현과 문장 구조, 교재에서 소개하는 핵심 표현을 연습해 보세요.`,
      `You scored high for Fluency in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      'n_caf.overview.caf_level123',
      `在本堂课中，流畅度水平较高。在下一堂课中，请留意得分相对较低的 "複杂度"，并尝试使用本课中学到的表达方式和句子结构。`,
      `在本堂課中，流暢度得分較高。在下一堂課中，請留意得分相對較低的 "複雜度"，並嘗試使用本課中學到的表達方式和句子結構。`,
      `今回のレッスンでは Fluency のスコアが高かったですね。次回のレッスンでは、相対的にスコアが低かったComplexityにもっと注意を払い、今回のレッスンで学んだ表現や文型を使ってみましょう。`,
      `You scored high for Fluency in this lesson. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
    ],
    caf_level312: [
      `이번 수업에서는 Complexity(복잡성) 레벨이 높았어요. 상대적으로 낮을 레벨을 받은 Accuracy(정확성)의 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `You scored high for Complexity in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      'n_caf.overview.caf_level312',
      `在本堂课中，複杂度水平较高。在预习或複习课程时，尝试着重在 1-2 个得分相对较低的 "准确度 "的错误。`,
      `在本堂課中，複雜度得分較高。在預習或複習課程時，嘗試著重在 1-2 個得分相對較低的 "準確度 "的錯誤。`,
      `今回のレッスンではComplexityのスコアが高かったですね。レッスンの準備や復習をするときは、相対的にスコアが低かったAccuracyの1～2分野に焦点を当ててみてください。`,
      `You scored high for Complexity in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
    ],
    caf_level213: [
      `이번 수업에서는 Fluency(유창성) 레벨이 높았어요. 상대적으로 낮을 레벨을 받은 Accuracy(정확성)의 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `You scored high for Fluency in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      'n_caf.overview.caf_level213',
      `在本堂课中，流畅度水平较高。在预习或複习课程时，尝试着重在 1-2 个您得分相对较低的 "准确度 "的错误。`,
      `在本堂課中，流暢度得分較高。在預習或複習課程時，嘗試著重在 1-2 個您得分相對較低的 "準確度 "的錯誤。`,
      `今回のレッスンではFluencyのスコアが高かったですね。レッスンの準備や復習をするときは、相対的にスコアが低かったAccuracyの1～2分野に焦点を当ててみてください。`,
      `You scored high for Fluency in this lesson. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
    ],
    caf_level131: [
      `이번 수업에서는 Accuracy(정확성) 레벨이 높았어요. 상대적으로 낮은 레벨을 받은 Complexity(복잡성)와 Fluency(유창성)에 집중해서 복습을 진행해보세요.`,
      `You scored high for Accuracy in this lesson. Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson.`,
      'n_caf.overview.caf_level131',
      `在本堂课中，准确度水平较高。複习时，尝试着重在 1-2 个您得分相对较低的"複度性 "和 "流畅度"。`,
      `在本堂課中，準確度得分較高。複習時，嘗試著重在 1-2 個您得分相對較低的"複度性 "和 "流暢度"。`,
      `今回のレッスンではAccuracyのスコアが高かったですね。このレッスンを復習するときは、相対的にスコアが低かった ComplexityとFluencyに焦点を当ててみてください。`,
      `You scored high for Accuracy in this lesson. Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson.`,
    ],
    caf_level221: [
      `전반적으로 평균적인 레벨을 받았어요. 다음 수업에서 상대적으로 낮은 레벨을 받은 Fluency(유창성)를 신경 써서 말하는 흐름이 끊기지 않도록 나에게 알맞은 페이스로 수업을 진행해 보세요.`,
      `You scored an average level overall. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
      'n_caf.overview.caf_level221',
      `您的整体能力一般，在下一堂课中，请留意得分相对较低的 "流畅度"，并尝试不被打断的速度进行谈话。`,
      `您的整體能力平均，在下一堂課中，請留意得分相對較低的 "流暢度"，並嘗試以能不被打斷的速度進行談話。`,
      `あなたのスコアは全体的に平均レベルでした。次回のレッスンでは、相対的にスコアが低かったFluencyにもっと注意を払い、会話が途切れないペースで話すことを心がけてみましょう。`,
      `You scored an average level overall. In your next lesson, pay more attention to Fluency, which you scored relatively lower, and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level122: [
      `전반적으로 평균적인 레벨을 받았어요. 다음 수업에서는 상대적으로 낮은 레벨을 받은 Complexity(복잡성)에 집중하여 튜터가 알려준 표현과 문장 구조, 교재에서 소개하는 핵심 표현을 연습하여 적용해 보세요.`,
      `You scored an average level overall. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
      'n_caf.overview.caf_level122',
      `您的整体能力平均为中等。在下一堂课中，请留意您得分相对较低的 "複杂度"，并多使用本课中学到的表达方式和句子结构。`,
      `您的整體能力平均為中等。在下一堂課中，請留意您得分相對較低的 "複雜度"，並多使用本課中學到的表達方式和句子結構。`,
      `あなたのスコアは全体的に平均レベルでした。次回のレッスンでは、相対的にスコアが低かったComplexityにもっと注意を払い、今回のレッスンで学んだ表現や文型を使ってみましょう。`,
      `You scored an average level overall. In your next lesson, pay more attention to Complexity, which you scored relatively lower, and try using expressions and sentence structures you learned from this lesson.`,
    ],
    caf_level311: [
      `이번 수업에서는 Complexity(복잡성) 레벨이 높았어요. 상대적으로 점수가 낮게 나온 Accuracy(정확성)와 Fluency(유창성)에 집중해서 복습을 진행해 보세요.`,
      `You scored high for Complexity in this lesson. Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson.`,
      'n_caf.overview.caf_level311',
      `本堂课的複杂度得分较高。在複习课程时，请尝试将重点放在准确度和流畅度上，因为这两项的得分相对较低。`,
      `本堂課的複雜度得分較高。在複習課程時，請嘗試將重點放在準確度和流暢度上，因為這兩項的得分相對較低。`,
      `今回のレッスンではComplexityのスコアが高かったですね。レッスンを復習するときは、相対的にスコアが低かったAccuracyとFluencyに焦点をあててみてください。`,
      `You scored high for Complexity in this lesson. Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson.`,
    ],
    caf_level212: [
      `전반적으로 평균적인 AI 분석 레벨을 받았어요. 상대적으로 낮을 레벨을 받은 Accuracy(정확성)의 1-2개의 학습 영역에 집중하여 예습과 복습을 해보세요.`,
      `You scored an average AI analysis level overall. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
      'n_caf.overview.caf_level212',
      `您的AI分析等级分数一般。在预习或複习课程时，尝试着重在 1-2 个得分相对较低的 "准确度 "的错误。`,
      `您的AI分析等級分數一般。在預習或複習課程時，嘗試著重在 1-2 個得分相對較低的 "準確度 "的錯誤。`,
      `あなたのAI analysis levelは全体的に平均的でした。レッスンの準備や復習をする際には、相対的にスコアが低かったAccuracyの1～2分野に焦点を当ててみてください。`,
      `You scored an average AI analysis level overall. Try focusing on 1-2 areas of Accuracy, which you scored relatively lower, when prepping for or reviewing lessons.`,
    ],
    caf_level113: [
      `이번 수업에서는 Fluency(유창성) 레벨이 높았어요. 상대적으로 점수가 낮게 나온 Complexity(복잡성)와 Accuracy(정확성)에 집중해서 복습을 진행해 보세요.`,
      `You scored high for Fluency in this lesson. Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson.`,
      'n_caf.overview.caf_level113',
      `本堂课的流畅度度分数较高。在複习时，尝试着重在得分相对较低的 "複杂度 "和 "准确度"，并尝试以能不被打断的速度进行谈话。`,
      `本堂課的流暢度度分數較高。在複習時，嘗試著重在得分相對較低的 "複雜度 "和 "準確度"，並嘗試以能不被打斷的速度進行談話。`,
      `今回のレッスンでは Fluency のスコアが高かったですね。今回のレッスンを復習するときは、相対的にスコアが低かったComplexityとAccuracyに焦点をあててみてください。`,
      `You scored high for Fluency in this lesson. Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson.`,
    ],
    caf_level121: [
      `Accuracy(정확성)에 비해 상대적으로 낮은 레벨을 받은 Complexity(복잡성)와 Fluency(유창성)에 집중해서 복습을 진행해보세요. 다음 수업에서는 문장 구조와 단어에 조금 더 신경을 쓰고 말의 흐름이 끊기지 않도록 나에게 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to sentence structures and vocabulary and try speaking at a pace that allows you to continue conversing without interruption.`,
      'n_caf.overview.caf_level121',
      `複习时，尝试着重在得分相对较低的複杂度和流畅度。在下一堂课中，请多留意句子结构和词彙，并尝试以能不被打断的速度进行谈话。`,
      `複習時，嘗試著重在得分相對較低的複雜度和流暢度。在下一堂課中，請多留意句子結構和詞彙，並嘗試以能不被打斷的速度進行談話。`,
      `レッスンの復習では、相対的にスコアの低かったComplexityとFluencyに重点を置いてみてください。次回のレッスンでは、文型や語彙にもっと注意を払い、会話が途切れないペースで話すことを心がけてみましょう。`,
      `Try focusing on Complexity and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to sentence structures and vocabulary and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level211: [
      `Complexity(복잡성)에 비해 상대적으로 낮은 레벨을 받은 Accuracy(정확성)와 Fluency(유창성)에 집중해서 복습을 진행해보세요. 다음 수업에서는 문법 정확도에 조금 더 신경을 쓰고 말의 흐름이 끊기지 않도록 나에게 알맞은 페이스를 정해서 수업을 진행해 보세요.`,
      `Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to grammar and try speaking at a pace that allows you to continue conversing without interruption.`,
      'n_caf.overview.caf_level211',
      `複习时，试着把重点放在准确度和流畅度上，因为这两项的得分相对较低。在下一堂课中，请多注意文法，并尝试以能不被打断的速度进行谈话。`,
      `複習時，試著把重點放在準確度和流暢度上，因為這兩項的得分相對較低。在下一堂課中，請多注意文法，並嘗試以能不被打斷的速度進行談話。`,
      `レッスンの復習の際には、相対的にスコアの低かった Accuracy と Fluency に重点を置いてみてください。次回のレッスンでは、文法にもっと注意を払い、会話が途切れないペースで話すことを心がけてみましょう。`,
      `Try focusing on Accuracy and Fluency, which you scored relatively lower, when you review the lesson. In your next lesson, pay more attention to grammar and try speaking at a pace that allows you to continue conversing without interruption.`,
    ],
    caf_level112: [
      `Fluency(유창성)에 비해 상대적으로 낮은 레벨을 받은 Complexity(복잡성)와 Accuracy(정확성)에 집중해서 복습을 진행해보세요. 다음 수업에서는 튜터가 알려준 표현과 문장 구조를 연습하여 적용해 보세요.`,
      `Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson. Practice the expressions and sentence structures you learned and try using them in your next lesson.`,
      'n_caf.overview.caf_level112',
      `複习时，试着把重点放在複杂度和准确度上，因为这两项的得分相对较低。练习所学的表达方式和句子结构，并试着在下堂课中使用。`,
      `複習時，試著把重點放在複雜度和準確度上，因為這兩項的得分相對較低。練習所學的表達方式和句子結構，並試著在下堂課中使用。`,
      `レッスンの復習では、相対的にスコアの低かったComplexityとAccuracyに焦点をあててみてください。学んだ表現や文型を練習し、次回のレッスンで使ってみましょう。`,
      `Try focusing on Complexity and Accuracy, which you scored relatively lower, when you review the lesson. Practice the expressions and sentence structures you learned and try using them in your next lesson.`,
    ],
    caf_level111: [
      `문법이나 단어 선택에 너무 얽매이지 말고, 정확도가 조금 떨어져도 영어로 생각하고 말하는 연습을 해보세요. 영어로 대화하는 데 큰 어려움이 없다고 판단될 때까지 Fluency(유창성) 레벨을 높이는 것을 목표로 수업을 해보세요.`,
      `Don't get too hung up on grammar or vocabulary. Instead, try to think and speak in English, even if you end up being less accurate. Make improving your Fluency your goal until you feel comfortable communicating in English.`,
      'n_caf.overview.caf_level111',
      `不要太在意文法或词彙而是尝试用英语思考和说话，即使准确度降低。把提高英语流利程度当成目标，直到能自在地用英语交流为止。`,
      `不要太在意文法或詞彙而是嘗試用英文思考和說話，即使準確度降低。把提高英文流利程度當成目標，直到能自在地用英文交流為止。`,
      `文法や語彙にこだわりすぎないようにしてください。たとえ正確さに欠けたとしても、英語で考え、英語で話すようにしましょう。英語でのコミュニケーションが快適に感じられるようになるまで、Fluencyを向上させることを目標にしましょう。`,
      `Don't get too hung up on grammar or vocabulary. Instead, try to think and speak in English, even if you end up being less accurate. Make improving your Fluency your goal until you feel comfortable communicating in English.`,
    ],
    tophighlights_title: [
      `내가 집중하고 싶은 학습 영역`,
      `My Focus Areas`,
      'n_caf.overview.tophighlights_title',
      `我的重点学习领域`,
      `我的重點學習領域`,
      `My Focus Areas`,
      `My Focus Areas`,
    ],
    tophighlights_info: [
      <>
        학습 영역을 고정하고 다른 수업에서
        <br />
        어떻게 달라지는지 확인해보세요.
      </>,
      <>
        Pin a focus area and see how the AI analysis
        <br />
        changes in other lessons.
      </>,
      'n_caf.overview.tophighlights_info',
      <>
        加入一个学习领域后
        <br />
        看其他课程如何变化
      </>,
      <>
        加入一個學習領域後
        <br />
        看其他課程如何變化
      </>,
      <>
        Focus Areasを固定して、他のレッスンで
        <br />
        どのように変化するかを確認してみてください。
      </>,
      <>
        Pin a focus area and see how the AI analysis
        <br />
        changes in other lessons.
      </>,
    ],
    tophighlights_edit: [`편집하기`, `Edit`, 'n_caf.overview.tophighlights_edit', `编辑`, `編輯`, `編集`, `Edit`],
    highlight_seeall: [
      `전체 학습 영역보기`,
      `View all focus areas`,
      'n_caf.overview.highlight_seeall',
      `看所有重点学习领域`,
      `看所有重點學習領域`,
      `View all focus areas`,
      `View all focus areas`,
    ],
    guide_page: {
      title: [
        `AI 분석 가이드`,
        `Introduction to AI Analysis`,
        'n_caf.overview.guide_page.title',
        `AI分析介绍`,
        `AI分析介紹`,
        `AI Analysisガイド`,
        `Introduction to AI Analysis`,
      ],
    },
    book_lesson: {
      btn: [
        `수업 예약하기`,
        `Book a lesson`,
        'n_caf.overview.book_lesson.btn',
        `预约课程`,
        `預約課程`,
        `Book a lesson`,
        `Book a lesson`,
      ],
    },
    book_lesson_title: {
      msg1: [
        `다음 수업에서는 Fluency에 집중해 볼까요?`,
        `How about focusing on Fluency next lesson?`,
        'n_caf.overview.book_lesson_title.msg1',
        `下一堂课集中学习流畅度如何？`,
        `下一堂課集中學習流暢度如何？`,
        `次回のレッスンではFluencyに焦点を当ててみませんか？`,
        `How about focusing on Fluency next lesson?`,
      ],
      msg2: [
        `다음 수업에서는 Complexity에 집중해 볼까요?`,
        `How about focusing on Complexity next lesson?`,
        'n_caf.overview.book_lesson_title.msg2',
        `下一堂课集中学习複杂度如何？`,
        `下一堂課集中學習複雜度如何？`,
        `次回のレッスンではComplexityに焦点を当ててみませんか？`,
        `How about focusing on Complexity next lesson?`,
      ],
      msg3: [
        `다음 수업에서는 Accuracy에 집중해볼까요?`,
        `How about focusing on Accuracy next lesson?`,
        'n_caf.overview.book_lesson_title.msg3',
        `下一堂课集中学习准确度如何？`,
        `下一堂課集中學習準確度如何？`,
        `次回のレッスンではAccuracyに焦点を当ててみませんか？`,
        `How about focusing on Accuracy next lesson?`,
      ],
    },
    book_lesson_body: {
      msg1: [
        `평균 월 6번 이상 수업을 듣는 사람들은 그렇지 않은 사람들보다 Fluency 향상될 가능성이 약 5배 더 높아요.`,
        `Ringlers who take 6 or more lessons per month are five times more likely to improve their Fluency than those who don't.`,
        'n_caf.overview.book_lesson_body.msg1',
        `每月上 6 次或以上课程的学习者的流畅度比其他人高出五倍`,
        `每月上 6 次或以上課程的學習者的流暢度比其他人高出五倍`,
        `1ヶ月に6回以上のレッスンを受けるRinglerは、しない人に比べて、Fluencyが向上する可能性が5倍ほど高いです。`,
        `Ringlers who take 6 or more lessons per month are five times more likely to improve their Fluency than those who don't.`,
      ],
      msg2: [
        `수업 전에 교재의 답변을 미리 준비하는 사람은 준비하지 않는 사람보다 Complexity 향상될 가능성이 약 2배 정도 더 높아요.`,
        `Ringlers who prep for lessons are two times more likely to improve their Complexity than those who don't.`,
        'n_caf.overview.book_lesson_body.msg2',
        `课前进行预习的学习者的複杂度比其他人可能高出两倍`,
        `課前進行預習的學習者的複雜度比其他人可能高出兩倍`,
        `レッスンの準備をするRinglerは、しない人に比べてComplexityが向上する可能性が約2倍ほど高いです。`,
        `Ringlers who prep for lessons are two times more likely to improve their Complexity than those who don't.`,
      ],
      msg3: [
        `모든 것을 한번에 고치려고 하다보면 오히려 잘했던 영역까지 실수를 할 수 있어요. 내가 개선하고 싶은 문법 유형 1-2개에 집중해보세요.`,
        `You may find yourself making mistakes in areas you've been good at if you try to fix everything all at once. Try working on 1-2 grammar rules you want to focus on at a time.`,
        'n_caf.overview.book_lesson_body.msg3',
        `如果想要一次改正所有错误，很可能导致原来不犯错的地方失误。试着从挑选1~2个语法错误类型开始。`,
        `如果想要一次改正所有錯誤，很可能導致原來不犯錯的地方失誤。試著從挑選1~2個文法錯誤類型開始。`,
        `一度にすべてを修正しようとすると、今まで得意だった分野でもミスをしてしまうかもしれません。1～2個の文法に焦点を当てて取り組んでみましょう。`,
        `You may find yourself making mistakes in areas you've been good at if you try to fix everything all at once. Try working on 1-2 grammar rules you want to focus on at a time.`,
      ],
    },
    checkout: {
      btn: [
        `학습 영역 둘러보기`,
        `Check out Focus Areas`,
        'n_caf.overview.checkout.btn',
        `确认重点学习领域`,
        `確認重點學習領域`,
        `Check out Focus Areas`,
        `Check out Focus Areas`,
      ],
    },
    tophighlights_info1: [
      `학습 영역을 고정하고 다른 수업에서 어떻게 달라지는지 확인해보세요.`,
      `Pin a focus area and see how the AI analysis changes in other lessons.`,
      'n_caf.overview.tophighlights_info1',
      `选择一个重点学习领域，看看 AI 分析在其他课程中的变化`,
      `選擇一個重點學習領域，看看 AI 分析在其他課程中的變化`,
      `Focus areaを固定し、他のレッスンでAI analysisがどのように変化するかを確認してください。`,
      `Pin a focus area and see how the AI analysis changes in other lessons.`,
    ],
    menu_overview: [
      `분석 개요`,
      `Overview`,
      'n_caf.overview.menu_overview',
      `综合评价`,
      `綜合評價`,
      `Overview`,
      `Overview`,
    ],
    menu_complexity: [
      `Complexity`,
      `Complexity`,
      'n_caf.overview.menu_complexity',
      `複杂度`,
      `複雜度`,
      `Complexity`,
      `Complexity`,
    ],
    menu_accuracy: [`Accuracy`, `Accuracy`, 'n_caf.overview.menu_accuracy', `准确度`, `準確度`, `Accuracy`, `Accuracy`],
    menu_fluency: [`Fluency`, `Fluency`, 'n_caf.overview.menu_fluency', `流畅度`, `流暢度`, `Fluency`, `Fluency`],
    menu_pronunciation: [
      `Pronunciation`,
      `Pronunciation`,
      'n_caf.overview.menu_pronunciation',
      `发音`,
      `發音`,
      `Pronunciation`,
      ``,
    ],
    menu_areas: [
      `학습 영역`,
      `Focus Areas`,
      'n_caf.overview.menu_areas',
      `学习重点`,
      `學習重點`,
      `Focus Areas`,
      `Focus Areas`,
    ],
  },
  highlight: {
    category18: [`발음`, `Pronunciation`, 'n_caf.highlight.category18', `发音`, `發音`, `Pronunciation`, ``],
    correct: {
      grammar18: [
        `발음 연습이 필요한 단어가 없었어요.`,
        `No words require practice.`,
        'n_caf.highlight.correct.grammar18',
        `没有需要练习的单字`,
        `沒有需要練習的單字`,
        `練習が必要な単語はありません。`,
        ``,
      ],
      grammar0: [
        `한정사| 관련 문법 실수가 없었어요.`,
        `Determiner| No mistakes detected.`,
        'n_caf.highlight.correct.grammar0',
        `冠词(determiners) 没有错误`,
        `冠詞(determiners) 沒有錯誤`,
        `Determiner（限定詞）| 関連する文法のミスはありませんでした。`,
        `Determiner| No mistakes detected.`,
      ],
      grammar1: [
        `불변화사| 관련 문법 실수가 없었어요.`,
        `Particle| No mistakes detected.`,
        'n_caf.highlight.correct.grammar1',
        `助词(Particle) 没有错误`,
        `助詞(Particle) 沒有錯誤`,
        `Particle（助詞）| 関連する法のミスはありませんでした。`,
        `Particle| No mistakes detected.`,
      ],
      grammar2: [
        `전치사| 관련 문법 실수가 없었어요`,
        `Preposition| No mistakes detected.`,
        'n_caf.highlight.correct.grammar2',
        `介词(prepositions) 没有错误`,
        `介系詞(prepositions) 沒有錯誤`,
        `Preposition（前置詞）| 関連する文法のミスはありませんでした。`,
        `Preposition| No mistakes detected.`,
      ],
      grammar3: [
        `동사 형태| 관련 문법 실수가 없었어요.`,
        `Verb Form| No mistakes detected.`,
        'n_caf.highlight.correct.grammar3',
        `动词型态(Verb Form) 没有错误`,
        `動詞型態(Verb Form)沒有錯誤`,
        `Verb Form（動詞の形）| 関連する文法のミスはありませんでした。`,
        `Verb Form| No mistakes detected.`,
      ],
      grammar4: [
        `명사 수일치| 관련 문법 실수가 없었어요.`,
        `Noun Number| No mistakes detected.`,
        'n_caf.highlight.correct.grammar4',
        `名词单複数(Noun Number)没有错误`,
        `名詞單複數(Noun Number)沒有錯誤`,
        `Noun Number（名詞数）| 関連する文法のミスはありませんでした。`,
        `Noun Number| No mistakes detected.`,
      ],
      grammar5: [
        `단어 순서| 관련 문법 실수가 없었어요.`,
        `Word Order| No mistakes detected.`,
        'n_caf.highlight.correct.grammar5',
        `词语顺序(Word Order) 没有错误`,
        `詞語順序(Word Order)沒有錯誤`,
        `Word Order（語順）| 関連する文法のミスはありませんでした。`,
        `Word Order| No mistakes detected.`,
      ],
      grammar6: [
        `형태 혼동| 관련 문법 실수가 없었어요.`,
        `Morphology| No mistakes detected.`,
        'n_caf.highlight.correct.grammar6',
        `词语型态| 没有错误`,
        `詞語型態| 沒有錯誤`,
        `Morphology（形態論）| 関連する文法のミスはありませんでした。`,
        `Morphology| No mistakes detected.`,
      ],
      grammar7: [
        `주어동사 수일치| 관련 문법 실수가 없었어요`,
        `Subject-Verb Agreement| No mistakes detected.`,
        'n_caf.highlight.correct.grammar7',
        `主词动词一致性(Subject-Verb Agreement)| 没有错误`,
        `主詞動詞一致性(Subject-Verb Agreement)沒有錯誤`,
        `Subject（主語）とVerb（動詞）の一致| 関連する文法のミスはありませんでした。`,
        `Subject-Verb Agreement| No mistakes detected.`,
      ],
      grammar8: [
        `형용사| 관련 문법 실수가 없었어요.`,
        `Adjective| No mistakes detected.`,
        'n_caf.highlight.correct.grammar8',
        `Adjective| 没有错误`,
        `Adjective| 沒有錯誤`,
        `Adjective（形容詞）| 関連する文法のミスはありませんでした。`,
        `Adjective| No mistakes detected.`,
      ],
      grammar9: [
        `최상급/비교급| 관련 문법 실수가 없었어요.`,
        `Superlative/Comparative| No mistakes detected.`,
        'n_caf.highlight.correct.grammar9',
        `最高级/比较级(Superlative/Comparative)| 没有错误`,
        `最高級/比較級(Superlative/Comparative)沒有錯誤`,
        `Superlative（最上級）/Comparative（比較級）| 関連する文法のミスはありませんでした。`,
        `Superlative/Comparative| No mistakes detected.`,
      ],
      grammar10: [
        `부사| 관련 문법 실수가 없었어요.`,
        `Adverb| No mistakes detected.`,
        'n_caf.highlight.correct.grammar10',
        `副词(Adverb) 没有错误`,
        `副詞(Adverb)沒有錯誤`,
        `Adverb（副詞）| 関連する文法のミスはありませんでした。`,
        `Adverb| No mistakes detected.`,
      ],
      grammar11: [
        `가산/불가산 명사| 관련 문법 실수가 없었어요.`,
        `Noun Inflection| No mistakes detected.`,
        'n_caf.highlight.correct.grammar11',
        `名词变化(Noun Inflection) 没有错误`,
        `名詞變化(Noun Inflection)沒有錯誤`,
        `Noun Inflection（名詞の変化）| 関連する文法のミスはありませんでした。`,
        `Noun Inflection| No mistakes detected.`,
      ],
      grammar12: [
        `동사 시제| 관련 문법 실수가 없었어요.`,
        `Verb Tense| No mistakes detected.`,
        'n_caf.highlight.correct.grammar12',
        `动词时态(Verb Tense) 没有错误`,
        `動詞時態(Verb Tense)沒有錯誤`,
        `Verb Tense（動詞の時制）| 関連する文法のミスはありませんでした。`,
        `Verb Tense| No mistakes detected.`,
      ],
      grammar13: [
        `반복적으로 사용한 단어|가 없었어요.`,
        `Word Repetition| None detected.`,
        'n_caf.highlight.correct.grammar13',
        `单字重複(Word Repetition) 没有错误`,
        `單字重複(Word Repetition)沒有錯誤`,
        `Word Repetition（単語の反復）| ありませんでした。`,
        `Word Repetition| None detected.`,
      ],
      grammar14: [
        `Run-on 문장|이 없었어요.`,
        `Run-on Sentence| None detected.`,
        'n_caf.highlight.correct.grammar14',
        `连写句(Run-on Sentence) 没有错误`,
        `連寫句(Run-on Sentence)沒有錯誤`,
        `Run-on Sentence（連結された文章）| ありませんでした。`,
        `Run-on Sentence| None detected.`,
      ],
      grammar15: [
        `말하기 속도|가 느렸던 구간이 없었어요.`,
        `Speech Rate| No slow speech sections detected.`,
        'n_caf.highlight.correct.grammar15',
        `语速(Speech Rate) 没有慢速语段`,
        `語速(Speech Rate) 沒有慢速語段`,
        `Speech Rate（スピーチ速度）| Slow speech の箇所はありませんでした。`,
        `Speech Rate| No slow speech sections detected.`,
      ],
      grammar16: [
        `필러워드| 사용이 많았던 구간이 없었어요.`,
        `Filler Words| No problematic sections detected.`,
        'n_caf.highlight.correct.grammar16',
        `填充词(Filler Words) 没有慢速语段`,
        `填充詞(Filler Words) 沒有慢速語段`,
        `Filler Words（間投詞）| 問題のある個所はありませんでした。`,
        `Filler Words| No problematic sections detected.`,
      ],
      grammar17: [
        `더 복잡한 문장 구조|를 시도해 볼 수 있는 구간이 없었어요.`,
        `Complex Sentence| No applicable sections.`,
        'n_caf.highlight.correct.grammar17',
        `无複合句适用区间`,
        `無複合句適用區間`,
        `Complex Sentence（複文）| 該当箇所がありません。`,
        `Complex Sentence| No applicable sections.`,
      ],
    },
    error: {
      grammar18: (count) => [
        `발음 연습이 필요한 단어|가 ${count}개 있어요.`,
        `${count} words require practice.`,
        'n_caf.highlight.error.grammar18',
        `有${count}个单字需要练习`,
        `有${count}個單字需要練習`,
        `${count} 語の練習が必要です。`,
        ``,
      ],
      grammar0: (count) => [
        `한정사| 관련 문법 실수가 ${count}개 있어요.`,
        `Determiner| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar0',
        `发现 ${count} 个冠词(Determiner)错误`,
        `發現 ${count} 個冠詞(Determiner)錯誤`,
        `Determiner（限定詞）| 関連する文法のミスが${count} つありました。`,
        `Determiner| ${count} mistakes detected.`,
      ],
      grammar1: (count) => [
        `불변화사| 관련 문법 실수가 ${count}개 있어요.`,
        `Particle| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar1',
        `发现 ${count} 个助词(Particle)错误`,
        `發現 ${count} 個助詞(Particle)錯誤`,
        `Particle（助詞）| 関連する文法のミスが${count} つありました。`,
        `Particle| ${count} mistakes detected.`,
      ],
      grammar2: (count) => [
        `전치사| 관련 문법 실수가 ${count}개 있어요.`,
        `Preposition| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar2',
        `发现 ${count} 个介词(Preposition)错误`,
        `發現 ${count} 個介系詞(Preposition)錯誤`,
        `Preposition（前置詞）| 関連する文法のミスが${count} つありました。`,
        `Preposition| ${count} mistakes detected.`,
      ],
      grammar3: (count) => [
        `동사 형태| 관련 문법 실수가 ${count}개 있어요.`,
        `Verb Form| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar3',
        `发现 ${count} 个动词型态(Verb Form)错误`,
        `發現 ${count} 個動詞型態(Verb Form)錯誤`,
        `Verb Form（動詞の形）| 関連する文法のミスが${count} つありました。`,
        `Verb Form| ${count} mistakes detected.`,
      ],
      grammar4: (count) => [
        `명사 수일치| 관련 문법 실수가 ${count}개 있어요.`,
        `Noun Number| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar4',
        `发现 ${count} 个名词单複数(Noun Number)错误`,
        `發現 ${count} 個名詞單複數(Noun Number)錯誤`,
        `Noun Number（名詞数）|関連する文法のミスが${count} つありました。`,
        `Noun Number| ${count} mistakes detected.`,
      ],
      grammar5: (count) => [
        `단어 순서| 관련 문법 실수가 ${count}개 있어요.`,
        `Word Order| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar5',
        `发现 ${count} 个词语顺序(Word Order)错误`,
        `發現 ${count} 個詞語順序(Word Order)錯誤`,
        `Word Order（語順）| 関連する文法のミスが${count} つありました。`,
        `Word Order| ${count} mistakes detected.`,
      ],
      grammar6: (count) => [
        `형태 혼동| 관련 문법 실수가 ${count}개 있어요.`,
        `Morphology| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar6',
        `发现 ${count} 个词语型态(Morphology)错误`,
        `發現 ${count} 個詞語型態(Morphology)錯誤`,
        `Morphology（形態論）|関連する文法のミスが${count} つありました。`,
        `Morphology| ${count} mistakes detected.`,
      ],
      grammar7: (count) => [
        `주어동사 수일치| 관련 문법 실수가 ${count}개 있어요.`,
        `Subject-Verb Agreement| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar7',
        `发现 ${count} 个主词动词不一致(Subject-Verb Agreement)错误`,
        `發現 ${count} 個主詞動詞不一致(Subject-Verb Agreement)錯誤`,
        `Subject（主語）とVerb（動詞）の一致| 関連する文法のミスが${count} つありました。`,
        `Subject-Verb Agreement| ${count} mistakes detected.`,
      ],
      grammar8: (count) => [
        `형용사| 관련 문법 실수가 ${count}개 있어요.`,
        `Adjective| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar8',
        `发现 ${count} 个形容词(Adjective)错误`,
        `發現 ${count} 個形容詞(Adjective)錯誤`,
        `Adjective（形容詞）| 関連する文法のミスが${count} つありました。`,
        `Adjective| ${count} mistakes detected.`,
      ],
      grammar9: (count) => [
        `최상급/비교급| 관련 문법 실수가 ${count}개 있어요.`,
        `Superlative/Comparative| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar9',
        `发现 ${count} 个最高级/比较级使用(superlative/comparative)错误`,
        `發現 ${count} 個最高級/比較級使用(superlative/comparative)錯誤`,
        `Superlative（最上級）/Comparative（比較級）| 関連する文法のミスが${count} つありました。`,
        `Superlative/Comparative| ${count} mistakes detected.`,
      ],
      grammar10: (count) => [
        `부사| 관련 문법 실수가 ${count}개 있어요.`,
        `Adverb| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar10',
        `发现 ${count} 个副词(Adverb)错误`,
        `發現 ${count} 個副詞(Adverb)錯誤`,
        `Adverb（副詞）| 関連する文法のミスが${count} つありました。`,
        `Adverb| ${count} mistakes detected.`,
      ],
      grammar11: (count) => [
        `가산/불가산 명사| 관련 문법 실수가 ${count}개 있어요.`,
        `Noun Inflection| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar11',
        `发现 ${count} 个名词变化(Noun Inflection)错误`,
        `發現 ${count} 個名詞變化(Noun Inflection)錯誤`,
        `Noun Inflection（名詞の変化）|関連する文法のミスが${count} つありました。`,
        `Noun Inflection| ${count} mistakes detected.`,
      ],
      grammar12: (count) => [
        `동사 시제| 관련 문법 실수가 ${count}개 있어요.`,
        `Verb Tense| ${count} mistakes detected.`,
        'n_caf.highlight.error.grammar12',
        `发现 ${count} 个动词时态(Verb Tense)错误`,
        `發現 ${count} 個動詞時態(Verb Tense)錯誤`,
        `Verb Tense（動詞の時制）| 関連する文法のミスが${count} つありました。`,
        `Verb Tense| ${count} mistakes detected.`,
      ],
      grammar13: (count) => [
        `반복적으로 사용한 단어|가 ${count}개 있어요.`,
        `Word Repetition| ${count} detected.`,
        'n_caf.highlight.error.grammar13',
        `发现 ${count} 个单字重複(Word Repetition)错误`,
        `發現 ${count} 個單字重複(Word Repetition)錯誤`,
        `Word Repetition（単語の反復）| ${count} つありました。`,
        `Word Repetition| ${count} detected.`,
      ],
      grammar14: (count) => [
        `Run-on 문장|이 ${count}개 있어요.`,
        `Run-on Sentence| ${count} detected.`,
        'n_caf.highlight.error.grammar14',
        `发现 ${count} 个连写句(Run-in Sentence)错误`,
        `發現 ${count} 個連寫句(Run-in Sentence)錯誤`,
        `Run-on Sentence（連結された文章）| ${count} つありました。`,
        `Run-on Sentence| ${count} detected.`,
      ],
      grammar15: (count) => [
        `말하기 속도|가 느렸던 구간이 ${count}개 있어요.`,
        `Speech Rate| ${count} slow speech sections detected.`,
        'n_caf.highlight.error.grammar15',
        `发现 ${count} 个语速(Speech Rate)下降区间`,
        `發現 ${count} 個語速(Speech Rate)下降區間`,
        `Speech Rate（スピーチ速度）| Slow speechの箇所が${count} つありました。`,
        `Speech Rate| ${count} slow speech sections detected.`,
      ],
      grammar16: (count) => [
        `필러워드| 사용이 많았던 구간이 ${count}개 있어요.`,
        `Filler Words| ${count} problematic sections detected.`,
        'n_caf.highlight.error.grammar16',
        `发现 ${count} 个填充词(Filler Words)使用区间`,
        `發現 ${count} 個填充詞(Filler Words)使用區間`,
        `Filler Words（間投詞）|問題のある箇所が ${count}つありました。`,
        `Filler Words| ${count} problematic sections detected.`,
      ],
      grammar17: (count) => [
        `더 복잡한 문장 구조|를 시도해 볼 수 있는 구간이 ${count}개 있어요.`,
        `Complex Sentence| ${count} applicable sections.`,
        'n_caf.highlight.error.grammar17',
        `複合句适用区间| ${count} 个`,
        `複合句適用區間| ${count} 個`,
        `Complex Sentence（複文）| 該当箇所が${count} 個あります。.`,
        `Complex Sentence| ${count} applicable sections.`,
      ],
    },
    msg_simpletocomplex: [
      <>
        이번 수업에서는 더 복잡한 문장 구조를 <br />
        시도해 볼 수 있는 구간을 찾지 못했어요.{' '}
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      'n_caf.highlight.msg_simpletocomplex',
      <>在这堂课中没有可以使用複合句的区间</>,
      <>在這堂課中沒有可以使用複合句的區間</>,
      <>
        今回のレッスンでは、Complex sentences（複文）を
        <br />
        使用することができるセクションがありませんでした。{' '}
      </>,
      ``,
    ],
    modal_sentence_structure: [
      `수업시간에 학습자가 말한 구간 중 하나의 구간 내에서 연속해서 단문을 사용하거나 중문을 사용한 구간 중 더 복잡한 문장 구조를 사용할 수 있는 구간이 표시됩니다.`,
      `Shows sections where you used simple sentences consecutively or a compound sentence, which may be changed into a complex sentence.`,
      'n_caf.highlight.modal_sentence_structure',
      `在之前的回答中，某些部分使用了连续的简单句或并列句，可以改写为複合句。`,
      `在之前的回答中，某些部分使用了連續的簡單句或並列句，可以改寫為複合句。`,
      `単純な文を連続して使用した箇所または複合文を使用した箇所を示します。これらは複文に変更できる可能性があります。`,
      ``,
    ],
    repetition1: [
      `특정 단어를 반복적으로 사용했어요.`,
      `Certain words were repeatedly used.`,
      'n_caf.highlight.repetition1',
      `某些单字被重复使用。`,
      `某些單字被重覆使用。`,
      `特定の単語が繰り返し使用されました。`,
      `Certain words were repeatedly used.`,
    ],
    repetition2: [
      `반복적으로 사용한 단어가 없었어요.`,
      `No words were used repeatedly.`,
      'n_caf.highlight.repetition2',
      `没有重复使用的单字。`,
      `沒有重覆使用的單字。`,
      `特定の単語が繰り返し使用されることはありませんでした。`,
      `No words were used repeatedly.`,
    ],
    msg_grammar: [
      `이번 수업에서는 문법 실수가 없었어요.`,
      `You did not make any grammar mistakes during this lesson.`,
      'n_caf.highlight.msg_grammar',
      `您在本堂课未犯任何文法错误`,
      `您在本堂課未犯任何文法錯誤`,
      `このレッスンで文法のミスはありませんでした。`,
      `You did not make any grammar mistakes during this lesson.`,
    ],
    msg_repetition: [
      `이번 수업에서는 같은 구간에서 3번이상 
반복적으로 사용한 단어가 없었어요.`,
      `No words were used more than 3 times
in the same section during this lesson.`,
      'n_caf.highlight.msg_repetition',
      `在本节课中，没有单字在同一区间中使用超过 3 次`,
      `在本節課中，沒有單字在同一區間中使用超過 3 次`,
      `このレッスン中、同じセクションで3回以上使用された単語はありませんでした。`,
      `No words were used more than 3 times
in the same section during this lesson.`,
    ],
    select: [
      `구간 선정 기준`,
      `Highlighted sections`,
      'n_caf.highlight.select',
      `选定区间`,
      `選定區間`,
      `ハイライトセクション`,
      `Highlighted sections`,
    ],
    time: [`시간`, `Time`, 'n_caf.highlight.time', `时间`, `時間`, `時間`, `Time`],
    viewmore: [`더보기`, `See more`, 'n_caf.highlight.viewmore', `看更多`, `看更多`, `もっと見る`, `See more`],
    report: [
      `오류 제보`,
      `Report error`,
      'n_caf.highlight.report',
      `回报错误`,
      `回報錯誤`,
      `エラー報告`,
      `Report error`,
    ],
    modal_repetition: [
      `수업 시간에 학습자가 말한 구간 중, 하나의 구간에서 같은 단어를 3번 이상 반복한 구간이 표시됩니다.`,
      `Shows sections where you used the same word 3 or more times.`,
      'n_caf.highlight.modal_repetition',
      `显示您使用相同单字 3 次或以上的区间。`,
      `顯示您使用相同單字 3 次或以上的區間。`,
      `同じ単語を3回以上使用したセクションを表示します。`,
      `Shows sections where you used the same word 3 or more times.`,
    ],
    modal_grammar_error: [
      `13가지 문법 실수 유형중에 이번 수업에서 가장 빈도가 높았던 3가지 유형을 보여줍니다.`,
      `Shows the top 3 most frequently made grammar mistakes (out of 13 types) you made during this lesson.`,
      'n_caf.highlight.modal_grammar_error',
      `显示您在本堂课中最常犯的 3 个文法错误（共 13 种）。`,
      `顯示您在本堂課中最常犯的 3 個文法錯誤（共 13 種）。`,
      `このレッスンで最も多かった文法のミス（13種類のうち上位3つ）を表示します。`,
      `Shows the top 3 most frequently made grammar mistakes (out of 13 types) you made during this lesson.`,
    ],
    modal_speech_rate: [
      `수업시간에 학습자가 말한 문장 중 말하기 속도가 부자연스럽게 느렸던 문장(77 wpm 이하)이 표시됩니다. 원어민의 자연스러운 말하기 속도는 120 - 180 wpm 사이 입니다.`,
      `Shows the sentences you spoke unnaturally slowly (under 77 wpm). A native speaker's natural speech rate is between 120 and 180 words per minute.`,
      'n_caf.highlight.modal_speech_rate',
      `显示您语速过慢（低于 77 wpm）的句子。母语人士的自然语速为每分钟 120 到 180 个单字。`,
      `顯示您語速過慢（低於 77 wpm）的句子。母語人士的自然語速為每分鐘 120 到 180 個單字。`,
      `あなたが比較的ゆっくり（77wpm以下）話した文章を表示します。ネイティブスピーカーの自然な発話速度は1分間に120～180語です。`,
      `Shows the sentences you spoke unnaturally slowly (under 77 wpm). A native speaker's natural speech rate is between 120 and 180 words per minute.`,
    ],
    modal_title: [
      `구간 선정 기준`,
      `Highlighted sections`,
      'n_caf.highlight.modal_title',
      `选定区间`,
      `選定區間`,
      `ハイライトセクション`,
      `Highlighted sections`,
    ],
    okay: [`확인`, `OK`, 'n_caf.highlight.okay', `OK`, `OK`, `OK`, `OK`],
    repeat: (count) => [
      `${count}번 반복`,
      `Repeat ${count}`,
      'n_caf.highlight.repeat',
      `重複${count}次`,
      `重複${count}次`,
      `${count}を繰り返す`,
      `Repeat ${count}`,
    ],
    graph_sr: [
      `나의 말하기 속도 (wpm)`,
      `My speech rate (wpm)`,
      'n_caf.highlight.graph_sr',
      `我的口说速度 (wpm)`,
      `我的口說速度 (wpm)`,
      `あなたのスピーチ速度 (wpm)`,
      `My speech rate (wpm)`,
    ],
    sr_section: [
      `말하기 속도가 느린 구간`,
      `Slow speech section`,
      'n_caf.highlight.sr_section',
      `口说速度较慢的区间`,
      `口說速度較慢的區間`,
      `ゆっくりスピーチしたセクション`,
      `Slow speech section`,
    ],
    category1: [
      `불변화사`,
      `Particle`,
      'n_caf.highlight.category1',
      `助词(Particle)`,
      `助詞(Particle)`,
      `Particle（助詞）`,
      `Particle`,
    ],
    category2: [
      `전치사`,
      `Preposition`,
      'n_caf.highlight.category2',
      `介词(prepositions)`,
      `介系詞(prepositions)`,
      `Preposition（前置詞）`,
      `Preposition`,
    ],
    category3: [
      `동사 형태`,
      `Verb Form`,
      'n_caf.highlight.category3',
      `动词形式(verb form)`,
      `動詞形式(verb form)`,
      `Verb Form（動詞の形）`,
      `Verb Form`,
    ],
    category4: [
      `명사 수일치`,
      `Noun Number`,
      'n_caf.highlight.category4',
      `名词单複数(Noun Number)`,
      `名詞單複數(Noun Number)`,
      `Noun Number（名詞数）`,
      `Noun Number`,
    ],
    category5: [
      `단어 순서`,
      `Word Order`,
      'n_caf.highlight.category5',
      `词语顺序(Word Order)`,
      `詞語順序(Word Order)`,
      `Word Order（語順）`,
      `Word Order`,
    ],
    category6: [
      `형태 혼동`,
      `Morphology`,
      'n_caf.highlight.category6',
      `词语型态(Morphology)`,
      `詞語型態(Morphology)`,
      `Morphology（形態論）`,
      `Morphology`,
    ],
    ringletip: [
      `Ringle’s Tip`,
      `Ringle’s Tip`,
      'n_caf.highlight.ringletip',
      `Ringle’s Tip`,
      `Ringle’s Tip`,
      `Ringle’s Tip`,
      `Ringle’s Tip`,
    ],
    msg_ros: [
      `이번 수업에서는 3개 이상의 독립절이 포함된
길게 이어진 문장이 없었어요.`,
      `There were no run-on sentences with 3 or more
independent clauses in this lesson.`,
      'n_caf.highlight.msg_ros',
      `没有侦测到包含三个或更多独立分句的连写句`,
      `沒有偵測到包含三個或更多獨立分句的連寫句`,
      `今回のレッスンでは、3つ以上のIndependent clauses（独立節）を持つ”Run-on sentences”（連結された文章）はありませんでした。`,
      `There were no run-on sentences with 3 or more
independent clauses in this lesson.`,
    ],
    count: [`개`, `on avg.`, 'n_caf.highlight.count', `平均`, `平均`, `平均`, `on avg.`],
    msg_speech_rate: [
      `이번 수업에서는 말하기 속도가 
전반적으로 자연스러웠어요.`,
      `Your speech rate was
natural throughout this lesson.`,
      'n_caf.highlight.msg_speech_rate',
      `你这堂课的说话速度整体来说很自然`,
      `你這堂課的說話速度整體來說很自然`,
      `今回のレッスンにおいて、あなたの話す速度は自然でした。`,
      `Your speech rate was
natural throughout this lesson.`,
    ],
    modal_runon: [
      `하나의 문장에 3개 이상의 독립절이 포함된 경우를 Run-on 문장으로 합니다.`,
      `A sentence is considered "run-on" if it includes more than 3 independent clauses.`,
      'n_caf.highlight.modal_runon',
      `一句话如果包含超过三个独立从句(Indeoendent clauses)，就被视为“连写句(run-on sentence)”。`,
      `一句話如果包含超過三個獨立從句(Indeoendent clauses)，就被視為“連寫句(run-on sentence)”。`,
      `1つの文が3つ以上のIndependent clauses（独立節）を含んでいる場合、その文章は Run-onとみなされます。`,
      `A sentence is considered "run-on" if it includes more than 3 independent clauses.`,
    ],
    category7: [
      `주어동사 수일치`,
      `Subject-Verb Agreement`,
      'n_caf.highlight.category7',
      `主词动词一致性`,
      `主詞動詞一致性`,
      `Subject（主語）とVerb（動詞）の一致`,
      `Subject-Verb Agreement`,
    ],
    category8: [
      `형용사`,
      `Adjective`,
      'n_caf.highlight.category8',
      `形容词`,
      `形容詞`,
      `Adjective（形容詞）`,
      `Adjective`,
    ],
    category9: [
      `최상급/비교급`,
      `Superlative/Comparative`,
      'n_caf.highlight.category9',
      `最高级/比较级`,
      `最高級/比較級`,
      `Superlative（最上級）/Comparative（比較級）`,
      `Superlative/Comparative`,
    ],
    category10: [`부사`, `Adverb`, 'n_caf.highlight.category10', `副词`, `副詞`, `Adverb（副詞）`, `Adverb`],
    category11: [
      `가산/불가산 명사`,
      `Noun Inflection`,
      'n_caf.highlight.category11',
      `名词变化`,
      `名詞變化`,
      `Noun Inflection（名詞の変化）`,
      `Noun Inflection`,
    ],
    category12: [
      `동사 시제`,
      `Verb Tense`,
      'n_caf.highlight.category12',
      `动词时态`,
      `動詞時態`,
      `Verb Tense（動詞の時制）`,
      `Verb Tense`,
    ],
    category13: [
      `단어 반복`,
      `Word Repetition`,
      'n_caf.highlight.category13',
      `单字重複`,
      `單字重複`,
      `Word Repetition（単語の反復）`,
      `Word Repetition`,
    ],
    category14: [
      `Run-on 문장`,
      `Run-on Sentence`,
      'n_caf.highlight.category14',
      `连写句`,
      `連寫句`,
      `Run-on Sentence（連結された文章）`,
      `Run-on Sentence`,
    ],
    category15: [
      `말하기 속도`,
      `Speech Rate`,
      'n_caf.highlight.category15',
      `语速`,
      `語速`,
      `Speech Rate（スピーチ速度）`,
      `Speech Rate`,
    ],
    category16: [
      `필러워드`,
      `Filler Words`,
      'n_caf.highlight.category16',
      `填充词`,
      `填充詞`,
      `Filler Words（間投詞）`,
      `Filler Words`,
    ],
    msg_filler: [
      `이번 수업에서는 
필러워드 사용 빈도가 적절했어요.`,
      `You used filler words
appropriately during this lesson.`,
      'n_caf.highlight.msg_filler',
      `“你在本课中恰当地使用了填充词`,
      `“你在本課中恰當地使用了填充詞`,
      `今回のレッスン中、あなたはFiller Words（間投詞）を適切に使用していました。`,
      `You used filler words
appropriately during this lesson.`,
    ],
    filler_length: [
      `평균 filler words 길이`,
      `Avg. filler word length`,
      'n_caf.highlight.filler_length',
      `在本课中恰当地使用了填充词"。`,
      `在本課中適當地使用了填充詞"。`,
      `平均Filler Words（間投詞）length`,
      `Avg. filler word length`,
    ],
    ai_paraphrase: [
      `AI 교정 보기`,
      `AI Proofreading`,
      'n_caf.highlight.ai_paraphrase',
      `平均填充词长度`,
      `平均填充詞長度`,
      `AI 校正を表示`,
      `AI Proofreading`,
    ],
    ai_phrase: [
      `AI 교정`,
      `AI Proofreading`,
      'n_caf.highlight.ai_phrase',
      `AI校正`,
      `AI校正`,
      `AI 校正`,
      `AI Proofreading`,
    ],
    ai_loading: [
      <>
        열심히 교정을 생성하고 있어요.
        <br />
        잠시만 기다려주세요.
      </>,
      <>
        Proofreading is in process.
        <br />
        Please wait a moment.
      </>,
      'n_caf.highlight.ai_loading',
      <>
        校正正在进行
        <br />
        请稍等
      </>,
      <>
        校正正在進行
        <br />
        請稍等
      </>,
      <>
        校正中です。
        <br />
        しばらくお待ちください。
      </>,
      <>
        Proofreading is in process.
        <br />
        Please wait a moment.
      </>,
    ],
    ai_error: [
      `오류가 발생했습니다.`,
      `An error has occurred.`,
      'n_caf.highlight.ai_error',
      `发生错误`,
      `發生錯誤`,
      `エラーが発生しました。`,
      `An error has occurred.`,
    ],
    ai_tryagain: [
      `다시 시도하기`,
      `Try again`,
      'n_caf.highlight.ai_tryagain',
      `再试一次`,
      `再試一次`,
      `Try again`,
      `Try again`,
    ],
    modal_filler_word: [
      `Um, uh와 같이 특정한 의미를 전달하지 않는 필러워드 사용으로 인해 발화의 진행에 부정적인 영향을 미친다고 판단되는 구간을 선정합니다.`,
      `Sections where the use of filler words (such as "um" and "uh" that have no specific meaning) negatively affected your speech are detected.`,
      'n_caf.highlight.modal_filler_word',
      `检测出使用填充词（如没有特定含义的 “um ”和 “uh”）对您的发言产生负面影响的部分。`,
      `檢測出使用填充詞（如沒有特定含義的 “um ”和 “uh”）對您的發言產生負面影響的部分。`,
      `”um”や”uh”など、スピーチに悪影響を及ぼしている特定の意味を持たないFiller wordの使用箇所が検出されます。`,
      `Sections where the use of filler words (such as "um" and "uh" that have no specific meaning) negatively affected your speech are detected.`,
    ],
    grammar_category: [
      `문법 실수`,
      `Grammar mistakes`,
      'n_caf.highlight.grammar_category',
      `文法错误`,
      `文法錯誤`,
      `文法のミス`,
      `Grammar mistakes`,
    ],
    category0: [
      `한정사`,
      `Determiner`,
      'n_caf.highlight.category0',
      `冠词(Determiner)`,
      `冠詞(Determiner)`,
      `Determiner（限定詞）`,
      `Determiner`,
    ],
    min: [`분`, `min`, 'n_caf.highlight.min', `分`, `分`, `分`, `min`],
    sec: [`초`, `sec`, 'n_caf.highlight.sec', `秒`, `秒`, `秒`, `sec`],
    fraction_counts: (detail_count, total_count) => [
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}개
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}
      </>,
      'n_caf.highlight.fraction_counts',
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}个
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}個
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}個
      </>,
      <>
        <span className="text-[20px] text-purple-500 h-[28px]">{detail_count}</span>&nbsp;/{total_count}
      </>,
    ],
    category17: [
      `문장 구조`,
      `Sentence structure`,
      'n_caf.highlight.category17',
      `句子结构 Sentence structure`,
      `句子結構 Sentence structure`,
      `Sentence structure（文章の構造）`,
      `Sentence structure`,
    ],
    report_sentence: [
      `선택된 문장`,
      `Selected Sentence`,
      'n_caf.highlight.report_sentence',
      `选取句子`,
      `選取句子`,
      `Selected Sentence`,
      `Selected Sentence`,
    ],
    report_content: [
      `리포팅 내용을 입력해주세요.`,
      `Please input the details.`,
      'n_caf.highlight.report_content',
      `请输入详细资讯`,
      `請輸入詳細資訊`,
      `詳細を入力してください。`,
      `Please input the details.`,
    ],
    msg_sentence_structure: [
      <>
        이번 수업에서는 더 복잡한 문장 구조를 <br />
        시도해 볼 수 있는 구간을 찾지 못했어요.{' '}
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
      'n_caf.highlight.msg_sentence_structure',
      <>本堂课没有可以使用複杂句的区间</>,
      <>本堂課沒有可以使用複雜句的區間</>,
      <>
        今回のレッスンでは、Complex sentencesを
        <br />
        使用することができるセクションがありませんでした。{' '}
      </>,
      <>
        There were no sections in this lesson
        <br />
        where complex sentences could be used.
      </>,
    ],
  },
  statistic: {
    highlight: {
      grammarerror18: (count) => [
        `발음 연습이 필요한 단어|가 평균${count}개 있어요.`,
        `An avg. of ${count} words require practice.`,
        'n_caf.statistic.highlight.grammarerror18',
        `平均有${count}个单字需要练习`,
        `平均有${count}個單字需要練習`,
        `平均${count}語の練習が必要です。`,
        ``,
      ],
      graph_title18: [
        `더 복잡한 문장 구조를 시도해 볼 수 있는 구간 수`,
        `Number of sections where complex sentences may be used`,
        'n_caf.statistic.highlight.graph_title18',
        `可以使用複合句的区间`,
        `可以使用複合句的區間`,
        `複文を使用するセクションの数`,
        ``,
      ],
      graph_date: [
        `수업 날짜`,
        `Lesson date`,
        'n_caf.statistic.highlight.graph_date',
        `课程日期`,
        `課程日期`,
        `レッスン日時`,
        `Lesson date`,
      ],
      count: (count) => [
        `총 ${count}개 수업의 학습 영역`,
        `Focus areas for ${count} lessons`,
        'n_caf.statistic.highlight.count',
        `总共 ${count}堂课的学习领域`,
        `總共 ${count}堂課的學習領域`,
        `${count}レッスンのFocus areas`,
        `Focus areas for ${count} lessons`,
      ],
      select: [
        `조회한 수업의 학습 영역`,
        `Focus areas for the chosen lesson`,
        'n_caf.statistic.highlight.select',
        `所选课程的学习领域`,
        `所選課程的學習領域`,
        `選択したレッスンのFocus areas`,
        `Focus areas for the chosen lesson`,
      ],
      grammarerror0: (count) => [
        `한정사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Determiner| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror0',
        `平均有${count} 个冠词(Determiner)错误`,
        `平均有${count} 個冠詞(Determiner)錯誤`,
        `Determiner（限定詞）| 関連する文法のミスが平均${count} つありました。`,
        `Determiner| ${count} mistakes detected on average.`,
      ],
      grammarerror1: (count) => [
        `불변화사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Particle| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror1',
        `平均有${count} 个助词(Particle)错误`,
        `平均有${count} 個助詞(Particle)錯誤`,
        `Particle（助詞）| 関連する文法のミスが平均${count} つありました。`,
        `Particle| ${count} mistakes detected on average.`,
      ],
      grammarerror2: (count) => [
        `전치사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Preposition| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror2',
        `平均有 ${count} 个介词(Preposition)错误`,
        `平均有 ${count} 個介系詞(Preposition)錯誤`,
        `Preposition（前置詞）| 関連する文法のミスが平均${count} つありました。`,
        `Preposition| ${count} mistakes detected on average.`,
      ],
      grammarerror3: (count) => [
        `동사 형태| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Verb Form| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror3',
        `平均有 ${count} 个动词型态(Verb Form)错误`,
        `平均有 ${count} 個動詞型態(Verb Form)錯誤`,
        `Verb Form（動詞の形）| 関連する文法のミスが平均${count} つありました。`,
        `Verb Form| ${count} mistakes detected on average.`,
      ],
      grammarerror4: (count) => [
        `명사 수일치| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Noun Number| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror4',
        `平均有 ${count} 个名词单複数(Noun Number)错误`,
        `平均有 ${count} 個名詞單複數(Noun Number)錯誤`,
        `Noun Number（名詞数）| 関連する文法のミスが平均${count} つありました。`,
        `Noun Number| ${count} mistakes detected on average.`,
      ],
      grammarerror5: (count) => [
        `단어 순서| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Word Order| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror5',
        `平均有 ${count} 个词语顺序(Word Order)错误`,
        `平均有 ${count} 個詞語順序(Word Order)錯誤`,
        `Word Order（語順）| 関連する文法のミスが平均${count} つありました。`,
        `Word Order| ${count} mistakes detected on average.`,
      ],
      grammarerror6: (count) => [
        `형태 혼동| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Morphology| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror6',
        `平均有 ${count} 个词语型态(Morphology)错误`,
        `平均有 ${count} 個詞語型態(Morphology)錯誤`,
        `Morphology（形態論）| 関連する文法のミスが平均${count} つありました。`,
        `Morphology| ${count} mistakes detected on average.`,
      ],
      grammarerror7: (count) => [
        `주어동사 수일치| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Subject-Verb Agreement| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror7',
        `平均有 ${count} 个主词动词不一致(Subject-Verb Agreement)错误`,
        `平均有 ${count} 個主詞動詞不一致(Subject-Verb Agreement)錯誤`,
        `Subject（主語）とVerb（動詞）の一致|関連する文法のミスが平均${count} つありました。`,
        `Subject-Verb Agreement| ${count} mistakes detected on average.`,
      ],
      grammarerror8: (count) => [
        `형용사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Adjective| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror8',
        `平均有 ${count} 个形容词(Adjective)错误`,
        `平均有 ${count} 個形容詞(Adjective)錯誤`,
        `Adjective（形容詞）| 関連する文法のミスが平均${count} つありました。`,
        `Adjective| ${count} mistakes detected on average.`,
      ],
      grammarerror9: (count) => [
        `최상급/비교급| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Superlative/Comparative| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror9',
        `平均有 ${count} 个最高级/比较级使用(superlative/comparative)错误`,
        `平均有 ${count} 個最高級/比較級使用(superlative/comparative)錯誤`,
        `Superlative（最上級）/Comparative（比較級）| 関連する文法のミスが平均${count} つありました。`,
        `Superlative/Comparative| ${count} mistakes detected on average.`,
      ],
      grammarerror10: (count) => [
        `부사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Adverb| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror10',
        `平均有 ${count} 个副词(Adverb)错误`,
        `平均有 ${count} 個副詞(Adverb)錯誤`,
        `Adverb（副詞）| 関連する文法のミスが平均${count} つありました。`,
        `Adverb| ${count} mistakes detected on average.`,
      ],
      grammarerror11: (count) => [
        `가산/불가산 명사| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Noun Inflection| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror11',
        `平均有 ${count} 个名词变化(Noun Inflection)错误`,
        `平均有 ${count} 個名詞變化(Noun Inflection)錯誤`,
        `Noun Inflection（名詞の変化）| ${count} 関連する文法のミスが平均${count} つありました。`,
        `Noun Inflection| ${count} mistakes detected on average.`,
      ],
      grammarerror12: (count) => [
        `동사 시제| 관련 문법 실수가 평균 ${count}개 있어요.`,
        `Verb Tense| ${count} mistakes detected on average.`,
        'n_caf.statistic.highlight.grammarerror12',
        `平均有 ${count} 个动词时态(Verb Tense)错误`,
        `平均有 ${count} 個動詞時態(Verb Tense)錯誤`,
        `Verb Tense（動詞の時制）| 関連する文法のミスが平均${count} つありました。`,
        `Verb Tense| ${count} mistakes detected on average.`,
      ],
      grammarerror13: (count) => [
        `반복적으로 사용한 단어|가 평균 ${count}개 있어요.`,
        `Word Repetition| ${count} problematic sections detected on average.`,
        'n_caf.statistic.highlight.grammarerror13',
        `平均有 ${count} 个单字重複(Word Repetition)错误`,
        `平均有 ${count} 個單字重複(Word Repetition)錯誤`,
        `Word Repetition（単語の反復）|問題のある箇所が平均 ${count} つありました。`,
        `Word Repetition| ${count} problematic sections detected on average.`,
      ],
      grammarerror14: (count) => [
        `Run-on 문장|이 평균 ${count}개 있어요.`,
        `Run-on Sentence| ${count} detected on average.`,
        'n_caf.statistic.highlight.grammarerror14',
        `平均有 ${count} 个连写句(Run-in Sentence)错误`,
        `平均有 ${count} 個連寫句(Run-in Sentence)錯誤`,
        `Run-on Sentence（連結された文章）|平均 ${count} つありました。`,
        `Run-on Sentence| ${count} detected on average.`,
      ],
      grammarerror15: (count) => [
        `말하기 속도|가 느렸던 구간이 평균 ${count}개 있어요.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        'n_caf.statistic.highlight.grammarerror15',
        `平均有${count}个语速下降的区间`,
        `平均有${count}個語速下降的區間`,
        `Speech Rate（スピーチ速度）|Slow speechの箇所が平均 ${count}つありました。`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
      ],
      grammarerror16: (count) => [
        `필러워드| 사용이 많았던 구간이 평균 ${count}개 있어요.`,
        `Filler Words| ${count} problematic sections detected on average.`,
        'n_caf.statistic.highlight.grammarerror16',
        `平均有${count}个使用填充词(Filler Words)的区间`,
        `平均有${count}個使用填充詞(Filler Words)的區間`,
        `Filler Words（間投詞）| 問題のある箇所が平均 ${count} つありました。`,
        `Filler Words| ${count} problematic sections detected on average.`,
      ],
      speech_rate1: (count) => [
        `말하기 속도|가 느렸던 구간이 평균 ${count}개 있었어요.`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
        'n_caf.statistic.highlight.speech_rate1',
        `平均有${count}个语速下降的区间`,
        `平均有${count}個語速下降的區間`,
        `Speech Rate（スピーチ速度）|Slow speechの箇所が平均 ${count}つありました。`,
        `Speech Rate| ${count} slow speech sections detected on average.`,
      ],
      graph_title0: [
        `실수 개수`,
        `No. of mistakes`,
        'n_caf.statistic.highlight.graph_title0',
        `错误次数`,
        `錯誤次數`,
        `No. of mistakes`,
        `No. of mistakes`,
      ],
      graph_title13: [
        `반복 단어 수`,
        `No. of repeated words`,
        'n_caf.statistic.highlight.graph_title13',
        `使用重複单字次数`,
        `使用重複單字次數`,
        `No. of repeated words`,
        `No. of repeated words`,
      ],
      graph_title14: [
        `Run-on 문장 수`,
        `No. of run-on sentences`,
        'n_caf.statistic.highlight.graph_title14',
        `使用连写句次数`,
        `使用連寫句次數`,
        `No. of run-on sentences`,
        `No. of run-on sentences`,
      ],
      graph_title15: [
        `말하기 속도가 느린 구간 수`,
        `No. of slow speech sections`,
        'n_caf.statistic.highlight.graph_title15',
        `语速减缓次数`,
        `語速減緩次數`,
        `No. of slow speech sections`,
        `No. of slow speech sections`,
      ],
      grammarerror17: (count) => [
        `더 복잡한 문장 구조|를 시도해 볼 수 있는 구간이 평균 ${count}개 있어요.`,
        `Complex Sentence| ${count} applicable sections on average.`,
        'n_caf.statistic.highlight.grammarerror17',
        `複合句适用区间平均| ${count} 个`,
        `複合句適用區間平均| ${count} 個`,
        `Complex Sentence（複文）|該当箇所が平均 ${count} 個あります。`,
        `Complex Sentence| ${count} applicable sections on average.`,
      ],
      graph_title17: [
        `더 복잡한 문장 구조를 시도해 볼 수 있는 구간 수`,
        `Number of sections where complex sentences could be used`,
        'n_caf.statistic.highlight.graph_title17',
        `複合句可适用区间个数`,
        `複合句可適用區間個數`,
        `Complex sentence（複文）が使用される可能性のあるセクションの数`,
        `Number of sections where complex sentences could be used`,
      ],
    },
    tab_menu: [
      `AI 분석 통계`,
      `AI Analysis Statistics`,
      'n_caf.statistic.tab_menu',
      `AI 分析统计`,
      `AI 分析統計`,
      `AI analysis統計`,
      `AI Analysis Statistics`,
    ],
    period: (year, month) => [
      `${year}년 ${month}월`,
      `${month}/${year}`,
      'n_caf.statistic.period',
      `${year}년 ${month}月`,
      `${year}년 ${month}月`,
      `${year}年 ${month}月`,
      `${month}/${year}`,
    ],
    level_avg: [
      `AI 분석 레벨 평균`,
      `Average Level`,
      'n_caf.statistic.level_avg',
      `平均等级`,
      `平均等級`,
      `平均レベル`,
      `Average Level`,
    ],
    lessons: [`분석한 수업`, `Lessons`, 'n_caf.statistic.lessons', `Lessons`, `Lessons`, `Lessons`, `Lessons`],
    highlight_title: [
      `추천 학습 영역`,
      `Recommended Focus Areas`,
      'n_caf.statistic.highlight_title',
      `推荐学习领域`,
      `推薦學習領域`,
      `Recommended Focus Areas`,
      `Recommended Focus Areas`,
    ],
    highlight_detail: (name, count) => [
      `${name}님의 지난 ${count}개의 수업 분석을 기반으로 다음 링글 수업에서 집중하여 개선하면 좋을 영역을 추천드립니다.`,
      `Recommended focus areas for your next lesson based on the analyses of your last ${count} lessons.`,
      'n_caf.statistic.highlight_detail',
      `根据上一次 ${count} 的课程分析，为下一次课程推荐学习领域`,
      `根據上一次 ${count} 的課程分析，為下一次課程推薦學習領域`,
      `前回の ${count} レッスンの分析に基づいて、次回のレッスンでのRecommended focus areasを示します。`,
      `Recommended focus areas for your next lesson based on the analyses of your last ${count} lessons.`,
    ],
    trend: {
      caf: [
        `전체 레벨`,
        `All Levels`,
        'n_caf.statistic.trend.caf',
        `All Levels`,
        `All Levels`,
        `All Levels`,
        `All Levels`,
      ],
      complexity: [
        `Complexity 레벨`,
        `Complexity Level`,
        'n_caf.statistic.trend.complexity',
        `複杂度等级`,
        `複雜度等級`,
        `Complexity Level`,
        `Complexity Level`,
      ],
      accuracy: [
        `Accuracy 레벨`,
        `Accuracy Level`,
        'n_caf.statistic.trend.accuracy',
        `准确度等级`,
        `準確度等級`,
        `Accuracy Level`,
        `Accuracy Level`,
      ],
      fluency: [
        `Fluency 레벨`,
        `Fluency Level`,
        'n_caf.statistic.trend.fluency',
        `流畅度等级`,
        `流暢度等級`,
        `Fluency Level`,
        `Fluency Level`,
      ],
      date: [
        `수업날짜`,
        `Lesson date`,
        'n_caf.statistic.trend.date',
        `课程日期`,
        `課程日期`,
        `レッスン日時`,
        `Lesson date`,
      ],
      cafallchip: [`전체`, `All`, 'n_caf.statistic.trend.cafallchip', `全部`, `全部`, `All`, `All`],
      cafall: [
        `전체 레벨`,
        `All Levels`,
        'n_caf.statistic.trend.cafall',
        `所有等级`,
        `所有等級`,
        `All Levels`,
        `All Levels`,
      ],
      min: [
        `최저 레벨`,
        `Lowest level`,
        'n_caf.statistic.trend.min',
        `最低等级`,
        `最低等級`,
        `Lowest level`,
        `Lowest level`,
      ],
      max: [
        `최대 레벨`,
        `Highest level`,
        'n_caf.statistic.trend.max',
        `嘴高等级`,
        `嘴高等級`,
        `Highest level`,
        `Highest level`,
      ],
      pronunciation: [
        `Pronunciation 레벨`,
        `Pronunciation Level`,
        'n_caf.statistic.trend.pronunciation',
        `发音等级`,
        `發音等級`,
        `Pronunciation Level`,
        `Pronunciation Level`,
      ],
    },
    nodata: [
      `선택한 기간에 한 개 이상의 수업 분석이
있어야 AI 분석 통계를 확인할 수 있습니다.`,
      `You need at least one AI analysis during
the chosen period to view AI Analysis statistics.`,
      'n_caf.statistic.nodata',
      `至少需要一堂课以上的AI分析才能看到AI分析统计`,
      `至少需要一堂課以上的AI分析才能看到AI分析統計`,
      `AI analysis統計を表示するには、選択した期間中に少なくとも1回のAI analysisの実施が必要です。`,
      `You need at least one AI analysis during
the chosen period to view AI Analysis statistics.`,
    ],
    less_list: {
      title: [
        `수업 리스트`,
        `Lesson list`,
        'n_caf.statistic.less_list.title',
        `课程清单`,
        `課程清單`,
        `Lesson list`,
        `Lesson list`,
      ],
      edit: [`편집`, `Edit`, 'n_caf.statistic.less_list.edit', `编辑`, `編輯`, `編集`, `Edit`],
      done: [`완료`, `Done`, 'n_caf.statistic.less_list.done', `完成`, `完成`, `完了`, `Done`],
      count: (count) => [
        <>
          총 <span className="text-primary">{count}</span>개의 수업
        </>,
        <>
          A total of <span className="text-primary">{count}</span> lessons
        </>,
        'n_caf.statistic.less_list.count',
        <>
          总共<span className="text-primary">{count}</span>堂课
        </>,
        <>
          總共<span className="text-primary">{count}</span>堂課
        </>,
        <>
          合計<span className="text-primary">{count}</span> 個のクラス
        </>,
        <>
          A total of <span className="text-primary">{count}</span> lessons
        </>,
      ],
    },
    lesson_list: {
      on: [
        `해당 수업의 분석을 AI 분석 통계에 포함했어요.`,
        `This lesson's  analysis is included in the AI Analysis statistics.`,
        'n_caf.statistic.lesson_list.on',
        `本堂课的分析包含在 AI 分析统计中。`,
        `本堂課的分析包含在 AI 分析統計中。`,
        `このレッスンの分析は、AI Analysisの統計に含まれています。`,
        `This lesson's  analysis is included in the AI Analysis statistics.`,
      ],
      off: [
        `해당 수업의 분석을 AI 분석 통계에서 제외했어요.`,
        `This lesson's analysis is excluded from the AI Analysis statistics.`,
        'n_caf.statistic.lesson_list.off',
        `本堂课的分析不包括在AI分析统计中。`,
        `本堂課的分析不包括在AI分析統計中。`,
        `このレッスンの分析は、AI Analysisの統計から除外されます。`,
        `This lesson's analysis is excluded from the AI Analysis statistics.`,
      ],
      unavailable: [
        `조회하신 기간의 모든 수업을 제외할 수 없습니다.`,
        `It is not possible to exclude all lessons within the selected period.`,
        'n_caf.statistic.lesson_list.unavailable',
        `无法排除所选时段内的所有课程。`,
        `無法排除所選時段內的所有課程。`,
        `選択された期間内のすべてのレッスンを除外することはできません。`,
        `It is not possible to exclude all lessons within the selected period.`,
      ],
    },
    date_optn1: [`최근 1개월`, `1 month`, 'n_caf.statistic.date_optn1', `最近1个月`, `最近1個月`, `1ヶ月`, `5 month`],
    date_optn2: [`최근 3개월`, `3 months`, 'n_caf.statistic.date_optn2', `最近3个月`, `最近3個月`, `3ヶ月`, `7 months`],
    date_optn3: [
      `최근 6개월`,
      `6 months`,
      'n_caf.statistic.date_optn3',
      `最近6个月`,
      `最近6個月`,
      `6ヶ月`,
      `10 months`,
    ],
    date_optn4: [
      `최근 12개월`,
      `12 months`,
      'n_caf.statistic.date_optn4',
      `最近12个月`,
      `最近12個月`,
      `12ヶ月`,
      `16 months`,
    ],
    date_optn5: [
      `직접 설정`,
      `Set manually`,
      'n_caf.statistic.date_optn5',
      `直接设定`,
      `直接設定`,
      `手動で設定`,
      `Set manually`,
    ],
    date_chip1: [`최근 1개월`, `1 month`, 'n_caf.statistic.date_chip1', `最近1个月`, `最近1個月`, `1ヶ月`, `5 month`],
    date_chip2: [`3개월`, `3 months`, 'n_caf.statistic.date_chip2', `最近3个月`, `最近3個月`, `3ヶ月`, `7 months`],
    date_chip3: [`6개월`, `6 months`, 'n_caf.statistic.date_chip3', `最近6个月`, `最近6個月`, `6ヶ月`, `10 months`],
    date_chip4: [
      `12개월`,
      `12 months`,
      'n_caf.statistic.date_chip4',
      `最近12个月`,
      `最近12個月`,
      `12ヶ月`,
      `16 months`,
    ],
    date_title: [
      `기간 설정`,
      `Set period`,
      'n_caf.statistic.date_title',
      `直接设定`,
      `直接設定`,
      `期間の設定`,
      `Set period`,
    ],
    date_btn: [`조회하기`, `Search`, 'n_caf.statistic.date_btn', `设定`, `設定`, `Search`, `Search`],
    date_modal: [
      `AI 분석 기록이 없습니다. 한 개 이상의 수업 분석이 있어야 통계의 기간 설정이 가능합니다.`,
      `You don't have any AI analysis results. You must have at least one AI analysis to set the period to view the statistics.`,
      'n_caf.statistic.date_modal',
      `您没有任何 AI 分析报告结果。您必须至少有一个 AI 分析报告，才能搜寻欲查询的日期区间。`,
      `您沒有任何 AI 分析報告結果。您必須至少有一個 AI 分析報告，才能搜尋欲查詢的日期區間。`,
      `AI analysis結果がありません。統計を表示するためには、少なくとも1つのAI analysisが必要です。`,
      `You don't have any AI analysis results. You must have at least one AI analysis to set the period to view the statistics.`,
    ],
    okay: [`확인`, `OK`, 'n_caf.statistic.okay', `OK`, `OK`, `OK`, `OK`],
    bottomsheet_cancel: [`취소`, `Cancel`, 'n_caf.statistic.bottomsheet_cancel', `取消`, `取消`, `Cancel`, `Cancel`],
    bottomsheet_apply: [`완료`, `Done`, 'n_caf.statistic.bottomsheet_apply', `完成`, `完成`, `完了`, `Done`],
    nodata1: [
      `선택한 기간에 분석된 수업이 없습니다.`,
      `You have no AI Analysis results.`,
      'n_caf.statistic.nodata1',
      `选择的日期没有可分析的课程`,
      `選擇的日期沒有可分析的課程`,
      `AI Analysisの結果はありません。`,
      `You have no AI Analysis results.`,
    ],
    nodata2: [
      `기간을 다시 선택해 주세요.`,
      `Please re-select the period.`,
      'n_caf.statistic.nodata2',
      `请重新设定日期`,
      `請重新設定日期`,
      `期間を再度選択してください。`,
      `Please re-select the period.`,
    ],
    view_list: [
      `수업 리스트 보기`,
      `View lesson list`,
      'n_caf.statistic.view_list',
      `看所有课程`,
      `看所有課程`,
      `View lesson list`,
      `View lesson list`,
    ],
    date_title1: [
      `직접 설정`,
      `Set period`,
      'n_caf.statistic.date_title1',
      `设定日期区间`,
      `設定日期區間`,
      `設定期間`,
      `Set period`,
    ],
    view_detail: [
      `자세히 보기`,
      `View details`,
      'n_caf.statistic.view_detail',
      `看更多`,
      `看更多`,
      `詳細を表示`,
      `View details`,
    ],
    menu_statistics: [
      `통계 개요`,
      `Statistics`,
      'n_caf.statistic.menu_statistics',
      `统计`,
      `統計`,
      `Statistics（統計）`,
      `Statistics`,
    ],
  },
  level_detail: {
    stat_info_p: [
      `*1000여명의 링글 학생 분석 데이터를 토대로 제공되는 레벨 분포입니다.`,
      `*Level distribution is provided based on the data of 1,000+ Ringle users.`,
      'n_caf.level_detail.stat_info_p',
      `等级分佈的数据是根据1000+Ringle学习者的分析数据提供`,
      `等級分佈的數據是根據1000+Ringle學習者的分析數據提供`,
      `レベルの分布は、1,000人以上のRingleユーザーのデータに基づいています。`,
      ``,
    ],
    p: {
      title: [
        `Pronunciation 레벨`,
        `Pronunciation level`,
        'n_caf.level_detail.p.title',
        `发音级别`,
        `發音級別`,
        `Pronunciationレベル`,
        ``,
      ],
      level9: [
        `말할 때, 모든 소리와 억양을 자연스럽게 사용하며 개인적인 발음 특징이 있어도 다른 사람이 이해하기에 어려움이 없습니다.`,
        `Uses all sounds and intonations naturally and is easy to understand regardless of personal accent.`,
        'n_caf.level_detail.p.level9',
        `自然地使用所有语音和语调，无论个人口音如何，都易于理解。`,
        `自然地使用所有語音和語調，無論個人口音如何，都易於理解。`,
        `個々のアクセントに関わらず、すべての音とイントネーションを自然に使いこなし、理解しやすいです。`,
        ``,
      ],
      level8: [
        `가끔 강세와 억양이 잘못되긴 하지만, 대체로 안정된 리듬으로 다양한 소리와 억양을 사용하여 말할 수 있습니다.`,
        `Generally speaks in a steady rhythm and uses a variety of sounds and intonations despite occasional mistakes in stress and intonation.`,
        'n_caf.level_detail.p.level8',
        `尽管偶尔会出现重音和语调错误，但说话节奏基本稳定，并能使用各种声音和语调。`,
        `盡管偶爾會出現重音和語調錯誤，但說話節奏基本穩定，並能使用各種聲音和語調。`,
        `時折音の強弱やイントネーションに誤りがあるものの、様々な音やイントネーションを使って安定したリズムで話せています。`,
        ``,
      ],
      level7: [
        `밴드 6의 모든 긍정적인 특징과 밴드 8의 일부 (하지만 모든 것은 아님) 긍정적인 특징을 나타냅니다.`,
        `Exhibits all of the positive features of Band 6 and some (but not all) positive features of Band 8.`,
        'n_caf.level_detail.p.level7',
        `表现出第六级的所有优点和和第八级的一些(但不是全部)优点。`,
        `表現出第六級的所有優點和和第八級的一些(但不是全部)優點。`,
        `バンド6のすべてのポジティブな特性を備えており、バンド8のポジティブな特性も一部（全てではない）示しています。`,
        ``,
      ],
      level6: [
        `적절한 청킹(chunking)을 기반으로 여러 음운론적 요소를 사용하지만 가끔 실수합니다. 그러나 이로 인해 소통에 큰 어려움이 없습니다.`,
        `Uses several phonological elements with appropriate chunking, but occasionally makes mistakes. However, this does not cause any major difficulties in communication.`,
        'n_caf.level_detail.p.level6',
        `使用多个语音要素，并有适当的分块，但偶尔会出错。不过，这不会让沟通有重大困难。`,
        `使用多個語音要素，並有適當的分塊，但偶爾會出錯。不過，這不會讓溝通有重大困難。`,
        `適切な区切りをつけ、いくつかの音韻要素を使用しますが、たまにミスが生じます。ただし、これはコミュニケーションにおいて大きな支障をきたすことはありません。`,
        ``,
      ],
      level5: [
        `밴드 4의 모든 긍정적인 특징과 밴드 6의 일부 (하지만 모든 것은 아님) 긍정적인 특징을 나타냅니다.`,
        `Exhibits all of the positive features of Band 4 and some (but not all) positive features of Band 6.`,
        'n_caf.level_detail.p.level5',
        `表现出第 4 级的所有优点和第 6 级的某些(但不是全部)优点。`,
        `表現出第 4 級的所有優點和第 6 級的某些(但不是全部)優點。`,
        `バンド4のすべてのポジティブな特性を備えており、バンド6のポジティブな特性も一部（全てではない）示しています。`,
        ``,
      ],
      level4: [
        `청킹(chunking), 억양, 그리고 강세와 같은 음운론적 요소의 사용이 제한된 범주 안에서 이뤄지고, 실수가 많아서 말하기 전달력이 좋지 않습니다.`,
        `Exhibits limited use of phonological elements (such as chunking, intonation, and stress) and many mistakes, which make the speech hard to understand.`,
        'n_caf.level_detail.p.level4',
        `语音要素（如分块、语调和重音）的使用有限，错误较多，使语音难以理解。`,
        `語音要素（如分塊、語調和重音）的使用有限，錯誤較多，使語音難以理解。`,
        `音韻要素（区切り方、イントネーション、音の強弱など）の使用が限られ、多くのミスが見られるため、発話内容が理解しにくくなっています。`,
        ``,
      ],
      level3: [
        `대부분의 발음, 그리고 음운론적 요소들의 사용이 적절하지 못하여 말하기의 전달력이 매우 부족합니다`,
        `Pronunciation and use of phonological elements are largely inadequate, resulting in very poor speech delivery.`,
        'n_caf.level_detail.p.level3',
        `发音和语音要素的使用基本不足，导致语言表达能力不佳。`,
        `發音和語音要素的使用基本不足，導致語言表達能力不佳。`,
        `発音や音韻要素の使用が不十分であり、その結果、理解ができないスピーチとなっています。`,
        ``,
      ],
      level2: [
        `전달력 부족으로 소통이 어려우며 대부분의 발음이 잘못 발음되어 이해하기 어렵습니다.`,
        `Communication is difficult due to faulty delivery, and most words are mispronounced, making it difficult to understand.`,
        'n_caf.level_detail.p.level2',
        `由于表达能力不足，大多数单字发音错误，导致难以理解。`,
        `由於表達能力不足，大多數單字發音錯誤，導致難以理解。`,
        `発話が不完全であるため、コミュニケーションが困難であり、ほとんどの単語が誤発音されているため、理解が難しい状況となっています。`,
        ``,
      ],
      level1: [
        `발음이 매우 어색해서 소통할 수 없습니다.`,
        `Pronunciation is too awkward to understand.`,
        'n_caf.level_detail.p.level1',
        `发音不佳，难以理解。`,
        `發音不佳，難以理解。`,
        `発音が不自然で、理解するのが困難です。`,
        ``,
      ],
    },
    stat_info: [
      `*5000여명의 링글 학습자의 분석 데이터를 토대로 제공되는 레벨 분포입니다.`,
      `*Level distribution is provided based on the data of 5,000+ Ringle users.`,
      'n_caf.level_detail.stat_info',
      `*等级分佈是以 5,000+ Ringle 使用者的资料为依据。`,
      `*等級分佈是以 5,000+ Ringle 使用者的資料為依據。`,
      `*レベル分布は、5,000人以上のRingleユーザーのデータに基づいています。`,
      `*Level distribution is provided based on the data of 5,000+ Ringle users.`,
    ],
    c: {
      title: [
        `Complexity 레벨`,
        `Complexity Level`,
        'n_caf.level_detail.c.title',
        `複杂度等级`,
        `複雜度等級`,
        `Complexity Level`,
        `Complexity Level`,
      ],
      level9: [
        `모든 주제에서 유연하고 정확한 어휘를 사용하고 관용적인 언어를 자연스럽고 정확하게 사용합니다.`,
        `Uses flexible and precise vocabulary for all topics and applies idiomatic expressions suitably and clearly.`,
        'n_caf.level_detail.c.level9',
        `针对所有主题使用灵活且精确使用词彙，并适当地应用惯用语。`,
        `針對所有主題使用靈活且精確使用詞彙，並適當地應用慣用語。`,
        `全てのトピックに対して柔軟で正確な語彙を使用し、慣用表現を適切かつ明確に適用することができます。`,
        `Uses flexible and precise vocabulary for all topics and applies idiomatic expressions suitably and clearly.`,
      ],
      level8: [
        `다양한 단어를 쉽고 유연하게 사용하여 정확한 의미를 전달합니다. 고급 어휘를 능숙하게 사용하지만, 가끔 부정확합니다. 필요에 따라 구문을 효과적으로 사용합니다.`,
        `Uses a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
        'n_caf.level_detail.c.level8',
        `能轻鬆灵活地使用各种词彙，包括进阶词彙，以传达精确的意思，但偶尔会有不准确的地方。`,
        `能輕鬆靈活地使用各種詞彙，包括進階詞彙，以傳達精確的意思，但偶爾會有不準確的地方。`,
        `高度な語彙を含むさまざまな単語を柔軟に使用して、正確な意味を伝えますが、時折不正確な場合があります。`,
        `Uses a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
      ],
      level7: [
        `다양한 주제를 논의하기 위해 어휘를 유연하게 구사합니다. 몇몇 고급 어휘를 사용할 줄 알고, 대부분은 반복 단어를 대체할 줄 압니다.`,
        `Employs vocabulary flexibly when discussing different topics, including some advanced vocabulary, and knows how to substitute repetitive words.`,
        'n_caf.level_detail.c.level7',
        `在讨论不同主题时能灵活运用词彙，包括一些进阶词彙，并知道如何取代重複的词彙。`,
        `在討論不同主題時能靈活運用詞彙，包括一些進階詞彙，並知道如何取代重複的詞彙。`,
        `異なるトピックについて話し合う際に、高度な語彙も含めて柔軟に語彙を使いこなし、繰り返し使用される単語をどのように置き換えるかを知っています。`,
        `Employs vocabulary flexibly when discussing different topics, including some advanced vocabulary, and knows how to substitute repetitive words.`,
      ],
      level6: [
        `대부분의 경우에 주제에 대해 길고 분명하게 의미를 전달할 수 있을 만큼 충분한 어휘력이 있습니다. 하지만, 종종 부적절한 경우가 있습니다.`,
        `Has sufficient vocabulary to communicate precisely and lengthily on the topic, but may show inappropriate word choice at times.`,
        'n_caf.level_detail.c.level6',
        `有足够的词彙量，能就主题进行精确且长时间的沟通，但有时可能会出现用字不当的情况。`,
        `有足夠的詞彙量，能就主題進行精確且長時間的溝通，但有時可能會出現用字不當的情況。`,
        `トピックについて正確かつ長く伝えるにあたり十分な語彙力がありますが、時に不適切な言葉の選択をすることがあります。`,
        `Has sufficient vocabulary to communicate precisely and lengthily on the topic, but may show inappropriate word choice at times.`,
      ],
      level5: [
        `익숙하지 않은 주제에 관해서도 이야기할 수 있지만, 제한된 범위의 단어들을 사용합니다.`,
        `Can converse freely even on unfamiliar topics but with a limited vocabulary.`,
        'n_caf.level_detail.c.level5',
        `即使是不熟悉的话题也能自在沟通，但词彙量有限。`,
        `即使是不熟悉的話題也能自在溝通，但詞彙量有限。`,
        `知らない話題でも自由に会話ができますが、語彙は限られています。`,
        `Can converse freely even on unfamiliar topics but with a limited vocabulary.`,
      ],
      level4: [
        `익숙한 주제에 대해서 잘 논의할 수 있지만, 익숙하지 않은 주제일 경우 기본적인 의미만 전달하며, 단어 선택에 있어 실수가 종종 있습니다.`,
        `Can discuss familiar topics well but is able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
        'n_caf.level_detail.c.level4',
        `能很好地讨论熟悉的话题，但对于不熟悉的话题只能传达基本的想法，并可能在用词上出错。`,
        `能很好地討論熟悉的話題，但對於不熟悉的話題只能傳達基本的想法，並可能在用詞上出錯。`,
        `馴染みのあるトピックについてはよく議論できますが、馴染みのないトピックについては基本的な考えしか伝えることができず、言葉の選択を誤ることがあります。`,
        `Can discuss familiar topics well but is able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
      ],
      level3: [
        `개인적인 정보를 전달하기 위해 단순한 단어들만 사용하고, 덜 친숙한 주제의 경우 적절한 단어를 사용하는 데에 어려움을 겪습니다.`,
        `Uses simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
        'n_caf.level_detail.c.level3',
        `使用简单的词彙来传达个人资讯，在谈论较不熟悉的话题时，可能难以使用适当的词彙。`,
        `使用簡單的詞彙來傳達個人資訊，在談論較不熟悉的話題時，可能難以使用適當的詞彙。`,
        `身近な情報を伝えるためには簡単な単語を使うことができますが、馴染みのないトピックについて話す際、適切な語彙を使用することに苦労するかもしれません。`,
        `Uses simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
      ],
      level2: [
        `매번 사용하는 단어나 암기한 단어를 위주로 사용합니다.`,
        `Uses the same set of words or those that have been memorized.`,
        'n_caf.level_detail.c.level2',
        `使用同一套词彙或已背诵的词彙。`,
        `使用同一套詞彙或已背誦的詞彙。`,
        `同じ単語や暗記した単語を使用しています。`,
        `Uses the same set of words or those that have been memorized.`,
      ],
      level1: [
        `제한된 몇가지 단어만 사용합니다.`,
        `Only uses only a limited number of words.`,
        'n_caf.level_detail.c.level1',
        `只使用有限的词彙。`,
        `只使用有限的詞彙。`,
        `限られた単語しか使用していません。`,
        `Only uses only a limited number of words.`,
      ],
    },
    a: {
      title: [
        `Accuracy 레벨`,
        `Accuracy Level`,
        'n_caf.level_detail.a.title',
        `正确度等级`,
        `正確度等級`,
        `Accuracy Level`,
        `Accuracy Level`,
      ],
      level9: [
        `모든 문법을 정확하고 적절하게 사용할 줄 알며, 원어민이 하는 정도의 문법 실수만 합니다.`,
        `Uses correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
        'n_caf.level_detail.a.level9',
        `大部分时间使用正确、恰当的语法，语法错误的频率仅与母语使用者相当。`,
        `大部分時間使用正確、恰當的文法，文法錯誤的頻率僅與母語使用者相當。`,
        `ネイティブスピーカー程度の文法のミスはありますが、すべての文法を正確かつ適切に使用することができます。`,
        `Uses correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
      ],
      level8: [
        `다양한 형태의 문법 구조를 유연하게 사용하며, 대부분의 문장에 문법적 오류가 없습니다. 다만, 가끔 기본적인 문법 실수를 합니다.`,
        `Can flexibly employ diverse grammar structures and construct flawless sentences, although basic grammar mistakes are made every now and then.`,
        'n_caf.level_detail.a.level8',
        `能灵活运用多种语法结构，造句完美无瑕，但偶尔会犯基本语法错误。`,
        `能靈活運用多種文法結構，造句完美無瑕，但偶爾會犯基本文法錯誤。`,
        `多様な文法構造を柔軟に使用し、正確な文章を作成することができますが、時折基本的な文法のミスがあります。`,
        `Can flexibly employ diverse grammar structures and construct flawless sentences, although basic grammar mistakes are made every now and then.`,
      ],
      level7: [
        `복잡한 문법 구조를 어느정도 유연하게 사용할 줄 알며, 자주 문법적 실수가 없는 문장을 사용합니다. 다만, 비슷한 문법 실수를 반복합니다.`,
        `Can employ complex grammar structures with some flexibility and often constructs flawless sentences, but tends to make similar grammar mistakes.`,
        'n_caf.level_detail.a.level7',
        `能灵活运用复杂的语法结构，经常造出完美无缺的句子，但容易犯类似的语法错误。`,
        `能靈活運用複雜的文法結構，經常造出完美無缺的句子，但容易犯類似的文法錯誤。`,
        `複雑な文法構造をある程度柔軟に使用し、正確な文章を作成しますが、似たような文法のミスをする傾向があります。`,
        `Can employ complex grammar structures with some flexibility and often constructs flawless sentences, but tends to make similar grammar mistakes.`,
      ],
      level6: [
        `단순한 문법 구조뿐 아니라 복잡한 문법 구조를 혼합하여 사용할 줄 알지만, 고급 문법을 사용할 때 실수가 잦아집니다.`,
        `Knows how to use both simple and complex grammar structures, but makes mistakes often when using more advanced grammar.`,
        'n_caf.level_detail.a.level6',
        `懂得使用简单和复杂的语法结构，但在使用高级语法时经常犯错。`,
        `懂得使用簡單和複雜的文法結構，但在使用高級文法時經常犯錯。`,
        `基本的なものから複雑な文法構造までを使いこなすことができますが、より高度な文法を使用する際にはよく誤ります。`,
        `Knows how to use both simple and complex grammar structures, but makes mistakes often when using more advanced grammar.`,
      ],
      level5: [
        `기본 문장들은 정확도에 큰 무리 없이 사용하고, 익숙한 복잡한 문법 구조를 사용할 줄 압니다. 다만, 복잡한 문법 구조를 사용할때, 문법 실수로 인해 상대방이 이해하는데 어려움을 겪을 수 있습니다.`,
        `Can construct basic sentences quite accurately and uses complex grammar structures that are familiar. However, complex sentences can be difficult to understand due to grammar mistakes.`,
        'n_caf.level_detail.a.level5',
        `能相当准确地造出基本句子，并能使用熟悉的复杂语法结构。但由于语法错误，复杂句子可能难以理解。`,
        `能相當準確地造出基本句子，並能使用熟悉的複雜的語法結構。但由於文法錯誤，複雜的句子可能難以理解。`,
        `基本的な文章は正確に構成し、使い慣れている複雑な文法構造を使うことができます。しかし、文法のミスのため、複雑な文章は理解しにくいことがあります。`,
        `Can construct basic sentences quite accurately and uses complex grammar structures that are familiar. However, complex sentences can be difficult to understand due to grammar mistakes.`,
      ],
      level4: [
        `기본적인 문장들을 만들어낼 수 있지만, 복잡한 문장들은 잘 사용하지 않습니다. 문법 실수가 꽤 잦은 편이며, 가끔 상대방이 이해하는 데 어려움을 겪을 수 있습니다.`,
        `Can speak basic sentences but rarely constructs complex ones. Also, grammar mistakes are fairly common and can sometimes be difficult to understand.`,
        'n_caf.level_detail.a.level4',
        `能说基本句子，但很少造复杂句子。此外，语法错误相当常见，有时难以理解。`,
        `能說基本句子，但很少造複雜的句子。此外，文法錯誤相當常見，有時難以理解。`,
        `基本的な文章は話せますが、複雑な文章を作ることはほとんどありません。また、一般的な文法のミスが多く、理解することが難しいこともあります。`,
        `Can speak basic sentences but rarely constructs complex ones. Also, grammar mistakes are fairly common and can sometimes be difficult to understand.`,
      ],
      level3: [
        `외우고 있는 문법에 의존하거나, 기본적인 문장을 자유롭게 사용하는 데 어려움을 겪을 때가 있습니다. 익숙한 표현을 사용할 때를 제외하고는 문법적 실수를 자주 합니다.`,
        `Relies on grammar that has been memorized and sometimes has difficulties constructing basic sentences. Also makes frequent grammar mistakes, except when using familiar expressions.`,
        'n_caf.level_detail.a.level3',
        `依赖已背诵的语法，有时很难造出基本句子。除使用熟悉的表达方式外，经常犯语法错误。`,
        `依賴已背誦的文法，有時很難造出基本句子。除使用熟悉的表達方式外，經常犯文法錯誤。`,
        `暗記した文法に頼るため、基本的な文章を構成することが難しいことがあります。また、使い慣れた表現を使用する場合以外は、頻繁に文法のミスがあります。`,
        `Relies on grammar that has been memorized and sometimes has difficulties constructing basic sentences. Also makes frequent grammar mistakes, except when using familiar expressions.`,
      ],
      level2: [
        `기본적인 문장 구조를 만들어내는데 어려움을 겪는 편입니다.`,
        `Has difficulties constructing basic sentences.`,
        'n_caf.level_detail.a.level2',
        `很难造出基本句子。`,
        `很難造出基本句子。`,
        `基本的な文章の構成に苦労します。`,
        `Has difficulties constructing basic sentences.`,
      ],
      level1: [
        `기초적인 문장 형식을 전혀 사용할 수 없습니다.`,
        `Cannot construct basic sentences at all.`,
        'n_caf.level_detail.a.level1',
        `全然无法造出基本句子。`,
        `全然無法造出基本句子。`,
        `基本的な文章を構成することができません。`,
        `Cannot construct basic sentences at all.`,
      ],
    },
    f: {
      title: [
        `Fluency 레벨`,
        `Fluency Level`,
        'n_caf.level_detail.f.title',
        `流畅度等级`,
        `流暢度等級`,
        `Fluency Level`,
        `Fluency Level`,
      ],
      level9: [
        `망설임 없이 말하고자 하는 바를 문법적 실수 없이 정확하게 전달할 수 있습니다.`,
        `Can convey intended meaning precisely, flawlessly, and without hesitation.`,
        'n_caf.level_detail.f.level9',
        `能准确无误、毫不犹豫地表达意思。`,
        `能準確無誤、毫不猶豫地表達意思。`,
        `意図した意味を正確に、完璧に、ためらうことなく伝えることができます。`,
        `Can convey intended meaning precisely, flawlessly, and without hesitation.`,
      ],
      level8: [
        `반복이나 self-correction 없이 유창하게 말할 수 있습니다. 멈춤이나 망설임이 있는 경우는 대부분 다음 말할 내용을 생각하느라 그렇습니다.`,
        `Can speak fluently without word repetition or self-correction. May make short pauses while speaking, mostly to think about what to say next.`,
        'n_caf.level_detail.f.level8',
        `能流利地说话，无需重复词语或自我纠正。说话时可能会有短暂的停顿，主要是为了思考下一句该说什么。`,
        `能流利地說話，無需重覆詞語或自我糾正。說話時可能會有短暫的停頓，主要是為了思考下一句該說什麼。`,
        `次に話す言葉を考えるために、短い間を置くことがありますが、単語の反復や自己修正なしに流暢に話すことができるます。`,
        `Can speak fluently without word repetition or self-correction. May make short pauses while speaking, mostly to think about what to say next.`,
      ],
      level7: [
        `무리 없이 길이감이 있는 논리적인 대화를 진행할 수 있습니다. 질문에 대한 대답을 영어로 생각하느라 멈추는 것보다, 단어나 문법이 생각이 안 나서 멈추는 경우가 더 많습니다.`,
        `Can easily carry on a lengthy conversation in a logical manner. Tends to make pauses because of word choice or grammar more often than to think about what to say.`,
        'n_caf.level_detail.f.level7',
        `能以合乎逻辑的方式轻松地进行长时间的交谈。由于用词或语法的原因而停顿的次数多于思考要说什么的次数。`,
        `能以合乎邏輯的方式輕鬆地進行長時間的交談。由於用詞或語法的原因而停頓的次數多於思考要說什麼的次數。`,
        `論理的なやりとりを通して長い会話を簡単に行うことができます。何を言うかを考えるよりも、単語の選択や文法のために、一時停止することがよくあります。`,
        `Can easily carry on a lengthy conversation in a logical manner. Tends to make pauses because of word choice or grammar more often than to think about what to say.`,
      ],
      level6: [
        `유창하게 말하려고 노력하나 종종 망설임이나, 반복, 자기 교정을 통해 전달력이 떨어질 수 있습니다.`,
        `Tries to speak fluently, but is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
        'n_caf.level_detail.f.level6',
        `尝试流利地说话，但由于犹豫不决、词语重复和自我纠正，往往会妨碍表达。`,
        `嘗試流利地說話，但由於猶豫不決、詞語重複和自我糾正，往往會妨礙表達。`,
        `流暢に話そうと努力していますが、ためらいや単語の反復、自己修正によって会話に支障をきたすことがあります。`,
        `Tries to speak fluently, but is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
      ],
      level5: [
        `간단한 대화에서는 유창하나, 복잡한 소통 환경에서는 유창함이 떨어지는 경우가 있습니다.`,
        `Is fluent in simple conversations but not so much when engaging in more complex communication.`,
        'n_caf.level_detail.f.level5',
        `能流利地进行简单的对话，但在进行较复杂的交流时就流畅度降低。`,
        `能流利地進行簡單的對話，但在進行較覆複雜對話時就流暢度降低。`,
        `簡単な会話は流暢ですが、より複雑なコミュニケーションは苦手です。`,
        `Is fluent in simple conversations but not so much when engaging in more complex communication.`,
      ],
      level4: [
        `자주 같은 말을 반복하고 천천히 말하거나, 멈춤 없이 대화를 이어가기 힘들어하는 경우가 있습니다.`,
        `Speaks slowly or finds it difficult to carry on a conversation without pauses.`,
        'n_caf.level_detail.f.level4',
        `语速缓慢，很难在谈话中没有停顿。`,
        `語速緩慢，很難在談話中沒有停頓。`,
        `ゆっくり話したり、途切れることなく会話を続けることが難しい場合があります。`,
        `Speaks slowly or finds it difficult to carry on a conversation without pauses.`,
      ],
      level3: [
        `말하는 중에 긴 pause가 있으며, 간단한 문장들로 대화를 이어가는 경향이 있습니다.`,
        `Makes long pauses while speaking and tends to carry on  conversations with simple sentences.`,
        'n_caf.level_detail.f.level3',
        `说话时停顿时间长，倾向于用简单句进行对话。`,
        `說話時停頓時間長，傾向於用簡單句進行對話。`,
        `話すときに長い間をとり、単文で会話を続ける傾向があります。`,
        `Makes long pauses while speaking and tends to carry on  conversations with simple sentences.`,
      ],
      level2: [
        `대부분 단어를 말하기 전에 길게 멈추는 경향이 있습니다.`,
        `Tends to make long pauses before saying most words.`,
        'n_caf.level_detail.f.level2',
        `在说大多数词之前往往停顿很长时间。`,
        `在說大多數單字之前往往停頓很長時間。`,
        `単語を言う前に、長い間を置く傾向があります。`,
        `Tends to make long pauses before saying most words.`,
      ],
      level1: [
        `대화가 진행되지 않고 의사소통이 불가능 합니다.`,
        `Is impossible to hold a conversation or communicate with in English.`,
        'n_caf.level_detail.f.level1',
        `无法用英语进行对话或交流。`,
        `無法用英語進行對話或交流。`,
        `英語での会話やコミュニケーションが不可能です。`,
        `Is impossible to hold a conversation or communicate with in English.`,
      ],
    },
    caflevel: {
      title: [
        `CAF 레벨`,
        `CAF Level`,
        'n_caf.level_detail.caflevel.title',
        `CAF Level`,
        `CAF Level`,
        `CAF Level`,
        `CAF Level`,
      ],
    },
    description: [
      `레벨 분포와 설명보기`,
      `Level description`,
      'n_caf.level_detail.description',
      `等级说明`,
      `等級說明`,
      `レベルの説明`,
      `Level description`,
    ],
  },
  highlight18: {
    area_sentence: [`문장`, `Sentence`, 'n_caf.highlight18.area_sentence', `句子`, `句子`, `文章`, ``],
    detail: [
      `최대 20개의 단어가 오류율이 높은 순으로 표시됩니다.`,
      `Up to 20 words are shown in order of highest error rate.`,
      'n_caf.highlight18.detail',
      `最多可显示 20 个单字，按错误率最高的顺序排列。`,
      `最多可顯示 20 個單字，按錯誤率最高的順序排列。`,
      `エラー率が高い順に最大20語が表示されます。`,
      ``,
    ],
    error_rate: [`오류율`, `Error rate`, 'n_caf.highlight18.error_rate', `错误率`, `錯誤率`, `エラー率`, ``],
    see_all_sentences_btn: [
      `오류 문장 더보기`,
      `View sentences`,
      'n_caf.highlight18.see_all_sentences_btn',
      `看错误的句子`,
      `看錯誤的句子`,
      `文章を表示する`,
      ``,
    ],
    tool_tip: [
      `수업 시간에 학생이 4번 이상 사용한 단어 중에 발음 오류 비율이 가장 높은 단어입니다.`,
      `Words with the highest error rates among the words you used more than four times this lesson.`,
      'n_caf.highlight18.tool_tip',
      `本堂课中使用超过四次的单字中错误率最高的单字。`,
      `本堂課中使用超過四次的單字中錯誤率最高的單字。`,
      `このレッスンで4回以上使用された単語の中で、エラー率が最も高い単語です。`,
      ``,
    ],
  },
  tip: {
    highlight18: {
      title1: [
        `명확한 발음이란?`,
        `What is articulation?`,
        'n_caf.tip.highlight18.title1',
        `什么是发音？`,
        `什麽是發音？`,
        `Articulationとは何ですか？`,
        ``,
      ],
      title2: [
        `명확한 발음이 중요한 이유는?`,
        `Why is articulation important?`,
        'n_caf.tip.highlight18.title2',
        `为什么发音很重要？`,
        `為什麽發音很重要？`,
        `なぜArticulationが大切なのですか？`,
        ``,
      ],
      title3: [
        `어떻게 연습해야할까?`,
        `How can I practice this?`,
        'n_caf.tip.highlight18.title3',
        `如何练习发音？`,
        `如何練習發音？`,
        `どのように練習すればいいのですか？`,
        ``,
      ],
      body1: [
        `발음의 명확성은 각 알파벳과 음절이 정확한 방식으로 소리 내는 것을 말합니다.`,
        `In order to be articulate, each letter and syllable must be pronounced in the correct way.`,
        'n_caf.tip.highlight18.body1',
        `为了做到发音清晰，每个字母和音节都必须以正确的方式发音。`,
        `為了做到發音清晰，每個字母和音節都必須以正確的方式發音。`,
        `明瞭な発音をするためには、それぞれの文字や音節を正しい方法で発音する必要があります。`,
        ``,
      ],
      body2: [
        <>
          발음의 명확성은 의사 표현 전달의 필수요소입니다. 한국어와 영어를 구성하는 소리는 매우 다르기 때문에 발음에
          대한 이해가 없다면 실수가 발생하기 쉽습니다.
          <br />
          <br />
          예를 들어 bit/beat/bet과 같이 혼동하기 쉬운 단어의 경우, 발음이 명확하지 않았을 때 상대가 말하고자 하는 바를
          이해하지 못할 가능성이 높습니다.
        </>,
        `Articulation is an essential part of English communication. The sounds that make up Korean and English are very different, so it is easy to make mistakes if you do not know how to pronounce English words correctly.

For example, in the case of words that sound similar like bit/beat/bet, your listener may not understand which word you are saying if you do not articulate it correctly.`,
        'n_caf.tip.highlight18.body2',
        `发音在英文沟通中扮演很重要的角色。中文和英文的发音非常不同，如果不知道如何正确发音，就很容易出错。
例如，对于 bit/beat/bet 等发音相似的单词，如果发音不正确，听众可能听不懂你在说哪个单字。`,
        `發音在英文溝通中扮演很重要的角色。中文和英文的發音非常不同，如果不知道如何正確發音，就很容易出錯。
例如，對於 bit/beat/bet 等發音相似的單詞，如果發音不正確，聽眾可能聽不懂你在說哪個單字。`,
        `Articulationは、英語でのコミュニケーションに欠かせない要素です。日本語と英語を構成する音は大きく異なるため、英単語を正しく発音する方法を知らないと相手に伝わらないことがあります。
 
 たとえば、bit/beat/bet のような似た音の単語の場合、あなたがそれを正確に発音しないと、聞き手はどの単語を言っているのか理解できないかもしれません。`,
        ``,
      ],
      body3: [
        `1. 링글 AI 분석 엔진이 제시하는 발음 오류 중 어떤 단어/음소(학습 영역 선정에 따라 변경)가 가장 자주 틀렸는지 파악하고, 원어민의 발음과 무엇이 다른지 오디오를 들어보세요. 

2. 해당 단어를 정확한 발음으로 다시 읽어보고, 같은 단어를 활용한 다양한 예문을 읽어보세요.`,
        `1. Among the pronunciation mistakes discerned by the Ringle AI engine, check which word or phoneme (depending on the focus areas you chose) you most often mispronounce and listen to the audio to check how you say it and compare it with a native speaker.

2. Try pronouncing the word correctly and read various sample sentences with this word out loud.`,
        'n_caf.tip.highlight18.body3',
        `1. 在 Ringle AI分析识别出的发音错误中，查看您最常发音错误的单字或音素（取决于您选择的重点学习领域），然后听录音，检查您是如何发音的，并与母语人士进行比较。

2. 尝试正确发音，并大声朗读包含该单字的各种例句。`,
        `1. 在 Ringle AI分析識別出的發音錯誤中，查看您最常發音錯誤的單字或音素（取決於您選擇的重點學習領域），然後聽錄音，檢查您是如何發音的，並與母語人士進行比較。

2. 嘗試正確發音，並大聲朗讀包含該單字的各種例句。`,
        `1.Ringle AI engineによって識別された誤った発音の中から、最もよく誤る単語や音素（選択したフォーカスエリアによって異なる）を確認し、どのように発音するかネイティブスピーカーと比較してみてください。
 
 2.単語を正しく発音し、その単語を使った様々な例文を声に出して読んでみてください。`,
        ``,
      ],
    },
    highlight13: {
      title1: [
        `단어 반복이란?`,
        `What is word repetition?`,
        'n_caf.tip.highlight13.title1',
        `什麽是单字重複(word repetition)?`,
        `什麼是單字重複(word repetition)?`,
        `Word repetitionとは何ですか？`,
        `What is word repetition?`,
      ],
      title2: [
        `단어를 반복하는 원인과 단점?`,
        `What are its causes and disadvantages?`,
        'n_caf.tip.highlight13.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Word repetitionを使用する原因とデメリットは何ですか？`,
        `What are its causes and disadvantages?`,
      ],
      title3: [
        `반복을 피하기 위한 방법은?`,
        `How can we avoid it?`,
        'n_caf.tip.highlight13.title3',
        `要如何避免？`,
        `要如何避免？`,
        `どうすれば改善しますか？`,
        `How can we avoid it?`,
      ],
      body1: [
        `2~3문장 이내에 동일한 단어를 3번이상 반복하는 경우 반복사용 단어로 제공합니다.`,
        `It is counted as "word repetition" if the same word is repeated 3 or more times within 2-3 sentences.`,
        'n_caf.tip.highlight13.body1',
        `如果同一词语在 2-3 个句子中重复 3 次或 3 次以上，则看作 “词语重复”。`,
        `如果同一詞語在 2-3 個句子中重覆 3 次或 3 次以上，則看作 “詞語重覆”。`,
        `2～3つの文章の中で同じ単語が3回以上繰り返される場合は、”Word repetition”（単語の反復）とみなされます。`,
        `It is counted as "word repetition" if the same word is repeated 3 or more times within 2-3 sentences.`,
      ],
      body2: [
        `숙지하고있는 단어의 부족, 반복사용을 인지하지 못함 혹은 습관적으로 반복사용하는 경우 등이 있습니다.
동일 단어를 반복적으로 사용하면 스피치가 단조롭고 지루하게 느껴질 수 있습니다. 또한 메시지의 명확성을 떨어트릴 수 있고, 과하게 반복적으로 사용하면 의사소통 능력이 부족하다고 판단될 수도 있습니다.`,
        `Word repetition occurs when you know a limited number of vocabulary, are unaware that you repeat the same words, or habitually use the same words.
Using the same words repeatedly can make your speech monotonous and boring. It can also make your meaning unclear and, if excessive, may make you seem lacking in communication skills.`,
        'n_caf.tip.highlight13.body2',
        `“当你知道的词语数量有限，没有意识到自己在重复使用相同的词语，或者习惯性地使用相同的词语时，就会出现词语重复。
重复使用同样的词会让你的讲话变得单调乏味。它还会使你的意思不明确，如果过多，可能会使你显得缺乏沟通技巧"。`,
        `“當你知道的詞語數量有限，沒有意識到自己在重覆使用相同的詞語，或者習慣性地使用相同的詞語時，就會出現詞語重覆。
重覆使用同樣的詞會讓你的講話變得單調乏味。它還會使你的意思不明確，如果過多，可能會使你顯得缺乏溝通技巧"。`,
        `Word repetition（単語の反復）は、限られた語彙しか知らない、または同じ単語を繰り返していることに気付かない、あるいは習慣的に同じ単語を使っている場合に起こります。同じ単語を繰り返し使うことは、スピーチを単調で退屈なものにしてしまいます。また、意味が不明瞭になり、度が過ぎるとコミュニケーション能力が不足していると思われることもあります。`,
        `Word repetition occurs when you know a limited number of vocabulary, are unaware that you repeat the same words, or habitually use the same words.
Using the same words repeatedly can make your speech monotonous and boring. It can also make your meaning unclear and, if excessive, may make you seem lacking in communication skills.`,
      ],
      body3: [
        <>
          1. 동의어에 대한 숙지: 문맥상 동일한 의미를 가지는 단어들을 찾아보고 학습해보세요.
          <br />
          <br />
          2. 문장 구조의 변경: 동일한 내용을 다른 문장 구조로 표현할 수 있게 학습해보세요.
          <br />
          <br />
          3. 다양한 단어에 대한 숙지: 새로운 단어 및 표현들을 꾸준히 학습해보세요.
        </>,
        <>
          1. Learn synonyms: Look up and learn words that have the same meaning in the given context.
          <br />
          <br />
          2. Use different sentence structures: Practice saying the same thing using different sentence structures.
          <br />
          <br />
          3. Increase your vocabulary: Keep learning new words and expressions.
        </>,
        'n_caf.tip.highlight13.body3',
        <>
          1. 学习同义词： 查找并学习在特定语境中含义相同的单词。
          <br />
          <br />
          2. 使用不同的句子结构： 练习用不同的句子结构表达同样的意思。.
          <br />
          <br />
          3. 增加词汇量： 不断学习新单词和表达方式。
        </>,
        <>
          1. 學習同義詞： 查找並學習在特定語境中含義相同的單字。
          <br />
          <br />
          2. 使用不同的句子結構： 練習用不同的句子結構表達同樣的意思。
          <br />
          <br />
          3. 增加詞匯量： 不斷學習新單字和表達方式。
        </>,
        <>
          1.同義語を学ぶ：与えられた文脈で同じ意味を持つ単語を調べて学びましょう。
          <br />
          <br />
          2.異なる文章構成を考える：同じことを異なる文章構成を考え、話す練習をしましょう。
          <br />
          <br />
          3.語彙を増やす：新しい単語や表現を学び続けましょう。
        </>,
        <>
          1. Learn synonyms: Look up and learn words that have the same meaning in the given context.
          <br />
          <br />
          2. Use different sentence structures: Practice saying the same thing using different sentence structures.
          <br />
          <br />
          3. Increase your vocabulary: Keep learning new words and expressions.
        </>,
      ],
    },
    highlight14: {
      title1: [
        `Run-on 문장이란?`,
        `What is a run-on sentence?`,
        'n_caf.tip.highlight14.title1',
        `什麽是连写句(run-on sentence)?`,
        `什麼是連寫句(run-on sentence)?`,
        `Run-on sentenceとは何ですか？`,
        `What is a run-on sentence?`,
      ],
      title2: [
        `Run-on 문장의 원인과 단점은?`,
        `What are its causes and disadvantages?`,
        'n_caf.tip.highlight14.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Run-on sentenceを使用する原因とデメリットは何ですか？`,
        `What are its causes and disadvantages?`,
      ],
      title3: [
        `Run-on 문장을 피하기 위한 방법은?`,
        `How can we avoid it?`,
        'n_caf.tip.highlight14.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid it?`,
      ],
      body1: [
        `2~3개의 문장을 적절한 마침표나 접속사 없이 이어말하는 것을 Run-on Sentence라고 합니다.`,
        `A sentence is considered "run-on" when 2-3 sentences continue one after another without periods or conjunctions dividing them.`,
        'n_caf.tip.highlight14.body1',
        `当一个句子连续 2-3 个句子，而没有句点或连接词划分时，这个句子就会被视为「连写句」。`,
        `當一個句子連續 2-3 個句子，而沒有句點或連接詞劃分時，這個句子就會被視為「連寫句」。`,
        `2～3つの文章がピリオドや接続詞で区切られることなく続いている場合は、”Run-on sentences”（連結された文章）とみなされます。`,
        `A sentence is considered "run-on" when 2-3 sentences continue one after another without periods or conjunctions dividing them.`,
      ],
      body2: [
        `멈추지 않고 계속 말하는 것이 유창할것이라고 생각하거나, 이어 말하는 습관에 의해 발생합니다.
내용이 이어지지 않는 말을 지속하면 맥락파악이 어려워지고 듣는사람 입장에서 이해하지 못하는 단점이 존재합니다.`,
        `People speak in run-on sentences either because they think speaking continuously make them sound fluent or out of habit.
When sentences run-on without a logical connection, it becomes difficult to understand the context or what you mean to say.`,
        'n_caf.tip.highlight14.body2',
        `"之所以会说连写句，可能是因为他们认为连续说句子会让他们听起来很流利，或是因为习惯使然。
如果句子之间没有逻辑关联，就很难理解上下文或您想表达的意思。`,
        `之所以會說連寫句，可能是因為他們認為連續說句子會讓他們聽起來很流利，或是因為習慣使然。
如果句子之間沒有邏輯關聯，就很難理解上下文或您想表達的意思"。`,
        `Run-on sentences（連結された文章）を話すのは、連続的に話すことが流暢に聞こえると考えていたり、それが習慣化してしまっているためです。
 論理的なつながりがないまま文章が連続すると、文脈や意図が理解しづらくなってしまいます。`,
        `People speak in run-on sentences either because they think speaking continuously make them sound fluent or out of habit.
When sentences run-on without a logical connection, it becomes difficult to understand the context or what you mean to say.`,
      ],
      body3: [
        <>
          1. 적절한 의미 단위로 문장을 끊어 말하는 연습을 해보세요. and,so 등을 지속적으로 쓰는 것 대신 명확하게
          마침표로 문장을 마쳐보세요.
          <br />
          <br />
          2. 이어지는 내용이 있다면 Although, However, Therefore 등의 접속사를 사용해서 문장을 적절히 연결하는 연습을
          해보세요.
        </>,
        <>
          1. Practice breaking your sentences into appropriate meaning units. End your sentences with a full stop
          instead of connecting them with "and" or "so."
          <br />
          <br />
          2. If the next sentence is connects to the previous one, practice connecting them properly using conjunctions
          like "Although," "However," and "Therefore."
        </>,
        'n_caf.tip.highlight14.body3',
        <>
          1. 练习将您的句子分成有意义的单元，以句号来结束句子，而不是用 “and 或 so ”来连接句子。
          <br />
          <br />
          2. 如果下一个句子与上一个句子有关联，练习使用"Although", "However," 或是"Therefore"将句子连接起来。"
        </>,
        <>
          1. 練習將您的句子分成有意義的單元，以句號來結束句子，而不是用 “and 或 so ”來連接句子。
          <br />
          <br />
          2. 如果下一個句子與上一個句子有關聯，練習使用"Although", "However," 或是"Therefore"將句子連接起來。"
        </>,
        <>
          1.文章を適切な意味の単位に区切って話す練習をしましょう。文末を”and”や‘"so"で結ばず、代わりにピリオドを付けましょう。
          <br />
          <br />
          2.次の文章が前の文章に繋がる場合は、適切に”Although”、”However”、”Therefore”などの接続詞を使ってつなげる練習をしましょう。
        </>,
        <>
          1. Practice breaking your sentences into appropriate meaning units. End your sentences with a full stop
          instead of connecting them with "and" or "so."
          <br />
          <br />
          2. If the next sentence is connects to the previous one, practice connecting them properly using conjunctions
          like "Although," "However," and "Therefore."
        </>,
      ],
    },
    highlight16: {
      title1: [
        `필러워드란?`,
        `What are filler words?`,
        'n_caf.tip.highlight16.title1',
        `什麽是填充词(filler words)?`,
        `什麼是填充詞(filler words)?`,
        `Filler wordsとは何ですか？`,
        `What are filler words?`,
      ],
      title2: [
        `필러워드 사용이 많아졌을때의 원인과 단점은?`,
        `Why do we use them and why are they a problem?`,
        'n_caf.tip.highlight16.title2',
        `为什麽我们会使用填充词及可能造成的问题?`,
        `為什麼我們會使用填充詞及可能造成的問題?`,
        `Filler wordsを使用する原因とデメリットは何ですか？`,
        `Why do we use them and why are they a problem?`,
      ],
      title3: [
        `필러워드를 적절히 사용하기 위한 방법은?`,
        `How can we avoid them?`,
        'n_caf.tip.highlight16.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid them?`,
      ],
      body1: [
        `필러워드는 Ah, Umm, uh, huh 처럼 대화 중에 생기는 어색함이나 공백을 채우기 위해 사용되는 단어입니다. 이를 과도하게 사용한 경우를 ‘필러워드 사용이 많았던 구간’으로 진단하고 있습니다.`,
        `Filler words are words used to fill awkwardness or gaps in conversation, such as "ah," "umm," "uh," and "huh." The AI engine detects sections where you use filler words excessively.`,
        'n_caf.tip.highlight16.body1',
        `填充词是用来填补对话中的尴尬或空隙的词，例如 "ah"、"umm"、"uh "和 "huh"。AI 引擎会侦测到您过度使用填充词的部分。`,
        `填充詞是用來填補對話中的尷尬或空隙的詞，例如 "ah"、"umm"、"uh "和 "huh"。AI 引擎會偵測到您過度使用填充詞的部分。`,
        `Filler Words（間投詞）とは、会話の中で不自然な間や不自然な感じを埋めるために使われる言葉であり、 "Ah"、 "Umm"、 "Uh"、”Huh”といった言葉が該当します。 これらをあなたがを過度に使用している場合は、”Filler Words”（間投詞）とみなされます。`,
        `Filler words are words used to fill awkwardness or gaps in conversation, such as "ah," "umm," "uh," and "huh." The AI engine detects sections where you use filler words excessively.`,
      ],
      body2: [
        `말을 이어가고 있다는 것을 나타내거나 생각을 정리하는 등의 긍정적인 목적으로 쓰이기도 하지만, 과도하게 사용되는 경우 전문성이 떨어져 보이거나 하고자 하는 말의 목적을 이해하는 데 방해가 되기도 합니다.`,
        `Filler words can be used to indicate that you are in the midst of speaking or organizing your thoughts. However, when used excessively, it can make you look unprofessional or make it difficult to understand what you are trying to say.`,
        'n_caf.tip.highlight16.body2',
        `填充词可以用来表示您正在说话或整理思绪。但是，如果过度使用，可能会让您看起来不专业，或让人难以理解您想要说的内容。`,
        `填充詞可以用來表示您正在說話或整理思緒。但是，如果過度使用，可能會讓您看起來不專業，或讓人難以理解您想要說的內容。`,
        `Filler words（間投詞）は、話している最中や思考を整理していることを示すために使われることがあります。しかし、過剰に使用すると、専門性が低く見えたり、何を言おうとしているのか理解しにくくなる場合があります。`,
        `Filler words can be used to indicate that you are in the midst of speaking or organizing your thoughts. However, when used excessively, it can make you look unprofessional or make it difficult to understand what you are trying to say.`,
      ],
      body3: [
        <>
          1. 말을 할 때 다음 단어가 생각이 나지 않는다면, 잠시 말하는 것을 멈추고 생각할 시간을 가져보세요. 필러워드를
          사용하기보단 튜터에게 생각할 시간을 조금 달라고 한 뒤 말하는 것을 추천합니다. <br />
          <br />
          2. 말하기 속도가 너무 빨라 생각할 시간이 필요하거나 속도 조절을 하기 위해 필러워드를 사용하는 경우라면,
          필러워드를 사용하는 것보다 대화에 여유를 가지고 말하기 속도를 늦춰보는 것을 추천합니다.
        </>,
        <>
          1. If you can't think of the word you want to say, take a pause to think rather than using filler words. You
          can ask the tutor to give you some time to think before speaking. <br />
          <br />
          2. If you need time to think because you talk too fast, or if you are using filler words to control your
          speech rate, you should try speaking more slowly rather than using filler words.
        </>,
        'n_caf.tip.highlight16.body3',
        <>
          1. 如果您想不到想说的单字，停下来想一下，而不要使用填充词。您可以要求教师给您一些时间思考后再说。 <br />
          <br />
          2.如果您因为说话太快而需要时间思考，或是您使用填充词来控制您的说话速度，您应该尝试说得慢一点，而不是使用填充词。
        </>,
        <>
          1. 如果您想不到想說的單字，停下來想一下，而不要使用填充詞。您可以要求教師給您一些時間思考後再說。 <br />
          <br />
          2.如果您因為說話太快而需要時間思考，或是您使用填充詞來控制您的說話速度，您應該嘗試說得慢一點，而不是使用填充詞。
        </>,
        <>
          1.言いたい単語が思い浮かばない場合は、Filler
          words（間投詞）を使うのではなく、一旦間を置いて考えてみましょう。話す前に少し考える時間を相手に求めることもできます。
          <br />
          <br />
          2.話す速度が速すぎて考える時間が必要な場合や、スピーチの速度をコントロールするためにFiller
          words（間投詞）を使っている場合は、ゆっくり話すことを試してみてください。
        </>,
        <>
          1. If you can't think of the word you want to say, take a pause to think rather than using filler words. You
          can ask the tutor to give you some time to think before speaking. <br />
          <br />
          2. If you need time to think because you talk too fast, or if you are using filler words to control your
          speech rate, you should try speaking more slowly rather than using filler words.
        </>,
      ],
    },
    highlight15: {
      title1: [
        `말하기 속도란?`,
        `What is speech rate?`,
        'n_caf.tip.highlight15.title1',
        `什麽是语速(speech rate)?`,
        `什麼是語速(speech rate)?`,
        `Speech rateとは何ですか？`,
        `What is speech rate?`,
      ],
      title2: [
        `말하기 속도가 느려졌을때의 단점은?`,
        `Why is slow speech rate a problem?`,
        'n_caf.tip.highlight15.title2',
        `为什麽缓慢的语速会造成问题?`,
        `為什麼緩慢的語速會造成問題?`,
        `Slow speech rateのデメリットは何ですか？`,
        `Why is slow speech rate a problem?`,
      ],
      title3: [
        `말하기 속도를 늘리는 방법은?`,
        `How can it be increased?`,
        'n_caf.tip.highlight15.title3',
        `要如何改善?`,
        `要如何改善?`,
        `どうすれば改善しますか？`,
        `How can it be increased?`,
      ],
      body1: [
        `말하기 속도는 분당 말한 단어의 개수를 wpm(word per minute)의 단위로 표현합니다.
대화 상황에서 적절한 말하기 속도는 120~150 wpm이라고 해요. 대화를 할때 의미 전달에 부정적인 영향을 끼친다고 판단되는 90 wpm 이하의 매우 느린 문장의 경우를 ‘말하기 속도가 느린 구간’으로 진단하고 있습니다.`,
        `Speech rate shows how fast you speak in terms of words per minute (wpm).
The appropriate speaking speed in a conversation is said to be between 120 and 150 wpm. The AI engine detects "slow speech sections" where you speak at a pace of 90 wpm or less, which is judge too slow to convey what you mean to say clearly.`,
        'n_caf.tip.highlight15.body1',
        `语速显示您说话的速度，以每分钟字数 (wpm) 来表示。
在对话中，适当的说话速度大约介于 120 到 150 wpm 之间。AI 引擎会侦测到您说话速度为每分钟 90 字或以下的「慢速语音区段」，判断您的说话速度太慢，无法清楚传达您的意思。`,
        `語速顯示您說話的速度，以每分鐘字數 (wpm) 來表示。
在對話中，適當的說話速度大約介於 120 到 150 wpm 之間。AI 引擎會偵測到您說話速度為每分鐘 90 字或以下的「慢速語音區段」，判斷您的說話速度太慢，無法清楚傳達您的意思。`,
        `Speech rate（スピーチ速度）は、1分あたりの単語数（wpm）で話す速さを示します。
 会話における適切な話す速度は120～150wpmと言われています。あなたが90wpm以下のスピードで話している場合は、あなたが言いたいことを明確に伝えるには遅すぎると判断され"slow speech sections"とみなされます。`,
        `Speech rate shows how fast you speak in terms of words per minute (wpm).
The appropriate speaking speed in a conversation is said to be between 120 and 150 wpm. The AI engine detects "slow speech sections" where you speak at a pace of 90 wpm or less, which is judge too slow to convey what you mean to say clearly.`,
      ],
      body2: [
        `공백이 많아 말하기 속도가 느려진다면, 듣는 사람이 대화에 집중을 못 하게 되는 경우가 있습니다. 또한 대화의 감정이나 톤이 효과적으로 전달되지 못해, 의도한 대로 대화를 이끌어가기 어려울 수 있습니다.`,
        `Speaking with a lot of silent pauses can distract your listener from the conversation. Also, the listener can have difficulties catching the emotion or tone of the conversation if you talk too slow, making it difficult to lead the conversation as intended.`,
        'n_caf.tip.highlight15.body2',
        `说话时如果有很多无声的停顿，会分散听众对谈话的注意力。此外，如果您说话的速度太慢，听众也很难捕捉到对话的情绪或语调，使您很难如预期般引导对话。`,
        `說話時如果有很多無聲的停頓，會分散聽眾對談話的注意力。此外，如果您說話的速度太慢，聽眾也很難捕捉到對話的情緒或語調，使您很難如預期般引導對話。`,
        `無言の間が多いと、相手を会話から遠ざけてしまいます。また、話すスピードが遅すぎると、相手は会話の感情やトーンをつかみにくくなり、意図したとおりに会話を進めることが難しくなります。`,
        `Speaking with a lot of silent pauses can distract your listener from the conversation. Also, the listener can have difficulties catching the emotion or tone of the conversation if you talk too slow, making it difficult to lead the conversation as intended.`,
      ],
      body3: [
        <>
          1. 영어를 주기적으로 사용하는 게 가장 큰 도움이 됩니다. 링글 수업을 주기적으로 수강하거나, 이전 수업의
          문장들을 다시 한번 말하면서 영어로 말하는 것을 익숙하게 만들어 보세요.
          <br />
          <br />
          2. 단어가 생각이 나지 않아 말하기 속도가 느려지는 경우가 많습니다. 대화를 시작하기 전에 어떤 내용으로 답변할지
          미리 생각해 보고 적절한 키워드들을 생각해 보는 것도 도움이 될 수 있습니다.
        </>,
        <>
          1. Using English regularly is most helpful. Try to get used to talking English by taking Ringle lessons
          regularly, or by practicing sentences from previous classes.
          <br />
          <br />
          2. If you talk too slowlly because you can't think of the word, it can be helpful to think about what you're
          going to say in advance and come up with appropriate keywords before starting a conversation.
        </>,
        'n_caf.tip.highlight15.body3',
        <>
          1. 经常使用英语是最有帮助的。透过定期上 Ringle 课程或练习之前课程的句子，尝试习惯说英语。
          <br />
          <br />
          2. 如果您因为想不到词而说得太慢，事先想好您要说的话，并在开始对话前想出适当的关键字，对您会有帮助。
        </>,
        <>
          1. 1. 經常使用英文是最有幫助的。透過定期上 Ringle 課程或練習之前課程的句子，嘗試習慣說英文。
          <br />
          <br />
          2. 如果您因為想不到詞而說得太慢，事先想好您要說的話，並在開始對話前想出適當的關鍵字，對您會有幫助。
        </>,
        <>
          1.英語を定期的に使うことが最も役立ちます。Ringleのレッスンを定期的に受けたり、過去のクラスで練習した文を使って英語で話すことに慣れるようにしましょう。
          <br />
          <br />
          2.単語が思い浮かばずに話す速度が遅くなる場合は、会話を始める前に言いたいことを事前に考え、適切なキーワードを思い付くことが役立ちます。
        </>,
        <>
          1. Using English regularly is most helpful. Try to get used to talking English by taking Ringle lessons
          regularly, or by practicing sentences from previous classes.
          <br />
          <br />
          2. If you talk too slowlly because you can't think of the word, it can be helpful to think about what you're
          going to say in advance and come up with appropriate keywords before starting a conversation.
        </>,
      ],
    },
    highlight0: {
      title1: [
        `한정사란?`,
        `What is "incorrect determiner"?`,
        'n_caf.tip.highlight0.title1',
        `什麽是错误的冠词?`,
        `什麼是錯誤的冠詞?`,
        `Incorrect determinerとは何ですか？`,
        `What is "incorrect determiner"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight0.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect determinerを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight0.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `a/an/the등의 관사, his/her등의 속격, this/that/these의 지시어, some/any/many/few등의 가산성이 포함되며 명사를 수식하는 문법 유형입니다.`,
        `A determiner is a word that modifies a noun and includes articles such as "a/an/the," genitives such as "his/her," demonstratives such as "this/that/these," and countables such as "some/any/many/few.`,
        'n_caf.tip.highlight0.body1',
        `冠词是修饰名词的词，限定词，如a/an/the; 属格，如 his/her; 指示代词，如 this/that/these; 可数词，如 some/any/many/few。`,
        `冠詞是修飾名詞的詞，限定詞，如a/an/the; 屬格，如 his/her; 指示代詞，如 this/that/these; 可數詞，如 some/any/many/few。`,
        `Determiners（限定詞）は名詞を修飾する単語で、"a”、”an”、”the "のようなArticles（冠詞）、"his”、”her "のようなGenitives（属格）、"this”、”that”、”these "のようなDemonstratives（指示詞）、"some”、”any”、”many”、”few "のようなCountables（可算名詞）が含まれます。`,
        `A determiner is a word that modifies a noun and includes articles such as "a/an/the," genitives such as "his/her," demonstratives such as "this/that/these," and countables such as "some/any/many/few.`,
      ],
      body2: [
        <>
          한정사가 정확히 어떤 의미와 목적을 가지는지 인지하지 못해 실수하는 경우가 가장 많고, 잘못 사용하는 경우
          말하고자 하는 의미가 정확히 전달되지 않을 수 있습니다.
          <br />
          <br />
          예를 들어, “I would like to work for a company that motivates me.”라는 문장에서 일반적인 회사를 언급하면 a
          company이고, 특정한 회사를 지칭하는 경우 the company라고 지칭해야합니다.
        </>,
        <>
          Most mistakes are made because the speaker does not understand the exact meaning and purpose of determiners.
          Incorrect determiners can hinder the clarity of what you mean to say.
          <br />
          <br />
          Let's take “I would like to work for a/the company that motivates me.” as an example. Here, saying "a company"
          refers to any company in general, and saying "the company" means a specific company.
        </>,
        'n_caf.tip.highlight0.body2',
        <>
          大多数的错误都是因为说话者不瞭解限定词的确切含义和目的。不正确的限定词会妨碍您清楚表达您的意思。
          <br />
          <br />
          让我们以 「I would like to work for a/the company that motivates me. 」为例。在这裡，说「a
          company」是泛指任何公司，而说「the company」则是指特定的公司。
        </>,
        <>
          大多數的錯誤都是因為說話者不瞭解限定詞的確切含義和目的。不正確的限定詞會妨礙您清楚表達您的意思。
          <br />
          <br />
          讓我們以 「I would like to work for a/the company that motivates me. 」為例。在這裡，說「a
          company」是泛指任何公司，而說「the company」則是指特定的公司。
        </>,
        <>
          ほとんどの間違いは、スピーカーがDeterminers（限定詞）の正確な意味と目的を理解していないために起こります。不正確なDeterminers（限定詞）は、言いたいことの明確さを妨げます。
          <br />
          <br />
          例えば、"I would like to work for a/the company that motivates me. "を例にとってみましょう。ここで "a company
          "と言えば会社全般を指し、"the company "と言えば特定の会社を指します。
        </>,
        <>
          Most mistakes are made because the speaker does not understand the exact meaning and purpose of determiners.
          Incorrect determiners can hinder the clarity of what you mean to say.
          <br />
          <br />
          Let's take “I would like to work for a/the company that motivates me.” as an example. Here, saying "a company"
          refers to any company in general, and saying "the company" means a specific company.
        </>,
      ],
      body3: [
        <>
          1. 한정사가 사용된 문장들을 학습해보세요. 아래 수업때 말한 한정사 실수가 있었던 문장, 튜터가 수정해준 문장
          혹은 교재에서 한정사가 사용된 문장들을 학습해보세요.
          <br />
          <br />
          2. 튜터 혹은 원어민은 맥락에 따라 어떤 한정사를 사용하는지 관찰해보세요.
        </>,
        <>
          1. Practice sentences that uses determiners. Review the sentences in which you used the wrong determiner,
          those your tutor corrected for you, or sentences using determiners in the material.
          <br />
          <br />
          2. Pay attention to the determiners tutors or native speakers use depending on the context.
        </>,
        'n_caf.tip.highlight0.body3',
        <>
          1. 练习使用冠词的句子。複习用错冠词的句子、教师纠正的句子，或教材中使用冠词的句子。
          <br />
          <br />
          2. 注意教师或母语人士根据上下文使用的冠词。
        </>,
        <>
          1. 練習使用冠詞的句子。複習用錯冠詞的句子、教師糾正的句子，或教材中使用冠詞的句子。
          <br />
          <br />
          2. 注意教師或母語人士根據上下文使用的冠詞。
        </>,
        <>
          1.Determiners（限定詞）を使用した文章を用いて練習しましょう。誤ったDeterminers（限定詞）を使用した文章、チューターによって修正された文章、および教材内のDeterminers（限定詞）を使用した文章を見直します。
          <br />
          <br />
          2.チューターやネイティブスピーカーが文脈によって使い分けるDeterminers（限定詞）に注意しましょう。
        </>,
        <>
          1. Practice sentences that uses determiners. Review the sentences in which you used the wrong determiner,
          those your tutor corrected for you, or sentences using determiners in the material.
          <br />
          <br />
          2. Pay attention to the determiners tutors or native speakers use depending on the context.
        </>,
      ],
    },
    highlight1: {
      title1: [
        `불변화사란?`,
        `What is "incorrect particle"?`,
        'n_caf.tip.highlight1.title1',
        `什麽是错误的助词(particle)?`,
        `什麼是錯誤的助詞(particle)?`,
        `Incorrect particleとは何ですか？`,
        `What is "incorrect particle"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight1.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect particleを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight1.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `look, turn, take와 같은 동사와 만나서 look up, turn in,  take off 등의 구동사를 이루는 문법 유형입니다.`,
        `A particle is a words such as "up," "in," and "off" that are used with verbs to form phrasal verbs, such as "look up," "turn in," and "take off.`,
        'n_caf.tip.highlight1.body1',
        `助词例如up、in 和 off 与动词搭配使用形成短语动词，如 look up、turn in 和 take off`,
        `助詞例如up、in 和 off 與動詞搭配使用形成短語動詞，如 look up、turn in 和 take off`,
        `Particle（助詞）とは、"look up"、"turn in"、"take off "などの Phrasal verbs（句動詞）を形成するために動詞と一緒に使われる "up"、"in"、"off "などの単語のことです。`,
        `A particle is a words such as "up," "in," and "off" that are used with verbs to form phrasal verbs, such as "look up," "turn in," and "take off.`,
      ],
      body2: [
        `불변화사는 문맥에 따라 다른 의미를 가지고 사용성도 다양하기 때문에 실수할 가능성이 높습니다.
예를 들어 동사 Turn과 불변화사 In이 결합해 “Turn In”이라는 단어를 만드는 경우 기존 단어들과 매우 다른 “제출하다”라는 의미를 가지기에 적절한 불변화사를 사용하지 않으면 다른 의미로 해석될 수 있습니다.`,
        `Mistakes in using particles are common because they have different meanings and usages depending on the context.
For example, "turn in" (combining the verb "turn" and the particle "in") means “to submit,” which diverges from the meanings of the individual verb and particle. Thus, using the wrong particle can result in a completely different meaning.`,
        'n_caf.tip.highlight1.body2',
        `使用助词时容易犯错，因为助词在不同的上下文中有不同的含义和用法。
例如，“turn in” 是由动词 “turn” 和助词 “in” 组合而成，表示“提交”的意思，这与单独的动词和助词的含义大不相同。因此，使用错误的助词可能导致完全不同的含义。`,
        `使用助詞時容易犯錯，因為助詞在不同的上下文中有不同的含義和用法。
例如，“turn in” 是由動詞 “turn” 和助詞 “in” 組合而成，表示“提交”的意思，這與單獨的動詞和助詞的含義大不相同。因此，使用錯誤的助詞可能導致完全不同的含義。`,
        `Particle（助詞）は文脈によって意味や用法が異なるため、使い方を間違えることはよくあります。例えば、”turn”と”in”という動詞と助詞を組み合わせた”turn in”は、「提出する」という意味を持ちますが、個々の動詞や助詞の意味とは異なります。そのため、間違ったParticle（助詞）を使うと完全に異なる意味になることがあります。`,
        `Mistakes in using particles are common because they have different meanings and usages depending on the context.
For example, "turn in" (combining the verb "turn" and the particle "in") means “to submit,” which diverges from the meanings of the individual verb and particle. Thus, using the wrong particle can result in a completely different meaning.`,
      ],
      body3: [
        <>
          1. AI 분석 엔진에서 포착한 불변화사 실수들을 확인하고, 적절한 불변화사를 사용할 수 있도록 복습해보세요.
          <br />
          <br />
          2. 또한 표현들을 많이 학습하고 그에 대한 의미를 숙지하는걸 권장드립니다. 해당 표현이 사용된 문장들을 반복해서
          읽다보면 보다 자연스럽게 불변화사를 적절히 사용할 수 있습니다.
        </>,
        <>
          1. Check the mistakes in using particles detected by the AI Analsysis engine and review how to use them
          correctly.
          <br />
          <br />
          2. We also recommended you to learn different expressions and learn their meanings. Reading the sentences with
          those expressions many times will help you learn how to use particles appropriately.
        </>,
        'n_caf.tip.highlight1.body3',
        <>
          1.检查 AI 分析引擎检测到的助词使用错误，并回顾如何正确使用这些助词。
          <br />
          <br />
          2.建议学习不同的表达方式及其含义。多次阅读包含这些表达方式的句子将有助于您正确使用助词。
        </>,
        <>
          1.檢查 AI 分析引擎檢測到的助詞使用錯誤，並回顧如何正確使用這些助詞。
          <br />
          <br />
          2.建議學習不同的表達方式及其含義。多次閱讀包含這些表達方式的句子將有助於您正確使用助詞。
        </>,
        <>
          1.AI Analsysis
          engineによって検出されたParticle（助詞）の間違いをチェックし、正しく使い方を見直してみましょう。
          <br />
          <br />
          2.異なる表現を学び、その意味を理解しましょう。それらの表現を含む文章を何度も読むことで、Particle（助詞）を適切に使う方法を学ぶのに役立ちます。
        </>,
        <>
          1. Check the mistakes in using particles detected by the AI Analsysis engine and review how to use them
          correctly.
          <br />
          <br />
          2. We also recommended you to learn different expressions and learn their meanings. Reading the sentences with
          those expressions many times will help you learn how to use particles appropriately.
        </>,
      ],
    },
    highlight2: {
      title1: [
        `전치사란?`,
        `What is "incorrect preposition"?`,
        'n_caf.tip.highlight2.title1',
        `什麽是错误的介词？`,
        `什麼是錯誤的介系詞？`,
        `Incorrect prepositionとは何ですか？`,
        `What is "incorrect preposition"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight2.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect prepositionを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight2.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `명사 앞에 위치해서 시간, 장소, 방향 등을 나타내는 문법 유형입니다. at/in/on/to/about 등이 대표적인 전치사입니다.`,
        `A preposition is a word that is placed before a noun to indicate time, place, direction, etc. Examples of prepositions are "at/in/on/to/about.`,
        'n_caf.tip.highlight2.body1',
        `介词是一个放在名词前面，用来表示时间、地点、方向等的词。例如，常见的介词有 "at"（在）、"in"（在……里面）、"on"（在……上面）、"to"（到……）、"about"（关于）`,
        `介係詞是一個放在名詞前面，用來表示時間、地點、方向等的詞。例如，常見的介詞有 "at"（在）、"in"（在……裏面）、"on"（在……上面）、"to"（到……）、"about"（關於）`,
        `Preposition（前置詞）とは、時間、場所、方向などを示すために名詞の前に置かれる単語のことです。Preposition（前置詞）の例として"at”、”in”、”on”、”to”、”about" 等があります。`,
        `A preposition is a word that is placed before a noun to indicate time, place, direction, etc. Examples of prepositions are "at/in/on/to/about.`,
      ],
      body2: [
        <>
          전치사의 사용법이 영어와 한국어는 많이 다르기 때문에 실수하는 경우가 많고, 익숙하지 않은 구문을 사용하는 경우
          적절한 전치사를 사용하는데 어려움을 겪습니다.
          <br />
          <br />
          전치사를 실수하는 경우에 의도하지 않은 의미로 문장이 받아들여질 수 있습니다. 예를 들어, “Can I put this knife
          on your leg”를 “Can I put this knife in your leg”로 말한다면 칼을 다리 위에 놓는다에서 칼을 찌른다의 의미가 될
          수 있습니다.
        </>,
        <>
          For Koreans, mistakes commonly arise from the different ways prepositions are used in English. Also, people
          often find it hard using appropriate prepositions when using unfamiliar phrases.
          <br />
          <br />
          Using the wrong preposition may make the sentence take on an unintended meaning. For example, saying “Can I
          put this knife in your leg" instead of “Can I put this knife on your leg” changes the meaning from placing a
          knife on the leg to stabbing the leg.
        </>,
        'n_caf.tip.highlight2.body2',
        <>
          对于中文使用者来说，英语介词的使用方式与韩语不同，常常会导致错误。此外，当使用不熟悉的短语时，往往难以选择合适的介词。
          <br />
          <br />
          使用错误的介词可能会让句子的意思发生意外的变化。例如，将 “Can I put this knife on your
          leg”（我可以把这把刀放在你的腿上吗）误用成 “Can I put this knife in your
          leg”（我可以把这把刀刺进你的腿裡吗）会导致意思从把刀放在腿上变成刺进腿裡。
        </>,
        <>
          對於中文使用者來說，英語介系詞的使用方式與韓語不同，常常會導致錯誤。此外，當使用不熟悉的短語時，往往難以選擇合適的介系詞。
          <br />
          <br />
          使用錯誤的介系詞可能會讓句子的意思發生意外的變化。例如，將 “Can I put this knife on your
          leg”（我可以把這把刀放在你的腿上嗎）誤用成 “Can I put this knife in your
          leg”（我可以把這把刀刺進你的腿裡嗎）會導致意思從把刀放在腿上變成刺進腿裡。
        </>,
        <>
          日本人は、不適切なPreposition（前置詞）を使用することで、よくミスを起こします。また、慣れないフレーズを使うとき、適切なPreposition（前置詞）の使用が難しいと感じます。
          <br />
          <br />
          誤ったPreposition（前置詞）を使うと、文章が意図しない意味になってしまうことがあります。例えば、"Can I put this
          knife on your leg "ではなく、"Can I put this knife in your leg
          "と言うと、脚にナイフを置くという意味から脚を刺すという意味に変わってしまいます。
        </>,
        <>
          For Koreans, mistakes commonly arise from the different ways prepositions are used in English. Also, people
          often find it hard using appropriate prepositions when using unfamiliar phrases.
          <br />
          <br />
          Using the wrong preposition may make the sentence take on an unintended meaning. For example, saying “Can I
          put this knife in your leg" instead of “Can I put this knife on your leg” changes the meaning from placing a
          knife on the leg to stabbing the leg.
        </>,
      ],
      body3: [
        <>
          1. AI 분석 엔진에서 포착한 전치사 실수들을 확인하고, 적절한 전치사를 사용할 수 있도록 복습해보세요.
          <br />
          <br />
          2. 전치사마다의 의미와 사용법을 익히시고, 원어민들이 사용하는 다양한 예제들을 접해보세요.
        </>,
        <>
          1. Check the mistakes in using prepositions detected by the AI Analysis engine and review how to use them
          correctly.
          <br />
          <br />
          2. Learn the meaning and usage of each preposition and go over how they are used by native speakers.
        </>,
        'n_caf.tip.highlight2.body3',
        <>
          1. 检查AI分析引擎检测到的介词使用错误，并复习正确的用法。
          <br />
          <br />
          2. 学习每个介词的含义和用法，并了解它们在母语者中的使用方式。
        </>,
        <>
          1. 檢查AI分析引擎檢測到的介系詞詞使用錯誤，並複習正確的用法。
          <br />
          <br />
          2. 學習每個介系詞的含義和用法，並了解它們在母語者中的使用方式。
        </>,
        <>
          1. AI Analysis engineが検出したPreposition（前置詞）の使い方のミスをチェックし、正しい使い方を復習しましょう。
          <br />
          <br />
          2.それぞれのPreposition（前置詞）の意味と使い方を学び、ネイティブスピーカーがどのように使っているかを確認しましょう。
        </>,
        <>
          1. Check the mistakes in using prepositions detected by the AI Analysis engine and review how to use them
          correctly.
          <br />
          <br />
          2. Learn the meaning and usage of each preposition and go over how they are used by native speakers.
        </>,
      ],
    },
    highlight3: {
      title1: [
        `동사 형태란?`,
        `What is "incorrect verb form"?`,
        'n_caf.tip.highlight3.title1',
        `什麽是错误的动词型态？`,
        `什麼是錯誤的動詞型態？`,
        `Incorrect verb formとは何ですか？`,
        `What is "incorrect verb form"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight3.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect verb fromを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight3.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `단수 복수(+ s), 과거형(+ ed), 현재분사(+ ing) 등 동사의 형태를 결정짓는 문법 유형입니다.`,
        `Verb form determines the form of a verb, such as singular plural (+ s), past tense (+ ed), and present participle (+ ing).`,
        'n_caf.tip.highlight3.body1',
        `动词形态决定了动词的形式，比如单数或复数（加 s）、过去式（加 ed）和现在分词（加 ing）`,
        `動詞形態決定了動詞的形式，比如單數或複數（加 s）、過去式（加 ed）和現在分詞（加 ing）`,
        `Verb form（動詞の形）は、単数複数形（＋s）、過去形（＋ed）、現在分詞（＋ing）など、動詞の形を決定します。`,
        `Verb form determines the form of a verb, such as singular plural (+ s), past tense (+ ed), and present participle (+ ing).`,
      ],
      body2: [
        <>
          표현하고자하는 적절한 의미를 가지는 동사형태를 찾지 못하거나, 동사의 불규칙변화에 대해 인지하지 못하는 경우
          실수하는 경우가 많습니다.
          <br />
          <br />
          동사 형태에 따라서도 의미가 달라질 수 있기에 정확한 의미 전달을 위해 동사 형태를 학습해야합니다. 예를 들어 “I
          eat breakfast this morning” 대신 “I ate breakfast this morning”을 사용해야합니다.
        </>,
        <>
          Mistakes are often made when the speaker does not know the correct verb form for what he/she wants to say or
          is unaware that the verb is an irregular verb.
          <br />
          <br />
          Since the meaning can change depending on the verb form, you need to learn the correct verb form for conveying
          what you mean. For example, you should use “I ate breakfast this morning” instead of “I eat breakfast this
          morning.”
        </>,
        'n_caf.tip.highlight3.body2',
        <>
          当说话者不知道他/她想表达的正确动词形式，或者没有意识到该动词是不规则动词时，常常会犯错误
          <br />
          <br />
          由于动词形式的不同可能会导致意思的变化，因此你需要学习正确的动词形式来准确传达你的意思。例如，你应该说 “I ate
          breakfast this morning” 而不是 “I eat breakfast this morning”
        </>,
        <>
          當說話者不知道他/她想表達的正確動詞形式，或者沒有意識到該動詞是不規則動詞時，常常會犯錯誤
          <br />
          <br />
          由於動詞形式的不同可能會導致意思的變化，因此你需要學習正確的動詞形式來準確傳達你的意思。例如，你應該說 “I ate
          breakfast this morning” 而不是 “I eat breakfast this morning”
        </>,
        <>
          スピーカーが言いたいことに適した正しいVerb
          form（動詞の形）を知らないか、その動詞が不規則動詞であることを知らなかった場合、ミスがよく起こります。
          <br />
          <br />
          Verb form（動詞の形）によって意味が変わってくるので、意味を伝えるための正しいVerb
          form（動詞の形）を覚える必要があります。例えば、"I eat breakfast this morning "ではなく、"I ate breakfast this
          morning "を使うべきです。
        </>,
        <>
          Mistakes are often made when the speaker does not know the correct verb form for what he/she wants to say or
          is unaware that the verb is an irregular verb.
          <br />
          <br />
          Since the meaning can change depending on the verb form, you need to learn the correct verb form for conveying
          what you mean. For example, you should use “I ate breakfast this morning” instead of “I eat breakfast this
          morning.”
        </>,
      ],
      body3: [
        <>
          1. AI 분석 엔진에서 포착한 동사 형태 실수들을 확인하고, 적절한 동사 형태를 사용할 수 있도록 복습해보세요.
          <br />
          <br />
          2. 동사 형태에 대한 공부를 하며 외국인들이 어떻게 사용하는지 다양한 예제를 접해보세요.
        </>,
        <>
          1. Check the mistakes in using verb form detected by the AI Analysis engine and review how to use them
          correctly.
          <br />
          <br />
          2. Study different verb forms and go over examples of how native speakers use them.
        </>,
        'n_caf.tip.highlight3.body3',
        <>
          1. 检查AI分析引擎检测到的动词形式使用错误，并复习正确的用法。
          <br />
          <br />
          2. 学习不同的动词形式，并通过示例了解母语者如何使用它们。
        </>,
        <>
          1. 檢查AI分析引擎檢測到的動詞形式使用錯誤，並覆習正確的用法。
          <br />
          <br />
          2. 學習不同的動詞形式，並通過示例了解母語者如何使用它們。
        </>,
        <>
          1. AI Analysis engineが検出したVerb form（動詞の形）のミスをチェックし、正しい使い方を見直しましょう。
          <br />
          <br />
          2. 異なるVerb form（動詞の形）を学び、ネイティブスピーカーがどのように使うのか例文を確認してみましょう。
        </>,
        <>
          1. Check the mistakes in using verb form detected by the AI Analysis engine and review how to use them
          correctly.
          <br />
          <br />
          2. Study different verb forms and go over examples of how native speakers use them.
        </>,
      ],
    },
    highlight4: {
      title1: [
        `명사 수일치란?`,
        `What is "incorrect noun number"?`,
        'n_caf.tip.highlight4.title1',
        `什麽是错误的名词单複数？`,
        `什麼是錯誤的名詞單複數？`,
        `Incorrect noun numberとは何ですか？`,
        `What is "incorrect noun number"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight4.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect noun numbeを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight4.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `명사가 관련된 단어(대명사, 형용사, 동사 등)와 같은 수(단수/복수)를 가지도록 일치시키는 문법 유형입니다. 예를 들어 one of 복수명사에서 단수명사를 사용하거나 or/and로 병렬로 이어진 단어에서 하나는 복수형, 하나는 명사형으로 사용되는 경우 포착됩니다.`,
        `Noun number refers to the singular/plural agreement of words related to the noun (pronouns, adjectives, verbs, etc.) with noun in the sentence. The AI Analysis engine detects when a singular noun is used after "one of" or when nouns following "or/and" do not match each other.`,
        'n_caf.tip.highlight4.body1',
        `名词单複数指的是句子中与名词相关的词（如代词、形容词、动词等）在单复数上的一致性。AI分析引擎能够检测出在“one of”之后使用了单数名词，或当“or/and”之后的名词不一致时的错误。`,
        `名詞單複數指的是句子中與名詞相關的詞（如代詞、形容詞、動詞等）在單覆數上的一致性。AI分析引擎能夠檢測出在“one of”之後使用了單數名詞，或當“or/and”之後的名詞不一致時的錯誤。`,
        `Noun number（名詞の数）とは、文章中の名詞に関連する単語（代名詞、形容詞、動詞など）と名詞の単数/複数の一致を指します。AI Analysis engineは、”one of”の後に単数名詞が使用されている場合、もしくは”or”、”and”に続く名詞が互いに一致しない場合を検出します。`,
        `Noun number refers to the singular/plural agreement of words related to the noun (pronouns, adjectives, verbs, etc.) with noun in the sentence. The AI Analysis engine detects when a singular noun is used after "one of" or when nouns following "or/and" do not match each other.`,
      ],
      body2: [
        <>
          올바른 명사 수일치를 유지하지 않으면 문장이 불분명하거나 의미가 왜곡될 수 있습니다.
          <br />
          <br />
          예를 들어 “I will watch one of the awards program”대신 “I will watch one of the awards programs”로
          사용해야하며, “listen to their opinions or their story” 대신 “listen to their opinions or their stories”로
          수정해야합니다.
        </>,
        <>
          When noun number is not in agreement, the sentence can become unclear or distorted.
          <br />
          <br />
          For example, you should say “I will watch one of the awards programs” instead of “I will watch one of the
          awards program” and “listen to their opinions or their stories” instead of “listen to their opinions or their
          story.”
        </>,
        'n_caf.tip.highlight4.body2',
        <>
          当名词单複数不一致时，句子的意思可能会变得不清楚或意思不同。
          <br />
          <br />
          例如，你应该说“I will watch one of the awards programs” 而不是“I will watch one of the awards
          program”，并且应该说“listen to their opinions or their stories” 而不是“listen to their opinions or their story
        </>,
        <>
          當名詞單複數不一致時，句子的意思可能會變得不清楚或意思不同
          <br />
          <br />
          例如，你應該說“I will watch one of the awards programs” 而不是“I will watch one of the awards
          program”，並且應該說“listen to their opinions or their stories” 而不是“listen to their opinions or their story
        </>,
        <>
          Noun number（名詞の数）が一致していないと、文章が不明瞭になってしまう可能性があります。
          <br />
          <br />
          例えば、”I will watch one of the awards program”ではなく、”I will watch one of the awards
          programs”が正しい文章です。また、”listen to their opinions or their story”も同様に、”listen to their opinions
          or their stories”が正しい文章です。
        </>,
        <>
          When noun number is not in agreement, the sentence can become unclear or distorted.
          <br />
          <br />
          For example, you should say “I will watch one of the awards programs” instead of “I will watch one of the
          awards program” and “listen to their opinions or their stories” instead of “listen to their opinions or their
          story.”
        </>,
      ],
      body3: [
        <>
          1. AI 분석 엔진이 잡아준 문장들을 확인하면서 어떤 상황에서 명사 수일치 실수를 하는지 확인해보세요.
          <br />
          <br />
          2. 명사와 그 주변 단어들 간의 관계를 보면서 수일치의 유무에 따른 의미 차이를 비교해보세요.
        </>,
        <>
          1. Review the sentences detected by the AI Analysis engine and check the contexts in which you make mistakes
          related to noun numbers.
          <br />
          <br />
          2. Look at the relationship between a noun and its surrounding words and compare how their meanings change
          depending on noun number agreement.
        </>,
        'n_caf.tip.highlight4.body3',
        <>
          1. 复习AI分析引擎检测到的句子，并检查与名词单複数相关的错误出现的语境。
          <br />
          <br />
          2.查看名词与其周围词语之间的关系，并比较根据名词数一致性，它们的意思如何变化。
        </>,
        <>
          1. 複習AI分析引擎檢測到的句子，並檢查與名詞單複數相關的錯誤出現的語境。
          <br />
          <br />
          2.查看名詞與其周圍詞語之間的關係，並比較根據名詞單複數一致性，它們的意思如何變化。
        </>,
        <>
          1. AI Analysis engineによって検出された文章を確認し、Noun
          number（名詞の数）に関連するミスをしている文脈をチェックしてみましょう。
          <br />
          <br />
          2.名詞とその周囲の単語との関係を見て、Noun
          number（名詞の数）の一致に応じてその意味がどのように変わるかを比較してみましょう。
        </>,
        <>
          1. Review the sentences detected by the AI Analysis engine and check the contexts in which you make mistakes
          related to noun numbers.
          <br />
          <br />
          2. Look at the relationship between a noun and its surrounding words and compare how their meanings change
          depending on noun number agreement.
        </>,
      ],
    },
    highlight7: {
      title1: [
        `주어동사 수일치란?`,
        `What is "incorrect subject-verb agreement"?`,
        'n_caf.tip.highlight7.title1',
        `什麽是错误的主词动词不一致？`,
        `什麼是錯誤的主詞動詞不一致？`,
        `Incorrect subject-verb agreementとは何ですか？`,
        `What is "incorrect subject-verb agreement"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight7.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect subject-verb agreementを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight7.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `복수형의 주어가 사용되었는데 단수형의 동사로 부적절히 사용되거나 그 반대의 상황에서 포착되는 문법 유형입니다. 예를 들어, “The cat chases the mouse.” 대신 “The cat chase the mouse.”를 사용하는 경우 포착됩니다.`,
        `Subject-verb agreement is wrong when the subject is plural but the verb is singular or vice versa. For example, the AI Analysis engine detects when “The cat chase the mouse” is used instead of “The cat chases the mouse.”`,
        'n_caf.tip.highlight7.body1',
        `主词动词不一致错误是指主语是复数但动词是单数，或主语是单数但动词是复数的情况。例如，AI 分析引擎会检测到使用“The cat chase the mouse”而不是“The cat chases the mouse”时的错误。`,
        `主詞動詞不一致錯誤是指主詞是複數但動詞是單數，或主詞是單數但動詞是複數的情況。例如，AI 分析引擎會檢測到使用“The cat chase the mouse”而不是“The cat chases the mouse”時的錯誤。`,
        `主語が複数で動詞が単数の場合、またはその逆の場合、Subject-verb agreement（主語と動詞の一致）が誤っている（もしくは一致していない）といえます。例えば、AI Analysis engineは、"The cat chase the mouse "ではなく "The cat chases the mouse "が使われた場合を検出します。`,
        `Subject-verb agreement is wrong when the subject is plural but the verb is singular or vice versa. For example, the AI Analysis engine detects when “The cat chase the mouse” is used instead of “The cat chases the mouse.”`,
      ],
      body2: [
        <>
          there + is를 습관적으로 사용하고 뒤에 복수형인 many를 붙여서 어색하게 만드는 경우가 많습니다. 혹은 사용한
          주어가 복수형인지 알지 못한채 습관적으로 단수형 동사를 사용하는 경우도 많습니다.
          <br />
          <br />
          원어민은 단수형 맥락에서 당연히 뒤의 내용도 단수일것으로 기대하지만, 복수형 내용이 나오는 경우 기대한것과 달라
          의미를 파악하기 어려울 수 있어 나의 발화의 전달력이 떨어질 수 있습니다.
        </>,
        <>
          Often, the speaker habitually uses "there + is" then adds "many," which is plural, right afterwards. There are
          also many cases where singular verbs are habitually used without considering whether the subject is singular
          or plural.
          <br />
          <br />
          Native speakers expect the verb to be singular after a singular subject, so it confuses them if a plural verb
          follows a singular subject. Thus, the intended meaning may not be conveyed properly.
        </>,
        'n_caf.tip.highlight7.body2',
        <>
          通常，说话者习惯性地使用“there +
          is”，然后紧接着添加“many”，这是一个复数。还有许多情况下，习惯性地在不考虑主语是单数还是复数的情况下使用单数动词。
          <br />
          <br />
          母语者期待在单数主语后使用单数动词，因此如果单数主语后跟随复数动词会让他们感到困惑，从而可能无法正确传达预期的意思。
        </>,
        <>
          通常，說話者習慣性地使用“there +
          is”，然後緊接著添加“many”，這是一個複數。還有許多情況下，習慣性地在不考慮主詞是單數還是複數的情況下使用單數動詞。
          <br />
          <br />
          母語者期待在單數主語後使用單數動詞，因此如果單數主語後跟隨覆數動詞會讓他們感到困惑，從而可能無法正確傳達預期的意思。
        </>,
        <>
          スピーカーは頻繁に "there + is" を使用し、直後に複数形の"many
          "を付け加えます。また、主語が単数形か複数形かを考慮せずに、単数形の動詞が使用されることも多いです。
          <br />
          <br />
          ネイティブスピーカーは、単数形の主語の後には単数形の動詞が続くと予測しているため、単数形の主語の後に複数形の動詞が続くと混乱します。そのため、意味が適切に伝わらないことがあります。
        </>,
        <>
          Often, the speaker habitually uses "there + is" then adds "many," which is plural, right afterwards. There are
          also many cases where singular verbs are habitually used without considering whether the subject is singular
          or plural.
          <br />
          <br />
          Native speakers expect the verb to be singular after a singular subject, so it confuses them if a plural verb
          follows a singular subject. Thus, the intended meaning may not be conveyed properly.
        </>,
      ],
      body3: [
        <>
          1. 앞뒤에 복수형/단수형 명사를 사용할건지 생각하고 적절한 동사를 사용하는 연습을 해보세요.
          <br />
          <br />
          2. AI 분석 엔진에서 포착한 수업에서 내가 말한 문장들을 다시 읽어보며 반복 학습을 진행해보세요.
        </>,
        <>
          1. Think about whether you will be using singular or plural nouns, and practice using matching verbs.
          <br />
          <br />
          2. Check the sentences detected by the AI Analysis engine and review them multiple times.
        </>,
        'n_caf.tip.highlight7.body3',
        <>
          1. 考虑你将要使用的是单数还是复数名词，并练习使用匹配的动词。
          <br />
          <br />
          2. 检查 AI 分析引擎检测到的句子，并多次复习。
        </>,
        <>
          1. 考慮你將要使用的是單數還是複數名詞，並練習使用匹配的動詞。
          <br />
          <br />
          2. 檢查 AI 分析引擎檢測到的句子，並多次複習。
        </>,
        <>
          1.単数形の名詞を使うか複数形の名詞を使うかを考え、適切な動詞を使う練習をしてみましょう。
          <br />
          <br />
          2. AI Analysis engineが検出した文章をチェックし、何度も見直してみましょう。
        </>,
        <>
          1. Think about whether you will be using singular or plural nouns, and practice using matching verbs.
          <br />
          <br />
          2. Check the sentences detected by the AI Analysis engine and review them multiple times.
        </>,
      ],
    },
    highlight5: {
      title1: [
        `단어순서란?`,
        `What is "incorrect word order"?`,
        'n_caf.tip.highlight5.title1',
        `什麽是错误的词语顺序？`,
        `什麼是錯誤的詞語順序？`,
        `Incorrect word orderとは何ですか？`,
        `What is "incorrect word order"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight5.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect word orderを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight5.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `영어에서는 단어의 순서에 따라 다른 의미를 가지며, 맥락에 따라 단어순서를 적절히 배치하는 문법 유형입니다.`,
        `In English, the order of words can change the meaning of the sentence. Word order refers to the proper arrangement of words according to the context.`,
        'n_caf.tip.highlight5.body1',
        `在英语中，詞語的顺序可以改变句子的含义。词序指的是根据上下文对单词进行的正确排列。`,
        `在英文中，詞語的順序可以改變句子的含義。詞序指的是根據上下文對單詞進行的正確排列。`,
        `英語では、Word order（語順）によって文章の意味が変わることがあります。Word order（語順）とは、文脈に応じて単語を適切に並べることをいいます。`,
        `In English, the order of words can change the meaning of the sentence. Word order refers to the proper arrangement of words according to the context.`,
      ],
      body2: [
        <>
          한국어와 영어의 어순이 달라 많이 실수하며, 문장의 의미와 해석이 달라질 수 있습니다.
          <br />
          <br />
          예를 들어 “나는 밥을 먹는다.”를 영어에서는 “I eat a meal.”로 말하는것처럼 동사와 목적어의 순서가 다르게
          표현됩니다.
        </>,
        <>
          Mistakes are common among Koreans because the word order is different between Korean and English and end up
          changing the meaning of the sentence.
          <br />
          <br />
          For example, when saying "I eat a meal" where the verb comes before the object in English, the verb comes
          after the object in Korean.
        </>,
        'n_caf.tip.highlight5.body2',
        <>
          由于中文和英语的词序使用习惯不同，中文母语者常常犯错，最终让句子变得不自然。
          <br />
          <br />
          例如，在说“我昨天去了图书馆”时，时间放在动词之前，而在英语中时间则放在句子末尾。.
        </>,
        <>
          由於中文和英文的詞序使用習慣不同，中文母語者常常犯錯，最終讓句子變得不自然。
          <br />
          <br />
          例如，在說“我昨天去了圖書館”時，時間放在動詞之前，而在英文中時間則放在句子末尾。
        </>,
        <>
          日本語と英語とではWord order（語順）が違うため、日本人はよく文章の意味を変えてしまいます。
          <br />
          <br />
          例えば、「"I eat a meal"」と言うとき、英語では動詞が目的語の前に来ますが、日本語では動詞が目的語の後に来ます。
        </>,
        <>
          Mistakes are common among Koreans because the word order is different between Korean and English and end up
          changing the meaning of the sentence.
          <br />
          <br />
          For example, when saying "I eat a meal" where the verb comes before the object in English, the verb comes
          after the object in Korean.
        </>,
      ],
      body3: [
        `다양한 문장 형식에 친숙해지시는걸 추천드립니다. 가장 흔한 형태는 주어-동사-목적어이지만, 부사, 형용사, 전치사 등이 포함된 다양한 문장 형태를 찾아 읽어보세요.`,
        `Familiarize yourself with diverse types of sentences. While subject-verb-object is the most common, it helps to go over ones that include adverbs, adjectives, prepositions, and more.`,
        'n_caf.tip.highlight5.body3',
        `请熟悉各种类型的句子。虽然主词-动词-宾语是最常见的句子结构，但複习包含副词、形容词、介词等的句子结构也会有所帮助。`,
        `請熟悉各種類型的句子。雖然主詞-動詞-賓語是最常見的句子結構，但複習包含副詞、形容詞、介詞等的句子結構也會有所幫助。`,
        `多様なタイプの文に慣れる。主語-動詞-目的語が最も一般的ですが、副詞、形容詞、前置詞などを含む文にも目を通しておくと役立ちます。
 様々な種類の文章に慣れるよう努めましょう。Subject（主語）、Verb（動詞）、Object（目的語）が最も一般的ですが、Adverb（副詞）、Adjective（形容詞）、 Preposition（前置詞）などを含む文章も確認すると役立ちます。`,
        `Familiarize yourself with diverse types of sentences. While subject-verb-object is the most common, it helps to go over ones that include adverbs, adjectives, prepositions, and more.`,
      ],
    },
    highlight6: {
      title1: [
        `형태 혼동이란?`,
        `What is "incorrect morphology"?`,
        'n_caf.tip.highlight6.title1',
        `什麽是错误的词语型态？`,
        `什麼是錯誤的詞語型態？`,
        `Incorrect morphologyとは何ですか？`,
        `What is "incorrect morphology"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight6.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect morphologyを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight6.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `단어의 생성 원리와 구조를 적절히 사용했는지 판단하는 문법 유형입니다. 예를들어 child의 복수형은 childs 대신 children, advantage의 부정형은 disadvantage 등이 적절히 사용되었는가를 판단합니다.`,
        `Morphology refers to the formation of words based on their principles and structures. For instance, the AI Analysis engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
        'n_caf.tip.highlight6.body1',
        `Morphology refers to the formation of words based on their principles and structures. For instance, the AI Analysis engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
        `Morphology refers to the formation of words based on their principles and structures. For instance, the CAF engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
        `Morphology（形態論）とは、単語の原則と構造に基づいて単語を形成することを指します。例えば、CAF engineは、childの複数形として "children"（"childs "ではない）を使用したか、advantageの否定形として "disadvantage "を使用したかどうかを判断します。`,
        `Morphology refers to the formation of words based on their principles and structures. For instance, the CAF engine determines whether you used "children" (not "childs") as the plural form of child, and "disadvantage" as the negative form of advantage.`,
      ],
      body2: [
        <>
          적절한 접미사/접두사를 알지 못하는 경우 해당 유형을 실수할 가능성이 높습니다.
          <br />
          <br />
          또한 적절한 형태로 사용하지 않는경우 원어민들이 말하고자 하는 단어를 이해하지 못할 가능성이 높습니다.
        </>,
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
        'n_caf.tip.highlight6.body2',
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
        <>
          適切なSuffix（接尾語）/Prefix（先頭語）を知らないと、この種のミスを犯す可能性が高くなります。
          <br />
          <br />
          また、不適切な語形が使われていると、ネイティブ・スピーカーは何を言おうとしているのか理解できない可能性が高くなります。
        </>,
        <>
          Not knowing the proper suffix/prefix increases the likelihood of making a mistake of this type.
          <br />
          <br />
          Also, when improper word forms are used, there is a good chance that native speakers won't understand what
          you're trying to say.
        </>,
      ],
      body3: [
        <>
          1. 주로 실수 하는 것들을 모아서 실수 했던 문장들을 나의 문장으로 가져오는 것이 필요합니다. 특히 단어
          하나하나를 암기하는 형태가 아니라, 다양한 나의 문장 형태로 저장하는 것을 추천드립니다.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. 또한, 동사의 과거형은 어떻게 변하는지, 형용사/부사로 바뀌는 경우 단어의 형태가 어떻게 변하는지 등을
          학습해보세요.
        </>,
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
        'n_caf.tip.highlight6.body3',
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
        <>
          1.よくミスをする箇所をチェックし、そのミスを含む文章をリストアップしてみましょう。個々の単語を覚えるのではなく、文章全体を覚えるようにしましょう。
          <br />
          例 ：I have two childs. → I have two children.
          <br />
          <br />
          2.また、動詞の過去形や、動詞が形容詞・副詞などになったときの語形の変化も覚えましょう。
        </>,
        <>
          1. Check the mistakes you make often and put together a list of the sentences that include those mistakes. Try
          learning the whole sentence, rather than memorizing individual words.
          <br />
          ex. I have two childs. → I have two children.
          <br />
          <br />
          2. Also, learn the past tenses of verbs and how the verb's word form changes when it becomes an
          adjective/adverb, etc.
        </>,
      ],
    },
    highlight8: {
      title1: [
        `형용사 문법 유형이란?`,
        `What is an "incorrect adjective"?`,
        'n_caf.tip.highlight8.title1',
        `什麽是错误的形容词？`,
        `什麼是錯誤的形容詞？`,
        `Incorrect adjectiveとは何ですか？`,
        `What is an "incorrect adjective"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight8.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect adjectiveを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight8.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `형용사가 어색하게 사용되거나 불필요한 경우 포착하는 문법 유형입니다. 예를 들어 “little city” 대신 “small city”, “The weather is nice for skiing” 대신 “The weather is good for skiing”를 사용해하는 문장을 포착합니다.`,
        `Incorrect adjective use is when adjectives are used awkwardly or unnecessarily. Examples are: saying “little city” instead of “small city,” “The weather is nice for skiing” instead of “The weather is good for skiing.”`,
        'n_caf.tip.highlight8.body1',
        `形容词使用不当是指形容词使用得生硬或不必要的情况。例如，使用“little city”而不是“small city”，或者说“The weather is nice for skiing”而不是“The weather is good for skiing”。`,
        `形容詞使用不當是指形容詞使用得生硬或不必要的情況。例如，使用“little city”而不是“small city”，或者說“The weather is nice for skiing”而不是“The weather is good for skiing”。`,
        `Incorrect adjective（不適切な形容詞）とは、Adjective（形容詞）が不自然であるか不必要に使用されているときです。例えば、"small city "の代わりに "little city "と言ったり、"The weather is nice for skiing "の代わりに "The weather is good for skiing "と言ったりすることが挙げられます。`,
        `Incorrect adjective use is when adjectives are used awkwardly or unnecessarily. Examples are: saying “little city” instead of “small city,” “The weather is nice for skiing” instead of “The weather is good for skiing.”`,
      ],
      body2: [
        `형용사의 정확한 의미를 파악하지 못하거나 문장의 구조를 잘못잡아 어색한 위치에 형용사를 사용하는 경우 주로 발생합니다.
다른 명사를 수식하게 되거나 다른 의미로 해석되어 소통에 어려움이 있을 수 있습니다.`,
        `This usually occurs when the speaker does not know the exact meaning of the adjective or puts the adjective in an awkward place in the sentence structure.
The adjective may end up modifying the wrong noun or understood incorrectly, causing difficulties in communication.`,
        'n_caf.tip.highlight8.body2',
        `"这种情况通常发生在说话者不清楚形容词的确切含义，或者将形容词放在句子结构中不合适的位置时。
形容词可能最终修饰了错误的名词，或被误解，从而导致沟通困难。`,
        `這種情況通常發生在說話者不清楚形容詞的確切含義，或者將形容詞放在句子結構中不合適的位置時。
形容詞可能最終修飾了錯誤的名詞，或被誤解，從而導致溝通困難。`,
        `これは通常、スピーカーがAdjective（形容詞）の正確な意味を知らなかったり、文章構造の中でAdjective（形容詞）を使いにくい場所に置いたりした場合に起こります。
 Adjective（形容詞）が誤った名詞を修飾してしまったり、誤って理解されてしまったりして、コミュニケーションが困難になることがあります。`,
        `This usually occurs when the speaker does not know the exact meaning of the adjective or puts the adjective in an awkward place in the sentence structure.
The adjective may end up modifying the wrong noun or understood incorrectly, causing difficulties in communication.`,
      ],
      body3: [
        <>
          1. 비슷한 의미를 가진 형용사들을 찾아보고 수업때 말했던 문장을 되돌아보면서 어떤 차이들이 존재하는지
          복습해보세요.
          <br />
          <br />
          2. 다양한 문맥속에서 형용사를 사용하고 튜터에게 피드백을 받아보세요. 사람, 장소, 사물 등 수식하는 대상에 따라
          미묘한 차이가 있을 수 있습니다.
        </>,
        <>
          1. Look up adjectives that have similar meanings and check their differences as you review the sentences you
          spoke duuring lessons.
          <br />
          <br />
          2. Use adjectives in different contexts and get feedback from your tutor. There may be subtle differences
          depending on what the adjective modifies, such as a person, place, or thing.
        </>,
        'n_caf.tip.highlight8.body3',
        <>
          1. 查找意思相近的形容词，并在复习上课时说的句子时，检查它们之间的区别。
          <br />
          <br />
          2. 在不同的语境中使用形容词，并从教师那里获取反馈。根据形容词修饰的是人、地点或事物，可能会有细微的差别。
        </>,
        <>
          1. 查找意思相近的形容詞，並在複習上課時說的句子時，檢查之間的區別。
          <br />
          <br />
          2. 在不同的語境中使用形容詞，並從教師獲取反饋。根據形容詞修飾的是人、地點或事物，可能會有細微的差別。
        </>,
        <>
          1.似たような意味を持つAdjective（形容詞）を調べ、レッスン中に話した文章を復習しながら、その違いを確認してみましょう。
          <br />
          <br />
          2.異なる文脈でAdjective（形容詞）を使い、チューターからフィードバックをもらいましょう。人、場所、物など、Adjective（形容詞）が何を修飾するかによって微妙な違いがあるかもしれません。
        </>,
        <>
          1. Look up adjectives that have similar meanings and check their differences as you review the sentences you
          spoke duuring lessons.
          <br />
          <br />
          2. Use adjectives in different contexts and get feedback from your tutor. There may be subtle differences
          depending on what the adjective modifies, such as a person, place, or thing.
        </>,
      ],
    },
    highlight9: {
      title1: [
        `비교급/최상급 문법 유형이란?`,
        `What is an "incorrect comparative/superlative"?`,
        'n_caf.tip.highlight9.title1',
        `什麽是错误的比较级/最高级？`,
        `什麼是錯誤的比較級/最高級？`,
        `Incorrect superlative/comparativeとは何ですか？`,
        `What is an "incorrect comparative/superlative"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight9.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect superlative/comparativeを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight9.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `easier이 아닌 more easy, much fastest 등 비교급/최상급 형용사를 잘못 사용하는 경우 포착하는 문법 유형입니다.`,
        `Incorrect comparative/superlative refers to the misuse of comparative/superlative adjectives, such as saying "more easy" instead of "easier" or "much fastest.`,
        'n_caf.tip.highlight9.body1',
        `比较级/最高级使用不当是指错误使用比较级/最高级形容词，例如说“more easy”而不是“easier”或者“much fastest”。`,
        `比較級/最高級使用不當是指錯誤使用比較級/最高級形容詞，例如說“more easy”而不是“easier”或者“much fastest”。`,
        `Incorrect superlative/comparative（不適切な最上級／比較級）とは、"easy "ではなく "more easy"、あるいは "much fastest "と言うような、Superlative/Comparative adjectives（最上級形容詞／比較級形容詞）の誤った使い方を指します。`,
        `Incorrect comparative/superlative refers to the misuse of comparative/superlative adjectives, such as saying "more easy" instead of "easier" or "much fastest.`,
      ],
      body2: [
        <>
          more + er으로 중복 비교급 혹은 most + est 최상급을 중복으로 쓰는 경우가 많으며, 비교급으로 사용되는 단어를
          모르는 경우가 많습니다.
          <br />
          <br />
          어색한 영어 문법으로 정확한 의미를 전달하거나 듣는 사람에게 Native처럼 느껴지지 않을 가능성이 있습니다.
        </>,
        <>
          A common mistake is redundant usage such as "more + er" or "most + est." Also, the speaker may not know the
          comparative adjective.
          <br />
          <br />
          This kind of mistake can confuse the intended meaning and make the speaker sound awkward and non-native.
        </>,
        'n_caf.tip.highlight9.body2',
        <>
          常见的错误是冗余使用，如“more + er”或“most + est”。此外，说话者可能不知道正确的比较级形容词。
          <br />
          <br />
          这类错误会混淆原本想表达的意思，使说话者显得生硬且不像母语者。
        </>,
        <>
          常見的錯誤是冗余使用，如“more + er”或“most + est”。此外，說話者可能不知道正確的比較級形容詞。
          <br />
          <br />
          這類錯誤會混淆原本想表達的意思，使說話者顯得生硬且不像母語者。
        </>,
        <>
          よくあるミスは、"more + er "や "most + est "などの冗長な使用です。 また、スピーカーはComparative
          adjective（比較級形容詞）を知らない場合もあります。
          <br />
          <br />
          このようなミスは意図された意味を混乱させ、不自然かつネイティブでないように聞こえてしまいます。
        </>,
        <>
          A common mistake is redundant usage such as "more + er" or "most + est." Also, the speaker may not know the
          comparative adjective.
          <br />
          <br />
          This kind of mistake can confuse the intended meaning and make the speaker sound awkward and non-native.
        </>,
      ],
      body3: [
        <>
          1. 자주 틀리는 비교급/최상급 형용사를 찾고, 정확한 사용법을 숙지하세요. 특히 말하는 상황에 의식적으로
          기억하는것을 추천드립니다.
          <br />
          <br />
          2. 몇가지 기억이 안나는 비교급/최상급이 있다면 예문을 만들거나 아래 실수한 문장들을 여러번 반복해서 말해
          기억속에 각인시켜보세요.
        </>,
        <>
          1. Look up the comparatives{'/'}superlatives you often use incorrectly and learn how to use them correctly.
          Try to remember these when speaking.
          <br />
          <br />
          2. If there are comparatives/superlatives that are hard to remember, make sample sentences or go over your
          mistakes many times to imprint them in your memory.
        </>,
        'n_caf.tip.highlight9.body3',
        <>
          1. 查找你经常用错的比较级/最高级，并学习如何正确使用它们。在说话时尽量记住这些用法。
          <br />
          <br />
          2. 如果有难以记住的比较级/最高级，尝试造句或多次复习你的错误，以便将它们牢牢记住。
        </>,
        <>
          1. 查找你經常用錯的比較級/最高級，並學習如何正確使用它們。在說話時盡量記住這些用法。
          <br />
          <br />
          2. 如果有難以記住的比較級/最高級，嘗試造句或多次覆習你的錯誤，以便將它們牢牢記住。
        </>,
        <>
          1.よくミスをするSuperlative/Comparative（最上級・比較級）を調べて、正しい使用方法を覚えましょう。話す際は、これらを思い出すようにしましょう。
          <br />
          <br />
          2.覚えにくいSuperlative/Comparative（最上級・比較級）があれば、例文を作ったり、誤ったところを何度も見直したりして、忘れないようにしましょう。
        </>,
        <>
          1. Look up the comparatives{'/'}superlatives you often use incorrectly and learn how to use them correctly.
          Try to remember these when speaking.
          <br />
          <br />
          2. If there are comparatives/superlatives that are hard to remember, make sample sentences or go over your
          mistakes many times to imprint them in your memory.
        </>,
      ],
    },
    highlight10: {
      title1: [
        `부사 문법 실수란?`,
        `What is "incorrect adverb"?`,
        'n_caf.tip.highlight10.title1',
        `什麽是错误的副词？`,
        `什麼是錯誤的副詞？`,
        `Incorrect adverbとは何ですか？`,
        `What is "incorrect adverb"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight10.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect adverbを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight10.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        <>
          “He plays the piano ~~good~~ well.” 과 같은 어색한 부사의 사용, “He speak ~~slow~~ slowly” 부사 대신 형용사를
          사용하는 경우, 잘못된 위치에 부사를 사용하는 경우 등이 포함됩니다.
          <br />
          <br />⇒ “He plays the piano ~~good~~ well.”, “He speak ~~slow~~ slowly” 처럼 어색하거나 잘못된 부사의 용법과
          관련된 문법 유형입니다.
        </>,
        <>
          Incorrect adverb use includes using awkward adverbs (ex. “He plays the piano ~~good~~ well”), using adjectives
          instead of adverbs (ex. “He speak ~~slow~~ slowly”) and putting adverbs in the wrong place.
          <br />
          <br />⇒ This type of mistake is related to using adverbs awkwardly or incorrectly, like “He plays the piano
          ~~good~~ well” or “He speak ~~slow~~ slowly.”
        </>,
        'n_caf.tip.highlight10.body1',
        <>
          不正确的副词使用包括使用生硬的副词（例如“他弹钢琴 good 而非 well”），用形容词代替副词（例如“他说话 slow而非
          slowly”），以及将副词放在错误的位置。
          <br />
          <br />⇒ 这种错误与生硬或不正确地使用副词有关，比如“他弹钢琴 good 而非 well”或“他说话 slow 而非 slowly。”
        </>,
        <>
          不正確的副詞使用包括使用生硬的副詞（例如“他彈鋼琴 good 而非 well”），用形容詞代替副詞（例如“他說話 slow而非
          slowly”），以及將副詞放在錯誤的位置。
          <br />
          <br />⇒ 這種錯誤與生硬或不正確地使用副詞有關，比如“他彈鋼琴 good 而非 well”或“他說話 slow 而非 slowly。”
        </>,
        <>
          Incorrect adverb（不適切な副詞）の使用には、不自然な副詞の使用（例："He plays the piano ~~good~~
          well"）、副詞の代わりに形容詞を使用すること（例："He speak ~~slow~~
          slowly"）、誤った位置に副詞を置くなどがあります。
          <br />
          <br />⇒ これらのミスは、"He plays the piano ~~good~~ well "や "He speak ~~slow~~ slowly
          "のように、副詞の使用が不自然であったり、誤っていたりすることに関連しています。
        </>,
        <>
          Incorrect adverb use includes using awkward adverbs (ex. “He plays the piano ~~good~~ well”), using adjectives
          instead of adverbs (ex. “He speak ~~slow~~ slowly”) and putting adverbs in the wrong place.
          <br />
          <br />⇒ This type of mistake is related to using adverbs awkwardly or incorrectly, like “He plays the piano
          ~~good~~ well” or “He speak ~~slow~~ slowly.”
        </>,
      ],
      body2: [
        <>
          형용사로 착각하여 부사를 써서 잘못된 의미가 전달되거나 잘못된 위치에 부사를 사용하여 문장이 어색해지는 경우가
          있습니다.
          <br />
          <br />
          예를 들어, “He works hard”는 열심히 일한다, “He works hardly”는 거의 일하지 않는다의 의미로 다른 의미의 문장이
          됩니다. 또한 “I eat breakfast never.” 대신 “I never eat breakfast”라고 표현해야 정확한 의미 전달이 가능합니다.
        </>,
        <>
          Using an adverb instead of an adjective can deliver the wrong meaning, and using adverbs in the wrong place
          can make the sentence seem awkward.
          <br />
          <br />
          For example, “He works hard” and “He works hardly” convey entirely different meanings. Also, instead of “I eat
          breakfast never," it should be “I never eat breakfast” to convey the precise meaning.
        </>,
        'n_caf.tip.highlight10.body2',
        <>
          用副词代替形容词可能会传达错误的意思，而将副词放在错误的位置可能会使句子显得生硬。
          <br />
          <br />
          例如，“He works hard”和“He works hardly”表达的是完全不同的意思。此外，应该用“I never eat breakfast”而不是“I
          eat breakfast never”来表达确切的意思。
        </>,
        <>
          用副詞代替形容詞可能會傳達錯誤的意思，而將副詞放在錯誤的位置可能會使句子顯得生硬。
          <br />
          <br />
          例如，“He works hard”和“He works hardly”表達的是完全不同的意思。此外，應該用“I never eat breakfast”而不是“I
          eat breakfast never”來表達確切的意思。
        </>,
        <>
          Adjective（形容詞）の代わりにAdverb（副詞）を使うと、誤った意味を伝えることになり、誤った場所にAdverb（副詞）を使うと、文章が不自然になってしまいます。
          <br />
          <br />
          例えば、“He works hard”と“He works hardly”では全く異なる意味になります。また、"I eat breakfast never.
          "の代わりに "I never eat breakfast. "とすれば、正確な意味を伝えることができます。
        </>,
        <>
          Using an adverb instead of an adjective can deliver the wrong meaning, and using adverbs in the wrong place
          can make the sentence seem awkward.
          <br />
          <br />
          For example, “He works hard” and “He works hardly” convey entirely different meanings. Also, instead of “I eat
          breakfast never," it should be “I never eat breakfast” to convey the precise meaning.
        </>,
      ],
      body3: [
        <>
          1. AI 분석 엔진이 포착한 부사 실수 중 어떤 형태로 가장 많이 틀리는지 파악하고, 관련 사용법을 찾아보세요.
          <br />
          <br />
          2. 자주 실수한 형태를 활용하고, 다양한 예문을 만들어 여러번 읽어 말하는 연습을 하는것을 추천드립니다.
        </>,
        <>
          1. Review the wrong adverb usages detected by the AI Analysis engine to check the types of mistakes you make
          the most and learn how to use them correctly.
          <br />
          <br />
          2. Practice adverbs you misuse often by reading sample sentences out loud many times.
        </>,
        'n_caf.tip.highlight10.body3',
        <>
          1. 复习 AI 分析引擎检测到的错误副词用法，检查你最常犯的错误类型，并学习如何正确使用它们。
          <br />
          <br />
          2. 通过多次大声朗读示例句子，练习你经常用错的副词。
        </>,
        <>
          1. 複習 AI 分析引擎檢測到的錯誤副詞用法，檢查你最常犯的錯誤類型，並學習如何正確使用它們。
          <br />
          <br />
          2. 通過多次大聲朗讀示例句子，練習你經常用錯的副詞。
        </>,
        <>
          1. AI Analysis
          engineが検出した誤ったAdverbs（副詞）の使用例を確認し、自分がよく誤るタイプをチェックして正しい使い方を学びましょう。
          <br />
          <br />
          2.よく誤るAdverbs（副詞）の学習のため、例文を何度も声に出して読んでみましょう。
        </>,
        <>
          1. Review the wrong adverb usages detected by the AI Analysis engine to check the types of mistakes you make
          the most and learn how to use them correctly.
          <br />
          <br />
          2. Practice adverbs you misuse often by reading sample sentences out loud many times.
        </>,
      ],
    },
    highlight11: {
      title1: [
        `가산/불가산 명사 문법 실수란?`,
        `What is "incorrect noun inflection"?`,
        'n_caf.tip.highlight11.title1',
        `什麽是名词变形错误？`,
        `什麼是名詞變形錯誤？`,
        `Incorrect noun inflectionとは何ですか？`,
        `What is "incorrect noun inflection"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight11.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect noun inflectionを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight11.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `영어 단어에는 셀수있는 명사가 있고, 셀수없는 명사가 있는데, 셀 수 없는 명사에 s를 붙여서 셀 수 있는 명사로 말하는 경우 가산/불가산 명사 문법 실수로 포착하고 있습니다.`,
        `In English, there are countable nouns and uncountable nouns. Cases where an "s" is attached at the end of an uncountable noun and used as a countable noun are detected by the AI Analysis engine as a noun inflection mistake.`,
        'n_caf.tip.highlight11.body1',
        `在英语中，有可数名词和不可数名词。当不可数名词的词尾错误地加上“s”并作为可数名词使用时，AI分析引擎会将其检测为名词词形变化错误。`,
        `在英文中，有可數名詞和不可數名詞。當不可數名詞的詞尾錯誤地加上“s”並作為可數名詞使用時，AI分析引擎會將其檢測為名詞詞形變化錯誤。`,
        `英語には可算名詞と不可算名詞があります。不可算名詞の末尾に「s」が付いて可算名詞として使用される場合は、AI Analysis engineによってNoun inflection（名詞の変化）のミスとして検出されます。`,
        `In English, there are countable nouns and uncountable nouns. Cases where an "s" is attached at the end of an uncountable noun and used as a countable noun are detected by the AI Analysis engine as a noun inflection mistake.`,
      ],
      body2: [
        `s가 붙을것 같지만 안붙는 불가산 명사를 가장 많이 실수합니다. 예를 들어 feedback이라는 단어는 복수형이 될 수 있을것 같지만, 그렇게 쓰이지 않습니다. “Ringle appreciates both positive and negative feedback from users.” 긍정적이고 부정적인 피드백을 모두 환영한다에서도 “s”를 붙이지 않습니다.`,
        `The most common mistake is adding an "s" at the end of an uncountable noun. For example, the word "feedback" seems like it may be changed to plural form by adding an "s," but this is incorrect. For instance, in “Ringle appreciates both positive and negative feedback from users,” there is no "s" after feedback.`,
        'n_caf.tip.highlight11.body2',
        `最常见的错误是在不可数名词的末尾加上“s”。例如，"feedback" 这个词看起来好像可以通过加“s”变为复数形式，但这是不正确的。例如，在句子 “Ringle appreciates both positive and negative feedback from users” 中，feedback 后面没有“s”。`,
        `最常見的錯誤是在不可數名詞的末尾加上“s”。例如，"feedback" 這個詞看起來好像可以通過加“s”變為覆數形式，但這是不正確的。例如，在句子 “Ringle appreciates both positive and negative feedback from users” 中，feedback 後面沒有“s”。`,
        `最もよくあるミスは、不可算名詞の最後に「s」をつけることです。例えば、"feedback "という単語は、"s "をつけることで複数形になるように思えますが、これは誤りです。例えば、“Ringle appreciates both positive and negative feedback from users,” の文章内にある”feedback”の後に "s "はありません。`,
        `The most common mistake is adding an "s" at the end of an uncountable noun. For example, the word "feedback" seems like it may be changed to plural form by adding an "s," but this is incorrect. For instance, in “Ringle appreciates both positive and negative feedback from users,” there is no "s" after feedback.`,
      ],
      body3: [
        <>
          1. 틀리는 특정한 단어들이 있다면, 해당 단어들의 사용법만 추가적으로 익히시면 금방 가산/불가산 명사 문법 유형의
          정확도가 올라갈 것으로 기대됩니다. <br />
          <br />
          2. 이외에 추가적인 실수를 방지하기 위해 미리 불가산 명사에 대해 숙지하는것도 추천드립니다.
        </>,
        <>
          1. If you use certain words incorrectly, you'll be able to increase your accuracy for this type of mistakes
          quickly by learning how to use those words. <br />
          <br />
          2. To prevent additional mistakes, familiarize yourself with other uncountable nouns beforehand.
        </>,
        'n_caf.tip.highlight11.body3',
        <>
          1.如果你错误地使用了某些词，学习如何正确使用这些词可以快速提高你在这类错误上的准确性。
          <br />
          <br />
          2. 为了防止更多错误，提前熟悉其他不可数名词。
        </>,
        <>
          1.如果你錯誤地使用了某些詞，學習如何正確使用這些詞可以快速提高你在這類錯誤上的準確性。 <br />
          <br />
          2.為了防止更多錯誤，提前熟悉其他不可數名詞。
        </>,
        <>
          1.もし特定の単語の使用方法が誤っているのであれば、その単語の使用方法を覚えましょう。特定の単語のミスに対する精度を早く上げることができるようになります。
          <br />
          <br />
          2.さらなるミスを防ぐために、あらかじめ他の不可算名詞にも慣れておくことが大切です。
        </>,
        <>
          1. If you use certain words incorrectly, you'll be able to increase your accuracy for this type of mistakes
          quickly by learning how to use those words. <br />
          <br />
          2. To prevent additional mistakes, familiarize yourself with other uncountable nouns beforehand.
        </>,
      ],
    },
    highlight12: {
      title1: [
        `동사 시제 변화 문법 실수란?`,
        `What is "incorrect verb tense"?`,
        'n_caf.tip.highlight12.title1',
        `什麽是错误的动词时态？`,
        `什麼是錯誤的動詞時態？`,
        `Incorrect verb tenseとは何ですか？`,
        `What is "incorrect verb tense"?`,
      ],
      title2: [
        `실수하는 원인과 단점은?`,
        `Why do we make this mistake and why is it a problem?`,
        'n_caf.tip.highlight12.title2',
        `犯错的原因和造成的问题为何？`,
        `犯錯的原因和造成的問題為何？`,
        `Incorrect verb tenseを使用する原因とデメリットは何ですか？`,
        `Why do we make this mistake and why is it a problem?`,
      ],
      title3: [
        `어떻게 고쳐야하는지?`,
        `How can we avoid making mistakes?`,
        'n_caf.tip.highlight12.title3',
        `要如何避免犯错？`,
        `要如何避免犯錯？`,
        `どうすれば改善しますか？`,
        `How can we avoid making mistakes?`,
      ],
      body1: [
        `수동태를 사용할때, would/could의 조동사 및 동사의 과거형이 잘못 사용된 경우, 혹은 의미상 시제가 잘못된 경우를 동사 시제 문법 실수로 포착하고 있습니다. 예를 들어 “When I am eating food, I saw him”는 의미상 어색하여 “When I was eating food, I saw him.”이 되어야 합니다.`,
        `The incorrect use of "would/could" as an auxillary verb or the past tense of "will/can" and the wrong use of verb tenses semantically or in passive voice are detected by the AI Analysis engine as mistakes. For example, “When I am eating food, I saw him” is semantically awkward and should be “When I was eating food, I saw him.”`,
        'n_caf.tip.highlight12.body1',
        `AI 分析引擎会将「would/could」作为助动词或「will/can」的过去式使用不当，以及语意上或在被动语态中错误使用动词时态，识别为错误。例如，「When I am eating food, I saw him」在语意上不通顺，应该改为「When I was eating food, I saw him」。`,
        `AI 分析引擎會將「would/could」作為助動詞或「will/can」的過去式使用不當，以及語意上或在被動語態中錯誤使用動詞時態，識別為錯誤。例如，「When I am eating food, I saw him」在語意上不通順，應該改為「When I was eating food, I saw him」。`,
        `AI Analysis engineは、”would/could”をAuxillary verb（助動詞）として誤って使用したり、”will/can”の過去形として誤って使用したり、意味的にまたは受動態でVerb tense（動詞の時制）を誤って使用したりするミスを検出します。例えば、”When I am eating food, I saw him.”という文章は意味的に不自然であり、”When I was eating food, I saw him.”とする必要があります。`,
        `The incorrect use of "would/could" as an auxillary verb or the past tense of "will/can" and the wrong use of verb tenses semantically or in passive voice are detected by the AI Analysis engine as mistakes. For example, “When I am eating food, I saw him” is semantically awkward and should be “When I was eating food, I saw him.”`,
      ],
      body2: [
        <>
          시제가 바뀌면 듣는 원어민 입장에서 맥락이 뒤죽박죽이 되어 본래 뜻을 이해하기 굉장히 힘들어서 특히 주의가
          필요합니다.
          <br />
          <br />
          예를 들어 “너 감기 걸려본적 있어?”라고 물어보는것을 “Did you get a cold?”라고 말한다면 “과거 특정 시점에
          감기가 걸렸었니”의 의미로 전달됩니다.
        </>,
        <>
          Verb tense requires special attention because using the wrong tense can confuse the context and make it very
          difficult to grasp the intended meaning.
          <br />
          <br />
          For example, if you ask “Did you get a cold?” instead of “Have you ever caught a cold?,” you end up asking
          “Have you catch a cold at some point in the past?”
        </>,
        'n_caf.tip.highlight12.body2',
        <>
          动词时态需要特别注意，因为使用错误的时态可能会溷淆上下文，让人难以理解原本想要表达的意思。
          <br />
          <br />
          例如，如果你问「Did you get a cold?」而不是「Have you ever caught a
          cold?」，你实际上是在问「你曾经得过感冒吗？」（Have you catch a cold at some point in the
          past?），这样的问法可能会让人误解你是在询问对方过去某个特定时刻是否感冒过，而不是询问对方是否曾经有过感冒的经历。
        </>,
        <>
          動詞時態需要特別注意，因為使用錯誤的時態可能會混淆上下文，讓人難以理解原本想要表達的意思。
          <br />
          <br />
          例如，如果你問「Did you get a cold?」而不是「Have you ever caught a
          cold?」，你實際上是在問「你曾經得過感冒嗎？」（Have you catch a cold at some point in the
          past?），這樣的問法可能會讓人誤解你是在詢問對方過去某個特定時刻是否感冒過，而不是詢問對方是否曾經有過感冒的經歷。
        </>,
        <>
          Verb
          tense（動詞の時制）は特に注意が必要です。誤った時制を使うと文脈が混乱し、意図した意味を把握するのが非常に難しくなるからです。
          <br />
          <br />
          例えば、"Have you ever caught a cold? "ではなく、"Did you get a cold? "と尋ねると、"Have you catch a cold at
          some point in the past?"という意味になってしまいます。
        </>,
        <>
          Verb tense requires special attention because using the wrong tense can confuse the context and make it very
          difficult to grasp the intended meaning.
          <br />
          <br />
          For example, if you ask “Did you get a cold?” instead of “Have you ever caught a cold?,” you end up asking
          “Have you catch a cold at some point in the past?”
        </>,
      ],
      body3: [
        `동사 시제 실수는 범위기 넓기에 세부 유형에서 어떤것들을 자주 틀리는지 확인하고, 하나하나가 명확하게 어떻게 쓰여야하는지 체크하는것을 추천드립니다.`,
        `There are various types of verb tense mistakes, so you should check which types you misuse often and learn the correct verb tense for each case.`,
        'n_caf.tip.highlight12.body3',
        `动词时态的错误有多种类型，请确认经常犯错的类型，并针对错误学习正确的动词时态使用。`,
        `動詞時態的錯誤有多種類型，請確認經常犯錯的類型，並針對錯誤學習正確的動詞時態使用。`,
        `Verb tense（動詞の時制）のミスには様々な種類があるので、よく誤用するVerb tense（動詞の時制）をチェックし、それぞれの場合に正しいVerb tense（動詞の時制）を学びましょう。`,
        `There are various types of verb tense mistakes, so you should check which types you misuse often and learn the correct verb tense for each case.`,
      ],
    },
    highlight17: {
      title1: [
        `단문이란?`,
        `What is a simple sentence?`,
        'n_caf.tip.highlight17.title1',
        `什麽是简单句(simple sentence)?`,
        `什麼是簡單句(simple sentence)?`,
        `Simple sentenceとは何ですか?`,
        `What is a simple sentence?`,
      ],
      title2: [
        `중문이란?`,
        `What is a compound sentence?`,
        'n_caf.tip.highlight17.title2',
        `什麽是并列句(compund sentence)？`,
        `什麼是並列句(compund sentence)？`,
        `Compound sentenceとは何ですか?`,
        `What is a compound sentence?`,
      ],
      title3: [
        `복잡한 문장 구조(복문)란?`,
        `What is a complex sentence?`,
        'n_caf.tip.highlight17.title3',
        `什麽是複杂句(complex sentence)？`,
        `什麼是複雜句(complex sentence)？`,
        `Complex sentenceとは何ですか?`,
        `What is a complex sentence?`,
      ],
      title4: [
        `복잡한 문장 구조를 사용해야 하는 이유는?`,
        `Why should we use complex sentences?`,
        'n_caf.tip.highlight17.title4',
        `为什麽要用複杂句(complex sentence)？`,
        `為什麼要用複雜句(complex sentence)？`,
        `なぜComplex sentencesを使用する必要があるのでしょうか?`,
        `Why should we use complex sentences?`,
      ],
      title5: [
        `복잡한 문장 구조를 사용하는 방법은?`,
        `How can we learn how to use complex sentences?`,
        'n_caf.tip.highlight17.title5',
        `如何学习使用複杂句(complex sentence)？`,
        `如何學習使用複雜句(complex sentence)？`,
        `Complex sentencesの使用方法について、どのように学べばよいのでしょうか?`,
        `How can we learn how to use complex sentences?`,
      ],
      body1: [
        `단문은 주어와 동사가 하나씩만 사용된 문장을 의미합니다.`,
        `A simple sentence has one subject and one verb.`,
        'n_caf.tip.highlight17.body1',
        `一个简单句包含一个主词一个动词`,
        `一個簡單句包含一個主詞一個動詞`,
        `Simple sentence（単文）には主語と動詞がひとつずつあります。`,
        `A simple sentence has one subject and one verb.`,
      ],
      body2: [
        `중문은 두 개의 단문이 접속사로 연결된 문장을 의미합니다.`,
        `A compound sentence connects two clauses using a conjunction.`,
        'n_caf.tip.highlight17.body2',
        `複合句由两个或多个 独立子句 组成，这些子句可以各自独立成句，但在複合句中，它们通常通过连接词（例如：「和」、「但」、「或」等）或分号来连接，从而在表达上形成一个整体。`,
        `複合句由兩個或多個 獨立子句 組成，這些子句可以各自獨立成句，但在複合句中，它們通常通過連接詞（例如：「和」、「但」、「或」等）或分號來連接，從而在表達上形成一個整體。`,
        `Compound sentence（重文）は、接続詞を使って2つの節をつなぎます。`,
        `A compound sentence connects two clauses using a conjunction.`,
      ],
      body3: [
        `종속접속사로 연결된 종속절을 포함하는 문장을 복문이라고 합니다.`,
        `A complex sentence includes a dependent clause that is connected by a subordinating conjunction.`,
        'n_caf.tip.highlight17.body3',
        `複杂句是由一个 独立子句（能够独立成句的子句）和一个或多个 从属子句（不能单独成句，需依赖主句的子句）组成的句子。`,
        `複雜句是由一個 獨立子句（能夠獨立成句的子句）和一個或多個 從屬子句（不能單獨成句，需依賴主句的子句）組成的句子。`,
        `Complex sentence（複文）には従属節が含まれており、これは従属接続詞によって接続されています。`,
        `A complex sentence includes a dependent clause that is connected by a subordinating conjunction.`,
      ],
      body4: [
        `모든 발화에서 복문을 사용하는 것이 좋은 말하기 습관인 것은 아닙니다. 단, 복문으로 표현할 수 있는 상황에서 단문이나 중문을 자주 사용할 경우 한 문장 내의 복잡하고 다양한 생각을 전달하기 어려울 수 있습니다. 또한 단문이나 중문은 문장 간의 관계를 나타내는 데 제한이 있어 표현이 단조롭고 끊기는 듯한 느낌을 줄 수 있습니다. 따라서 상황과 표현에 따라 적절하게 복문을 사용할 수 있도록 학습해야 합니다.`,
        `It's not necessarily a good habit to use complex sentences every time. However, sticking to simple or compound sentences can make your speech sound monotonous and disjointed as they can limit the expression of complex ideas or the relationships between sentences. So, it is important to learn how to use complex sentences appropriately.`,
        'n_caf.tip.highlight17.body4',
        `每次都使用複杂句不一定是个好习惯。但是，拘泥于简单子或并列句会让您的说话听起来单调、不连贯，因为它们会限制複杂想法或句子之间关係的表达。因此，学习如何适当地使用複杂句是非常重要的。`,
        `每次都使用複雜句不一定是個好習慣。但是，拘泥於簡單子或並列句會讓您的說話聽起來單調、不連貫，因為它們會限制複雜想法或句子之間關係的表達。因此，學習如何適當地使用複雜句是非常重要的。`,
        `Complex sentence（複文）を毎回使うことは必ずしも良い習慣ではありません。しかし、Simple sentence（単文）やCompound sentence（重文）に固執すると、複雑なアイデアや文と文の関係性の表現が制限され、単調でまとまりのない話し方に聞こえてしまうことがあります。そのため、Complex sentence（複文）の適切な使用方法を方法を学ぶことが大切です。`,
        `It's not necessarily a good habit to use complex sentences every time. However, sticking to simple or compound sentences can make your speech sound monotonous and disjointed as they can limit the expression of complex ideas or the relationships between sentences. So, it is important to learn how to use complex sentences appropriately.`,
      ],
      body5: [
        `1. 단문을 복문으로 전환하는 방법에는 부사절, 관계절, 명사절 사용이 있습니다. 각각이 언제, 어떻게 사용되는 지 공부하는 것이 가장 큰 도움이 됩니다.
    - 부사절 : I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - 관계절 : I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - 명사절 : I know what the answer is.
2. AI가 교정한 문장들을 보면서 반복해서 말하는 연습을 해보며 익숙해지도록 만들어보세요.`,
        `1. You can use an adverb/relative/noun clause to change a simple sentence into a complex one. It helps to learn when and how each of these clauses are used. 
    - Adverb clause: I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - Relative clause: I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - Noun clause: I know what the answer is.
2. Try to familiarize yourself with complex sentences by reading the AI-proofread sentences out loud many times.`,
        'n_caf.tip.highlight17.body5',
        `1. 您可以使用副词/关係词/名词子句将一个简单的句子变为複杂的句子。学习使用这些词的时机和方法会有帮助。
    - 副词子句： I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
（那部电影我看了两遍。那部电影是我的最爱。→ 我看了那部电影两次，因为那部电影是我的最爱。）
    - 相对子句： I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
（我昨天买了一本书。这本书的作者是个名人。→ 我昨天买了一本书，它的作者是一位名人。）
    - 名词子句： I know what the answer is.
2. 尝试多次大声朗读 AI修正的句子以熟悉複杂的句子。`,
        `1. 您可以使用副詞/關係詞/名詞子句將一個簡單的句子變為複雜的句子。學習使用這些詞的時機和方法會有幫助。
    - 副詞子句： I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
（那部電影我看了兩遍。那部電影是我的最愛。→ 我看了那部電影兩次，因為那部電影是我的最愛。）
    - 相對子句： I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
（我昨天買了一本書。這本書的作者是個名人。→ 我昨天買了一本書，它的作者是一位名人。）
    - 名詞子句： I know what the answer is.
2. 嘗試多次大聲朗讀 AI修正的句子以熟悉複雜的句子。`,
        `1.Adverb（副詞）／Relative（関係詞）／Noun clause（名詞節）を使用すると、Simple sentence（単文）をComplex sentence（複文）に変えることができます。それぞれの節がいつ、どのように使用されるかを学ぶことが役立ちます。
  - Adverb clause（副詞節）： I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
  - Relative clause（関係詞節）：I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
  - Noun clause（名詞節）： I know what the answer is.
 2. AIが校正した文章を何度も声に出して読み、Complex sentence（複文）に慣れるようにしましょう。`,
        `1. You can use an adverb/relative/noun clause to change a simple sentence into a complex one. It helps to learn when and how each of these clauses are used. 
    - Adverb clause: I watched that movie twice. That movie is my favorite. → I watched that movie twice because that movies is my favorite.
    - Relative clause: I bought a book yesterday. The author of the book is a famous person. → I bought a book yesterday, whose author is a famous person.
    - Noun clause: I know what the answer is.
2. Try to familiarize yourself with complex sentences by reading the AI-proofread sentences out loud many times.`,
      ],
    },
  },
  complexity: {
    default: [`Complexity`, `Complexity`, 'n_caf.complexity.default', `複杂度`, `複雜度`, `Complexity`, `Complexity`],
    level_score: [`Level`, `Level`, 'n_caf.complexity.level_score', `Level`, `Level`, `Level`, `Level`],
    percent: (percent) => [
      `상위 ${percent}%`,
      `Upper ${percent}% / Top`,
      'n_caf.complexity.percent',
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Upper ${percent}% / Top`,
    ],
    level_detail: [
      `9가지 중 하나!`,
      `Out of 9 types!`,
      'n_caf.complexity.level_detail',
      `9种中的一种!`,
      `9種中的一種!`,
      `9種類の中から1つ!`,
      `Out of 9 types!`,
    ],
    tab1: [
      `어휘 난이도`,
      `Vocabulary level`,
      'n_caf.complexity.tab1',
      `单字等级`,
      `單字等級`,
      `Vocabulary level（語彙力）`,
      `Vocabulary level`,
    ],
    tab2: [
      `문장 구조`,
      `Sentence structure`,
      'n_caf.complexity.tab2',
      `句子结构`,
      `句子結構`,
      `Sentence structure（文章の構造）`,
      `Sentence structure`,
    ],
    tab3: [
      `어휘 다양성`,
      `Lexical diversity`,
      'n_caf.complexity.tab3',
      `语彙多样性`,
      `語彙多樣性`,
      `Lexical diversity（語彙の多様性）`,
      `Lexical diversity`,
    ],
    graph_name1: [
      `어휘 사용률`,
      `Word usage rate`,
      'n_caf.complexity.graph_name1',
      `语彙使用率`,
      `語彙使用率`,
      `単語の使用率`,
      `Word usage rate`,
    ],
    graph_name2: [
      `문장 사용률`,
      `Sentence usage rate`,
      'n_caf.complexity.graph_name2',
      `句型使用率`,
      `句型使用率`,
      `文章の使用率`,
      `Sentence usage rate`,
    ],
    highlights: [
      `Complexity 관련 학습 영역`,
      `Areas related to Complexity`,
      'n_caf.complexity.highlights',
      `和複杂度有关的学习领域`,
      `和複雜度有關的學習領域`,
      `Complexityに関連する分野`,
      `Areas related to Complexity`,
    ],
    highlights_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the AI analysis.`,
      'n_caf.complexity.highlights_detail',
      `根据AI分析报告推荐的重点学习领域`,
      `根據AI分析報告推薦的重點學習領域`,
      `AI analysisに基づいた、今後の学習で重点的に取り組むべき分野です。`,
      `Recommended focus areas for learning based on the AI analysis.`,
    ],
    vocab_info: [
      `최대 15개의 단어가 표시됩니다.`,
      `Shows the top 15 most frequently used words.`,
      'n_caf.complexity.vocab_info',
      `最多标示15个单字`,
      `最多標示15個單字`,
      `最も頻繁に使用された上位15件の単語を表示します。`,
      `Shows the top 15 most frequently used words.`,
    ],
    vocab_info1: (count) => [
      `총 ${count} 단어가 표시됩니다.`,
      `Shows a total of ${count} words.`,
      'n_caf.complexity.vocab_info1',
      `总共 ${count}个单字`,
      `總共 ${count}個單字`,
      `合計${count}語を表示します。`,
      `Shows a total of ${count} words.`,
    ],
    viewmore_btn: [`더보기`, `See more`, 'n_caf.complexity.viewmore_btn', `看更多`, `看更多`, `もっと見る`, `See more`],
    subsection_info: (count) => [
      <span>
        총 <span className="text-primary">{count}</span>개의 단어
      </span>,
      <span>
        A total of <span className="text-primary">{count}</span> words{' '}
      </span>,
      'n_caf.complexity.subsection_info',
      <span>
        总共<span className="text-primary">{count}</span>个单字
      </span>,
      <span>
        總共<span className="text-primary">{count}</span>個單字
      </span>,
      <span>
        合計<span className="text-primary">{count}</span>語{' '}
      </span>,
      <span>
        A total of <span className="text-primary">{count}</span> words{' '}
      </span>,
    ],
    sentence_info: [
      `최대 5개의 문장이 표시됩니다.`,
      `Shows up to 5 sentences.`,
      'n_caf.complexity.sentence_info',
      `最多标示5个句子`,
      `最多標示5個句子`,
      `最大5つのセンテンスが表示されます。`,
      `Shows up to 5 sentences.`,
    ],
    subsection_info2: (count) => [
      `총 ${count}개의 문장`,
      `A total of ${count} sentences`,
      'n_caf.complexity.subsection_info2',
      `总共f ${count} 个句子`,
      `總共f ${count} 個句子`,
      `合計${count}文`,
      `A total of ${count} sentences`,
    ],
    sentence_info1: (count) => [
      `총 ${count}개의 문장이 표시됩니다.`,
      `Shows a total of ${count} sentences.`,
      'n_caf.complexity.sentence_info1',
      `总共标示 ${count}个句子`,
      `總共標示 ${count}個句子`,
      `合計${count}文を表示します。`,
      `Shows a total of ${count} sentences.`,
    ],
    mtld: [
      `Measure of Textual Lexical Diversity (MTLD)`,
      `Measure of Textual Lexical Diversity (MTLD)`,
      'n_caf.complexity.mtld',
      `文本词彙多样性衡量标准(MTLD)`,
      `文本詞彙多樣性衡量標準(MTLD)`,
      `Measure of Textual Lexical Diversity (MTLD)`,
      `Measure of Textual Lexical Diversity (MTLD)`,
    ],
    my_mtld: [
      `이번 수업`,
      `This lesson`,
      'n_caf.complexity.my_mtld',
      `本次课程`,
      `本次課程`,
      `This lesson`,
      `This lesson`,
    ],
    percent_mtld: [
      `상위 25% 평균`,
      `Top 25%`,
      'n_caf.complexity.percent_mtld',
      `Top 25%`,
      `Top 25%`,
      `Top 25%`,
      `Top 25%`,
    ],
    tutor_mtld: [
      `원어민 평균`,
      `Native Speakers`,
      'n_caf.complexity.tutor_mtld',
      `母语人士`,
      `母語人士`,
      `Native Speakers`,
      `Native Speakers`,
    ],
    mtld_modal_title: [
      `어휘 다양성`,
      `Lexical diversity`,
      'n_caf.complexity.mtld_modal_title',
      `语彙多样性`,
      `語彙多樣性`,
      `Lexical diversity（語彙の多様性）`,
      `Lexical diversity`,
    ],
    mtld_modal_body: [
      `어휘 다양성을 보여주는 Measure of Textual Lexical Diversity (MTLD) 을 측정한 지표입니다. 
MTLD란, TTR 값(Type-token ratio: 전체 단어 개수에 대한 중복을 제외한 단어 개수의 비율)을 특정 기준이상으로 유지하며 말 할 수 있는 단어 개수의 평균입니다.`,
      `Indicator measuring the Measure of Textual Lexical Diversity (MTLD), which shows the diversity of your vocabulary. MTLD is measured as the avg. number of words you speak while maintaining TTR above a certain level. (Type-token ratio (TTR): the total number of unique words divided by the total number of words)`,
      'n_caf.complexity.mtld_modal_body',
      `衡量文本词彙多样性（MTLD）的指标，显示您词彙的多样性。MTLD 的衡量标准是，在保持 TTR 高于一定水平的情况下，您说话的平均单字数。(类型-单字比（TTR)：独特单字总数除以单字总数）`,
      `衡量文本詞彙多樣性（MTLD）的指標，顯示您詞彙的多樣性。MTLD 的衡量標準是，在保持 TTR 高於一定水平的情況下，您說話的平均單字數。(類型-單字比（TTR)：獨特單字總數除以單字總數）`,
      `Lexical diversityを示すMTLD（Measure of Textual Lexical Diversity）は、TTRを一定以上に保ちながら話す単語の平均数として測定されます。(Type-token ratio（TTR）：ユニークな単語の総数を単語の総数で割ったもの）`,
      `Indicator measuring the Measure of Textual Lexical Diversity (MTLD), which shows the diversity of your vocabulary. MTLD is measured as the avg. number of words you speak while maintaining TTR above a certain level. (Type-token ratio (TTR): the total number of unique words divided by the total number of words)`,
    ],
    mtld_modal_btn: [`확인`, `OK`, 'n_caf.complexity.mtld_modal_btn', `OK`, `OK`, `OK`, `OK`],
    vocab_detail: [
      `*어휘 유형은 CEFR 척도를 기반으로 분류되었습니다.`,
      `*Vocabulary types are classified based on the CEFR's English Vocabulary Profile.`,
      'n_caf.complexity.vocab_detail',
      `*词彙类型根据 CEFR 的英文词彙库进行分类。`,
      `*詞彙類型根據 CEFR 的英文詞彙庫進行分類。`,
      `*Vocabulary typeはCEFRのEnglish Vocabulary Profileに基づいて分類されています。`,
      `*Vocabulary types are classified based on the CEFR's English Vocabulary Profile.`,
    ],
    pos: {
      adjective: [
        `형용사`,
        `Adjective`,
        'n_caf.complexity.pos.adjective',
        `形容词(Adjective)`,
        `形容詞(Adjective)`,
        `Adjective（形容詞）`,
        `Adjective`,
      ],
      adverb: [
        `부사`,
        `Adverb`,
        'n_caf.complexity.pos.adverb',
        `副词(Adverb）`,
        `副詞(Adverb）`,
        `Adverb（副詞）`,
        `Adverb`,
      ],
      conjunction: [
        `접속사`,
        `Conjunction`,
        'n_caf.complexity.pos.conjunction',
        `连接词(Conjunction)`,
        `連接詞(Conjunction)`,
        `Conjunction（接続詞）`,
        `Conjunction`,
      ],
      determiner: [
        `한정사`,
        `Determiner`,
        'n_caf.complexity.pos.determiner',
        `冠词(determiners）`,
        `冠詞(determiners）`,
        `Determiner（限定詞）`,
        `Determiner`,
      ],
      noun: [`명사`, `Noun`, 'n_caf.complexity.pos.noun', `名词(Noun)`, `名詞(Noun)`, `Noun（名詞）`, `Noun`],
      numeral: [
        `수사`,
        `Numeral`,
        'n_caf.complexity.pos.numeral',
        `数词(Numeral)`,
        `數詞(Numeral)`,
        `Numeral（数詞）`,
        `Numeral`,
      ],
      particle: [
        `불변화사`,
        `Particle`,
        'n_caf.complexity.pos.particle',
        `助词(Particle)`,
        `助詞(Particle)`,
        `Particle（助詞）`,
        `Particle`,
      ],
      pronoun: [
        `대명사`,
        `Pronoun`,
        'n_caf.complexity.pos.pronoun',
        `代名词(Pronoun)`,
        `代名詞(Pronoun)`,
        `Pronoun（代名詞）`,
        `Pronoun`,
      ],
      verb: [`동사`, `Verb`, 'n_caf.complexity.pos.verb', `动词(Verb)`, `動詞(Verb)`, `Verb（動詞）`, `Verb`],
      auxiliary: [
        `조동사`,
        `Auxiliary Verb`,
        'n_caf.complexity.pos.auxiliary',
        `助动词(Auxiliary Verb)`,
        `助動詞(Auxiliary Verb)`,
        `Auxiliary Verb（助動詞）`,
        `Auxiliary Verb`,
      ],
    },
    caf_level9: [
      `9 레벨을 받은 대부분 사람은 모든 주제에 대해 유연하고 정확한 어휘를 사용하며 관용적인 표현을 자연스럽게 사용합니다.`,
      `Lv. 9 denotes that you use flexible and precise vocabulary for all topics and apply idiomatic expressions suitably.`,
      'n_caf.complexity.caf_level9',
      `Lv.9 表示在所有话题都能灵活、准确地使用词彙和片语。`,
      `Lv.9 表示在所有話題都能靈活、準確地使用詞彙和片語。`,
      `Lv.9は、あらゆるトピックに柔軟かつ正確な語彙を使用し、慣用表現を適切に適用することを示しています。`,
      `Lv. 9 denotes that you use flexible and precise vocabulary for all topics and apply idiomatic expressions suitably.`,
    ],
    caf_level8: [
      `8 레벨을 받은 대부분 사람은 다양한 단어를 쉽고 유연하게 사용하여 정확한 의미를 전달합니다. 고급 어휘를 능숙하게 사용하지만, 가끔 부정확할 수 있습니다.`,
      `Lv. 8 denotes that you use a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
      'n_caf.complexity.caf_level8',
      `Lv.8 表示能轻鬆灵活地使用各种词彙，包括高级词彙，精确表达想法，但偶尔会有不准确的情况。`,
      `Lv.8 表示能輕鬆靈活地使用各種詞彙，包括高級詞彙，精確表達想法，但偶爾會有不準確的情況。`,
      `Lv.8は、高度な語彙を含むさまざまな単語を簡単かつ柔軟に使いこなし、正確な意味を伝えることができますが、時折正確さに欠けることを示しています。`,
      `Lv. 8 denotes that you use a variety of words, including advanced vocabulary, easily and flexibly to convey precise meaning, but can be inaccurate every now and then.`,
    ],
    caf_level7: [
      `7 레벨을 받은 대부분 사람은 다양한 주제를 논의하기 위해 유연하게 어휘를 사용합니다. 몇몇 고급 어휘를 사용할 수 있고 반복되는 단어를 대체할 수 있습니다.`,
      `Lv. 7 denotes that you employ vocabulary flexibly when discussing different topics, including some advanced vocabulary, and know how to substitute repetitive words.`,
      'n_caf.complexity.caf_level7',
      `Lv.7 表示在讨论不同话题时能灵活运用词汇，包括一些高级词汇，并知道如何替换重复的词汇。`,
      `Lv.7 表示在討論不同話題時能靈活運用詞匯，包括一些高級詞匯，並知道如何替換重覆的詞匯。`,
      `Lv.7は、異なるトピックについて話し合う際に、高度な語彙も含めて柔軟に語彙を使いこなし、繰り返し使われる単語をどのように置き換えるかを知っていることを示しています。`,
      `Lv. 7 denotes that you employ vocabulary flexibly when discussing different topics, including some advanced vocabulary, and know how to substitute repetitive words.`,
    ],
    caf_level6: [
      `6 레벨을 받은 대부분 사람은 대부분의 주제에 대해 명확하고 충분한 어휘력으로 의사소통할 수 있습니다. 하지만 때로는 부적절한 선택이 있을 수 있습니다.`,
      `Lv. 6 denotes that you can communicate precisely on most topics using sufficient vocabulary, but your word choice can be inappropriate at times.`,
      'n_caf.complexity.caf_level6',
      `Lv.6 表示能使用足够的词彙在大多数话题进行准确的交流，但有时用词不精确。`,
      `Lv.6 表示能使用足夠的詞彙在大多數話題進行準確的交流，但有時用詞不精確。`,
      `Lv.6は、十分な語彙を用いて、ほとんどのトピックについて正確にコミュニケーションできますが、時には語の選択が不適切であることを示しています。`,
      `Lv. 6 denotes that you can communicate precisely on most topics using sufficient vocabulary, but your word choice can be inappropriate at times.`,
    ],
    caf_level5: [
      `5 레벨을 받은 대부분 사람은 익숙하지 않은 주제에 관해서도 이야기할 수 있지만, 제한된 어휘를 사용합니다.`,
      `Lv. 5 denotes that you can converse freely even on unfamiliar topics but with a limited vocabulary.`,
      'n_caf.complexity.caf_level5',
      `Lv.5 表示即使是不熟悉的话题仍可自由交谈，但使用的词彙量有限。`,
      `Lv.5 表示即使是不熟悉的話題仍可自由交談，但使用的詞彙量有限。`,
      `Lv.5は、未知の話題でも自由に会話ができますが、語彙が限られていることを示しています。`,
      `Lv. 5 denotes that you can converse freely even on unfamiliar topics but with a limited vocabulary.`,
    ],
    caf_level4: [
      `4 레벨을 받은 대부분 사람은 익숙한 주제에 대해 잘 논의할 수 있지만, 익숙하지 않은 주제일 경우 기본적인 의미만 전달하며, 단어 선택에 실수가 있을 수 있습니다.`,
      `Lv. 4 denotes that you can discuss familiar topics well but are able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
      'n_caf.complexity.caf_level4',
      `Lv.4 表示能无碍地讨论熟悉的话题，但对于不熟悉的话题只能表达基本观点，而且可能会在用词上出现错误。`,
      `Lv.4 表示能無礙地討論熟悉的話題，但對於不熟悉的話題只能表達基本觀點，而且可能會在用詞上出現錯誤。`,
      `Lv.4は、身近な話題についてはよく議論できますが、未知の話題については基本的な考えしか伝えられず、言葉の選択を誤ってしまう可能性があることを示しています。`,
      `Lv. 4 denotes that you can discuss familiar topics well but are able to convey only basic ideas on unfamiliar topics and may make mistakes in word choice.`,
    ],
    caf_level3: [
      `3 레벨을 받은 대부분 사람은 개인적인 정보를 전달하기 위해 간단한 단어를 사용하며, 덜 친숙한 주제에 대해서는 적절한 어휘 선택에 어려움이 있을 수 있습니다.`,
      `Lv. 3 denotes that you use simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
      'n_caf.complexity.caf_level3',
      `Lv.3 表示能使用简单的词语来表达个人信息，但在谈论不太熟悉的话题时可能难以使用适当的词彙。`,
      `Lv.3 表示能使用簡單的詞語來表達個人信息，但在談論不太熟悉的話題時可能難以使用適當的詞彙。`,
      `Lv.3は、個人的な情報を伝えるのに単純な言葉を使用し、馴染みの薄いトピックについて話す際に適切な語彙を使うのに苦労することを示しています。`,
      `Lv. 3 denotes that you use simple words to convey personal information and may have difficulty using appropriate vocabulary when talking about less familiar topics.`,
    ],
    caf_level2: [
      `2 레벨을 받은 대부분 사람은 제한된 단어만 사용하며, 기억한 단어에 의존합니다.`,
      `Lv. 2 denotes that you use only a limited number of words, relying on words you memorized.`,
      'n_caf.complexity.caf_level2',
      `Lv.2 表示只能使用有限的词彙，依赖记忆的词彙。`,
      `Lv.2 表示只能使用有限的詞彙，依賴記憶的詞彙。`,
      `Lv.2は、覚えた単語に頼り、わずかな言葉しか使用しないことを示しています。`,
      `Lv. 2 denotes that you use only a limited number of words, relying on words you memorized.`,
    ],
    caf_level1: [
      `1 레벨을 받은 대부분 사람은 제한된 몇 가지 단어만 사용합니다.`,
      `Lv. 1 denotes that you only use a limited number of words.`,
      'n_caf.complexity.caf_level1',
      `Lv.1 表示只能使用有限的词彙。`,
      `Lv.1 表示只能使用有限的詞彙。`,
      `Lv.1は、限られた数の単語しか使用しないことを示しています。`,
      `Lv. 1 denotes that you only use a limited number of words.`,
    ],
    metric: [
      `이번 수업의 Complexity`,
      `This Lesson's Complexity`,
      'n_caf.complexity.metric',
      `本堂课的複杂度`,
      `本堂課的複雜度`,
      `This Lesson's Complexity（複雑さ）`,
      `This Lesson's Complexity`,
    ],
    vocab_advanced: [
      `고급 (Advanced)`,
      `Advanced (A)`,
      'n_caf.complexity.vocab_advanced',
      `Advanced (A)`,
      `Advanced (A)`,
      `Advanced (A)`,
      `Advanced (A)`,
    ],
    vocab_high: [
      `중고급 (High Intermediate)`,
      `High Intermediate (HI)`,
      'n_caf.complexity.vocab_high',
      `High Intermediate (HI)`,
      `High Intermediate (HI)`,
      `High Intermediate (HI)`,
      `High Intermediate (HI)`,
    ],
    vocab_inter: [
      `중급 (Intermediate)`,
      `Intermediate (I)`,
      'n_caf.complexity.vocab_inter',
      `Intermediate (I)`,
      `Intermediate (I)`,
      `Intermediate (I)`,
      `Intermediate (I)`,
    ],
    vocab_low: [
      `중하급 (Low Intermediate)`,
      `Low Intermediate (LI)`,
      'n_caf.complexity.vocab_low',
      `Low Intermediate (LI)`,
      `Low Intermediate (LI)`,
      `Low Intermediate (LI)`,
      `Low Intermediate (LI)`,
    ],
    vocab_beginner: [
      `초급 (Beginner)`,
      `Beginner (B)`,
      'n_caf.complexity.vocab_beginner',
      `Beginner (B)`,
      `Beginner (B)`,
      `Beginner (B)`,
      `Beginner (B)`,
    ],
    graph_advanced: [`고급`, `A`, 'n_caf.complexity.graph_advanced', `A`, `A`, `A`, `A`],
    graph_high: [`중고급`, `HI`, 'n_caf.complexity.graph_high', `HI`, `HI`, `HI`, `HI`],
    graph_inter: [`중급`, `I`, 'n_caf.complexity.graph_inter', `I`, `I`, `I`, `I`],
    graph_low: [`중하급`, `LI`, 'n_caf.complexity.graph_low', `LI`, `LI`, `LI`, `LI`],
    graph_beginner: [`초급`, `B`, 'n_caf.complexity.graph_beginner', `B`, `B`, `B`, `B`],
    sentence_cc: [
      `혼합문 (Compound-complex)`,
      `Compound-complex (CC)`,
      'n_caf.complexity.sentence_cc',
      `Compound-complex (CC)`,
      `Compound-complex (CC)`,
      `Compound-complex (CC)`,
      `Compound-complex (CC)`,
    ],
    sentence_complex: [
      `복문 (Complex)`,
      `Complex (CX)`,
      'n_caf.complexity.sentence_complex',
      `Complex (CX)`,
      `Complex (CX)`,
      `Complex (CX)`,
      `Complex (CX)`,
    ],
    sentence_compound: [
      `중문 (Compound)`,
      `Compound (CD)`,
      'n_caf.complexity.sentence_compound',
      `Compound (CD)`,
      `Compound (CD)`,
      `Compound (CD)`,
      `Compound (CD)`,
    ],
    sentence_simple: [
      `단문 (Simple)`,
      `Simple (S)`,
      'n_caf.complexity.sentence_simple',
      `Simple (S)`,
      `Simple (S)`,
      `Simple (S)`,
      `Simple (S)`,
    ],
    sentence_other: [
      `비문 (Not a Sentence)`,
      `Not a Sentence (NaS)`,
      'n_caf.complexity.sentence_other',
      `Not a Sentence (NaS)`,
      `Not a Sentence (NaS)`,
      `Not a Sentence (NaS)`,
      `Not a Sentence (NaS)`,
    ],
    graph_cc: [`혼합문`, `CC`, 'n_caf.complexity.graph_cc', `CC`, `CC`, `CC`, `CC`],
    graph_complex: [`복문`, `CX`, 'n_caf.complexity.graph_complex', `CX`, `CX`, `CX`, `CX`],
    graph_compound: [`중문`, `CD`, 'n_caf.complexity.graph_compound', `CD`, `CD`, `CD`, `CD`],
    graph_simple: [`단문`, `S`, 'n_caf.complexity.graph_simple', `S`, `S`, `S`, `S`],
    graph_other: [`비문`, `NaS`, 'n_caf.complexity.graph_other', `NaS`, `NaS`, `NaS`, `NaS`],
    top25: [`상위 25%`, `Top 25%`, 'n_caf.complexity.top25', `Top 25%`, `Top 25%`, `Top 25%`, `Top 25%`],
    native: [
      `원어민`,
      `Native speaker`,
      'n_caf.complexity.native',
      `母语人士`,
      `母語人士`,
      `Native speaker`,
      `Native speaker`,
    ],
  },
  accuracy: {
    default: [`Accuracy`, `Accuracy`, 'n_caf.accuracy.default', `准确度`, `準確度`, `Accuracy`, `Accuracy`],
    level_score: [`Level`, `Level`, 'n_caf.accuracy.level_score', `Level`, `Level`, `Level`, `Level`],
    percent: (percent) => [
      `상위 ${percent}%`,
      `Top ${percent}%`,
      'n_caf.accuracy.percent',
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
    ],
    level_detail: [
      `9가지 중 하나!`,
      `Out of 9 types!`,
      'n_caf.accuracy.level_detail',
      `9种中的一种!`,
      `9種中的一種!`,
      `9種類の中から1つ!`,
      `Out of 9 types!`,
    ],
    my_epc: [`나의 EPC`, `My EPC`, 'n_caf.accuracy.my_epc', `My EPC`, `My EPC`, `My EPC`, `My EPC`],
    top_25_epc: [`상위 25% EPC`, `Top 25%`, 'n_caf.accuracy.top_25_epc', `Top 25%`, `Top 25%`, `Top 25%`, `Top 25%`],
    tutor_epc: [
      `원어민 EPC`,
      `Native speaker`,
      'n_caf.accuracy.tutor_epc',
      `母语人士`,
      `母語人士`,
      `Native speaker`,
      `Native speaker`,
    ],
    modal_title: [`EPC`, `EPC`, 'n_caf.accuracy.modal_title', `EPC`, `EPC`, `EPC`, `EPC`],
    modal_body: [
      `EPC (Error Per Clause): 문장의 문법적 오류 빈도
한 절에 오류가 하나일때 EPC는 1.0입니다.`,
      `Error Per Clause (EPC): Frequency of grammar mistakes in a sentence
EPC is 1.0 when one mistake was made per clause.`,
      'n_caf.accuracy.modal_body',
      `"每个子句的错误（EPC）： 句子中文法错误的频率
当每个子句出现一个错误时，EPC 为 1.0"。`,
      `"每個子句的錯誤（EPC）： 句子中文法錯誤的頻率
當每個子句出現一個錯誤時，EPC 為 1.0"。`,
      `Error Per Clause (EPC)： 文中の文法のミスの頻度
 EPCは1つの文章に1つのミスがあった場合、1.0となります。`,
      `Error Per Clause (EPC): Frequency of grammar mistakes in a sentence
EPC is 1.0 when one mistake was made per clause.`,
    ],
    modal_btn: [`확인`, `OK`, 'n_caf.accuracy.modal_btn', `OK`, `OK`, `OK`, `OK`],
    grammarerror_type: [
      `진단한 문법 유형`,
      `Grammar Analysis`,
      'n_caf.accuracy.grammarerror_type',
      `文法分析(Grammar Analysis)`,
      `文法分析(Grammar Analysis)`,
      `Grammar Analysis`,
      `Grammar Analysis`,
    ],
    error_type1: [
      `한정사`,
      `Determiner`,
      'n_caf.accuracy.error_type1',
      `冠词(determiners）`,
      `冠詞(determiners）`,
      `Determiner（限定詞）`,
      `Determiner`,
    ],
    error_type2: [
      `불변화사`,
      `Particle`,
      'n_caf.accuracy.error_type2',
      `助词(particles）`,
      `助詞(particles）`,
      `Particle（助詞）`,
      `Particle`,
    ],
    error_type3: [
      `전치사`,
      `Preposition`,
      'n_caf.accuracy.error_type3',
      `介词(prepositions)`,
      `介系詞(prepositions)`,
      `Preposition（前置詞）`,
      `Preposition`,
    ],
    error_type4: [
      `동사 형태`,
      `Verb Form`,
      'n_caf.accuracy.error_type4',
      `动词形式(verb form)`,
      `動詞形式(verb form)`,
      `Verb Form（動詞の形）`,
      `Verb Form`,
    ],
    error_type5: [
      `명사 수일치`,
      `Noun Number`,
      'n_caf.accuracy.error_type5',
      `名词单複数(Noun Number)`,
      `名詞單複數(Noun Number)`,
      `Noun Number（名詞数）`,
      `Noun Number`,
    ],
    error_type6: [
      `단어 순서`,
      `Word Order`,
      'n_caf.accuracy.error_type6',
      `词语顺序(Word Order)`,
      `詞語順序(Word Order)`,
      `Word Order（語順）`,
      `Word Order`,
    ],
    error_type7: [
      `형태 혼동`,
      `Morphology`,
      'n_caf.accuracy.error_type7',
      `词语型态(Morphology)`,
      `詞語型態(Morphology)`,
      `Morphology（形態論）`,
      `Morphology`,
    ],
    error_type8: [
      `주어동사 수일치`,
      `Subject-Verb Agreement`,
      'n_caf.accuracy.error_type8',
      `主词动词一致性`,
      `主詞動詞一致性`,
      `Subject-Verb Agreement（主語と動詞の一致）`,
      `Subject-Verb Agreement`,
    ],
    error_type_en1: [
      `Determiner`,
      `Determiner`,
      'n_caf.accuracy.error_type_en1',
      `冠词(determiners）`,
      `冠詞(determiners）`,
      `Determiner`,
      `Determiner`,
    ],
    error_type_en2: [
      `Particle`,
      `Particle`,
      'n_caf.accuracy.error_type_en2',
      `助词(particles）`,
      `助詞(particles）`,
      `Particle`,
      `Particle`,
    ],
    error_type_en3: [
      `Preposition`,
      `Preposition`,
      'n_caf.accuracy.error_type_en3',
      `介词(prepositions)`,
      `介系詞(prepositions)`,
      `Preposition`,
      `Preposition`,
    ],
    error_type_en4: [
      `Verb Form`,
      `Verb Form`,
      'n_caf.accuracy.error_type_en4',
      `动词形式(verb form)`,
      `動詞形式(verb form)`,
      `Verb Form`,
      `Verb Form`,
    ],
    error_type_en5: [
      `Noun Number`,
      `Noun Number`,
      'n_caf.accuracy.error_type_en5',
      `名词单複数(Noun Number)`,
      `名詞單複數(Noun Number)`,
      `Noun Number`,
      `Noun Number`,
    ],
    error_type_en6: [
      `Word Order`,
      `Word Order`,
      'n_caf.accuracy.error_type_en6',
      `词语顺序(Word Order)`,
      `詞語順序(Word Order)`,
      `Word Order`,
      `Word Order`,
    ],
    error_type_en7: [
      `Morphology`,
      `Morphology`,
      'n_caf.accuracy.error_type_en7',
      `词语型态(Morphology)`,
      `詞語型態(Morphology)`,
      `Morphology`,
      `Morphology`,
    ],
    error_type_en8: [
      `Subject-verb Agreement`,
      `Subject-Verb Agreement`,
      'n_caf.accuracy.error_type_en8',
      `主词动词一致性`,
      `主詞動詞一致性`,
      `Subject-Verb Agreement`,
      `Subject-Verb Agreement`,
    ],
    highlights: [
      `Accuracy 관련 학습 영역`,
      `Areas related to Accuracy`,
      'n_caf.accuracy.highlights',
      `和准确度有关的学习领域`,
      `和準確度有關的學習領域`,
      `Accuracyに関連する分野`,
      `Areas related to Accuracy`,
    ],
    highlights_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the AI analysis.`,
      'n_caf.accuracy.highlights_detail',
      `根据AI分析报告推荐的重点学习领域`,
      `根據AI分析報告推薦的重點學習領域`,
      `AI analysisに基づいた、今後の学習で重点的に取り組むべき分野です。`,
      `Recommended focus areas for learning based on the AI analysis.`,
    ],
    subsection_info: (count, category) => [
      <span>
        총 <span className="text-primary">{count}</span>개의 {category} 관련 문법 실수 구간
      </span>,
      <span>
        Section where you made a total of <span className="text-primary">{count}</span> {category} related grammar
        mistakes
      </span>,
      'n_caf.accuracy.subsection_info',
      <span>
        总共犯<span className="text-primary">{count}</span>次 {category}文法错误
      </span>,
      <span>
        總共犯<span className="text-primary">{count}</span>次 {category}文法錯誤
      </span>,
      <span>
        合計<span className="text-primary">{count}</span>件の{category}関連の文法のミスがあったセクション
      </span>,
      <span>
        Section where you made a total of <span className="text-primary">{count}</span> {category} related grammar
        mistakes
      </span>,
    ],
    viewmore_btn: [`더보기`, `See more`, 'n_caf.accuracy.viewmore_btn', `看更多`, `看更多`, `もっと見る`, `See more`],
    error_toast: [
      `링글팀에게 오류가 제보되었었어요.`,
      `The error report has been sent to the Ringle team.`,
      'n_caf.accuracy.error_toast',
      `错误回报已送交给Ringle团队`,
      `錯誤回報已送交給Ringle團隊`,
      `エラー報告は Ringle teamに送られました。`,
      `The error report has been sent to the Ringle team.`,
    ],
    caf_level9: [
      `9 레벨을 받은 대부분 사람은 모든 문법을 정확하고 적절하게 사용할 줄 알며, 원어민이 하는 정도의 문법 실수만 합니다.`,
      `Lv. 9 denotes that you use correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
      'n_caf.accuracy.caf_level9',
      `Lv. 9 表示您大部分时间都能使用正确和恰当的语法，犯语法错误的频率与母语人士相当。`,
      `Lv. 9 表示您大部分時間都能使用正確和恰當的文法，犯文法錯誤的頻率與母語人士相當。`,
      `Lv.9は、ほとんどの場合、正確で適切な文法を使用し、文法のミスをネイティブスピーカーと同じ頻度で行うことを示しています。`,
      `Lv. 9 denotes that you use correct and proper grammar most of the time, making grammar mistakes only as often as native speakers.`,
    ],
    caf_level8: [
      `8 레벨을 받은 대부분 사람은 다양한 형태의 문법 구조를 유연하게 사용하며, 대부분의 문장에 문법적 오류가 없습니다. 다만, 가끔 기본적인 문법 실수를 합니다.`,
      `Lv. 8 denotes that you can flexibly employ diverse grammar structures and construct flawless sentences, although you make occasional mistakes in basic grammar.`,
      'n_caf.accuracy.caf_level8',
      `Lv. 8 表示您能灵活运用多种语法结构，并能造出完美无缺的句子，但偶尔会犯基本语法错误。`,
      `Lv. 8 表示您能靈活運用多種文文法結構，並能造出完美無缺的句子，但偶爾會犯基本文法錯誤。`,
      `Lv.8は、基本的な文法は時々間違えるものの、多様な文法構造を柔軟に使いこなし、完璧な文章を構成できることを示しています。`,
      `Lv. 8 denotes that you can flexibly employ diverse grammar structures and construct flawless sentences, although you make occasional mistakes in basic grammar.`,
    ],
    caf_level7: [
      `7 레벨을 받은 대부분 사람은 복잡한 문법 구조를 어느 정도 유연하게 사용할 줄 알며, 자주 문법적 실수가 없는 문장을 사용합니다. 다만, 비슷한 문법 실수를 반복합니다.`,
      `Lv. 7 denotes that you can employ complex grammar structures with some flexibility and often construct flawless sentences, but you tend to make similar grammar mistakes.`,
      'n_caf.accuracy.caf_level7',
      `Lv. 7 表示您能灵活运用复杂的语法结构，并经常造出完美无缺的句子，但容易犯类似的语法错误。`,
      `Lv. 7 表示您能靈活運用複雜的文法結構，並經常造出完美無缺的句子，但容易犯類似的文法錯誤。`,
      `Lv.7は、ある程度柔軟性を持って複雑な文法構造を使用し、しばしば完璧な文章を構成することができますが、類似の文法を誤る傾向があることを示しています。`,
      `Lv. 7 denotes that you can employ complex grammar structures with some flexibility and often construct flawless sentences, but you tend to make similar grammar mistakes.`,
    ],
    caf_level6: [
      `6 레벨을 받은 대부분 사람은 단순한 문법 구조뿐 아니라 복잡한 문법 구조를 혼합하여 사용할 줄 알지만, 고급 문법을 사용할 때 실수가 잦아집니다.`,
      `Lv. 6 denotes that you know how to use both simple and complex grammar structures but make mistakes often when using more advanced grammar.`,
      'n_caf.accuracy.caf_level6',
      `Lv. 6 表示您既懂得使用简单语法结构，也懂得使用复杂语法结构，但在使用高级语法时经常出错。`,
      `Lv. 6 表示您既懂得使用簡單文法結構，也懂得使用複雜的文法結構，但在使用高級文法時經常出錯。`,
      `Lv.6は、簡単な文法と複雑な文法の両方の使い方を知っていますが、より高度な文法を使うときにミスが多いことを示しています。`,
      `Lv. 6 denotes that you know how to use both simple and complex grammar structures but make mistakes often when using more advanced grammar.`,
    ],
    caf_level5: [
      `5 레벨을 받은 대부분 사람은 기본 문장들은 정확도에 큰 무리 없이 사용하고, 익숙한 복잡한 문법 구조를 사용할 줄 압니다. 다만, 복잡한 문법 구조를 사용할 때, 문법 실수로 인해 상대방이 이해하는 데 어려움을 겪을 수 있습니다.`,
      `Lv. 5 denotes that you can construct basic sentences quite accurately and use complex grammar structures you are familiar with, but complex sentences you make can be difficult to understand.`,
      'n_caf.accuracy.caf_level5',
      `Lv. 5 表示您能相当准确地造出基本句子，并能使用您熟悉的复杂语法结构，但您造出的复杂句子可能难以理解。`,
      `Lv. 5 表示您能相當準確地造出基本句子，並能使用熟悉的複雜文法結構，但造出的複雜句子可能難以理解。`,
      `Lv.5は、基本的な文章はかなり正確に構成でき、使い慣れた複雑な文法構造も使えますが、複雑な文章は理解しにくいことを示しています。`,
      `Lv. 5 denotes that you can construct basic sentences quite accurately and use complex grammar structures you are familiar with, but complex sentences you make can be difficult to understand.`,
    ],
    caf_level4: [
      `4 레벨을 받은 대부분 사람은 기본적인 문장들을 만들어 낼 수 있지만, 복잡한 문장들은 잘 사용하지 않습니다. 문법 실수가 꽤 잦은 편이며, 가끔 상대방이 이해하는 데 어려움을 겪을 수 있습니다.`,
      `Lv. 4 denotes that you can speak basic sentences but rarely construct complex ones. Also, you make grammar mistakes fairly often and can sometimes be difficult to understand.`,
      'n_caf.accuracy.caf_level4',
      `Lv. 4 表示您能说基本句子，但很少造复杂句子。此外，您经常会犯语法错误，有时会难以理解。`,
      `Lv. 4 表示您能說基本句子，但很少造複雜句子。此外，您經常會犯文法錯誤，有時會難以理解。`,
      `Lv.4は、基本的な文章は話せますが、複雑な文章はほとんど作れないことを示しています。また、文法のミスも多く、理解しにくいこともります。`,
      `Lv. 4 denotes that you can speak basic sentences but rarely construct complex ones. Also, you make grammar mistakes fairly often and can sometimes be difficult to understand.`,
    ],
    caf_level3: [
      `3 레벨을 받은 대부분 사람은 외우고 있는 문법에 의존하거나, 기본적인 문장을 자유롭게 사용하는 데 어려움을 겪을 때가 있습니다. 익숙한 표현을 사용할 때를 제외하고는 문법적 실수를 자주 합니다.`,
      `Lv. 3 denotes that you rely on grammar you memorized and sometimes find it difficult to construct basic sentences. You also make frequent grammar mistakes, except when using familiar expressions.`,
      'n_caf.accuracy.caf_level3',
      `Lv. 3 表示您依赖于背诵的语法，有时很难造出基本句子。除了使用熟悉的表达方式外，您还经常犯语法错误。`,
      `Lv. 3 表示您依賴於背誦的文法，有時很難造出基本句子。除了使用熟悉的表達方式外，還經常有文法錯誤。`,
      `Lv.3は、暗記した文法に頼り、基本的な文章を構成するのが難しいことを示しています。また、慣れ親しんだ表現を使うとき以外は、文法のミスも多くなっています。`,
      `Lv. 3 denotes that you rely on grammar you memorized and sometimes find it difficult to construct basic sentences. You also make frequent grammar mistakes, except when using familiar expressions.`,
    ],
    caf_level2: [
      `2 레벨을 받은 대부분 사람은 기본적인 문장 구조를 만들어내는 데 어려움을 겪는 편입니다.`,
      `Lv. 2 denotes that you have difficulty constructing basic sentences.`,
      'n_caf.accuracy.caf_level2',
      `Lv. 2 表示您很难造出基本句子。`,
      `Lv. 2 表示您很難造出基本句子。`,
      `Lv.2は、基本的な文章の組み立てが難しいことを示しています。`,
      `Lv. 2 denotes that you have difficulty constructing basic sentences.`,
    ],
    caf_level1: [`-`, `-`, 'n_caf.accuracy.caf_level1', `-`, `-`, `-`, `-`],
    more_info: (count) => [
      `외 ${count}가지 오류`,
      `and ${count} other errors`,
      'n_caf.accuracy.more_info',
      `和 ${count}个错误`,
      `和 ${count}個錯誤`,
      `その他 ${count} 個のエラー`,
      `and ${count} other errors`,
    ],
    error_type9: [
      `형용사`,
      `Adjective`,
      'n_caf.accuracy.error_type9',
      `形容词`,
      `形容詞`,
      `Adjective（形容詞）`,
      `Adjective`,
    ],
    error_type10: [
      `최상급/비교급`,
      `Superlative/Comparative`,
      'n_caf.accuracy.error_type10',
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      `Superlative（最上級）/Comparative（比較級）`,
      `Superlative/Comparative`,
    ],
    error_type11: [
      `부사`,
      `Adverb`,
      'n_caf.accuracy.error_type11',
      `副词(Adverb）`,
      `副詞(Adverb）`,
      `Adverb（副詞）`,
      `Adverb`,
    ],
    error_type12: [
      `가산/불가산 명사`,
      `Noun Inflection`,
      'n_caf.accuracy.error_type12',
      `名词变化(Noun Inflection)`,
      `名詞變化(Noun Inflection)`,
      `Noun Inflection（名詞の変化）`,
      `Noun Inflection`,
    ],
    error_type13: [
      `동사 시제`,
      `Verb Tense`,
      'n_caf.accuracy.error_type13',
      `动词时态(Verb Tense)`,
      `動詞時態(Verb Tense)`,
      `Verb Tense（動詞の時制）`,
      `Verb Tense`,
    ],
    error_type14: [
      `단어 반복`,
      `Word Repetition`,
      'n_caf.accuracy.error_type14',
      `单字重複(Word Repetition)`,
      `單字重複(Word Repetition)`,
      `Word Repetition（単語の反復）`,
      `Word Repetition`,
    ],
    error_type15: [
      `Run-on 문장`,
      `Run-on Sentence`,
      'n_caf.accuracy.error_type15',
      `连写句(Run-on Sentence)`,
      `連寫句(Run-on Sentence)`,
      `Run-on Sentence（連結された文章）`,
      `Run-on Sentence`,
    ],
    error_type16: [
      `짧게 말한 구간`,
      `Short Sentence`,
      'n_caf.accuracy.error_type16',
      `短句(Short Sentence)`,
      `短句(Short Sentence)`,
      `Short Sentence（短い文章）`,
      `Short Sentence`,
    ],
    error_type17: [
      `말하기 속도`,
      `Speech Rate`,
      'n_caf.accuracy.error_type17',
      `语速(Speech Rate)`,
      `語速(Speech Rate)`,
      `Speech Rate（スピーチ速度）`,
      `Speech Rate`,
    ],
    error_type18: [`Pause`, `Pause`, 'n_caf.accuracy.error_type18', `停顿`, `停頓`, `Pause`, `Pause`],
    error_type_en9: [
      `Adjective`,
      `Adjective`,
      'n_caf.accuracy.error_type_en9',
      `形容词`,
      `形容詞`,
      `Adjective`,
      `Adjective`,
    ],
    error_type_en10: [
      `Superlative/Comparative`,
      `Superlative/Comparative`,
      'n_caf.accuracy.error_type_en10',
      `最高级/比较级`,
      `最高級/比較級`,
      `Superlative/Comparative`,
      `Superlative/Comparative`,
    ],
    error_type_en11: [`Adverb`, `Adverb`, 'n_caf.accuracy.error_type_en11', `副词`, `副詞`, `Adverb`, `Adverb`],
    error_type_en12: [
      `Noun inflection`,
      `Noun inflection`,
      'n_caf.accuracy.error_type_en12',
      `名词变化`,
      `名詞變化`,
      `Noun inflection`,
      `Noun inflection`,
    ],
    error_type_en13: [
      `Verb Tense`,
      `Verb Tense`,
      'n_caf.accuracy.error_type_en13',
      `动词时态`,
      `動詞時態`,
      `Verb Tense`,
      `Verb Tense`,
    ],
    underline_text: [
      `다른 유형의 문법실수`,
      `Other types of grammar mistakes`,
      'n_caf.accuracy.underline_text',
      `其他文法错误`,
      `其他文法錯誤`,
      `その他のタイプの文法のミス`,
      `Other types of grammar mistakes`,
    ],
    other_errors: (count) => [
      `외 ${count}가지 오류`,
      `and ${count} other types of errors`,
      'n_caf.accuracy.other_errors',
      `以外 ${count}其他类型的错误`,
      `以外 ${count}其他類型的錯誤`,
      `その他 ${count} 種類のエラー`,
      `and ${count} other types of errors`,
    ],
    collapse: [`접기`, `Close`, 'n_caf.accuracy.collapse', `关闭`, `關閉`, `閉じる`, `Close`],
  },
  fluency: {
    default: [`Fluency`, `Fluency`, 'n_caf.fluency.default', `流畅度`, `流暢度`, `Fluency`, `Fluency`],
    level_score: [`Level`, `Level`, 'n_caf.fluency.level_score', `Level`, `Level`, `Level`, `Level`],
    percent: (percent) => [
      `상위 ${percent}%`,
      `Top ${percent}%`,
      'n_caf.fluency.percent',
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
      `Top ${percent}%`,
    ],
    level_detail: [
      `9가지 중 하나!`,
      `Out of 9 types!`,
      'n_caf.fluency.level_detail',
      `9种中的一种!`,
      `9種中的一種!`,
      `9種類の中から1つ!`,
      `Out of 9 types!`,
    ],
    tab1: [
      `평균 말하기 속도`,
      `Avg. speech rate`,
      'n_caf.fluency.tab1',
      `平均口说速度`,
      `平均口說速度`,
      `平均的なスピーチ速度`,
      `Avg. speech rate`,
    ],
    tab2: [
      `평균 이어 말한 단어수`,
      `Mean length of run`,
      'n_caf.fluency.tab2',
      `平均使用单字数`,
      `平均使用單字數`,
      `平均的な語彙数`,
      `Mean length of run`,
    ],
    tab3: [
      `필러워드 비율`,
      `Filler word ratio`,
      'n_caf.fluency.tab3',
      `填充字使用频率`,
      `填充字使用頻率`,
      `間投語の比率`,
      `Filler word ratio`,
    ],
    graph_name1: [
      `나의 말하기 속도 (wpm)`,
      `My speech rate (wpm)`,
      'n_caf.fluency.graph_name1',
      `我的口说速度 (wpm)`,
      `我的口說速度 (wpm)`,
      `あなたのスピーチ速度 (wpm)`,
      `My speech rate (wpm)`,
    ],
    graph_name2: [
      `나의 이어 말한 단어 수`,
      `My mean length of run`,
      'n_caf.fluency.graph_name2',
      `平均使用单字数`,
      `平均使用單字數`,
      `あなたの平均的な語彙数`,
      `My mean length of run`,
    ],
    graph_name3: [
      `나의 필러워드 비율`,
      `My filler word ratio`,
      'n_caf.fluency.graph_name3',
      `填充字使用频率`,
      `填充字使用頻率`,
      `あなたの間投語の比率`,
      `My filler word ratio`,
    ],
    highlights: [
      `Fluency 관련 학습 영역`,
      `Areas related to Fluency`,
      'n_caf.fluency.highlights',
      `和流畅度有关的学习领域`,
      `和流暢度有關的學習領域`,
      `Fluencyに関連する分野`,
      `Areas related to Fluency`,
    ],
    highlights_detail: [
      `수업 분석을 기반으로 향후 학습에서 집중해 보면 좋을 영역을 제안 드립니다.`,
      `Recommended focus areas for learning based on the AI analysis.`,
      'n_caf.fluency.highlights_detail',
      `根据AI分析报告推荐的重点学习领域`,
      `根據AI分析報告推薦的重點學習領域`,
      `AI analysisに基づいた、今後の学習で重点的に取り組むべき分野です。`,
      `Recommended focus areas for learning based on the AI analysis.`,
    ],
    caf_level9: [
      `9 레벨을 받은 대부분 사람은 망설임 없이 말하고자 하는 바를 문법적 실수 없이 정확하게 전달할 수 있습니다.`,
      `Lv. 9 denotes that you can convey what you want to say flawlessly and without hesitation.`,
      'n_caf.fluency.caf_level9',
      `Lv.9 表示您能完美地、毫不犹豫地表达想说的话。`,
      `Lv.9 表示您能完美地、毫不猶豫地表達想說的話。`,
      `Lv.9は、言いたいことを完璧に、迷いなく伝えられることを示しています。`,
      `Lv. 9 denotes that you can convey what you want to say flawlessly and without hesitation.`,
    ],
    caf_level8: [
      `8 레벨을 받은 대부분 사람은 단어 반복이나 자기 교정(self-correction) 없이 유창하게 말할 수 있습니다. 말하는 도중에 일시적인 pause가 있을 수 있지만, 대부분은 다음에 말할 내용을 생각하느라 발생합니다.`,
      `Lv. 8 denotes that you can speak fluently without word repetition or self-correction. You may make short pauses while speaking, mostly because you are thinking about what to say next.`,
      'n_caf.fluency.caf_level8',
      `Lv.8 表示可以流利地说话，无需重复词语或自我修正。在说话时可能会有短暂的停顿，主要是因为在思考下一句要说什么。`,
      `Lv.8 表示可以流利地說話，無需重覆詞語或自我修正。在說話時可能會有短暫的停頓，主要是因為在思考下一句要說什麼。`,
      `Lv.8は、単語の繰り返しや自己修正なしに流暢に話すことができることを示しています。話している最中に短い間ができることがありますが、それは次に何を話すかを考えているためです。`,
      `Lv. 8 denotes that you can speak fluently without word repetition or self-correction. You may make short pauses while speaking, mostly because you are thinking about what to say next.`,
    ],
    caf_level7: [
      `7 레벨을 받은 대부분 사람은 무리 없이 길이가 있는 논리적인 대화를 원활하게 이어갈 수 있습니다. 질문에 대한 대답을 영어로 생각하느라 멈추는 것보다, 단어나 문법이 생각이 안 나서 멈추는 경우가 더 많습니다.`,
      `Lv. 7 denotes that you can easily carry on a lengthy conversation in a logical manner. You tend to make pauses because of word choice or grammar more often than to think about what to say.`,
      'n_caf.fluency.caf_level7',
      `Lv.7 表示可以轻松地以合乎逻辑的方式进行长时间的交谈。往往会因为选词或语法而停顿，而不是在思考要说什么。`,
      `Lv.7 表示可以輕松地以合乎邏輯的方式進行長時間的交談。往往會因為選詞或語法而停頓，而不是在思考要說什麼。`,
      `Lv.7は、長時間の会話を論理的に進めることができることを示しています。何を話すかを考えるよりも、言葉の選び方や文法で間を取ることが多い傾向があります。`,
      `Lv. 7 denotes that you can easily carry on a lengthy conversation in a logical manner. You tend to make pauses because of word choice or grammar more often than to think about what to say.`,
    ],
    caf_level6: [
      `6 레벨을 받은 대부분 사람은 유창하게 말하려고 노력하지만, 종종 망설임이나, 단어 반복, 자기 교정(self-correction) 때문에 전달력이 떨어질 수 있습니다.`,
      `Lv. 6 denotes that you try to speak fluently, but your speech is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
      'n_caf.fluency.caf_level6',
      `Lv.6 表示您尝试流利地讲话，但由于犹豫不决、词语重复和自我纠正，讲话时经常受阻。`,
      `Lv.6 表示您嘗試流利地講話，但由於猶豫不決、詞語重覆和自我糾正，講話時經常受阻。`,
      `Lv.6は、流暢に話そうとしていますが、ためらいや言葉の繰り返し、自己修正などによって話すことに支障をきたすことが多いことを示しています。`,
      `Lv. 6 denotes that you try to speak fluently, but your speech is often hindered in delivery due to hesitation, word repetition, and self-correction.`,
    ],
    caf_level5: [
      `5 레벨을 받은 대부분 사람은 간단한 대화에서는 유창하지만, 더욱 복잡한 소통 환경에서는 유창함이 무너지는 경우가 있습니다.`,
      `Lv. 5 denotes that you are fluent in simple conversations but not so much when engaging in more complex communication.`,
      'n_caf.fluency.caf_level5',
      `Lv.5 表示能够流利地进行简单的对话，但在进行较复杂的交流时就不那么流利了。`,
      `Lv.5 表示能夠流利地進行簡單的對話，但在進行較複雜的交流時就不那麼流利了。`,
      `Lv.5は、簡単な会話は流暢にこなせますが、複雑なコミュニケーションは苦手であることを示しています。`,
      `Lv. 5 denotes that you are fluent in simple conversations but not so much when engaging in more complex communication.`,
    ],
    caf_level4: [
      `4 레벨을 받은 대부분 사람은 천천히 말하거나, 멈춤 없이 대화를 이어가는 것을 힘들어하는 경우가 있습니다.`,
      `Lv. 4 denotes that you speak slowly or find it difficult to carry on a conversation without pauses.`,
      'n_caf.fluency.caf_level4',
      `Lv.4 表示您的语速较慢，或者很难在谈话中没有停顿。`,
      `Lv.4 表示您的語速較慢，或者很難在談話中沒有停頓。`,
      `Lv.4は、話すのが遅いか、会話を中断することなく進めるのが難しいことを示しています。`,
      `Lv. 4 denotes that you speak slowly or find it difficult to carry on a conversation without pauses.`,
    ],
    caf_level3: [
      `3 레벨을 받은 대부분 사람은 말하는 중에 긴 pause가 있으며, 간단한 문장들로 대화를 이어가는 경향이 있습니다.`,
      `Lv. 3 denotes that you make long pauses while speaking and tend to carry on  conversations with simple sentences.`,
      'n_caf.fluency.caf_level3',
      `Lv.3 表示您在说话时停顿时间较长，倾向于用简单的句子进行对话。`,
      `Lv.3 表示您在說話時停頓時間較長，傾向於用簡單的句子進行對話。`,
      `Lv.3は、話している間に長い間があり、簡単な文章で会話を続ける傾向があることを示しています。`,
      `Lv. 3 denotes that you make long pauses while speaking and tend to carry on  conversations with simple sentences.`,
    ],
    caf_level2: [
      `2 레벨을 받은 대부분 사람은 대부분 단어를 말하기 전에 길게 멈추는 경향이 있습니다.`,
      `Lv. 2 denotes that you tend to make long pauses before saying most words.`,
      'n_caf.fluency.caf_level2',
      `Lv.2 表示您在说大多数单词之前往往停顿很长时间。`,
      `Lv.2 表示在說大多數單詞之前往往停頓很長時間。`,
      `Lv.2は、ほとんどの単語を言う前に長い間をとる傾向があることを示しています。`,
      `Lv. 2 denotes that you tend to make long pauses before saying most words.`,
    ],
    caf_level1: [`-`, `-`, 'n_caf.fluency.caf_level1', `-`, `-`, `-`, `-`],
    tab4: [`Pause 비율`, `Pause Rate`, 'n_caf.fluency.tab4', `停顿率`, `停頓率`, `ポーズ率`, `Pause Rate`],
    tab5: [
      `반복단어 비율`,
      `Word Repeat Rate`,
      'n_caf.fluency.tab5',
      `单字重複率`,
      `單字重複率`,
      `単語リピート率`,
      `Word Repeat Rate`,
    ],
    graph_name4: [
      `나의 Pause 비율`,
      `My Pause Rate`,
      'n_caf.fluency.graph_name4',
      `我的停顿率`,
      `我的停頓率`,
      `My Pause Rate（ポーズ率）`,
      `My Pause Rate`,
    ],
    graph_name5: [
      `나의 단어 반복 비율`,
      `My Word Repeat Rate`,
      'n_caf.fluency.graph_name5',
      `我的单字重複率`,
      `我的單字重複率`,
      `My Word Repeat Rate（単語リピート率）`,
      `My Word Repeat Rate`,
    ],
    metric: [
      `이번 수업의 Fluency`,
      `This Lesson's Fluency`,
      'n_caf.fluency.metric',
      `这堂课的流畅度`,
      `這堂課的流暢度`,
      `This Lesson's Fluency`,
      `This Lesson's Fluency`,
    ],
    graph_sentence: [
      `내가 말한 문장`,
      `My Sentences`,
      'n_caf.fluency.graph_sentence',
      `我的句子`,
      `我的句子`,
      `My Sentences`,
      `My Sentences`,
    ],
    graph_legend1: [
      `자연스러운 말하기 속도`,
      `Natural speech rate`,
      'n_caf.fluency.graph_legend1',
      `自然语速`,
      `自然語速`,
      `自然なスピーチ速度`,
      `Natural speech rate`,
    ],
    graph_legend2: [
      `문장별 말하기속도 평균`,
      `Avg. speech rate`,
      'n_caf.fluency.graph_legend2',
      `平均语速`,
      `平均語速`,
      `平均的なスピーチ速度`,
      `Avg. speech rate`,
    ],
    graph_legend3: [`77 wpm`, `77 wpm`, 'n_caf.fluency.graph_legend3', `77 wpm`, `77 wpm`, `77 wpm`, `77 wpm`],
    graph_legend4: [
      `느린 구간`,
      `Slow speech section`,
      'n_caf.fluency.graph_legend4',
      `语速减缓区间`,
      `語速減緩區間`,
      `ゆっくりスピーチしたセクション`,
      `Slow speech section`,
    ],
    myav: [`이번 수업 평균`, `This Lesson`, 'n_caf.fluency.myav', `本堂课`, `本堂課`, `This Lesson`, `This Lesson`],
    top: [`상위 25% 평균`, `Top 25%`, 'n_caf.fluency.top', `Top 25%`, `Top 25%`, `Top 25%`, `Top 25%`],
    tutor: [
      `원어민 평균`,
      `Native Speaker`,
      'n_caf.fluency.tutor',
      `母语人士`,
      `母語人士`,
      `Native Speaker`,
      `Native Speaker`,
    ],
    s_modal_title: [
      `학습자가 말한 문장`,
      `My Sentences`,
      'n_caf.fluency.s_modal_title',
      `我的句子`,
      `我的句子`,
      `My Sentences`,
      `My Sentences`,
    ],
    s_modal_subtitle: [
      `대화 형식의 링글 수업 중 튜터가 말한 구간을 제외한 학습자가 말한 문장입니다.`,
      `Sentences you spoke when conversing with the tutor during the lesson.`,
      'n_caf.fluency.s_modal_subtitle',
      `在上课时与教师对话时使用的句子`,
      `在上課時與教師對話時使用的句子`,
      `レッスン中にチューターと会話した時の文章。`,
      `Sentences you spoke when conversing with the tutor during the lesson.`,
    ],
    modal_okay: [`확인`, `OK`, 'n_caf.fluency.modal_okay', `OK`, `OK`, `OK`, `OK`],
    modal_title1: [
      `말하기 속도`,
      `Speech rate (wpm)`,
      'n_caf.fluency.modal_title1',
      `语速 (wpm)`,
      `語速 (wpm)`,
      `スピーチ速度 (wpm)`,
      `Speech rate (wpm)`,
    ],
    modal_subtitle1: [
      `말하기 속도는 분당 말한 단어 수(word per minute, wpm)입니다. 원어민의 자연스러운 말하기 속도는 120 - 180 wpm 사이입니다.`,
      `Speech rate refers to the number of words you speak per minute (word per minute, wpm). A native speaker's natural speech rate is between 120 - 180 wpm.`,
      'n_caf.fluency.modal_subtitle1',
      `语速是指您每分钟讲的字数（每分钟字数，wpm）。母语人士的自然语速在 120 - 180 wpm 之间。`,
      `語速是指您每分鐘講的字數（每分鐘字數，wpm）。母語人士的自然語速在 120 - 180 wpm 之間。`,
      `スピーチレートとは、1分間に話す単語の数（word per minute:wpm）のことです。ネイティブスピーカーの自然な発話速度は120～180wpmです。`,
      `Speech rate refers to the number of words you speak per minute (word per minute, wpm). A native speaker's natural speech rate is between 120 - 180 wpm.`,
    ],
    modal_title3: [
      `필러워드 비율`,
      `Filler word ratio`,
      'n_caf.fluency.modal_title3',
      `填充词比率`,
      `填充詞比率`,
      `Filler word（間投詞）比率`,
      `Filler word ratio`,
    ],
    modal_subtitle3: [
      `필러워드는 um, uh와 같이 특정한 의미를 전달하지 않는 filler word를 사용하는 것을 의미합니다. 필러워드 비율은 필러워드를 사용한 빈도와 시간을 합산하여 계산합니다.`,
      `Filler words refer to words like "um" and "uh" that do not have any specific meaning. Filler word percentage is calculated based on the frequency and duration of filler word usage.`,
      'n_caf.fluency.modal_subtitle3',
      `填充词是指像 「um 「和 」uh 」这样没有任何特定含义的词。填充词比例是根据填充词的使用频率和持续时间来计算的。`,
      `填充詞是指像 「um 「和 」uh 」這樣沒有任何特定含義的詞。填充詞比例是根據填充詞的使用頻率和持續時間來計算的。`,
      `Filler word（間投詞）とは、"um "や "uh "のような特定の意味を持たない単語を指します。Filler word（間投詞）の割合は、Filler word（間投詞）の使用頻度と使用時間に基づいて計算されます。`,
      `Filler words refer to words like "um" and "uh" that do not have any specific meaning. Filler word percentage is calculated based on the frequency and duration of filler word usage.`,
    ],
    modal_title4: [
      `Pause 비율`,
      `Pause rate`,
      'n_caf.fluency.modal_title4',
      `停顿率`,
      `停頓率`,
      `ポーズ率`,
      `Pause rate`,
    ],
    modal_subtitle4: [
      `Pause는 단어와 단어 사이에 발생하는 무음으로 된 공백을 의미합니다. Pause 비율은 공백이 있었던 빈도와 시간을 합산하여 계산합니다.`,
      `A pause refers to the unfilled gaps between words. Pause rate is calculated based on the frequency and duration of pauses between words.`,
      'n_caf.fluency.modal_subtitle4',
      `停顿是指字与字之间未填满的空隙。停顿率是根据字词之间停顿的频率和持续时间来计算。`,
      `停頓是指字與字之間未填滿的空隙。停頓率是根據字詞之間停頓的頻率和持續時間來計算。`,
      `ポーズとは、単語と単語の間に発生する無音の空白を意味します。ポーズ率は単語間のポーズの頻度と時間に基づいて計算されます。`,
      `A pause refers to the unfilled gaps between words. Pause rate is calculated based on the frequency and duration of pauses between words.`,
    ],
    modal_title5: [
      `단어 반복 비율`,
      `Word repeat rate`,
      'n_caf.fluency.modal_title5',
      `单词重複率`,
      `單字重複率`,
      `単語リピート率`,
      `Word repeat rate`,
    ],
    modal_subtitle5: [
      `단어 반복은 같은 단어 혹은 구를 여러 번 반복하여 사용하는 것을 의미합니다. 단어 반복 비율은 반복한 단어 개수와 말한 총 단어 개수의 비율을 계산합니다.`,
      `Word repeat rate denotes the repeated use of the same words or phrases and is calculated by finding the ratio between the number of repeated words and the total number of words spoken.`,
      'n_caf.fluency.modal_subtitle5',
      `单词重複率指重複使用相同的单词或词组，其计算方式是找出重複使用的单词数与说话总字数的比率。`,
      `單字重複率指重複使用相同的單字或詞組，其計算方式是找出重複使用的單字數與說話總字數的比率。`,
      `単語リピート率は、同じ単語やフレーズが繰り返し使用されることを表し、繰り返された単語の数と使用された単語の総数の比率を求めることによって計算されます。`,
      `Word repeat rate denotes the repeated use of the same words or phrases and is calculated by finding the ratio between the number of repeated words and the total number of words spoken.`,
    ],
    tooltip1: (count) => [
      <span>
        이어 말한 단어 <span className="font-medium">{count}개</span>
      </span>,
      <span>
        <span className="font-medium">{count} words</span>&nbsp;spoken without pause
      </span>,
      'n_caf.fluency.tooltip1',
      <span>
        连续发言无停顿使用的单词<span className="font-medium">{count}个</span>
      </span>,
      <span>
        連續發言無停頓使用的單字<span className="font-medium">{count}個</span>
      </span>,
      <span>
        ポーズ無しで話した単語<span className="font-medium">{count}語</span>
      </span>,
      <span>
        <span className="font-medium">{count} words</span>&nbsp;spoken without pause
      </span>,
    ],
  },
  faq: {
    ques_1: [
      `링글 AI 분석이란 
무엇인가요?`,
      `What is 
"Ringle AI Analysis"?`,
      'n_caf.faq.ques_1',
      `Ringle AI分析是什麽?`,
      `"Ringle AI分析是什麼"?`,
      `Ringle AI Analysisとは何ですか？`,
      `What is 
"Ringle AI Analysis"?`,
    ],
    ques_2: [
      `AI 분석 레벨은 어떻게 
구성되나요?`,
      `What are the
AI analysis levels?`,
      'n_caf.faq.ques_2',
      `AI分析的等级有哪些?`,
      `AI分析的等級有哪些?`,
      `AI analysis levelsとは？`,
      `What are the
AI analysis levels?`,
    ],
    ques_3: [
      `링글 AI 분석은 어떻게
이루어지나요?`,
      `How is AI Analysis
performed?`,
      'n_caf.faq.ques_3',
      `AI分析报告是怎麽产出的？`,
      `AI分析報告是怎麼產出的？`,
      `AI Analysisはどのように行われますか？`,
      `How is AI Analysis
performed?`,
    ],
    ques_4: [
      `학습 영역은 
무엇인가요?`,
      `What are Focus Areas?`,
      'n_caf.faq.ques_4',
      `什麽是重点学习领域?`,
      `什麼是重點學習領域?`,
      `Focus Areasとは何ですか？`,
      `What are Focus Areas?`,
    ],
    tab_1: [`AI 분석`, `AI Analysis`, 'n_caf.faq.tab_1', `AI分析`, `AI分析`, `AI Analysis`, `AI Analysis`],
    tab_2: [
      `AI 분석 레벨`,
      `AI Analysis Level`,
      'n_caf.faq.tab_2',
      `AI分析等级`,
      `AI分析等級`,
      `AI Analysis Level`,
      `AI Analysis Level`,
    ],
    tab_3: [
      `분석 방법`,
      `Analysis Method`,
      'n_caf.faq.tab_3',
      `分析方法`,
      `分析方法`,
      `Analysis Method`,
      `Analysis Method`,
    ],
    tab_4: [
      `학습 영역`,
      `Focus Areas`,
      'n_caf.faq.tab_4',
      `重点学习领域`,
      `重點學習領域`,
      `Focus Areas`,
      `Focus Areas`,
    ],
  },
  graph_common: {
    user_section: {
      title: [
        `내가 말한 구간`,
        `My Turns`,
        'n_caf.graph_common.user_section.title',
        `我发言的区间`,
        `我發言的區間`,
        `My Turns`,
        `My Turns`,
      ],
      modal_title: [
        `내가 말한 구간`,
        `My Turns`,
        'n_caf.graph_common.user_section.modal_title',
        `我发言的区间`,
        `我發言的區間`,
        `My Turns`,
        `My Turns`,
      ],
      modal_subtitle: [
        `대화 형식의 링글 수업 중 튜터가 말한 구간을 제외한 학습자가 말한 구간(Turn)입니다.`,
        `Sections where you took your turn speaking when coversing with the tutor during the lesson.`,
        'n_caf.graph_common.user_section.modal_subtitle',
        `和教师进行课程对话时，我发言的部分(turn)`,
        `和教師進行課程對話時，我發言的部分(turn)`,
        `レッスン中、チューターとの会話であなたが話したセクション。`,
        `Sections where you took your turn speaking when coversing with the tutor during the lesson.`,
      ],
    },
  },
  highlight_list: {
    sort_title: [
      `정렬 기준`,
      `Sort by`,
      'n_caf.highlight_list.sort_title',
      `排序依据`,
      `排序依據`,
      `並べ替え`,
      `Sort by`,
    ],
    sort_optn1: [
      `링글 추천순`,
      `Ringle recommended`,
      'n_caf.highlight_list.sort_optn1',
      `Ringle推荐`,
      `Ringle推薦`,
      `Ringleのおすすめ`,
      `Ringle recommended`,
    ],
    sort_optn2: [
      `구간 많은 순`,
      `Number of sections`,
      'n_caf.highlight_list.sort_optn2',
      `区间数`,
      `區間數`,
      `セクション数`,
      `Number of sections`,
    ],
    sort_optn3: [
      `카테고리 순`,
      `Category`,
      'n_caf.highlight_list.sort_optn3',
      `分类`,
      `分類`,
      `カテゴリー`,
      `Category`,
    ],
    weakness1: [
      `Weakness`,
      `Weakness`,
      'n_caf.highlight_list.weakness1',
      `弱项 Weakness`,
      `弱項 Weakness`,
      `Weakness`,
      `Weakness`,
    ],
    weakness2: (level) => [
      `레벨 ${level} 평균보다 못한 영역`,
      `Areas below Lv. ${level} average`,
      'n_caf.highlight_list.weakness2',
      `Lv.${level}平均以下的领域`,
      `Lv.${level}平均以下的領域`,
      `Lv. ${level} 平均以下の分野`,
      `Areas below Lv. ${level} average`,
    ],
    strength1: [
      `Strength`,
      `Strength`,
      'n_caf.highlight_list.strength1',
      `强项 Strength`,
      `強項 Strength`,
      `Strength`,
      `Strength`,
    ],
    strength2: (level) => [
      `레벨 ${level} 평균보다 잘한 영역`,
      `Areas above Lv. ${level} average`,
      'n_caf.highlight_list.strength2',
      `Lv. ${level}平均以上的领域`,
      `Lv. ${level}平均以上的領域`,
      `Lv. ${level} 平均以上の分野`,
      `Areas above Lv. ${level} average`,
    ],
    complexity1: [
      `Complexity`,
      `Complexity`,
      'n_caf.highlight_list.complexity1',
      `Complexity`,
      `Complexity`,
      `Complexity`,
      `Complexity`,
    ],
    complexity2: [
      `복잡성`,
      `Complexity`,
      'n_caf.highlight_list.complexity2',
      `複杂度`,
      `複雜度`,
      `複雑さ`,
      `Complexity`,
    ],
    accuracy1: [
      `Accuracy`,
      `Accuracy`,
      'n_caf.highlight_list.accuracy1',
      `Accuracy`,
      `Accuracy`,
      `Accuracy`,
      `Accuracy`,
    ],
    accuracy2: [`정확성`, `Accuracy`, 'n_caf.highlight_list.accuracy2', `正确度`, `準確度`, `正確さ`, `Accuracy`],
    fluency1: [`Fluency`, `Fluency`, 'n_caf.highlight_list.fluency1', `Fluency`, `Fluency`, `Fluency`, `Fluency`],
    fluency2: [`유창성`, `Fluency`, 'n_caf.highlight_list.fluency2', `流畅度`, `流暢度`, `流暢さ`, `Fluency`],
    title: [
      `학습 영역`,
      `Focus Areas`,
      'n_caf.highlight_list.title',
      `重点学习领域`,
      `重點學習領域`,
      `Focus Areas`,
      `Focus Areas`,
    ],
    edit: [`편집하기`, `Edit`, 'n_caf.highlight_list.edit', `编辑`, `編輯`, `編集`, `Edit`],
    count: [
      <>
        총 <span className="text-purple-500">18</span> 가지 학습 영역
      </>,
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
      'n_caf.highlight_list.count',
      <>
        <span className="text-purple-500">18</span>学习领域
      </>,
      <>
        <span className="text-purple-500">18</span>學習領域
      </>,
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
      <>
        <span className="text-purple-500">18</span> focus areas
      </>,
    ],
    edit_done: [`편집 완료`, `Done`, 'n_caf.highlight_list.edit_done', `编辑完成`, `編輯完成`, `完了`, `Done`],
    pronunciation1: [
      `Pronunciation`,
      `Pronunciation`,
      'n_caf.highlight_list.pronunciation1',
      `发音`,
      `發音`,
      `Pronunciation`,
      `Pronunciation`,
    ],
    pronunciation2: [
      `발음`,
      `Pronunciation`,
      'n_caf.highlight_list.pronunciation2',
      `发音`,
      `發音`,
      `Pronunciation（発音）`,
      `Pronunciation`,
    ],
  },
  highlight_list_edit: {
    title: [
      `내가 집중하고 싶은 학습 영역`,
      `My Focus Areas`,
      'n_caf.highlight_list_edit.title',
      `我的重点学习领域`,
      `我的重點學習領域`,
      `My Focus Areas`,
      `My Focus Areas`,
    ],
    done: [`완료`, `Done`, 'n_caf.highlight_list_edit.done', `完成`, `完成`, `完了`, `Done`],
    count: (count) => [
      <>
        고정한 학습 영역 <span className="text-purple-500">{count}</span>개
      </>,
      <>
        <span className="text-purple-500">{count}</span> pinned focus areas
      </>,
      'n_caf.highlight_list_edit.count',
      <>
        固定的学习领域<span className="text-purple-500">{count}</span>
      </>,
      <>
        固定的學習領域<span className="text-purple-500">{count}</span>
      </>,
      <>
        固定されたFocus areas<span className="text-purple-500">{count}</span> 個
      </>,
      <>
        <span className="text-purple-500">{count}</span> pinned focus areas
      </>,
    ],
    info: [
      <>
        <span className="text-purple-500">최대 3개</span>의 학습 영역을 고정할 수 있습니다.
      </>,
      <>
        You can pin <span className="text-purple-500">&nbsp;up to 3&nbsp;</span> focus areas.
      </>,
      'n_caf.highlight_list_edit.info',
      <>
        最多可以选择<span className="text-purple-500">&nbsp;up to 3&nbsp;</span>学习领域
      </>,
      <>
        最多可以選擇<span className="text-purple-500">&nbsp;up to 3&nbsp;</span>學習領域
      </>,
      <>
        <span className="text-purple-500">最大3つ</span>のFocus areasを固定することができます。
      </>,
      <>
        You can pin <span className="text-purple-500">&nbsp;up to 3&nbsp;</span> focus areas.
      </>,
    ],
    toast1: [
      `내가 집중하고 싶은 학습 영역에 추가되었어요.`,
      `Added to My Focus Areas.`,
      'n_caf.highlight_list_edit.toast1',
      `加入我的重点学习领域`,
      `加入我的重點學習領域`,
      `My Focus Areasに追加`,
      `Added to My Focus Areas.`,
    ],
    toast2: [
      `내가 집중하고 싶은 학습 영역에서 제외되었어요.`,
      `Deleted from My Focus Areas.`,
      'n_caf.highlight_list_edit.toast2',
      `从我的重点学习领域删除`,
      `從我的重點學習領域刪除`,
      `My Focus Areasから削除`,
      `Deleted from My Focus Areas.`,
    ],
    toast3: [
      `최대 3개의 학습 영역을 고정 할 수 있어요.`,
      `You can pin up to 3 focus areas.`,
      'n_caf.highlight_list_edit.toast3',
      `最多可选择3个学习领域`,
      `最多可選擇3個學習領域`,
      `最大3つのFocus Areasを固定することができます。`,
      `You can pin up to 3 focus areas.`,
    ],
    toast4: [
      `최대 3개의 학습 영역을 고정 할 수 있어요.`,
      `You can pin up to 3 focus areas.`,
      'n_caf.highlight_list_edit.toast4',
      `最多可选择3个学习领域`,
      `最多可選擇3個學習領域`,
      `You can pin up to 3 focus areas.`,
      `You can pin up to 3 focus areas.`,
    ],
    toast4_btn: [`편집하기`, `Edit`, 'n_caf.highlight_list_edit.toast4_btn', `编辑`, `編輯`, `Edit`, `Edit`],
  },
  level_info: [
    `레벨 분포와 설명`,
    `Level distribution & description`,
    'n_caf.level_info',
    `级别分布及说明`,
    `級別分布及說明`,
    `レベル分布と解説`,
    `Level distribution & description`,
  ],
  speechrate_def: {
    modal_title: [
      `토`,
      `Speech Rate`,
      'n_caf.speechrate_def.modal_title',
      `说话速度`,
      `說話速度`,
      `スピーチ速度`,
      `Speech Rate`,
    ],
    modal_body: [
      `분당 말한 단어 수(word per minute, wpm)입니다.`,
      `Shows the number of words you spoke per minute (wpm).`,
      'n_caf.speechrate_def.modal_body',
      `说话时1分钟所使用的单字数 (wpm).`,
      `說話時1分鐘所使用的單字數 (wpm).`,
      `1分間に話した単語数（word per minute:wpm）を示します。`,
      `Shows the number of words you spoke per minute (wpm).`,
    ],
  },
  mlr_def: {
    modal_title: [
      `나의 이어 말한 단어 수`,
      `Mean Length of Run (MLR)`,
      'n_caf.mlr_def.modal_title',
      `Mean Length of Run (MLR)`,
      `Mean Length of Run (MLR)`,
      `Mean Length of Run (MLR)`,
      `Mean Length of Run (MLR)`,
    ],
    modal_body: [
      `0.25초 이상의 공백 없이 이어말한 단어수(Mean Length of Run, MLR)입니다.`,
      `Shows to the average number of words you spoke without pauses exceeding 0.25 seconds.`,
      'n_caf.mlr_def.modal_body',
      `显示你在不超过0.25秒的停顿内平均说出的单字数量`,
      `顯示你在不超過0.25秒的停頓內平均說出的單字數量`,
      `0.25秒以上の間を置かずに話した単語の平均数を示します。`,
      `Shows to the average number of words you spoke without pauses exceeding 0.25 seconds.`,
    ],
  },
  pause_def: {
    modal_title: [
      `Pause 비율`,
      `Pause Rate`,
      'n_caf.pause_def.modal_title',
      `停顿率`,
      `停頓率`,
      `ポーズ率`,
      `Pause Rate`,
    ],
    modal_body: [
      `학습자가 말한 시간과 말하는 중 Pause가있었던 시간의 비율입니다.`,
      `Shows the ratio between the time you spent speaking and the time you spent pausing.`,
      'n_caf.pause_def.modal_body',
      `显示说话时间和停顿时间的比例`,
      `顯示說話時間和停頓時間的比例`,
      `発話時間とポーズ時間の比率を示します。`,
      `Shows the ratio between the time you spent speaking and the time you spent pausing.`,
    ],
  },
  vocablv_def: {
    modal_title: [
      `어휘 난이도`,
      `Vocabulary Level`,
      'n_caf.vocablv_def.modal_title',
      `单字等级`,
      `單字等級`,
      `Vocabulary Level（語彙力）`,
      `Vocabulary Level`,
    ],
    modal_body: [
      `학습자가 사용한 어휘의 난이도 유형별 분포입니다.`,
      `Shows the distribution of the types of vocabulary you used.`,
      'n_caf.vocablv_def.modal_body',
      `显示您所用词彙类型的分佈情况`,
      `顯示您所用詞彙類型的分佈情況`,
      `使用したVocabularyの種類の分布を示します。`,
      `Shows the distribution of the types of vocabulary you used.`,
    ],
  },
  sentence_def: {
    modal_title: [
      `문장 구조`,
      `Sentence Structure`,
      'n_caf.sentence_def.modal_title',
      `句子结构`,
      `句子結構`,
      `Sentence Structure（文章の構造）`,
      `Sentence Structure`,
    ],
    modal_body: [
      `학습자가 사용한 문장 유형별 분포입니다.`,
      `Shows the distribution of the types of sentences you used.`,
      'n_caf.sentence_def.modal_body',
      `显示您所用句子类型的分佈情况`,
      `顯示您所用句子類型的分佈情況`,
      `使用した文章の種類の分布を示します。`,
      `Shows the distribution of the types of sentences you used.`,
    ],
  },
  speech_rate_def: {
    modal_title: [
      `말하기 속도`,
      `Speech Rate`,
      'n_caf.speech_rate_def.modal_title',
      `语速`,
      `語速`,
      `Speech Rate（スピーチ速度）`,
      `Speech Rate`,
    ],
    modal_body: [
      `분당 말한 단어 수(word per minute, wpm)입니다.`,
      `Refers to the number of words you spoke per minute (wpm).`,
      'n_caf.speech_rate_def.modal_body',
      `每分钟讲的单字数 (wpm).`,
      `每分鐘講的單字數 (wpm).`,
      `1分間に話した単語数（word per minute:wpm）を示します。`,
      `Refers to the number of words you spoke per minute (wpm).`,
    ],
  },
  type_c: {
    word: [`어휘`, `vocabulary`, 'n_caf.type_c.word', `单字`, `單字`, `vocabulary（語彙）`, `vocabulary`],
    sentence: [
      `문장`,
      `use of sentences`,
      'n_caf.type_c.sentence',
      `使用句型`,
      `使用句型`,
      `use of sentences（センテンス）`,
      `use of sentences`,
    ],
    main: {
      up: (group) => [
        <>지난 수업보다 {group} 영역에서 성장했어요.</>,
        <>Your {group} got better than last time.</>,
        'n_caf.type_c.main.up',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>あなたの {group}は前回より良くなりました。</>,
        <>Your {group} got better than last time.</>,
      ],
      down: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        'n_caf.type_c.main.down',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>あなたの {group}は前回ほど良くありませんでした。</>,
        <>Your {group} was not as good as last time.</>,
      ],
      same: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        'n_caf.type_c.main.same',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>あなたの {group}は前回ほど良くありませんでした。</>,
        <>Your {group} was not as good as last time.</>,
      ],
    },
    sub: {
      up: (group) => [
        <>다음 수업에서는 {group} 영역을 신경써서 수업해보세요.</>,
        <>Try paying more attention to your {group} next time.</>,
        'n_caf.type_c.sub.up',
        <>下次试着多注意{group}</>,
        <>下次試著多注意{group}</>,
        <>次回はもっとあなたの{group} に注意を払ってみてください。</>,
        <>Try paying more attention to your {group} next time.</>,
      ],
      down: (group) => [
        <>하지만 {group} 영역은 지난 수업보다 개선되었어요.</>,
        <>But your {group} was better than last time.</>,
        'n_caf.type_c.sub.down',
        <>但是你的{group}比上次表现好</>,
        <>但是你的{group}比上次表現好</>,
        <>一方で、あなたの{group} は前回より良くなりました。</>,
        <>But your {group} was better than last time.</>,
      ],
      same: (group) => [
        <>{group} 영역은 지난 수업보다 개선되었어요.</>,
        <>Your {group} improved from last time.</>,
        'n_caf.type_c.sub.same',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>あなたの {group}は前回より良くなりました。</>,
        <>Your {group} improved from last time.</>,
      ],
    },
  },
  type_f: {
    speed: [
      `말하기 속도`,
      `speech rate`,
      'n_caf.type_f.speed',
      `说话速度`,
      `說話速度`,
      `speech rate（スピーチ速度）`,
      `speech rate`,
    ],
    pause: [`멈춤`, `use of pauses`, 'n_caf.type_f.pause', `停顿`, `停頓`, `use of pauses（ポーズ）`, `use of pauses`],
    main: {
      down: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        'n_caf.type_f.main.down',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>あなたの {group}は前回ほど良くありませんでした。</>,
        <>Your {group} was not as good as last time.</>,
      ],
      same: (group) => [
        <>지난 수업보다 {group} 영역이 낮게 측정 되었어요.</>,
        <>Your {group} was not as good as last time.</>,
        'n_caf.type_f.main.same',
        <>你的{group}没有上次表现好</>,
        <>你的{group}沒有上次表現好</>,
        <>あなたの {group}は前回ほど良くありませんでした。</>,
        <>Your {group} was not as good as last time.</>,
      ],
      up: (group) => [
        <>지난 수업보다 {group} 영역에서 성장했어요.</>,
        <>Your {group} got better than last time.</>,
        'n_caf.type_f.main.up',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>あなたの{group}は前回よりも良くなりました。 </>,
        <>Your {group} got better than last time.</>,
      ],
    },
    sub: {
      up: (group) => [
        <>다음 수업에서는 {group} 영역을 신경써서 수업해보세요.</>,
        <>Try paying more attention to your {group} next time.</>,
        'n_caf.type_f.sub.up',
        <>下次试着多注意{group}</>,
        <>下次試著多注意{group}</>,
        <>次回はもっとあなたの{group} に注意を払ってみてください。</>,
        <>Try paying more attention to your {group} next time.</>,
      ],
      down: (group) => [
        <>하지만 {group} 영역은 지난 수업보다 개선되었어요.</>,
        <>But your {group} was better than last time.</>,
        'n_caf.type_f.sub.down',
        <>但是你的{group}比上次表现好</>,
        <>但是你的{group}比上次表現好</>,
        <>一方で、あなたの{group} は前回より良くなりました。</>,
        <>But your {group} was better than last time.</>,
      ],
      same: (group) => [
        <>{group} 영역은 지난 수업보다 개선되었어요.</>,
        <>Your {group} improved from last time.</>,
        'n_caf.type_f.sub.same',
        <>你的{group}比上次进步</>,
        <>你的{group}比上次進步</>,
        <>あなたの {group}は前回より良くなりました。</>,
        <>Your {group} improved from last time.</>,
      ],
    },
  },
  type_a: {
    det: [
      `한정사`,
      `use of determiners`,
      'n_caf.type_a.det',
      `冠词使用(determiners）`,
      `冠詞使用(determiners）`,
      `use of determiners（限定詞）`,
      `use of determiners`,
    ],
    part: [
      `불변화사`,
      `use of particles`,
      'n_caf.type_a.part',
      `助词使用(particles）`,
      `助詞使用(particles）`,
      `use of particles（助詞）`,
      `use of particles`,
    ],
    prep: [
      `전치사`,
      `use of prepositions`,
      'n_caf.type_a.prep',
      `介词使用(prepositions)`,
      `介系詞使用(prepositions)`,
      `use of prepositions（前置詞）`,
      `use of prepositions`,
    ],
    verb_form: [
      `동사 형태`,
      `use of verb form`,
      'n_caf.type_a.verb_form',
      `动词形式(verb form)`,
      `動詞形式(verb form)`,
      `use of verb form（動詞の形）`,
      `use of verb form`,
    ],
    noun_num: [
      `명사 수일치`,
      `use of noun number`,
      'n_caf.type_a.noun_num',
      `名词单複数`,
      `名詞單複數`,
      `use of noun number（名詞数）`,
      `use of noun number`,
    ],
    word: [
      `단어 순서`,
      `use of word order`,
      'n_caf.type_a.word',
      `词语顺序`,
      `詞語順序`,
      `use of word order（語順）`,
      `use of word order`,
    ],
    morph: [
      `형태 혼동`,
      `use of morphology`,
      'n_caf.type_a.morph',
      `词语型态使用`,
      `詞語型態使用`,
      `use of morphology（形態論）`,
      `use of morphology`,
    ],
    sva: [
      `주어동사 수일치`,
      `use of subject-verb agreement`,
      'n_caf.type_a.sva',
      `主词动词一致性`,
      `主詞動詞一致性`,
      `use of subject-verb agreement（主語と動詞の一致）`,
      `use of subject-verb agreement`,
    ],
    adj: [
      `형용사`,
      `use of adjectives`,
      'n_caf.type_a.adj',
      `形容词使用(adjectives)`,
      `形容詞使用(adjectives)`,
      `use of adjectives（形容詞）`,
      `use of adjectives`,
    ],
    adj_form: [
      `최상급/비교급`,
      `use of superlative/comparative`,
      'n_caf.type_a.adj_form',
      `最高级/比较级使用(superlative/comparative)`,
      `最高級/比較級使用(superlative/comparative)`,
      `use of superlative/comparative（最上級/比較級）`,
      `use of superlative/comparative`,
    ],
    adv: [
      `부사`,
      `use of adverbs`,
      'n_caf.type_a.adv',
      `副词使用(adverbs)`,
      `副詞使用(adverbs)`,
      `use of adverbs（副詞）`,
      `use of adverbs`,
    ],
    noun_infl: [
      `가산/불가산 명사`,
      `use of noun Inflection`,
      'n_caf.type_a.noun_infl',
      `可数/不可数名词`,
      `可數/不可數名詞`,
      `use of noun Inflection（名詞の変化）`,
      `use of noun Inflection`,
    ],
    verb_tense: [
      `동사 시제`,
      `use of verb tense`,
      'n_caf.type_a.verb_tense',
      `动词时态`,
      `動詞時態`,
      `use of verb tense（動詞の時制）`,
      `use of verb tense`,
    ],
    main: {
      up: (group) => [
        <>지난 수업보다 {group} 문법 실수가 적었어요.</>,
        <>Your made less mistakes in your {group} than last time.</>,
        'n_caf.type_a.main.up',
        <>你在{group}犯的错误比上次少</>,
        <>你在{group}犯的錯誤比上次少</>,
        <>あなたの｛{group}でのミスは前回より減りました。</>,
        <>Your made less mistakes in your {group} than last time.</>,
      ],
      down: (group) => [
        <>지난 수업보다 {group} 문법 실수가 많았어요.</>,
        <>Your made more mistakes in your {group} than last time.</>,
        'n_caf.type_a.main.down',
        <>你在{group}犯的错误比上次多</>,
        <>你在{group}犯的錯誤比上次多</>,
        <>あなたの {group}でのミスは前回よりも増えました。</>,
        <>Your made more mistakes in your {group} than last time.</>,
      ],
      same: (group) => [
        <>지난 수업보다 {group} 문법 실수가 많았어요.</>,
        <>Your made more mistakes in your {group} than last time.</>,
        'n_caf.type_a.main.same',
        <>你在{group}犯的错误比上次多</>,
        <>你在{group}犯的錯誤比上次多</>,
        <>あなたの {group}でのミスは前回よりも増えました。</>,
        <>Your made more mistakes in your {group} than last time.</>,
      ],
    },
    sub: {
      up: (group) => [
        <>다음 수업에서는 {group} 까지 신경써서 수업해보세요.</>,
        <>Try paying more attention to your {group} during lessons.</>,
        'n_caf.type_a.sub.up',
        <>试着在课堂中多注意{group}</>,
        <>試著在課堂中多注意{group}</>,
        <>レッスン中、{group}にもっと注意を払うようにしてください。</>,
        <>Try paying more attention to your {group} during lessons.</>,
      ],
      down: (group) => [
        <>하지만 {group} 실수는 줄었어요.</>,
        <>But you made less mistakes in your {group}.</>,
        'n_caf.type_a.sub.down',
        <>但是你减少在{group}犯错</>,
        <>但是你減少在{group}犯錯</>,
        <>一方で、{group}のミスは減りました。</>,
        <>But you made less mistakes in your {group}.</>,
      ],
      same: (group) => [
        <>{group}은 지난 수업보다 실수가 적었어요.</>,
        <>You made less mistakes in your {group} than last time.</>,
        'n_caf.type_a.sub.same',
        <>你在{group}犯的错误比上次少</>,
        <>你在{group}犯的錯誤比上次少</>,
        <>あなたは前回より{group}でのミスが減りました。</>,
        <>You made less mistakes in your {group} than last time.</>,
      ],
    },
  },
  diff_title: {
    up: (type, score) => [
      `${type}가 ${score} 올랐어요!`,
      `You scored ${score} higher in ${type}!`,
      'n_caf.diff_title.up',
      `${type}的 ${score}分数提升了!`,
      `${type}的 ${score}分數提升了!`,
      `あなたは${type}でより高いスコア${score} を獲得しました！`,
      `You scored ${score} higher in ${type}!`,
    ],
    down: (type, score) => [
      `${type}가 ${score} 떨어졌어요.`,
      `You scored ${score} lower in ${type}.`,
      'n_caf.diff_title.down',
      `${type}的 ${score}分数降低了`,
      `${type}的 ${score}分數降低了`,
      `あなたは${type}で${score}低いスコアを出しました。`,
      `You scored ${score} lower in ${type}.`,
    ],
    same: (type) => [
      `${type} 레벨 변동이 없었어요.`,
      `Your ${type} level stayed the same.`,
      'n_caf.diff_title.same',
      `${type}的分数维持一致`,
      `${type}的分数维持一致`,
      `あなたの${type}レベルは変わりません。`,
      `Your ${type} level stayed the same.`,
    ],
    up_little: (type, score) => [
      `${type}가 ${score} 올랐어요.`,
      `You scored ${score} higher in ${type}.`,
      'n_caf.diff_title.up_little',
      `${type}的 ${score}分数提升了!`,
      `${type}的 ${score}分數提升了!`,
      `あなたは${type}でより高いスコア${score} を獲得しました。`,
      `You scored ${score} higher in ${type}.`,
    ],
  },
  trend: {
    history: [`레벨 변화`, `History`, 'n_caf.trend.history', `等级变化`, `等級變化`, `History`, `History`],
    score_detail: [
      `상세 레벨`,
      `Score Detail`,
      'n_caf.trend.score_detail',
      `等级详细说明`,
      `等級詳細說明`,
      `スコアの詳細`,
      `Score Detail`,
    ],
  },
  past_lesson: [`지난 수업`, `Past Lesson`, 'n_caf.past_lesson', `上一堂课`, `上一堂課`, `Past Lesson`, `Past Lesson`],
  this_lesson: [`이번 수업`, `This lesson`, 'n_caf.this_lesson', `本次课程`, `本次課程`, `This lesson`, `This lesson`],
}
export const n_lesson_review = {
  lesson_recoding_msg: {
    modal_body: [
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          AI 분석은 링글에서 새롭게 제작한 AI 엔진으로 기존 수업 분석보다 개선된 기능입니다.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          기존 수업 녹음의 텍스트보다 정확하게 인식이 가능해졌고, 기존 수업 분석보다 다각도에서 분석이 진행됩니다.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>베타 서비스가 종료된 후 하반기에 기존 기능들과 병합될
          예정입니다.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>AI 분석에 대해 구체적인 가이드가 궁금하시다면?
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          AI analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, AI analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about AI analylsis?
        </p>
      </div>,
      'n_lesson_review.lesson_recoding_msg.modal_body',
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          AI 分析使用 Ringle 全新的 AI 引擎提供更精准的分析。
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF 分析採用改良的语音识别技术，可对您的表现进行更多维度的分析。
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>测试服务之后，AI 分析将在今年与课程分析合併。
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>想要了解更多AI分析吗？
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          AI 分析使用 Ringle 全新的 AI 引擎提供更精準的分析。
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF 分析採用改良的語音識別技術，可對您的表現進行更多面向的分析。
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>測試服務之後，AI 分析將在今年與課程分析合併。
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>想要了解更多AI分析嗎？
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          AI analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, AI analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about AI analylsis?
        </p>
      </div>,
      <div className="pl-[10px]">
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          AI analysis uses Ringle's new AI engine to provide more advanced insights.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>
          CAF analysis employs improved speech recognition and provides a more multidimensional analysis of your
          performance.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>After the beta service, AI analysis will be merged with
          lesson analysis later this year.
        </p>
        <p className="relative">
          <span className="absolute left-[-10px] top-0">•</span>Want to know more about AI analylsis?
        </p>
      </div>,
    ],
    modal_btn: [`확인`, `Got it`, 'n_lesson_review.lesson_recoding_msg.modal_btn', `确认`, `確認`, `Got it`, `Got it`],
    modal_body2: [
      `AI 분석 가이드`,
      `See "Introduction to AI Analysis`,
      'n_lesson_review.lesson_recoding_msg.modal_body2',
      `看Ringle AI分析介绍`,
      `看Ringle AI分析介紹`,
      `See "Introduction to AI Analysis`,
      `See "Introduction to AI Analysis`,
    ],
  },
}
export const n_system = {
  lesson_style_caf: [
    `링글 AI 분석이란?`,
    `What is Ringle AI Analysis?`,
    'n_system.lesson_style_caf',
    `什麽是Ringle AI分析？`,
    `什麼是Ringle AI分析？`,
    `Ringle AI analysisとは何ですか?`,
    `What is Ringle AI Analysis?`,
  ],
}
